/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(2);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(3);

	var _index6 = _interopRequireDefault(_index5);

	var _env = __webpack_require__(4);

	var _env2 = _interopRequireDefault(_env);

	var _auth = __webpack_require__(5);

	var _auth2 = _interopRequireDefault(_auth);

	var _components = __webpack_require__(11);

	var _components2 = _interopRequireDefault(_components);

	var _resources = __webpack_require__(12);

	var _resources2 = _interopRequireDefault(_resources);

	var _queues = __webpack_require__(22);

	var _queues2 = _interopRequireDefault(_queues);

	var _socketio = __webpack_require__(37);

	var _socketio2 = _interopRequireDefault(_socketio);

	var _sentry = __webpack_require__(38);

	var _sentry2 = _interopRequireDefault(_sentry);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Resources
	//import Users from './resources/users.resource';

	// Services
	/* global moment:false, _:false, toastr:false, io:false */
	/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[mod]" }] */

	angular.module('queue-manager', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ngMaterial', 'toastr', 'pascalprecht.translate', 'ngStorage', 'angular-virtual-keyboard', 'vcRecaptcha', 'monospaced.qrcode',
	// modules
	'mod.env', 'mod.auth', //'ja.qr',
	// Owner
	'mod.resources', _sentry2.default, _queues2.default, _components2.default, 'ngSentry']).constant('moment', moment).constant('_', _).constant('toastr', toastr).constant('io', io).config(_index2.default).config(_index4.default).run(_index6.default).service('SocketioService', _socketio2.default);

	// Modules

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	appConfig.$inject = ["$logProvider", "toastrConfig", "$translateProvider", "$mdThemingProvider", "$localStorageProvider", "config", "VKI_CONFIG", "$compileProvider", "$mdDateLocaleProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appConfig;

	/** @ngInject */

	function appConfig($logProvider, toastrConfig, $translateProvider, $mdThemingProvider, $localStorageProvider, config, VKI_CONFIG, $compileProvider, $mdDateLocaleProvider) {
	  // Enable log
	  $logProvider.debugEnabled(config.DEBUG_ENABLED);
	  // $mdAriaProvider.disabledWarnings();
	  // $templateFactoryProvider.shouldUnsafelyUseHttp(true);
	  // $resourceProvider.defaults.stripTrailingSlashes = false;

	  // Storage config
	  $localStorageProvider.setKeyPrefix('qm_');

	  // Pretchel Translate
	  $translateProvider.useStaticFilesLoader({
	    prefix: 'assets/i18n/',
	    suffix: '.json'
	  });
	  $translateProvider.registerAvailableLanguageKeys(['es', 'en', 'fr', 'pt'], {
	    'es': 'es',
	    'es-ES': 'es',
	    'en': 'en',
	    'en-*': 'en',
	    'fr': 'fr',
	    'fr-FR': 'fr',
	    'pt': 'pt'
	  });
	  $translateProvider.preferredLanguage('es');
	  $translateProvider.useLocalStorage();
	  $translateProvider.usePostCompiling(true);
	  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension):/);

	  // Set options third-party lib
	  toastrConfig.allowHtml = true;
	  toastrConfig.timeOut = 3000;
	  toastrConfig.maxOpened = 3;
	  toastrConfig.positionClass = 'toast-top-right';
	  toastrConfig.preventDuplicates = false;
	  toastrConfig.progressBar = true;
	  toastrConfig.closeButton = false;

	  // Example of a Spanish localization.
	  $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	  $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
	  $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	  $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
	  // Can change week display to start on Monday.
	  $mdDateLocaleProvider.firstDayOfWeek = 1;

	  // material theming and colors
	  // red, pink, purple, deep-purple, indigo, blue, light-blue, cyan, teal, green, light-green, lime, yellow, amber, orange, deep-orange, brown, grey, blue-grey

	  $mdThemingProvider.theme('default').primaryPalette('green').accentPalette('orange').warnPalette('red');
	  //.backgroundPalette('green');

	  // virtual keyboard
	  VKI_CONFIG.layout.Numerico = {
	    'name': 'Numerico', 'keys': [[['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5']], [['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['0', '0']], [['← Borrar', 'Bksp'], ['↵ Aceptar', 'Enter']]], 'lang': ["es"]
	  };

	  VKI_CONFIG.layout.All = {
	    'name': 'Name', 'keys': [[['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['0', '0']], [['q', 'q'], ['w', 'w'], ['e', 'e'], ['r', 'r'], ['t', 't'], ['y', 'y'], ['u', 'u'], ['i', 'i'], ['o', 'o'], ['p', 'p']], [['a', 'a'], ['s', 's'], ['d', 'd'], ['f', 'f'], ['g', 'g'], ['h', 'h'], ['j', 'j'], ['k', 'k'], ['l', 'l'], ['ñ', 'ñ'], ['← Borrar', 'Bksp']], [['z', 'z'], ['x', 'x'], ['c', 'c'], ['v', 'v'], ['b', 'b'], ['n', 'n'], ['m', 'm'], ['↵ Aceptar', 'Enter']]], 'lang': ["es"] };

	  VKI_CONFIG.layout.Name = {
	    'name': 'Name', 'keys': [[['q', 'q'], ['w', 'w'], ['e', 'e'], ['r', 'r'], ['t', 't'], ['y', 'y'], ['u', 'u'], ['i', 'i'], ['o', 'o'], ['p', 'p']], [['a', 'a'], ['s', 's'], ['d', 'd'], ['f', 'f'], ['g', 'g'], ['h', 'h'], ['j', 'j'], ['k', 'k'], ['l', 'l'], ['ñ', 'ñ'], ['← Borrar', 'Bksp']], [['z', 'z'], ['x', 'x'], ['c', 'c'], ['v', 'v'], ['b', 'b'], ['n', 'n'], ['m', 'm'], ['↵ Aceptar', 'Enter']]], 'lang': ["es"] };
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	routeConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routeConfig;

	/** @ngInject */

	function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  // .hashPrefix('!');

	  $urlRouterProvider.otherwise('/');

	  /**
	   * Se definen 4 rutas principales
	   * app: Inicio por defecto es la página de login
	   * queue: incluye counter(Pantallas) y request(totems)
	   * list
	   */
	  $stateProvider
	  // Dashboard component
	  .state('login', {
	    url: '/',
	    templateUrl: 'app/modules/auth/pages/login.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	    // resolve: {
	    //   skipIfLoggedIn: AuthService.skipIfLoggedIn
	    // }
	  }).state('app', {
	    abstract: true,
	    template: '<app class="full-height"></app>'
	  })
	  // Queue component
	  .state('queue', {
	    template: '<ui-view></ui-view>'
	  }).state('queue.request-index', {
	    url: '/request',
	    template: '<queues-request-index></queues-request-index>'
	  }).state('queue.request-queues', {
	    url: '/request/kiosk/:kioskId',
	    template: '<turn-request></turn-request>',
	    resolve: {
	      loginRequired: ["AuthService", "$state", "$q", "$mdDialog", function loginRequired(AuthService, $state, $q, $mdDialog) {
	        if (AuthService.isLoggedIn()) {
	          return $q.resolve(true);
	        } else {
	          $mdDialog.show($mdDialog.alert().title('Iniciar sesión').textContent('No ha iniciado sesión').ok('Entendido')).then(function () {
	            $state.go('login');
	          });
	          return $q.reject('Not authenticated');
	        }
	      }]
	    }
	  }).state('queue.request-queues-subservices', {
	    url: '/request/kiosk/:kioskId/service/:serviceId',
	    template: '<turn-request-subservices></turn-request-subservices>'
	  });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	runBlock.$inject = ["$log", "$rootScope", "$state", "$auth", "toastr"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = runBlock;

	/** @ngInject */

	function runBlock($log, $rootScope, $state, $auth, toastr) {

	  window.location.search;
	  if (window.angularLoadTimeout) {
	    clearTimeout(window.angularLoadTimeout);
	    var messageDiv = document.getElementById('redirect-message');
	    if (messageDiv) {
	      messageDiv.remove();
	    }

	    var styleEl = document.getElementById('angular-load-style');
	    if (styleEl) {
	      styleEl.remove();
	    }

	    if (window.__angularStart && Date.now() - window.__angularStart <= 30000) {} else {
	      toastr.info("Por favor, revise su conexión", "Conexión inestable", {
	        timeOut: 5000
	      });
	    }
	  }

	  $rootScope.$on('$stateChangeSuccess', function (event, toState) {

	    if (!$auth.isAuthenticated() && toState.name !== 'login' && toState.name.substr(0, 3) === 'app') {
	      event.preventDefault();
	      $state.go('login');
	    }

	    if (!$auth.isAuthenticated() && toState.name === 'queue.request-queues') {
	      event.preventDefault();
	      localStorage.clear();
	      $state.go('login');
	    }
	  });
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//Angular configuration generated based on env.config.yaml file
	exports.default = angular.module("mod.env", []).constant("config", {
	  "DEBUG_ENABLED": false,
	  "IS_PRE": false,
	  "VERSION": "1.0.0",
	  "api": {
	    "DSN": "https://95daf711c4d84bcf968f53b56deecffa@o227410.ingest.sentry.io/4504886987522048",
	    "BASE_URL": "https://api.bookthecity.app/api",
	    "BASE_URL_KIOSK": "https://request.bookthecity.app/",
	    "BASE_URL_ONLINE_KIOSK": "https://request-online.bookthecity.app/",
	    "WEBSOCKET_URL": "https://api.bookthecity.app",
	    "DASHBOARD_URL": "https://dashboard.bookthecity.app",
	    "PUBLIC_KEY_CAPTCHA": "6Lc69l4aAAAAACGfsjuFb14fp6e2WyEHDL4if9YK"
	  }
	});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _auth = __webpack_require__(6);

	var _auth2 = _interopRequireDefault(_auth);

	var _auth3 = __webpack_require__(7);

	var _auth4 = _interopRequireDefault(_auth3);

	var _auth5 = __webpack_require__(8);

	var _auth6 = _interopRequireDefault(_auth5);

	var _auth7 = __webpack_require__(9);

	var _auth8 = _interopRequireDefault(_auth7);

	var _auth9 = __webpack_require__(10);

	var _auth10 = _interopRequireDefault(_auth9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('mod.auth', ['satellizer']).config(_auth2.default).config(_auth4.default).run(_auth6.default).controller('AuthController', _auth8.default).factory('AuthService', _auth10.default);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	appConfig.$inject = ["$authProvider", "config"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appConfig;

	/** @ngInject */

	function appConfig($authProvider, config) {

	  //$authProvider.withCredentials = false;
	  $authProvider.tokenPrefix = 'auth';
	  $authProvider.baseUrl = config.api.BASE_URL;
	  $authProvider.loginUrl = '/employees/login';
	  $authProvider.logoutUrl = '/employees/logout';
	  $authProvider.tokenType = '';
	  //$httpProvider.interceptors.push('ExpiredInterceptor');
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	routeConfig.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routeConfig;

	/** @ngInject */

	function routeConfig($stateProvider) {

	  $stateProvider.state('logout', {
	    url: '/logout',
	    templateUrl: 'app/modules/auth/pages/redirect.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";

	runBlock.$inject = ["$log", "$auth", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = runBlock;

	/* @ngInject */

	function runBlock($log, $auth, AuthService) {

	  if ($auth.isAuthenticated()) {
	    AuthService.loadCurrentData();
	  }
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	AuthController.$inject = ["$rootScope", "$state", "$log", "toastr", "AuthService", "$translate", "$stateParams", "$localStorage", "config", "$auth"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AuthController;

	/* @ngInject */

	function AuthController($rootScope, $state, $log, toastr, AuthService, $translate, $stateParams, $localStorage, config, $auth) {
	  var vm = this;
	  this.$translate = $translate;
	  this.toastr = toastr;
	  this.$rootScope = $rootScope;
	  this.config = config;
	  this.$localStorage = $localStorage;
	  this.$auth = $auth;
	  this.window = window;
	  vm.version = 'v ' + this.config.VERSION;
	  vm.credentials = {};
	  vm.isWidget = true;
	  //vm.$translate = $translate;

	  vm.login = login;
	  vm.logout = logout;
	  vm.cleanAll = cleanAll;
	  vm._showPass = _showPass;
	  vm._show = false;

	  activate();
	  autoLogin();
	  function activate() {
	    if ('logout' === $state.current.name) {
	      logout();
	    }
	    return true;
	  }
	  function autoLogin() {
	    if (!window.location.search) {
	      vm.isWidget = false;
	      return;
	    }
	    var urlParams = new URLSearchParams(window.location.search);
	    var details = urlParams.get('q');
	    var id = '';
	    var token = '';

	    if (!details) {
	      id = urlParams.get('id');
	      token = urlParams.get('auth_token');
	    } else {
	      var params = atob(details).split('|');
	      id = params[0];
	      token = params[1];
	    }

	    localStorage.color = urlParams.get('color') ? urlParams.get('color') : 'FFF6F0';
	    localStorage.colorService = urlParams.get('colorService') ? urlParams.get('colorService') : 'ff914d';
	    $localStorage.current_kiosk_id = urlParams.get('kioskId');

	    vm.colorService = localStorage.colorService;
	    vm.color = localStorage.color;

	    AuthService.autoLogin(id, token).then(function () {
	      var current_role = $localStorage.currentRole.toUpperCase();
	      if (current_role == 'ADMIN' || current_role === 'ROOT') {
	        //this.$rootScope.isKiosk = true;
	        $state.go('queue.request-index');
	      }
	    }).catch(function (error) {
	      $log.error('AutoLogin error:', error);
	    });
	  }

	  function _showPass() {
	    vm.show = !vm.show;
	  }

	  function login(form) {
	    var _this = this;

	    if (form.$valid) {

	      // vm.credentials.username = vm.credentials.username.toLowerCase();
	      AuthService.login(vm.credentials).then(function () {
	        var current_role = $localStorage.currentRole.toUpperCase();
	        if (current_role == 'KIOSK') {
	          _this.$rootScope.isKiosk = true;
	          $state.go('queue.request-index');
	        }
	      }).catch(function (err) {
	        if (err.status == -1) {
	          $translate('app.login.OFFLINE').then(function (msg) {
	            toastr.error(msg);
	          });
	        } else {
	          var errorCode = '';
	          if (err && err.data && err.data.error) {
	            errorCode = err.data.error.code;
	          }
	          switch (errorCode) {
	            case 'LOGIN_FAILED_EMAIL_NOT_VERIFIED':
	              $translate('app.login.EMAIL_NOT_VERIFIED').then(function (msg) {
	                toastr.error(msg);
	              });
	              break;
	            case 'LOGIN_FAILED':
	              $translate('app.login.SIGNED_ERROR').then(function (msg) {
	                toastr.error(msg);
	              });
	              break;
	            default:
	              if (_this.$log) {
	                _this.$log.error(err);
	              }
	              $translate('app.login.SIGNED_FAIL').then(function (msg) {
	                toastr.error(msg);
	              });
	              break;
	          }
	        }
	      });
	    }
	  }

	  function logout() {
	    AuthService.logout().then(function () {
	      vm.$rootScope.isKiosk = false;
	      toastr.info('You have been logged out');
	      $state.go('login');
	    });
	  }

	  function cleanAll() {
	    vm.$localStorage.$reset();
	    vm.$auth.removeToken();
	  }
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";

	AuthService.$inject = ["$rootScope", "$auth", "$q", "$state", "_", "$localStorage", "Users", "SocketioService", "$log", "toastr", "config"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	exports.default = AuthService;

	/* @ngInject */

	function AuthService($rootScope, $auth, $q, $state, _, $localStorage, Users, SocketioService, $log, toastr, config) {

	  var _currentEstablishment = void 0;
	  var _currentUser = void 0;
	  var _currentRole;
	  var _currentOrganization = void 0;
	  var _currentLocation = void 0;
	  var _currentProfile = void 0;
	  var adminRoles = config.ADMIN_ROLES;

	  var service = {
	    login: login,
	    logout: logout,
	    autoLogin: autoLogin,
	    skipIfLoggedIn: skipIfLoggedIn,
	    loginRequired: loginRequired,
	    isLoggedIn: isLoggedIn,
	    allowSelectRoles: allowSelectRoles,
	    allowShowRoles: allowShowRoles,
	    hasValidRole: hasValidRole,
	    // setCurrentData: setCurrentData,
	    loadCurrentData: loadCurrentData,
	    getCurrentUser: getCurrentUser,
	    getCurrentLocation: getCurrentLocation,
	    getCurrentRole: getCurrentRole,
	    getCurrentOrganization: getCurrentOrganization,
	    deleteCurrentUser: deleteCurrentUser,
	    getCurrentProfile: getCurrentProfile,
	    getCurrentEstablishment: getCurrentEstablishment
	  };

	  return service;

	  function login(credentials) {
	    var deferred = $q.defer();
	    $auth.login(credentials).then(function (response) {
	      $auth.setToken(response.data.id);
	      // get User, Location, Organization
	      return Users.me({ id: response.data.userId, filter: { include: [{ relation: "location", "scope": { "include": ["organization"] } }, { relation: "secondaryLocations" }] } }).$promise;
	    }).then(function (user) {
	      _setCurrentData(user);
	      // SocketioService.connect();
	      deferred.resolve();
	    }).catch(function (err) {
	      // Handle errors here, such as displaying a notification for invalid email and/or password.
	      deferred.reject(err);
	      if ($auth.isAuthenticated()) {
	        $auth.logout();
	      }
	    });
	    return deferred.promise;
	  }

	  function autoLogin(id, token) {
	    $auth.setToken(token);
	    var usuario = Users.me({ id: id, filter: { include: [{ relation: "location", "scope": { "include": ["organization"] } }, { relation: "secondaryLocations" }] } }).$promise.then(function (user) {
	      _setCurrentData(user);
	    });
	    return usuario;
	  }

	  function logout() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      Users.logout().$promise.then(function () {
	        $localStorage.currentUser = _currentUser = $rootScope.currentUser = '';
	        $localStorage.currentRole = _currentRole = $rootScope.currentRole = '';
	        $auth.logout();
	        //SocketsService.close();
	        SocketioService.unSubscribeAll();
	      });
	    }
	    deferred.resolve();
	    return deferred.promise;
	  }

	  /**
	   * Helper auth functions
	   */
	  function skipIfLoggedIn() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      deferred.reject();
	    } else {
	      deferred.resolve();
	    }
	    return deferred.promise;
	  }

	  function loginRequired() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      deferred.resolve();
	    } else {
	      $state.go('login');
	    }
	    return deferred.promise;
	  }

	  function isLoggedIn() {
	    return !!$localStorage.currentUser;
	  }

	  /*
	   * Valida si el usuario esta autorizado
	   */
	  function hasValidRole(key) {

	    if (_currentUser.role === 'admin') {
	      return true;
	    }

	    var keys = _.split(key, '.');
	    var parent = keys[1];
	    var child = keys[2];
	    if (_currentProfile.roles[parent]) {
	      if (child) {
	        return _.includes(_currentProfile.roles[parent], child);
	      }
	      return true;
	    }
	    return false;
	  }
	  //{"name":"Oficina de Getafe","description":"","address":"Calle Velasco, 13, 28901 Getafe, Madrid","phone":null,"city":"Getafe","status":false,"askingName":true,"id":"5a019af19c2b393b465a8f2f","organizationId":"5a019a6a9c2b393b465a8f2e","organization":{"name":"CloudAppi","description":"","address":"Calle Velasco, 13, 28901 Getafe, Madrid","phone":null,"id":"5a019a6a9c2b393b465a8f2e"}}
	  function _setCurrentData(user) {
	    $localStorage.currentUser = '';
	    $localStorage.currentRole = '';
	    $localStorage.currentLocation = '';
	    $localStorage.currentOrganization = '';
	    $localStorage.current_kiosk_id = '';
	    $localStorage.currentUser = _currentUser = $rootScope.currentUser = user;
	    $localStorage.currentRole = _currentRole = $rootScope.currentRole = _.upperCase(_currentUser.role);
	    $localStorage.currentLocation = _currentLocation = $rootScope.currentLocation = user.location;
	    $localStorage.currentOrganization = _currentLocation.organization = $rootScope.currentOrganization = user.location.organization;
	    $rootScope.organization_logo = user.location.organization.logo;

	    if (user.secondaryLocations && user.secondaryLocations.length > 0) {
	      var exists = user.secondaryLocations.some(function (loc) {
	        return loc.id === user.location.id;
	      });
	      var locations = exists ? user.secondaryLocations : [user.location].concat(_toConsumableArray(user.secondaryLocations));
	      $localStorage.currentAllLocations = locations.map(function (loc) {
	        return {
	          id: loc.id,
	          name: loc.name
	        };
	      });
	    } else if (user.locationId) {
	      $localStorage.currentAllLocations = [{
	        id: user.locationId,
	        name: user.location.name
	      }];
	    } else {
	      $localStorage.currentAllLocations = [];
	    }

	    // const locs = _.map(locations, loc => {
	    //   return _.pick(loc.location, ['id', 'name', 'description'])
	    // });
	    // // TODO: Por defecto asignamos la 1ra location, esto se debe seleccionar o filtrar dependiendo del rol del usuario
	    // $localStorage.currentLocation = _currentLocation = $rootScope.currentLocation = locs[0];

	    //user.profile.roles = HelperService.parseRoles(user.profile.roles);
	    // $localStorage.currentLocations = _currentLocations = $rootScope.currentLocations = currentLocations;
	    //$localStorage.currentProfile = _currentProfile = $rootScope.currentProfile = $rootScope.currentUser.profile;
	  }

	  /*
	   * Carga los datos cuando se refresca en el navegador
	   */
	  function loadCurrentData() {
	    _currentUser = $rootScope.currentUser = $localStorage.currentUser;
	    _currentRole = $rootScope.currentRole = $localStorage.currentRole;
	    _currentOrganization = $rootScope.currentOrganization = $localStorage.currentOrganization;
	    _currentLocation = $rootScope.currentLocation = $localStorage.currentLocation;
	    //_currentProfile = $rootScope.currentProfile = $localStorage.currentProfile;
	  }

	  function getCurrentUser() {
	    return _currentUser;
	  }

	  function deleteCurrentUser() {
	    //$localStorage.currentUser = _currentUser = $rootScope.currentUser = '';
	  }

	  function getCurrentProfile() {
	    return _currentProfile;
	  }

	  function getCurrentEstablishment() {
	    return _currentEstablishment;
	  }

	  function getCurrentRole() {
	    return _currentRole;
	  }

	  function getCurrentOrganization() {
	    return _currentOrganization;
	  }

	  function getCurrentLocation() {
	    return _currentLocation;
	  }

	  function allowSelectRoles(role_option) {
	    var role_order = void 0;
	    switch ($localStorage.currentRole) {
	      case "ROOT":
	        role_order = 1;
	        break;
	      case "SUPERADMIN":
	        role_order = 2;
	        break;
	      case "ADMIN":
	        role_order = 3;
	        break;
	    }

	    if (role_order < role_option) {
	      return true;
	    } else {
	      return false;
	    }
	  }

	  function allowShowRoles(userRole) {
	    var role_option = adminRoles.indexOf(userRole);
	    var role_order = adminRoles.indexOf($localStorage.currentRole);
	    if (role_order > role_option && role_option != -1) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var componentsModule = angular.module('mod.components', []).name;

	exports.default = componentsModule;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _organizations = __webpack_require__(13);

	var _organizations2 = _interopRequireDefault(_organizations);

	var _establishments = __webpack_require__(14);

	var _establishments2 = _interopRequireDefault(_establishments);

	var _kiosks = __webpack_require__(15);

	var _kiosks2 = _interopRequireDefault(_kiosks);

	var _employee = __webpack_require__(16);

	var _employee2 = _interopRequireDefault(_employee);

	var _users = __webpack_require__(17);

	var _users2 = _interopRequireDefault(_users);

	var _queues = __webpack_require__(18);

	var _queues2 = _interopRequireDefault(_queues);

	var _bookitit = __webpack_require__(19);

	var _bookitit2 = _interopRequireDefault(_bookitit);

	var _queue = __webpack_require__(20);

	var _queue2 = _interopRequireDefault(_queue);

	var _token = __webpack_require__(21);

	var _token2 = _interopRequireDefault(_token);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = resources;
	// TODO: Para evitar romper crean los nuevos rescursos usando solo el plural
	//import AuthResource from './auth.resource';

	var resources = angular.module('mod.resources', [])
	//.service('AuthResource', AuthResource)
	.service('OrganizationsResource', _organizations2.default).service('EstablishmentsResource', _establishments2.default).service('KiosksResource', _kiosks2.default).service('EmployeeResource', _employee2.default).service('Users', _users2.default).service('Queues', _queues2.default).service('BookititResource', _bookitit2.default).service('QueueResource', _queue2.default).service('TokenResource', _token2.default).name;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsResource =

	/** ngInject */
	function OrganizationsResource(config, $resource) {
	  _classCallCheck(this, OrganizationsResource);

	  var endpoint = config.api.BASE_URL + '/organizations/:id/:type';

	  var organizationsResource = $resource(endpoint, {}, {
	    getOrganizationData: {
	      method: 'GET',
	      params: { organizationId: '@organizationId' }
	    }
	  });
	  return organizationsResource;
	};

	OrganizationsResource.$inject = ['config', '$resource'];

	exports.default = OrganizationsResource;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EstablishmentsResource =
	/** ngInject */
	function EstablishmentsResource(config, $resource) {
	  _classCallCheck(this, EstablishmentsResource);

	  var endpoint = config.api.BASE_URL + '/locations/:id/:type';

	  var establishmentsResource = $resource(endpoint, {}, {

	    get: {
	      method: 'GET',
	      isArray: true
	    },

	    getDevicesByEstablishment: {
	      method: 'GET',
	      params: { id: '@establishmentId', type: '@type' },
	      isArray: true
	    },

	    getUsersByLocation: {
	      method: 'GET',
	      params: { id: '@id', type: '@type', filter: '@filter' },
	      isArray: true
	    }

	  });

	  return establishmentsResource;
	};

	EstablishmentsResource.$inject = ['config', '$resource'];

	exports.default = EstablishmentsResource;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var KiosksResource =
	/** ngInject */
	function KiosksResource(config, $resource) {
	  _classCallCheck(this, KiosksResource);

	  var endpoint = config.api.BASE_URL + '/kiosks/:id/:type/:option/:fk';

	  var kiosksResource = $resource(endpoint, {
	    establishmentId: '@establishmentId'
	  },
	  ///kiosks/{id}/queues
	  {
	    getKioskData: {
	      method: 'GET',
	      params: { id: '@kioskId' }
	    },
	    getServices: {
	      method: 'GET',
	      params: { filter: '@filter' },
	      isArray: true
	    }
	  });

	  return kiosksResource;
	};

	KiosksResource.$inject = ['config', '$resource'];

	exports.default = KiosksResource;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EmployeeResource =

	/** ngInject */
	function EmployeeResource(config, $resource) {
	  _classCallCheck(this, EmployeeResource);

	  var endpoint = config.api.BASE_URL + '/employees/sendEmail?email=' + ':email' + '&subject=' + ':subject' + '&msg=' + ':msg' + '&html=' + ':html';

	  var employeeResource = $resource(endpoint, {}, {
	    getEmail: {
	      method: 'GET',
	      params: { email: '@email', subject: '@subject', msg: '@msg', html: '@html' }
	      // isArray: true 
	    }
	  });

	  return employeeResource;
	};

	EmployeeResource.$inject = ['config', '$resource'];

	exports.default = EmployeeResource;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Users =

	/** ngInject */
	function Users(config, $resource) {
	  _classCallCheck(this, Users);

	  //var endpoint = config.api.BASE_URL + '/establishments/:establishmentId/employees';
	  var endpoint = config.api.BASE_URL + '/employees/:id/:type/:typeId';

	  var usersResource = $resource(endpoint, {
	    establishmentId: '@establishmentId',
	    id: '@userId'
	  }, {
	    logout: { method: 'POST', params: { id: 'logout' } },
	    me: { method: 'GET' }
	  });
	  return usersResource;
	};

	Users.$inject = ['config', '$resource'];

	exports.default = Users;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Queues =
	/** ngInject */
	function Queues(config, $resource) {
	  _classCallCheck(this, Queues);

	  var endpoint = config.api.BASE_URL + '/turns/:id/:resource/:resourceId';
	  var endpoint2 = config.api.BASE_URL + '/queueTypeByKiosk';

	  var queues = $resource(endpoint, { id: '@id' }, {
	    createTurn: {
	      method: 'POST'
	    }
	  });

	  var queuesInstructions = $resource(endpoint2, { establishmentId: '@establishmentId' }, {
	    getRel: { method: 'GET', isArray: true }
	  });

	  return {
	    id: queues.id,
	    createTurn: queues.createTurn,
	    getRel: queuesInstructions.getRel
	  };
	};

	Queues.$inject = ['config', '$resource'];

	exports.default = Queues;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BookititResource =
	/** ngInject */
	function BookititResource(config, $resource) {
	  _classCallCheck(this, BookititResource);

	  var endpoint = config.api.BASE_URL + '/bookitits/:id/:resource';

	  var bookititResource = $resource(endpoint, { organizationId: '@organizationId' }, {

	    get: {
	      method: 'GET',
	      isArray: true
	    },

	    getById: {
	      method: 'GET',
	      params: { id: '@bookititId' }
	    },

	    getAgendasByOrganizationId: {
	      method: 'GET',
	      params: { id: '@organizationId', resource: 'agendas' }
	    },

	    getEventsByOrganizationId: {
	      method: 'GET',
	      params: { id: '@organizationId', resource: 'events', startDate: '@startDate', endDate: '@endDate', serviceID: '@serviceID', email: '@email' },
	      isArray: true
	    },
	    getEventsByField: {
	      method: 'GET',
	      params: { id: '@organizationId', resource: 'eventsByField', todayDate: '@todayDate', hour: '@hour', serviceID: '@serviceID', field: '@field' }
	    },
	    setEventCaller: {
	      method: 'POST',
	      params: { id: '@organizationId', resource: 'setEventCaller' },
	      body: JSON.stringify({ updatedAppointment: '@updatedAppointment' })
	    }

	  });

	  return bookititResource;
	};

	BookititResource.$inject = ['config', '$resource'];

	exports.default = BookititResource;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var QueueResource =
	/** ngInject */
	function QueueResource(config, $resource) {
	  _classCallCheck(this, QueueResource);

	  var endpoint = config.api.BASE_URL + '/queues/:id';

	  var queueResource = $resource(endpoint, {}, {

	    getById: {
	      method: 'GET',
	      params: { id: '@queueId' }
	    }

	  });
	  return queueResource;
	};

	QueueResource.$inject = ['config', '$resource'];

	exports.default = QueueResource;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TokenResource =

	/** ngInject */
	function TokenResource(config, $resource) {
	  _classCallCheck(this, TokenResource);

	  var endpoint = config.api.BASE_URL + '/employees/:id/:type/';

	  var tokenResource = $resource(endpoint, { id: '@id' }, {
	    getTokenAccess: { method: 'POST', params: { type: 'accessTokens' }, hasBody: false },

	    logout: { method: 'POST', params: { type: 'logout', access_token: '@access_token' } }
	  });

	  return tokenResource;
	};

	TokenResource.$inject = ['config', '$resource'];

	exports.default = TokenResource;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _turnRequest = __webpack_require__(23);

	var _turnRequest2 = _interopRequireDefault(_turnRequest);

	var _common = __webpack_require__(27);

	var _common2 = _interopRequireDefault(_common);

	var _turnRequestSubservices = __webpack_require__(32);

	var _turnRequestSubservices2 = _interopRequireDefault(_turnRequestSubservices);

	var _request = __webpack_require__(35);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * components/components.js
	 *
	 * Module that contains the specific components for the application.
	 */
	var queues = angular.module('queues', [_turnRequest2.default, _common2.default, _turnRequestSubservices2.default]).component('queuesRequestIndex', _request.RequestComponent).name;
	// Components
	exports.default = queues;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _turnRequest = __webpack_require__(24);

	//import RequestService from './turn-request.service';

	var request = angular.module('turnRequest', []).component('turnRequest', _turnRequest.TurnRequestComponent)
	//.service('RequestService', RequestService)
	.name;

	exports.default = request;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TurnRequestComponent = undefined;

	var _turnRequest = __webpack_require__(25);

	var _turnRequest2 = _interopRequireDefault(_turnRequest);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TurnRequestComponent = exports.TurnRequestComponent = {
	  controller: _turnRequest2.default,
	  templateUrl: 'app/modules/queues/turn-request/turn-request.html'
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _index = __webpack_require__(26);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var RequestController = function () {
	  /** @ngInject */
	  RequestController.$inject = ["$scope", "$rootScope", "$translate", "toastr", "$mdDialog", "config", "KiosksResource", "$timeout", "$document", "SocketioService", "$stateParams", "Queues", "$localStorage", "AuthService", "$state", "OrganizationsResource", "EmployeeResource", "vcRecaptchaService", "BookititResource", "QueueResource", "TokenResource", "EstablishmentsResource", "queuesTypes", "instructions", "showInstructions"];
	  function RequestController($scope, $rootScope, $translate, toastr, $mdDialog, config, KiosksResource, $timeout, $document, SocketioService, $stateParams, Queues, $localStorage, AuthService, $state, OrganizationsResource, EmployeeResource, vcRecaptchaService, BookititResource, QueueResource, TokenResource, EstablishmentsResource, queuesTypes, instructions, showInstructions) {
	    var _this2 = this;

	    _classCallCheck(this, RequestController);

	    // private
	    var $this = this;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.Queues = Queues;
	    this.AuthService = AuthService;
	    this.KiosksResource = KiosksResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.EmployeeResource = EmployeeResource;
	    this.BookititResource = BookititResource, this.QueueResource = QueueResource, this.TokenResource = TokenResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.$stateParams = $stateParams;
	    this.$localStorage = $localStorage;
	    this.$document = $document;
	    this.SocketioService = SocketioService;
	    this.window = window;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$state = $state;
	    this.$mdDialog = $mdDialog;
	    var ref = this;
	    this.$timeout = $timeout;
	    this.determinateValue = 105;
	    this.determinatePhoneValue = 30000;
	    var timeout = "";
	    var timerValue = 0;
	    var numbers = "";
	    this.phone = "";
	    this.$rootScope.remainingTurns = {};
	    this.$rootScope.isClicked = false;
	    this.$rootScope.remainingGlobalTurns = $rootScope.remainingGlobalTurns || 0;
	    // this.$rootScope.css = this.$localStorage.currentOrganization.style_link;
	    this.uniqueKiosk = false;
	    $this.location = this.$localStorage.currentLocation.name;

	    this.isKioskClosed = false;
	    this.isNetworkError = false;
	    this.isOpen = true;
	    this.selectedMode = "md-fling";
	    this.showManualPrint = false;

	    this._kioskId = '';
	    this.areServiceId = false;
	    var legatTerms = "Los datos personales tratados se conservarán en todo caso mientras sean necesarios para la finalidad del tratamiento, y se suprimirán a solicitud del interesado, o una vez finalizado el tratamiento sin perjuicio de su conservación por los plazos establecidos para atender responsabilidades.";

	    this.user_name_is_valid = true;
	    this.name_is_valid_spaces = false;
	    this.dni_is_valid = true;
	    this.dni_is_valid = true;
	    this.spaces_is_valid = true;
	    this.textInvalid = new RegExp(/^[A-Za-z0-9\s]+$/g);
	    this.spaceTrim = new RegExp(/^[A-Za-z\s]+$/g);
	    this.spaceTrimS = new RegExp(/^[\s]+$/g);
	    this.queuesTypes = queuesTypes;
	    this.instructions = instructions;
	    this.showInstructions = showInstructions;
	    this.dni_bookitit_is_valid = true;
	    this.field_bookitit_is_valid = true;
	    var debug_enabled = config.DEBUG_ENABLED;
	    var queues = [];
	    var queuesLoaded = false;
	    var isHelpMode = false;
	    var isAsking = true;
	    this.widgetId = null;
	    this.vcRecaptchaService = vcRecaptchaService;
	    this.captchaIsValid = false;
	    this.$localStorage.captchaIsValid = this.captchaIsValid;
	    this.publicKeyCaptcha = config.api.PUBLIC_KEY_CAPTCHA;
	    var lang = this.$localStorage.currentUser.language ? this.$localStorage.currentUser.language : this.window.navigator.language;
	    $this.isLoggingOut = false;

	    this.$rootScope.isPrinting = false;

	    setTimeout(function () {
	      $this.selectLanguage(lang);
	    }, 5000);

	    function getOrganizationData(hasBackground) {
	      var _this = this;

	      this.OrganizationsResource.getOrganizationData({
	        id: $this.$localStorage.currentOrganization.id
	      }).$promise.then(function (data) {
	        if (!hasBackground && data.img_link) {
	          $this.$localStorage.currentOrganization.img_link = data.img_link;
	        }
	        $this.$localStorage.currentOrganization.logo_link = data.logo_link;
	        _this.ticketLogo = data.logo_link;
	      }).catch(function (error) {
	        if (_this.$log) {
	          _this.$log.error(error);
	        }
	      });
	    }

	    function resetControl() {
	      if ($scope.dniForm) {
	        $scope.dniForm.$setPristine();
	        $scope.dniForm.$setUntouched();
	      }
	      if ($scope.dniNameForm) {
	        $scope.dniNameForm.$setPristine();
	        $scope.dniNameForm.$setUntouched();
	      }
	    }

	    function _sendCustomField(field, resp) {
	      switch (field) {
	        case "name":
	          if (!resp || !this.user_name_is_valid) {
	            this.user_name_is_valid = false;
	            return;
	          }
	          this._close();
	          this.name = resp;
	          this.searchServicesBookititQueue();
	          document.getElementById("user_name").value = "";
	          break;
	        case "dni":
	          if (!resp || !this.dni_is_valid) {
	            this.dni_is_valid = false;
	            return;
	          }
	          this._close();
	          this.dni = resp;
	          this.searchServicesBookititQueue();
	          document.getElementById("dni").value = "";
	          break;
	        case "email":
	          this._close();
	          this.email = resp;
	          this.searchServicesBookititQueue();
	          document.getElementById("user_email").value = "";
	          break;
	        case "name_phone":
	          if (!resp || !this.user_name_is_valid) {
	            this.user_name_is_valid = false;
	            return;
	          }
	          if (!this.numbers) {
	            return;
	          }
	          this._close();
	          this.phone = this.numbers;
	          this.name = resp;
	          this.searchServicesBookititQueue();

	          break;
	        case "dni_phone":
	          if (!resp || !this.dni_is_valid || !this.numbers) {
	            this.dni_is_valid = false;
	            return;
	          }
	          this._close();
	          this.phone = this.numbers;
	          this.dni = resp;
	          this.searchServicesBookititQueue();

	          document.getElementById("dni_phone").value = "";
	          break;
	        case "email_phone":
	          if (!this.numbers) {
	            return;
	          }
	          this._close();
	          this.phone = this.numbers;
	          this.email = resp;
	          this.searchServicesBookititQueue();
	          document.getElementById("phone_email_email").value = "";
	          break;
	        case "field_bookitit":
	          if (resp.indexOf("@") > -1) {
	            this._validField("email_bookitit", resp);
	          } else if (resp.indexOf("@") < 0 && resp.length >= 9 && !isNaN(resp)) {
	            this.field_bookitit_is_valid = true;
	          } else {
	            this._validField("dni_bookitit", resp);
	          }
	          if (!resp || !this.field_bookitit_is_valid) {
	            this.field_bookitit_is_valid = false;
	            return;
	          } else this.getVerifyCita(resp);
	          break;
	        case "dni_name":
	          if (!resp || !this.dni_is_valid || !this.user_name_is_valid) {
	            this.dni_is_valid = false;
	            this.user_name_is_valid = false;
	            return;
	          }
	          this._close();
	          this.resetControl();
	          this.dni = resp;
	          this.searchServicesBookititQueue();
	      }
	    }

	    /**************** Bookitit **************** */

	    ////Get services of bookitit the actual queue before forms
	    var searchServicesBookititQueue = function searchServicesBookititQueue() {
	      _this2.QueueResource.getById({
	        id: _this2.$rootScope.currentQueue.queueId
	      }).$promise.then(function (result) {
	        if (result.hasBokititServices) {
	          _this2.$localStorage.bokititServices = result.bokititServices;
	          _this2._showDniBookititForm2();
	        } else {
	          _this2._getTurn();
	        }
	      }).catch(function (error) {
	        _this2.$rootScope.isClicked = false;
	        if (_this2.$log) {
	          _this2.$log.error(error);
	        }
	      });
	    };

	    //Open modal with input dni  before forms

	    function _showDniBookititForm2() {
	      var _this3 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#myDniBookititDialog",
	        parent: angular.element(document.body),
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "$ctrl",
	        clickOutsideToClose: true
	      }).then(function () {

	        if (_this3.$log) {
	          _this3.$log.debug('_showDniBookititForm2 resolved successfully');
	        }
	      }).catch(function (error) {
	        _this3.$rootScope.isClicked = false;
	        _this3.name = "";
	        _this3.dni_bookitit = "";
	        $this.$scope.dniBookititForm.$setPristine();
	        $this.$scope.dniBookititForm.$setUntouched();
	        $this.$scope.nameForm.$setPristine();
	        $this.$scope.nameForm.$setUntouched();
	        if (_this3.$log) {
	          _this3.$log.error(error);
	        }
	      });
	    }

	    //Verify if exist events today in the services bokitit relations
	    var getVerifyCita = function getVerifyCita(fieldInput) {
	      var field = fieldInput;
	      var bokititServicesId = _this2.$localStorage.bokititServices;
	      var organizationId = _this2.$localStorage.currentOrganization.id;
	      var serviceId = null;

	      var i = 0;
	      var band = false;
	      var messageTime = false;

	      // bokititServicesId.forEach((serviceId) => {
	      _this2.BookititResource.getEventsByField({
	        id: organizationId,
	        todayDate: _this2.getFormatDate(new Date()), //'2022-04-19',
	        hour: _this2.getFormatHour(),
	        serviceID: serviceId,
	        field: field
	      }).$promise.then(function (result) {
	        i++; //cant of services where is search

	        if (!result.status) {
	          messageTime = true; // if no data
	          result.code = 1;
	        }
	        // else if (result.code == 0)
	        //   messageTime = true; // if exists data to today but not range time
	        // else if (result.code == 1)
	        //   messageTime = true; // if exists data to today but not range time
	        else if (result.data && result.data.id && band === false) {
	            if (_this2.$localStorage.printedAppointments && _this2.$localStorage.printedAppointments.indexOf(result.data.id) > -1) {
	              _this2.$translate("app.request.APPOINTMENT_ONLINE_PRINTED").then(function (msg) {
	                return _this2.toastr.info(msg);
	              });
	              _this2._cancelDniBokitit();
	              _this2.resetControl();
	              document.body.click();
	            } else {
	              //if exists data into service getTurn

	              _this2.$localStorage.currentAppointment = result.data;
	              band = true;
	              _this2.$translate("app.request.APPOINTMENT_ONLINE_TRUE").then(function (msg) {
	                return _this2.toastr.info(msg);
	              });
	              _this2._getTurn(band);
	              _this2._close();
	            }
	          }

	        // if (i === bokititServicesId.length && band === false) {
	        //   //if not found data into all services of bookitit

	        //   if (messageTime) {
	        //     this.$translate(
	        //       "app.request.APPOINTMENT_ONLINE_FALSE_TIME"
	        //     ).then((msg) => this.toastr.info(msg));
	        //   } else {
	        //     this.$translate("app.request.APPOINTMENT_ONLINE_FALSE").then(
	        //       (msg) => this.toastr.info(msg)
	        //     );
	        //   }
	        // }
	        if (messageTime && result.code === 0) {
	          _this2.$translate("app.request.APPOINTMENT_ONLINE_FALSE_TIME").then(function (msg) {
	            return _this2.toastr.info(msg);
	          });
	        } else if (messageTime && result.code === 1) {
	          _this2.$translate("app.request.APPOINTMENT_ONLINE_FALSE").then(function (msg) {
	            return _this2.toastr.info(msg);
	          });
	        }
	        _this2._cancelDniBokitit();
	        _this2.resetControl();
	        document.body.click();
	      }).catch(function (error) {
	        if (_this2.$log) {
	          _this2.$log.error(error);
	        }
	        _this2.$translate("app.request.APPOINTMENT_ONLINE_ERROR").then(function (msg) {
	          return _this2.toastr.error(msg);
	        });
	        _this2._cancelDniBokitit();
	        _this2.resetControl();
	        document.body.click();
	      });
	      // });

	      _this2.dni_bookitit = "";
	      _this2.field_bookitit = "";
	      $this.$scope.dniBookititForm.$setPristine();
	      $this.$scope.dniBookititForm.$setUntouched();
	      $this.$scope.nameForm.$setPristine();
	      $this.$scope.nameForm.$setUntouched();
	      $this.$scope.dniPhoneForm.$setPristine();
	      $this.$scope.dniPhoneForm.$setUntouched();
	      _this2.$scope.dniForm.$setPristine();
	      _this2.$scope.dniForm.$setUntouched();
	      $this.$scope.userForm.$setPristine();
	      $this.$scope.userForm.$setUntouched();
	      $this.$scope.namePhoneForm.$setPristine();
	      $this.$scope.namePhoneForm.$setUntouched();
	    };

	    //cancel dni bokititi and request turn
	    function _cancelDniBokitit() {
	      $mdDialog.cancel();
	      this.phone = "";
	      this.name = "";
	      this.dni = "";
	      this.numbers = "";
	      this.dni_is_valid = true;
	      this.isAsking = true;
	      this._stopTimer();
	      this.phone = "";
	      this.name = "";
	      this.numbers = "";
	      this.dni = "";
	      this.dni_is_valid = true;
	      this.dni_bookitit = "";
	      $this.$scope.dniBookititForm.$setPristine();
	      $this.$scope.dniBookititForm.$setUntouched();
	      $this.$scope.nameForm.$setPristine();
	      $this.$scope.nameForm.$setUntouched();
	      $this.$scope.dniPhoneForm.$setPristine();
	      $this.$scope.dniPhoneForm.$setUntouched();
	      this.$scope.dniForm.$setPristine();
	      this.$scope.dniForm.$setUntouched();
	      $this.$scope.userForm.$setPristine();
	      $this.$scope.userForm.$setUntouched();
	      $this.$scope.namePhoneForm.$setPristine();
	      $this.$scope.namePhoneForm.$setUntouched();
	    }

	    //Format date of bookitit
	    var getFormatDate = function getFormatDate(date) {
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate();
	      return year + "-" + month + "-" + day;
	    };

	    //Format hour
	    var getFormatHour = function getFormatHour() {
	      var date = new Date();
	      var _ref = [date.getHours(), date.getMinutes(), date.getSeconds()],
	          hour = _ref[0],
	          minutes = _ref[1],
	          seconds = _ref[2];

	      return hour + ":" + minutes;
	    };

	    function _show_legalTerms() {
	      var $this = this;
	      var confirm = $mdDialog.confirm().title("Debes aceptar la politica de datos").textContent(legatTerms).ariaLabel("Lucky day").ok("Acepto").cancel("No quiero");

	      $mdDialog.show(confirm).then(function () {
	        $this.legalTerms = new Date();
	        $this._getTurn();
	      }, function () {
	        $this.name = undefined;
	        $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title("No podemos seguir").textContent("Lo sentimos, sin aceptar las condiciones legales no puedes seguir adelante con el sorteo").ok("Salir"));
	      });
	    }

	    function _sendPhone(typeButton) {
	      if (!this.numbers && typeButton !== "btnCancel") {
	        return;
	      }
	      this.phone = this.numbers;
	      this._close();
	      this.searchServicesBookititQueue();
	    }

	    function _sendCode() {
	      this._close();
	      this.searchServicesBookititQueue();
	    }

	    function _showTicketDialog(ev) {
	      var _this4 = this;

	      if (this.$rootScope.isPrinting) return;
	      this.$rootScope.isPrinting = true;
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#myTicket",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this4;
	        },
	        controllerAs: "ctrl",
	        onComplete: function onComplete() {
	          return _this4._printDirective(ev);
	        } //Only in Kiosko Fisico
	      }).then(function () {}, function () {
	        $this.$rootScope.isClicked = false;
	        ref.isAsking = true;
	      }).finally(function () {
	        _this4.$rootScope.isPrinting = false;
	      });
	    }

	    function _showTimeBookingDialog(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#myBookingMessage",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl"
	      }).then(function () {
	        $this.$rootScope.isClicked = false;
	      }, function () {
	        $this.$rootScope.isClicked = false;
	      });
	    }

	    function _receiveAdvice() {
	      this.isAsking = false;
	      this._reStartTimer(this.determinatePhoneValue);
	    }

	    function _finishDialogs() {
	      this._stopTimer();
	      $mdDialog.hide();
	      this.isAsking = true;
	    }

	    function _startTimer(value) {
	      // the Determinate loader.
	      ref.timerValue = value;
	      timeout = $timeout(function () {
	        ref.timerValue -= 1;
	        if (ref.timerValue < 0) {
	          $timeout.cancel(timeout);
	          $mdDialog.cancel();
	        }
	      }, 100);
	    }

	    function _reStartTimer(value) {
	      this._stopTimer();
	      this._startTimer(value);
	    }

	    function _stopTimer() {
	      $timeout.cancel(timeout);
	    }

	    function _close() {
	      this._stopTimer();
	      $mdDialog.hide();
	      this.isAsking = true;
	    }

	    function _cancel() {
	      $mdDialog.cancel();
	      this.phone = "";
	      this.name = "";
	      this.dni = "";
	      this.numbers = "";
	      this.dni_is_valid = true;
	      this.isAsking = true;
	      this._stopTimer();
	      this.phone = "";
	      this.name = "";
	      this.numbers = "";
	      this.dni = "";
	      this.dni_is_valid = true;
	    }

	    function back() {
	      this.prueba = this.$localStorage.currentUser.id;
	      this.auth_token = localStorage.auth_token;
	      this.location = this.$localStorage.currentLocation.id;
	      window.location = config.api.BASE_URL + "/panels?id=" + this.prueba + "&auth_token=" + this.auth_token + "&location=" + this.location;
	    }

	    function backOffice(kioskId, token) {
	      $this.dataQR = config.api.BASE_URL_ONLINE_KIOSK + "kiosk/" + kioskId + "?auth_token=" + token;
	    }

	    var createInitialQr = function createInitialQr(locationId, statusQr, kioskId) {
	      if (statusQr && !$this.$localStorage.kiosk_online_token) {
	        _this2.EstablishmentsResource.getUsersByLocation({
	          id: locationId,
	          type: "employees"
	        }).$promise.then(function (user) {
	          if (user.length > 0) {
	            _this2.TokenResource.getTokenAccess({ id: user[0].id }).$promise.then(function (response) {
	              backOffice(kioskId, response.id);
	              $this.$localStorage.kiosk_online_token = response.id;
	              $this.$localStorage.kiosk_online_userId = response.userId;
	            }).catch(function (err) {
	              if (_this2.$log) {
	                _this2.$log.error(err);
	              }
	            });
	          }
	        }).catch(function (error) {
	          if (_this2.$log) {
	            _this2.$log.error(error);
	          }
	        });
	      } else if (statusQr && $this.$localStorage.kiosk_online_token) {
	        backOffice(kioskId, $this.$localStorage.kiosk_online_token);
	      }
	    };

	    function _getTurn() {
	      var _this6 = this;

	      var onlineAppointment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      var $this = this;
	      var qm_currentLocation = JSON.parse(localStorage.getItem("qm_currentLocation"));
	      var user_phone = $this.numbers == "" ? null : Number($this.numbers);
	      var name = $this.name ? $this.name : "";
	      var user_dni = $this.dni ? $this.dni : "";
	      var user_email = $this.email ? $this.email : "";
	      var user_code = $this.code ? $this.code : "";
	      var service_type = $this.code ? "booking" : "secuential";
	      var organization_name = $this.$localStorage.currentOrganization.name;
	      var dateLegalTerms = $this.legalTerms;
	      var timeAlert = $this.$rootScope.currentQueue.timeAlert;
	      // TODO: Refactorizar, por falta de tiempo se hace aquí, pero el back debería automatizar algunas de estas tareas
	      var filter = "{\"where\":{\"queueTypeId\": \"" + $this.$rootScope.currentQueue.id + "\"}}";
	      $this.Queues.getRel({ filter: filter }).$promise.then(function (result) {
	        if (result.length > 0 && result[0].instructions) {
	          $this.instructions = result[0].instructions;
	        }
	        if (qm_currentLocation.showInstrucciones) {
	          $this.showInstructions = true;
	        } else {
	          $this.showInstructions = false;
	        }
	      }).catch(function (error) {
	        if (_this6.$log) {
	          _this6.$log.error(error);
	        }
	        _this6.isNetworkError = true;
	        _this6.$translate("app.kiosks.ERROR_DETAILKIOSK").then(function (errorMsg) {
	          _this6.toastr.error(errorMsg, "Error");
	        }).catch(function (err) {
	          if (_this6.$log) {
	            _this6.$log.error(err);
	          }
	        });
	      });
	      var turn = {
	        kioskId: $this.$localStorage.current_kiosk_id,
	        queueTypeId: $this.$rootScope.currentQueue.id,
	        phone: user_phone,
	        name: name,
	        dni: user_dni,
	        email: user_email,
	        bookingCode: user_code,
	        organization_name: organization_name,
	        serviceType: service_type,
	        dateLegalTerms: dateLegalTerms,
	        timeAlert: timeAlert,
	        onlineAppointment: onlineAppointment
	      };
	      if (this.$localStorage.currentAppointment) {
	        var currentAppointment = this.$localStorage.currentAppointment;
	        turn.bookingAgendaId = currentAppointment.agenda_id;
	        turn.bookingId = currentAppointment.id;
	        turn.bookingServiceId = currentAppointment.service_id;
	        turn.bookingUserId = currentAppointment.user_id;
	      }
	      $this.Queues.createTurn({}, turn).$promise.then(function (result) {
	        $this.$scope.bookingForm.$setPristine();
	        $this.$scope.bookingForm.$setUntouched();
	        $this.numbers = "";
	        $this.name = "";
	        $this.dni = "";
	        $this.code = "";
	        result.queueName = $this.$rootScope.currentQueue.name;
	        $this.turn = result;
	        $this._showTurn({ turn: $this.turn });

	        if (_this6.$localStorage.printedAppointments) {
	          _this6.$localStorage.printedAppointments.push(turn.bookingId);
	        } else {
	          _this6.$localStorage.printedAppointments = [turn.bookingId];
	        }
	        // $this.onSelect({ turn: $this.turn });
	        // delete $this.$localStorage.currentQueue;
	        // TODO: esto se puede enviar como parte
	        //return ArrayOfTurns.count({ where: { queueId: turn.queueId, and: [{ status: 'CREATED' }] } }).$promise
	        if (onlineAppointment) {
	          var appointment = _this6.$localStorage.currentAppointment;
	          appointment.description = "patatas fritas";
	          return setBTCCaller($this.$localStorage.currentOrganization.id, appointment);
	          // delete this.$localStorage.currentAppointment;
	        }
	      }).catch(function (err) {
	        $this.$scope.bookingForm.$setPristine();
	        $this.$scope.bookingForm.$setUntouched();
	        $this.numbers = "";
	        $this.name = "";
	        $this.dni = "";
	        $this.code = "";
	        var current_toastr = "";
	        var error_msg = "";
	        var message = "";

	        if (err && err.data && err.data.error) {
	          message = err.data.error.message;
	        }
	        switch (message) {
	          case "tooSoon":
	            error_msg = "app.BOOKING_TOSOON";
	            break;
	          case "tooLate":
	            error_msg = "app.BOOKING_TOLATE";
	            break;
	          case "Internal Server Error":
	            error_msg = "app.INTERNAL_SERVER_ERROR";
	            break;
	          case "No existe el servicio":
	            error_msg = "app.NO_SERVICE";
	            break;
	          case "kiosko cerrado":
	            error_msg = "app.KIOSK_CLOSED";
	            _this6.isKioskClosed = true; // check if kiosk is closed
	            break;
	          default:
	            switch (err.status) {
	              case 401:
	                error_msg = "app.login.SIGNED_FAIL";
	                break;
	              case -1:
	                _this6.isNetworkError = true;
	                error_msg = "app.ERR_INTERNET_DISCONNECTED";
	                break;
	              default:
	                error_msg = "app.DEFAULT_ERROR";
	                break;
	            }
	        }
	        $timeout(function () {
	          $this.$rootScope.isClicked = false;
	        }, 5000);
	        if (error_msg != "app.BOOKING_TOSOON" && error_msg != "app.BOOKING_TOLATE") {
	          $translate(error_msg).then(function (msg) {
	            current_toastr = toastr.error(msg);
	          });
	        } else {
	          $translate(error_msg).then(function (msg) {
	            $this.time_error_msg = msg;
	            $this._showTimeBookingDialog();
	          });
	        }
	        if (err.status == 401) {
	          $timeout(function () {
	            toastr.clear(current_toastr);
	            $this.$state.go("login");
	          }, 3000);
	        }
	      }).catch(function (err) {
	        if (_this6.$log) {
	          _this6.$log.error(err);
	        }
	        $translate("app.INTERNAL_SERVER_ERROR").then(function (msg) {
	          toastr.error(msg);
	        }, 5000);
	      });

	      $this.$scope.nameForm.$setPristine();
	      $this.$scope.nameForm.$setUntouched();
	    }
	    function selectPromoForTurns(promotions) {

	      if (!promotions) {
	        return "";
	      }
	      var totalPercentage = promotions.reduce(function (sum, obj) {
	        return sum + obj.percentage;
	      }, 0);

	      var random = Math.random() * totalPercentage;

	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = promotions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var promotion = _step.value;

	          if (random < promotion.percentage) {
	            return promotion.image_url;
	          }
	          random -= promotion.percentage;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      return "";
	    }
	    function _showTurn(currentTurn) {
	      var promo_link = selectPromoForTurns($this.$rootScope.currentQueue.promo_links);
	      this.ticketPromo = promo_link;

	      this.enqueued_people = Number(this.$rootScope.remainingTurns[currentTurn.turn.queueTypeId]);
	      this.queueId = currentTurn.turn.id;
	      this.your_queue = currentTurn.turn.queueName.toUpperCase();
	      if (currentTurn.turn.bookingCode) {
	        this.your_turn = currentTurn.turn.bookingCode ? currentTurn.turn.code : "DATE-001";
	        this.showEnqueuedPeople = false;
	      } else {
	        this.your_turn = currentTurn.turn.code ? currentTurn.turn.code.split("-")[0] + "-" + pad(currentTurn.turn.code.split("-")[1], 3) : "TEST-001";
	        this.showEnqueuedPeople = this.$localStorage.currentOrganization.waitingPeople ? this.$localStorage.currentOrganization.waitingPeople : false;
	      }
	      var date = new Date();
	      this.current_time = date.toLocaleString().replace(" à ", " ");
	      this.readable_time = this.current_time.split(" ")[1];
	      this.readable_date = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
	      var isOnlineKiosk = $this.$localStorage.isOnline === "true" || $this.$localStorage.isOnline === true ? true : false;
	      if (!isOnlineKiosk) {
	        this._showTicketDialog();
	      } else {
	        this._getEmail(this.email);
	        this.email = "";
	      }
	      return true;
	    }

	    function setBTCCaller(organizationId, updatedAppointment) {
	      var _this7 = this;

	      $this.BookititResource.setEventCaller({ id: organizationId }, { updatedAppointment: updatedAppointment }).$promise.then(function (result) {

	        return result;
	      }).catch(function (error) {
	        if (_this7.$log) {
	          _this7.$log.error(error);
	        }
	        return error;
	      }).finally(function () {});
	    }

	    function pad(n, length) {
	      n = n.toString();
	      while (n.length < length) {
	        n = "0" + n;
	      }
	      return n;
	    }

	    function _printDirective() {
	      var _this8 = this;

	      this.showManualPrint = false;
	      var elemToPrint = document.getElementById("dialog_ticket");
	      if (elemToPrint) {
	        this.printElement(elemToPrint).then(function () {
	          _this8.showManualPrint = false;
	          $mdDialog.cancel();
	        }).catch(function (error) {
	          $timeout(function () {
	            _this8.showManualPrint = true;
	          }, 0);
	          if (_this8.$log) {
	            _this8.$log.error(error);
	          }
	        });
	      }
	    }

	    function printElement(elem) {
	      var _this9 = this;

	      return new Promise(function (resolve, reject) {
	        try {
	          _this9.showManualPrint = false;

	          var existingFrame = document.getElementById("print-iframe");
	          if (existingFrame) {
	            try {
	              document.body.removeChild(existingFrame);
	            } catch (_) {}
	          }

	          var iframe = document.createElement("iframe");
	          iframe.id = "print-iframe";
	          iframe.style.position = "absolute";
	          iframe.style.top = "-1000000px";
	          iframe.style.width = "0";
	          iframe.style.height = "0";
	          iframe.style.border = "0";

	          document.body.appendChild(iframe);

	          $timeout(function () {
	            try {
	              var frameDoc = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument ? iframe.contentDocument.document : iframe.contentDocument;

	              if (!frameDoc) throw new Error("No se pudo acceder al documento del iframe");

	              var clone = elem.cloneNode(true);
	              clone.querySelectorAll("#no-print, #no-print2, #no-print3").forEach(function (el) {
	                return el.remove();
	              });

	              var styles = "<style>@import url(\"//fonts.googleapis.com/css?family=Roboto+Slab:400,700|Roboto:400,700,700italic,400italic\");img.tiket_logo { max-width: 100%; max-height: 170px !important; } p.ticket_number { font-size: 56px !important; text-align: center !important; padding-top: 10px !important; }</style>";

	              var htmlContent = "<!DOCTYPE html><html style=\"margin:0; padding:0;\"><head><title>QueueM ticket</title>" + styles + "</head><body style=\"font-family: 'Roboto Slab', serif; text-align: center; margin:20px 10px; font-size:10px !important; padding:0;\"><div style=\"width:100%;\">" + clone.innerHTML + "</div></body></html>";

	              frameDoc.open();
	              frameDoc.write(htmlContent);
	              frameDoc.close();

	              $timeout(function () {
	                try {
	                  var frameWindow = iframe.contentWindow;
	                  if (!frameWindow) throw new Error("No se pudo acceder a la ventana del iframe");

	                  if (typeof frameWindow.print === "function") {
	                    frameWindow.focus();
	                    frameWindow.print();
	                    resolve();
	                  } else {
	                    throw new Error("El método print no está disponible");
	                  }
	                } catch (printErr) {
	                  reject(printErr);
	                } finally {
	                  try {
	                    document.body.removeChild(iframe);
	                  } catch (_) {}
	                  $this.$rootScope.isClicked = false;
	                }
	              }, 300);
	            } catch (err) {
	              try {
	                document.body.removeChild(iframe);
	              } catch (_) {}
	              reject(err);
	            }
	          }, 100);
	        } catch (error) {
	          reject(error);
	        }
	      });
	    }

	    function _getEmail(resp) {
	      var emailTemplate = _index2.default;
	      var subject = emailTemplate.subject;
	      var header = emailTemplate.header;
	      var beforeproduct = emailTemplate.beforeproduct;
	      var message = emailTemplate.message;

	      var messageLogo = "<img class=\"tiket_logo\" style=\"margin: auto; width: 270px;\" src=\"" + this.ticketLogo + "\">";
	      var messageTurno = "<p style=\"box-sizing: border-box; margin-top: 0; margin-bottom: 5px; font-size: 29px; font-weight: bold;\">" + this.your_turn + "</p>";
	      var messagePromo = "<img class=\"tiket_logo\" style=\"margin: auto; width: 160px;\" src=\"" + this.ticketPromo + "\">";
	      var contentHtml = header + beforeproduct + message + messageLogo + emailTemplate.txtTurno + messageTurno + messagePromo + emailTemplate.end;

	      this.EmployeeResource.getEmail({
	        email: resp,
	        subject: subject,
	        msg: "Tu turno es",
	        html: contentHtml
	      }).$promise.then(function () {});
	    }

	    function _processQueues(all_queues) {
	      all_queues.forEach(function (queue) {
	        return buildTreeServices(queue, all_queues);
	      });
	      all_queues = all_queues.filter(function (q) {
	        return !q._processed;
	      });
	      all_queues.forEach(function (q) {
	        return delete q._processed;
	      });

	      var queuesToStore = all_queues.map(mapQueueToStorageFormat);
	      this.queuesByArea = queuesToStore;
	      this.$localStorage.queuesByArea = queuesToStore;

	      return queuesToStore;
	    }

	    function buildTreeServices(queue, queues) {
	      var childrenRefs = queue.queue ? queue.queue.queueId : null;

	      if (Array.isArray(childrenRefs) && childrenRefs.length > 0) {
	        queue.children = [];

	        childrenRefs.forEach(function (ref) {
	          var childIndex = queues.findIndex(function (q) {
	            return q.queueId === ref.queueId;
	          });

	          if (childIndex !== -1) {
	            var child = queues[childIndex];
	            buildTreeServices(child, queues);
	            queues[childIndex]._processed = true;
	            queue.children.push(child);
	          }
	        });
	      }
	      return queues;
	    }

	    function mapQueueToStorageFormat(queue) {
	      return {
	        id: queue.id,
	        name: queue.name,
	        order: queue.order,
	        display: queue.display,
	        remainingTurns: queue.remainingTurns,
	        outOfService: queue.outOfService,
	        previousNotificationLimit: queue.previousNotificationLimit,
	        queueId: queue.queueId,
	        children: Array.isArray(queue.children) && queue.children.length > 0 ? queue.children.map(function (child) {
	          return mapQueueToStorageFormat(child);
	        }) : []
	      };
	    }

	    function getServices() {
	      var _this10 = this;

	      var $this = this;

	      $this._cleanServiceSubscriptions();

	      // carga las colas por area y los turnos por cada cola
	      // const filter =
	      //   '{"include":[{"relation":"turns","scope":{"where":{"or":[{"status":"PRINTED"}, {"status":"RESENT"}]}}},"childQueue"]}';
	      var filter = "{\"include\": [\n            {\n              \"relation\": \"turns\",\n              \"scope\": {\n                \"where\": {\n                  \"or\": [\n                    { \"status\": \"PRINTED\" },\n                    { \"status\": \"RESENT\" }\n                  ]\n                }\n              }\n            },\n            {\n              \"relation\": \"queue\",\n              \"scope\": {\n                \"fields\": [\"id\", \"name\", \"queueId\"]\n              }\n            }\n        ]\n      }";
	      this.KiosksResource.getServices({
	        id: $this.$localStorage.current_kiosk_id,
	        type: "queueTypes",
	        filter: filter
	      }).$promise.then(function (res) {
	        if (res.length > 0) {
	          var all_queues = [];
	          _this10.queuesTypes = res;
	          res.map(function (queue) {
	            if (typeof queue.status !== "undefined" && Boolean(queue.status) && (String(queue.isVisible) === "undefined" || Boolean(queue.isVisible))) {
	              var queueStatus = queue.status === "true" || queue.status === true ? true : false;
	              queue.outOfService = false;
	              if (queueStatus) {
	                if (queue.open) {
	                  if (new Date(queue.open).getHours() > new Date().getHours() || new Date(queue.open).getHours() === new Date().getHours() && new Date(queue.open).getMinutes() > new Date().getMinutes() || new Date(queue.close).getHours() > new Date().getHours() || new Date(queue.close).getHours() === new Date().getHours() && new Date(queue.close).getMinutes() <= new Date().getMinutes()) {
	                    queue.outOfService = true;
	                  } else {
	                    queue.outOfService = false;
	                  }

	                  $this._checkServiceTimer(queue);
	                }

	                all_queues.push(queue);
	                all_queues.sort(function (a, b) {
	                  return Number(a.order) - Number(b.order);
	                });

	                if (queue.turns) {
	                  queue.remainingTurns = queue.turns.length;
	                  $this.$rootScope.remainingTurns[queue.id] = queue.turns.length;
	                  queue.turns = null;
	                }

	                $this.SocketioService.subscribeStatusService(queue.id, function (message) {
	                  queue.outOfService = message == "enable" ? false : true;
	                });
	                $this.SocketioService.p;
	              }
	            }
	          });
	          all_queues = _this10._processQueues(all_queues);

	          $this.$rootScope.remainingGlobalTurns = all_queues.map(function (q) {
	            return countAllRemainingTurns(q);
	          }).reduce(function (a, b) {
	            return a + b;
	          }, 0);

	          if ($this.queuesByArea.length > 2) {
	            var container = document.getElementById("selects-container");
	            container.style.margin = "0 auto";
	          }
	        } else {
	          $this.queuesLoaded = false;
	        }
	      }).catch(function () {
	        if ($this.isLoggingOut) return;
	        $this.isLoggingOut = true;
	        _this10.AuthService.logout().then(function () {
	          $this.toastr.info("You have been logged out");
	          $this.$state.go("login");
	        }).finally(function () {
	          return $this.isLoggingOut = false;
	        });
	      });
	    }

	    function validateServiceToNotShow(queue) {
	      var $this = this;

	      if (Array.isArray(queue.children) && queue.children.length > 0) {
	        return false;
	      }
	      for (var i = 0; i < $this.queuesByArea.length; i++) {
	        var q = $this.queuesByArea[i];

	        if (q.queue && Array.isArray(q.children) /* || q.queuea.queueId === null */) {
	          var index = q.children.findIndex(function (s) {
	            return s.queueId === queue.queueId;
	          });
	          if (index !== -1) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    function validateServiceToShowInQueue(queue) {
	      var $this = this;

	      if (queue.queue && Array.isArray(queue.children) && queue.children.length > 0) {

	        for (var i = 0; i < $this.queuesByArea.length; i++) {
	          var q = $this.queuesByArea[i];

	          if (q.queue && Array.isArray(q.children)) {
	            var index = q.children.findIndex(function (s) {
	              return s.queueId === queue.queueId;
	            });

	            if (index !== -1) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    }

	    function getSubservice(subservice) {
	      var $this = this;

	      $this._cleanServiceSubscriptions();

	      var all_queues = [];
	      var queues = $this.$localStorage.queuesByArea || [];

	      function findQueueById(queueId, queueList) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;

	        try {
	          for (var _iterator2 = queueList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var queue = _step2.value;

	            if (queue.queueId === queueId) return queue;
	            if (queue.children && queue.children.length > 0) {
	              var found = findQueueById(queueId, queue.children);
	              if (found) return found;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }

	      var targetQueue = findQueueById(subservice, queues) || [];
	      var childQueues = targetQueue.children || [];

	      childQueues.forEach(function (queue) {
	        if (typeof $this.$rootScope.remainingTurns[queue.id] !== 'number') {
	          $this.$rootScope.remainingTurns[queue.id] = queue.remainingTurns || 0;
	        }
	        queue.remainingTurns = $this.$rootScope.remainingTurns[queue.id];

	        all_queues.push(queue);

	        $this.SocketioService.subscribeStatusService(queue.id, function (message) {
	          queue.outOfService = message == "enable" ? false : true;
	        });

	        $this.SocketioService.subscribeNewTurnEnqueued(queue.id, function (message) {
	          if ($this.$rootScope.remainingTurns[queue.id] !== undefined) {
	            var _updateRemainingTurnsInStorage = function _updateRemainingTurnsInStorage(id, queueList) {
	              var _iteratorNormalCompletion3 = true;
	              var _didIteratorError3 = false;
	              var _iteratorError3 = undefined;

	              try {
	                for (var _iterator3 = queueList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                  var q = _step3.value;

	                  if (q.id === id) {
	                    q.remainingTurns = $this.$rootScope.remainingTurns[queue.id];
	                    return true;
	                  }
	                  if (q.children && q.children.length > 0) {
	                    var updated = _updateRemainingTurnsInStorage(id, q.children);
	                    if (updated) return true;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                  }
	                } finally {
	                  if (_didIteratorError3) {
	                    throw _iteratorError3;
	                  }
	                }
	              }

	              return false;
	            };

	            $this.$rootScope.remainingTurns[queue.id]++;
	            if ($this.$rootScope.remainingGlobalTurns !== undefined) {
	              $this.$rootScope.remainingGlobalTurns++;
	            }
	            queue.remainingTurns = $this.$rootScope.remainingTurns[queue.id];

	            _updateRemainingTurnsInStorage(queue.id, $this.$localStorage.queuesByArea || []);

	            $this.$rootScope.$apply();
	          }
	        });

	        $this.SocketioService.subscribeNewTurnCalled(queue.id, function (message) {
	          if ($this.$rootScope.remainingTurns[queue.id] !== undefined && $this.$rootScope.remainingTurns[queue.id] > 0) {
	            $this.$rootScope.remainingTurns[queue.id]--;
	            if ($this.$rootScope.remainingGlobalTurns !== undefined && $this.$rootScope.remainingGlobalTurns > 0) {
	              $this.$rootScope.remainingGlobalTurns--;
	            }
	            queue.remainingTurns = $this.$rootScope.remainingTurns[queue.id];
	            $this.$rootScope.$apply();
	          }
	        });
	      });
	      all_queues.sort(function (a, b) {
	        return Number(a.order) - Number(b.order);
	      });

	      $this.queuesByArea = all_queues;
	      $this.queuesLoaded = all_queues.length > 0;

	      if ($this.queuesByArea.length > 2) {
	        var container = document.getElementById("selects-container");
	        container.style.margin = "0 auto";
	      }
	    }

	    function getInformation() {
	      if ($this.$stateParams.serviceId) {
	        this.getSubservice($this.$stateParams.serviceId);
	        this.areServiceId = true;
	      } else {
	        this.getServices();
	      }
	    }

	    function countAllRemainingTurns(queue) {
	      var total = queue.remainingTurns || 0;
	      if (Array.isArray(queue.children) && queue.children.length > 0) {
	        queue.children.forEach(function (child) {
	          total += countAllRemainingTurns(child);
	        });
	      }
	      return total;
	    }

	    function _validateEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(String(email).toLowerCase());
	    }

	    function _checkServiceTimer(queue) {
	      var _this11 = this;

	      window.setInterval(function () {
	        if (new Date(queue.open).getHours() > new Date().getHours() || new Date(queue.open).getHours() === new Date().getHours() && new Date(queue.open).getMinutes() > new Date().getMinutes() || new Date(queue.close).getHours() < new Date().getHours() || new Date(queue.close).getHours() === new Date().getHours() && new Date(queue.close).getMinutes() <= new Date().getMinutes()) {
	          if (!queue.outOfService) {
	            queue.outOfService = true;
	            $this.isKioskClosed = true;
	            $this.$rootScope.$apply();
	          }
	        } else {
	          if (queue.outOfService) {
	            queue.outOfService = false;
	            $this.isKioskClosed = false;
	            $this.$rootScope.$apply();
	          }
	        }
	        _this11.queuesLoaded = _this11.$localStorage.queuesByArea.length > 0;
	      }, 30000);
	    }

	    function _checkKioskTimer(kiosk) {
	      var _this12 = this;

	      var checkStatus = function checkStatus() {
	        _this12.$rootScope.$evalAsync(function () {
	          _this12.isNetworkError = false;
	          if (!Array.isArray(_this12.queuesTypes) || _this12.queuesTypes.length === 0) {
	            return;
	          }
	          var all_queues = _this12.queuesTypes || [];

	          var updateQueues = function updateQueues(status) {
	            kiosk.outOfService = status;
	            _this12.isKioskClosed = status;

	            var updateChildrenStatus = function updateChildrenStatus(queues) {
	              queues.forEach(function (q) {
	                q.outOfService = status;
	                if (Array.isArray(q.children) && q.children.length) {
	                  updateChildrenStatus(q.children);
	                }
	              });
	            };

	            updateChildrenStatus(_this12.queuesTypes);
	          };

	          if (kiosk.open) {
	            if (new Date(kiosk.open).getHours() > new Date().getHours() || new Date(kiosk.open).getHours() === new Date().getHours() && new Date(kiosk.open).getMinutes() > new Date().getMinutes() || new Date(kiosk.close).getHours() < new Date().getHours() || new Date(kiosk.close).getHours() === new Date().getHours() && new Date(kiosk.close).getMinutes() <= new Date().getMinutes()) {
	              updateQueues(true);
	            } else {
	              updateQueues(false);
	            }
	          } else {
	            updateQueues(false);
	          }

	          all_queues = _this12._processQueues(all_queues);
	          _this12.queuesLoaded = _this12.$localStorage.queuesByArea.length > 0;
	        });
	      };
	      checkStatus();

	      if (this.$rootScope.kioskTimerInterval) {
	        clearInterval(this.$rootScope.kioskTimerInterval);
	        this.$rootScope.kioskTimerInterval = null;
	      }

	      this.$rootScope.kioskTimerInterval = window.setInterval(checkStatus, 30000);
	    }

	    // exports
	    // TODO: ¿por qué no se define como parte de la clase?
	    angular.extend(this, {
	      queues: queues,
	      queuesLoaded: queuesLoaded,
	      isHelpMode: isHelpMode,
	      isAsking: isAsking,
	      debug_enabled: debug_enabled,
	      getOrganizationData: getOrganizationData,

	      _sendCustomField: _sendCustomField,
	      resetControl: resetControl,
	      _sendPhone: _sendPhone,
	      _sendCode: _sendCode,
	      _show_legalTerms: _show_legalTerms,
	      _showTicketDialog: _showTicketDialog,
	      _showTimeBookingDialog: _showTimeBookingDialog,
	      _close: _close,
	      _cancel: _cancel,
	      back: back,
	      backOffice: backOffice,
	      createInitialQr: createInitialQr,

	      _startTimer: _startTimer,
	      _reStartTimer: _reStartTimer,
	      _stopTimer: _stopTimer,
	      _receiveAdvice: _receiveAdvice,
	      _finishDialogs: _finishDialogs,
	      _showTurn: _showTurn,
	      _getTurn: _getTurn,
	      onSelect: this.onSelect,
	      _printDirective: _printDirective,
	      _getEmail: _getEmail,
	      printElement: printElement,
	      numbers: numbers,
	      timeout: timeout,
	      timerValue: timerValue,
	      getServices: getServices,
	      _validateEmail: _validateEmail,
	      countAllRemainingTurns: countAllRemainingTurns,
	      getVerifyCita: getVerifyCita,
	      getFormatDate: getFormatDate,
	      searchServicesBookititQueue: searchServicesBookititQueue,
	      _showDniBookititForm2: _showDniBookititForm2,
	      _cancelDniBokitit: _cancelDniBokitit,
	      getFormatHour: getFormatHour,
	      _checkKioskTimer: _checkKioskTimer,
	      _checkServiceTimer: _checkServiceTimer,
	      _processQueues: _processQueues,
	      getSubservice: getSubservice,
	      getInformation: getInformation,
	      validateServiceToNotShow: validateServiceToNotShow,
	      validateServiceToShowInQueue: validateServiceToShowInQueue
	    });
	  }
	  /**
	   * Al iniciar debe cargar las colas de un area
	   */


	  _createClass(RequestController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this13 = this;

	      var $this = this;
	      this.singleQueue = this.$localStorage.currentLocation.singleQueue;
	      this.enqueued_people = 0;
	      var isReloading = false;

	      if ($this.$stateParams.kioskId) {
	        this._kioskId = $this.$stateParams.kioskId;
	        $this.$localStorage.current_kiosk_id = $this.$stateParams.kioskId;
	        // Actualiza el contador cada vez que se imprime un turno
	        $this.currentLocation = $this.$localStorage.currentLocation;
	        $this.currentLocationId = $this.currentLocation.id;
	        $this.currentLocationTextTicket = $this.currentLocation.ticketText ? $this.currentLocation.ticketText : null;

	        var reloadTimeout = void 0;
	        $this.SocketioService.subscribeUpdateKioskCounter($this.$localStorage.current_kiosk_id, function (data) {

	          var message = typeof data === 'string' ? data : data.type;

	          if (message === "reload" && isReloading === false) {
	            isReloading = true;

	            if (reloadTimeout) {
	              clearTimeout(reloadTimeout);
	            }

	            $this.window.location.reload();
	          }
	        });

	        $this.SocketioService.subscribeUpdateKioskServices($this.$localStorage.current_kiosk_id, function (data) {
	          if ($this.$log) {
	            $this.$log.debug('updateKioskServices received:', data);
	          }

	          $this._cleanServiceSubscriptions();

	          $this.getInformation();
	        });

	        /**
	         * Ejemplo para validar la posibilidad de inyectar dianmicamente css
	         */
	        //this.$rootScope.css = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min';
	        // Check background

	        this.KiosksResource.getKioskData({
	          id: $this.$localStorage.current_kiosk_id
	        }).$promise.then(function (data) {
	          _this13.$rootScope.css = _this13.$localStorage.currentOrganization.style_link;
	          var hasBackground = data.img_link ? true : false;
	          $this.$localStorage.isOnline = data.isOnline === "true";
	          $this.isOnlineKiosk = $this.$localStorage.isOnline === "true" || $this.$localStorage.isOnline === true ? true : false;
	          $this.kiosk = data;
	          // Set background image
	          if (hasBackground) {
	            var background = data.img_link;
	            angular.element($this.$document.find("body")).css({
	              "background-image": "url(" + background + ")",
	              "background-repeat": "no-repeat",
	              "background-position": "center top",
	              "background-size": "cover"
	            });
	            $this.$localStorage.currentOrganization.logo_link = data.logo_link;
	          } else {
	            angular.element($this.$document.find("body")).css({
	              "background-image": "",
	              "background-repeat": "",
	              "background-position": "",
	              "background-size": ""
	            });
	          }
	          _this13.getOrganizationData(hasBackground);

	          _this13.createInitialQr(data.locationId, data.activeQR, data.id);

	          data.outOfService = false;
	          _this13.getInformation();
	          if (data.open) {
	            $this.$timeout(function () {
	              _this13._checkKioskTimer(data);
	            }, 500);
	          } else {
	            _this13.queuesLoaded = _this13.$localStorage.queuesByArea.length > 0;
	          }
	        }).catch(function (error) {
	          if (_this13.$log) {
	            _this13.$log.error("Error en getKioskData: ", error);
	          }
	        });
	        // this.getServices();
	        $this.getInformation();

	        /**
	         * Subscribirse a los cambios horarios de un kiosko para refrescar la pestaña
	         */

	        $this.SocketioService.subscribeNewHour(function (data) {
	          if ($this.$localStorage.current_kiosk_id === data.kioskId) {

	            $this.kiosk.open = typeof data.open === 'number' ? new Date(data.open) : data.open;
	            $this.kiosk.close = typeof data.close === 'number' ? new Date(data.close) : data.close;

	            _this13._checkKioskTimer({
	              kioskId: data.kioskId,
	              open: $this.kiosk.open,
	              close: $this.kiosk.close
	            });
	            $this.$rootScope.$apply();
	          }
	        });
	        /*
	         * Subscribirse a los cambios  de un kiosko of dashboard
	         */
	        $this.SocketioService.subscribeCreateAndUpdateKiosk($this.$localStorage.current_kiosk_id, function (kiosk) {
	          if (kiosk.activeQR) {
	            _this13.TokenResource.getTokenAccess({ id: kiosk.kiosk_online_id }).$promise.then(function (response) {

	              _this13.backOffice(kiosk.id, response.id); //generate new token
	              $this.$localStorage.kiosk_online_token = response.id;
	              $this.$localStorage.kiosk_online_userId = response.userId;
	            }).catch(function (err) {
	              if (_this13.$log) {
	                _this13.$log.error("err", err);
	              }
	            });
	          } else {
	            //delete token and logout token
	            if ($this.$localStorage.kiosk_online_token) {
	              _this13.TokenResource.logout({
	                access_token: $this.$localStorage.kiosk_online_token
	              }).$promise.then(function (response) {
	                $this.$localStorage.kiosk_online_token = undefined;
	                $this.$localStorage.kiosk_online_userId = undefined;
	              }).catch(function (err) {
	                if (_this13.$log) {
	                  _this13.$log.error("err", err);
	                }
	              });
	            }
	          }
	          $this.kiosk.activeQR = kiosk.activeQR;
	          $this.$rootScope.$apply();
	        });

	        $this.SocketioService.subscribeUpdateOrganization($this.$localStorage.currentOrganization.id, function (message) {
	          var newLink = message.style_link + '?v=' + Date.now();
	          $this.$localStorage.currentOrganization.style_link = newLink;
	          $this.$localStorage.currentOrganization.waitingPeople = message.waitingPeople;
	          $this.$rootScope.css = $this.$localStorage.currentOrganization.style_link;
	          if (!$this.$rootScope.$$phase) {
	            $this.$rootScope.$apply();
	          }
	        });

	        /**
	         * subscribe Notify Regenerate Token Kiosk
	         */
	        $this.SocketioService.subscribeNotifyRegenerateTokenKiosk($this.$localStorage.current_kiosk_id, function (message) {

	          _this13.TokenResource.getTokenAccess({
	            id: $this.$localStorage.kiosk_online_userId
	          }).$promise.then(function (response) {
	            _this13.backOffice($this.$localStorage.current_kiosk_id, response.id); //Regenerate new token
	            $this.$localStorage.kiosk_online_token = response.id;
	          }).catch(function (err) {
	            if (_this13.$log) {
	              _this13.$log.error("err", err);
	            }
	          });
	        });

	        $this.SocketioService.subscribeUpdateLocation($this.$localStorage.currentLocation.id, function (data) {
	          $this.$scope.$evalAsync(function () {
	            $this.$localStorage.currentLocation.singleQueue = data.singleQueue;
	            $this.$localStorage.currentLocation.asking_phone = data.asking_phone;
	            $this.singleQueue = data.singleQueue;
	            if (data.singleQueue) {
	              $this.$rootScope.previousNotificationLimit = data.previousNotificationLimit;
	              $this.$localStorage.currentLocation.previousNotificationLimit = data.previousNotificationLimit;
	            }
	            $this.$rootScope.$broadcast("updateLocation", data);
	          });
	        });
	      }

	      this._startPeriodicCleanup();
	    }
	  }, {
	    key: "selectLanguage",
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }, {
	    key: "helpMode",
	    value: function helpMode() {
	      this.isHelpMode = !this.isHelpMode;
	    }
	  }, {
	    key: "onSelectTurn",
	    value: function onSelectTurn(turn) {
	      this._showTurn(turn);
	    }
	  }, {
	    key: "onSelect",
	    value: function onSelect(t) {
	      var isOnlineKiosk = this.$localStorage.isOnline === "true" || this.$localStorage.isOnline === true ? true : false;
	      if (isOnlineKiosk) {
	        this.vcRecaptchaService.reload();
	        this.captchaIsValid = false;
	        this.$localStorage.captchaIsValid = this.captchaIsValid;
	      }
	    }
	  }, {
	    key: "setResponse",
	    value: function setResponse(response) {
	      this.captchaIsValid = response ? true : false;
	      this.$localStorage.captchaIsValid = this.captchaIsValid;
	    }
	  }, {
	    key: "cbExpiration",
	    value: function cbExpiration() {
	      this.captchaIsValid = false;
	      this.$localStorage.captchaIsValid = this.captchaIsValid;
	    }
	  }, {
	    key: "_validField",
	    value: function _validField(nameField, field) {
	      switch (nameField) {
	        case "user_name":
	          {
	            this.user_name_is_valid = field.length > 1 ? true : false;
	          }
	          break;
	        case "name":
	          {
	            this.name_is_valid = true;
	            this.name_is_valid_spaces = false;

	            var contar_numeros = field.replace(/[^0-9]/g, "").length;
	            if (contar_numeros > 0) {
	              this.name_is_valid = false;
	            }
	            if (/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/g.test(field)) {
	              this.name_is_valid_spaces = false;
	            } else {
	              this.name_is_valid_spaces = true;
	            }
	            if (field.length === 0) {
	              return this.name_is_valid_spaces = false;
	            }
	          }
	          break;
	        case "dni":
	          {
	            if (/^([a-zA-Z0-9]+[,.]?[]?|[a-zA-Z0-9]+['-]?)+$/g.test(field)) {
	              this.dni_is_valid = true;
	            } else {
	              this.dni_is_valid = false;
	            }
	            if (field.length === 0) {
	              return this.dni_is_valid = true;
	            }
	          }
	          break;
	        case "email_bookitit":
	          {
	            var numbers = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	            if (field.match(numbers)) {
	              this.email_bookitit_is_valid = true;
	              this.field_bookitit_is_valid = true;
	            } else {
	              this.email_bookitit_is_valid = false;
	              this.field_bookitit_is_valid = false;
	            }
	            field.trim();
	          }
	          break;
	        case "dni_bookitit":
	          {
	            if (/^([a-zA-Z0-9]+[,.]?[]?|[a-zA-Z0-9]+['-]?)+$/g.test(field)) {
	              this.dni_bookitit_is_valid = true;
	              this.field_bookitit_is_valid = true;
	            } else {
	              this.dni_bookitit_is_valid = false;
	              this.field_bookitit_is_valid = false;
	            }
	            field.trim();
	          }
	          break;
	        case "numbers":
	          {
	            var _numbers = /^[0-9]+$/;
	            this.numbers_is_valid = false;
	            if (field.match(_numbers)) {
	              this.numbers_is_valid = true;
	            }
	          }
	          break;
	      }
	    }
	  }, {
	    key: "_cleanServiceSubscriptions",
	    value: function _cleanServiceSubscriptions() {
	      var $this = this;

	      if ($this.SocketioService.cleanServiceListeners) {
	        $this.SocketioService.cleanServiceListeners();
	      }

	      if ($this.queuesByArea) {
	        $this.queuesByArea.forEach(function (queue) {
	          queue.turns = null;
	          queue.remainingTurns = 0;
	        });
	      }

	      if (this.$log) {
	        this.$log.debug('Service subscriptions cleaned');
	      }
	    }
	  }, {
	    key: "_startPeriodicCleanup",
	    value: function _startPeriodicCleanup() {
	      var $this = this;

	      this.cleanupInterval = setInterval(function () {
	        if ($this.$log) {
	          $this.$log.debug('Running periodic memory cleanup');
	        }

	        if ($this.SocketioService.cleanServiceListeners) {
	          $this.SocketioService.cleanServiceListeners();
	        }

	        if ($this.queuesByArea) {
	          $this.queuesByArea = $this.queuesByArea.filter(function (q) {
	            return q && q.id;
	          });
	        }

	        if ($this.$localStorage.printedAppointments && $this.$localStorage.printedAppointments.length > 50) {

	          $this.$localStorage.printedAppointments = $this.$localStorage.printedAppointments.slice(-50);
	        }

	        if (performance && performance.memory) {
	          var memoryInfo = {
	            usedJSHeapSize: (performance.memory.usedJSHeapSize / 1048576).toFixed(2) + ' MB',
	            totalJSHeapSize: (performance.memory.totalJSHeapSize / 1048576).toFixed(2) + ' MB',
	            subscriptions: $this.$rootScope.subscriptionsList ? $this.$rootScope.subscriptionsList.length : 0
	          };

	          if ($this.$log) {
	            $this.$log.info('Memory usage:', memoryInfo);
	          }
	        }
	      }, 600000);
	    }
	  }, {
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      var $this = this;

	      if (this.$log) {
	        this.$log.debug('Cleaning up turn-request controller');
	      }

	      $this._cleanServiceSubscriptions();

	      if ($this.$localStorage.current_kiosk_id) {
	        $this.SocketioService.unSubscribe("updateKioskCounter/" + $this.$localStorage.current_kiosk_id);
	        $this.SocketioService.unSubscribe("updateKioskServices/" + $this.$localStorage.current_kiosk_id);
	        $this.SocketioService.unSubscribe("createAndUpdateKiosk/" + $this.$localStorage.current_kiosk_id);
	        $this.SocketioService.unSubscribe("regenerateTokenKiosk/" + $this.$localStorage.current_kiosk_id);
	        $this.SocketioService.unSubscribe("newHour");
	      }

	      if ($this.timeout) {
	        $this.$timeout.cancel($this.timeout);
	      }

	      if (this.cleanupInterval) {
	        clearInterval(this.cleanupInterval);
	      }

	      $this.queuesByArea = null;
	      $this.queuesTypes = null;
	      $this.$rootScope.remainingTurns = {};
	    }
	  }]);

	  return RequestController;
	}();

	RequestController.$inject = ["$scope", "$rootScope", "$translate", "toastr", "$mdDialog", "config", "KiosksResource", "$timeout", "$document", "SocketioService", "$stateParams", "Queues", "$localStorage", "AuthService", "$state", "OrganizationsResource", "EmployeeResource", "vcRecaptchaService", "BookititResource", "QueueResource", "TokenResource", "EstablishmentsResource"];

	exports.default = RequestController;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  subject: 'Yo Pido Turno Desde Casa | Ticket turno.',
	  header: '<!DOCTYPE html> <html lang="es" style="box-sizing: border-box;"> <head style="box-sizing: border-box;"> <meta charset="UTF-8" style="box-sizing: border-box;"> <title style="box-sizing: border-box;">Queue Email Template</title>  </head>',
	  beforeproduct: '<body style="box-sizing: border-box;"><div class="container" style="box-sizing: border-box;width: 600px;margin: 0 auto;display: block;font-family: Helvetica;border: 1px solid #fafafa;">  <div class="header" style="box-sizing: border-box;">' + '</div> <div class="content" style="box-sizing: border-box;padding: 30px 60px;">' + '<p class="informed" style="box-sizing: border-box;display: block;"> El ticket de su turno:</p>' + '<section class="product-container" style="box-sizing: border-box;">',
	  message: ' <div class="product-item" style="box-sizing: border-box;text-align: center;width: 270px;margin: 0 auto;font-weight: bold;box-shadow: -2px 20px 20px -11px rgba(0,0,0,0.75);">',
	  txtTurno: '<p style="box-sizing: border-box;margin-top: 10px;margin-bottom: 5px;">Su turno</p>',
	  end: '</div></section></div></div></body></html>'
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _turnRequestButton = __webpack_require__(28);

	var _turnRequestButtonService = __webpack_require__(30);

	var common = angular.module('queues.common', []).component('turnRequestButton', _turnRequestButton.TurnRequestButtonComponent).component('turnRequestButtonService', _turnRequestButtonService.TurnRequestButtonServiceComponent).name;

	exports.default = common;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TurnRequestButtonComponent = undefined;

	var _turnRequestButton = __webpack_require__(29);

	var _turnRequestButton2 = _interopRequireDefault(_turnRequestButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TurnRequestButtonComponent = exports.TurnRequestButtonComponent = {
	  bindings: {
	    queue: '=',
	    // turnSelection: '<',
	    // helpMode: '<',
	    // isEmployee: '<',
	    onSelect: '&'
	  },
	  controller: _turnRequestButton2.default,
	  templateUrl: 'app/modules/queues/common/turn-request-button/turn-request-button.html'
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TurnRequestButtonController = function () {

	  /** @ngInject */
	  TurnRequestButtonController.$inject = ["$scope", "toastr", "$translate", "config", "$rootScope", "Queues", "$mdDialog", "$interval", "$localStorage", "SocketioService", "vcRecaptchaService", "BookititResource", "QueueResource", "RequestController"];
	  function TurnRequestButtonController($scope, toastr, $translate, config, $rootScope, Queues, $mdDialog, $interval, $localStorage, SocketioService, vcRecaptchaService, BookititResource, QueueResource, RequestController) {
	    var _this11 = this;

	    _classCallCheck(this, TurnRequestButtonController);

	    // private
	    //  const $this = this;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$log;
	    this.SocketioService = SocketioService;
	    this.Queues = Queues;
	    this.toastr = toastr;
	    this.$translate = $translate;
	    this.establishmentId = config.ESTABLISHMENT_ID;
	    this.$mdDialog = $mdDialog;
	    this.$interval = $interval;
	    this.$localStorage = $localStorage;
	    this.determinateValue = 105;
	    var interval = '';
	    this.isAsking = true;
	    //var activePhoneQuestion = false;
	    this.remainingTurns = 0;
	    this.timerValue = 0;
	    this.name = '';
	    this.phone = '';
	    this.noTickets = false;
	    this.serviceBackground = localStorage.colorService;
	    this.showWaitingPeople = this.$localStorage.currentOrganization.waitingPeople ? this.$localStorage.currentOrganization.waitingPeople : false;
	    this.singleQueue = this.$localStorage.currentLocation.singleQueue;
	    this.previousNotificationLimit = this.$localStorage.currentLocation.previousNotificationLimit;
	    this.asking_name = this.$localStorage.currentLocation.askingName ? this.$localStorage.currentLocation.askingName : false;
	    this.asking_dni = this.$localStorage.currentLocation.askingDNI ? this.$localStorage.currentLocation.askingDNI : false;
	    this.asking_phone = this.$localStorage.currentLocation.asking_phone;
	    // this.$rootScope.css = this.$localStorage.currentOrganization.style_link;
	    //Captcha
	    this.vcRecaptchaService = vcRecaptchaService;

	    //Bookitit
	    this.BookititResource = BookititResource;
	    this.QueueResource = QueueResource;

	    this.RequestController = RequestController;

	    var ref = this;
	    /*setTimeout(function(){
	      $this.generateQR()
	     }, 5000);*/
	    //var queue = {};

	    /*
	     function prepareTurn(queue){
	     this.currentQueue = queue.queue;
	     this.queueId = queue.queue.id;
	     this.remainingTurns = queue.queue.turns.length;
	        }
	     */
	    function _showNameForm(ev) {
	      var _this = this;

	      this.hasName = false;
	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myNameDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this.$rootScope.isClicked = false;
	        if (_this.$log) {
	          _this.$log.error(error);
	        }
	        _this.$scope.$parent.$ctrl.name = '';
	        _this.$scope.$parent.nameForm.$setPristine();
	        _this.$scope.$parent.nameForm.$setUntouched();
	        if (_this.$log) {
	          _this.$log.error('_showNameForm', error);
	        }
	      });
	    }

	    function _showDNIForm(ev) {
	      var _this2 = this;

	      var parent = this;
	      // this.hasName = false;
	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myDNIDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this2;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {
	        document.getElementById('dni').value = "";
	      }).catch(function (error) {
	        _this2.$rootScope.isClicked = false;
	        if (_this2.$log) {
	          _this2.$log.error(error);
	        }
	        _this2.name = '';
	        document.getElementById('dni').value = "";
	        if (!_this2.$scope.$parent.$ctrl.dni_is_valid && _this2.$scope.$parent.$ctrl.dni) document.getElementById('mssgError').innerHTML = "";
	      });
	    }

	    function _showDNIPhoneForm(ev) {
	      var _this3 = this;

	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myDNIPhoneDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this3.$rootScope.isClicked = false;
	        _this3.$scope.$parent.$ctrl.numbers = '';
	        _this3.$scope.$parent.$ctrl.dni = '';
	        _this3.$scope.$parent.dniPhoneForm.$setPristine();
	        _this3.$scope.$parent.dniPhoneForm.$setUntouched();
	        _this3.$scope.$parent.dniForm.$setPristine();
	        _this3.$scope.$parent.dniForm.$setUntouched();
	        if (_this3.$log) {
	          _this3.$log.error('_showDNIPhoneForm', error);
	        }
	      });
	    }

	    function _showPhoneForm(ev) {
	      var _this4 = this;

	      var $this = this;
	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myPhoneDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return $this;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        $this.$rootScope.isClicked = false;

	        _this4.$scope.$parent.$ctrl.numbers = '';
	        _this4.$scope.$parent.userForm.$setPristine();
	        _this4.$scope.$parent.userForm.$setUntouched();
	        if (_this4.$log) {
	          _this4.$log.error('_showPhoneForm', error);
	        }
	      });
	    }
	    function _showNamePhoneForm(ev) {
	      var _this5 = this;

	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myNamePhoneDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this5.$rootScope.isClicked = false;

	        _this5.$scope.$parent.$ctrl.name = '';
	        _this5.$scope.$parent.$ctrl.numbers = '';
	        _this5.$scope.$parent.namePhoneForm.$setPristine();
	        _this5.$scope.$parent.namePhoneForm.$setUntouched();
	        if (_this5.$log) {
	          _this5.$log.error('You cancelled phone the dialog.', error);
	        }
	        if (_this5.$log) {
	          _this5.$log.error('You cancelled name_phone the dialog.', error);
	        }
	      });
	    }

	    function _showNameDniForm(ev) {
	      var _this6 = this;

	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myDNINameDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this6.$rootScope.isClicked = false;

	        _this6.$scope.$parent.$ctrl.name = '';
	        _this6.$scope.$parent.$ctrl.numbers = '';
	        _this6.$scope.$parent.namePhoneForm.$setPristine();
	        _this6.$scope.$parent.namePhoneForm.$setUntouched();
	        if (_this6.$log) {
	          _this6.$log.error('You cancelled phone the dialog.', error);
	        }
	        if (_this6.$log) {
	          _this6.$log.error('You cancelled name_phone the dialog.', error);
	        }
	      });
	    }

	    function _showPhoneEmailForm(ev) {
	      var _this7 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myPhoneEmailDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this7;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this7.$rootScope.isClicked = false;
	        if (_this7.$log) {
	          _this7.$log.error('You cancelled name_phone the dialog.', error);
	        }
	      });
	    }

	    function _showEmailForm(ev) {
	      var _this8 = this;

	      var $this = this;
	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myEmailDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return $this;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        $this.$rootScope.isClicked = false;
	        if (_this8.$log) {
	          _this8.$log.error('You cancelled email the dialog.', error);
	        }
	      });
	    }
	    function _showBookingForm(ev) {
	      var _this9 = this;

	      var $this = this;
	      //this._startTimer(this.determinateValue);
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myBookingDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return $this;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        $this.$rootScope.isClicked = false;
	        if (_this9.$log) {
	          _this9.$log.error('You cancelled phone the dialog.', error);
	        }
	      });
	    }

	    function _startTimer(value) {

	      // the Determinate loader.
	      ref.timerValue = value;
	      interval = $interval(function () {
	        ref.timerValue -= 1;
	        if (ref.timerValue < 0) {
	          $interval.cancel(interval);
	          $mdDialog.cancel();
	        }
	      }, 100);
	    }

	    function _reStartTimer(value) {
	      this._stopTimer();
	      this._startTimer(value);
	    }

	    function _stopTimer() {
	      this.phone = '';
	      this.name = '';

	      $interval.cancel(interval);
	    }

	    //*********************** Bookitit *********************************/
	    //Open modal with input email  after forms
	    function _showDniBookititForm(ev) {
	      var _this10 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myDniBookititDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        fullscreen: this.customFullscreen, // Only for -xs, -sm breakpoints.
	        controller: function controller() {
	          return _this10;
	        },
	        controllerAs: '$ctrl',
	        clickOutsideToClose: true
	      }).then(function () {}).catch(function (error) {
	        _this10.$rootScope.isClicked = false;
	        if (_this10.$log) {
	          _this10.$log.error('_showDniBookititForm', error);
	        }
	        _this10.$scope.$parent.$ctrl.dni_bookitit = '';
	        _this10.$scope.$parent.dniBookititForm.$setPristine();
	        _this10.$scope.$parent.dniBookititForm.$setUntouched();
	      });
	    }

	    //Get services of bookitit the actual queue after forms
	    var searchServicesBookititQueue = function searchServicesBookititQueue(ev) {

	      _this11.QueueResource.getById({
	        id: _this11.queue.queueId
	      }).$promise.then(function (result) {
	        if (result.hasBokititServices && $localStorage.currentOrganization.hasBooking) {

	          _this11.$localStorage.bokititServices = result.bokititServices;
	          _this11._showDniBookititForm(ev);
	        } else {

	          _this11.$scope.$parent.$parent.$ctrl._getTurn();
	        }
	      }).catch(function (error) {
	        _this11.$scope.$parent.$parent.$ctrl.isNetworkError = true;
	        _this11.$rootScope.isClicked = false;
	      });
	    };

	    // exports TODO: ?????
	    angular.extend(this, {
	      _showNameForm: _showNameForm,
	      _showDNIForm: _showDNIForm,
	      _showPhoneForm: _showPhoneForm,
	      _showNamePhoneForm: _showNamePhoneForm,
	      _showNameDniForm: _showNameDniForm,
	      _showDNIPhoneForm: _showDNIPhoneForm,
	      _showPhoneEmailForm: _showPhoneEmailForm,
	      _showEmailForm: _showEmailForm,
	      _showBookingForm: _showBookingForm,
	      _startTimer: _startTimer,
	      _reStartTimer: _reStartTimer,
	      _stopTimer: _stopTimer,

	      _showDniBookititForm: _showDniBookititForm,
	      searchServicesBookititQueue: searchServicesBookititQueue
	    });
	  }

	  //////


	  _createClass(TurnRequestButtonController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var $this = this;
	      this.singleQueue = this.$localStorage.currentLocation.singleQueue;

	      // TODO: chapuza, buscar una mejor alternativa
	      if (!$this.$rootScope.remainingTurns) {
	        $this.$rootScope.remainingTurns = {};
	      }

	      $this.areaId = $this.queue.areaId;
	      $this.queue.colorService = this.serviceBackground ? '#' + this.serviceBackground : "#ff914d";
	      /*
	       $this.SocketioService.subscribeRemainingTurnsCounter($this.queue.id, (message) => {
	           $this.$rootScope.remainingTurns[$this.queue.id] = message.count;
	        $this.$rootScope.$apply();
	        $this.remainingTurns = message.count;
	      });
	      */
	      // Actualiza el contador cada vez que se imprime un turno
	      $this.SocketioService.subscribeNewTurnEnqueued($this.queue.id, function (message) {

	        $this.newEnqueued = setTimeout(function () {
	          $this.$rootScope.remainingTurns[$this.queue.id]++;
	          $this.$rootScope.remainingGlobalTurns++;
	          var turns_count = Number($this.$rootScope.remainingTurns[$this.queue.id]);
	          $this.remainingTurns = turns_count;
	          $this.noTickets = message.finishTickets;

	          function updateRemainingTurnsInStorage(id, queueList) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;

	            try {
	              for (var _iterator = queueList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var queue = _step.value;

	                if (queue.id === id) {
	                  queue.remainingTurns = turns_count;
	                  return true;
	                }
	                if (queue.children && queue.children.length > 0) {
	                  var updated = updateRemainingTurnsInStorage(id, queue.children);
	                  if (updated) return true;
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }

	            return false;
	          }
	          updateRemainingTurnsInStorage($this.queue.id, $this.$localStorage.queuesByArea);

	          $this.$rootScope.$apply();
	        }, 1000);
	      });

	      // Actualiza el contador cada vez que se atiendo un usuario
	      $this.SocketioService.subscribeNewTurnCalled($this.queue.id, function (message) {

	        if (message.serviceType.toLowerCase() == 'manual') {
	          clearTimeout($this.newEnqueued);
	        }
	        var remainingTurns = $this.$rootScope.remainingTurns[$this.queue.id];
	        if (Number(remainingTurns) > 0) {
	          $this.$rootScope.remainingTurns[$this.queue.id]--;
	        }
	        if ($this.$rootScope.remainingGlobalTurns && $this.$rootScope.remainingGlobalTurns > 0) {
	          $this.$rootScope.remainingGlobalTurns--;
	        }
	        var turns_count = Number($this.$rootScope.remainingTurns[$this.queue.id]);
	        $this.remainingTurns = turns_count;
	        $this.$rootScope.$apply();
	      });

	      $this.SocketioService.subscribeUpdateOrganization($this.$localStorage.currentOrganization.id, function (message) {
	        var newLink = message.style_link + '?v=' + Date.now();
	        $this.$localStorage.currentOrganization.style_link = newLink;
	        $this.$localStorage.currentOrganization.waitingPeople = message.waitingPeople;
	        $this.showWaitingPeople = message.waitingPeople;
	        $this.$rootScope.css = $this.$localStorage.currentOrganization.style_link;
	        if (!$this.$rootScope.$$phase) {
	          $this.$rootScope.$apply();
	        }
	      });

	      $this.$scope.$on("updateLocation", function (event, value) {
	        $this.$scope.$evalAsync(function () {
	          $this.singleQueue = value.singleQueue;
	          $this.$localStorage.currentLocation.singleQueue = value.singleQueue;
	          $this.asking_phone = value.asking_phone;
	          $this.$localStorage.currentLocation.asking_phone = value.asking_phone;
	          if (value.singleQueue) {
	            $this.previousNotificationLimit = value.previousNotificationLimit;
	            $this.$rootScope.previousNotificationLimit = value.previousNotificationLimit;
	            $this.$localStorage.currentLocation.previousNotificationLimit = value.previousNotificationLimit;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'generateQR',
	    value: function generateQR() {}
	    //  const $this = this;

	    //var qrdata = document.getElementById($this.queue.id);
	    /*var qrcode = new QRCode(qrdata,{
	      correctLevel: QRCode.CorrectLevel.H
	    });
	    //var data = "<p click='hola()'>Hola</p>";
	    qrcode.makeCode($this.queue.id)*/

	    /**
	     * Crea un nuevo turno y dispara los eventos
	     * 1. Crear un nuevo turno
	     * 2. Agrega el turno al array de la tabla virtual
	     * 3. Guarda un evento para turno
	     * 4. Enviar una notificación a las Workstations del area (Websockets)
	     * @param turns_before
	     */

	  }, {
	    key: 'onSelectClick',
	    value: function onSelectClick(ev) {
	      var _this12 = this;

	      if (this.noTickets) {
	        return true;
	      }

	      this.$rootScope.currentQueue = this.queue;
	      this.$rootScope.isClicked = true;
	      this.$scope.$parent.$parent.$ctrl.isNetworkError = false;
	      var isOnline = this.$localStorage.isOnline === 'true' || this.$localStorage.isOnline === true ? true : false;

	      if (isOnline) {
	        if (!this.$localStorage.captchaIsValid) {
	          this.$translate('app.request.CAPTCHA_ERROR').then(function (msg) {
	            return _this12.toastr.error(msg);
	          });
	          return;
	        }

	        this.$scope.$parent.$parent.$ctrl.onSelect();

	        if (this.queue.serviceType === "booking") {
	          this._showBookingForm(ev);
	        } else if (this.asking_phone == true) {

	          var previousLimit = this.singleQueue ? this.previousNotificationLimit : this.queue.previousNotificationLimit;

	          this.$rootScope.previousNotificationLimit = previousLimit;
	          this._showPhoneEmailForm(ev);
	        } else {

	          this._showEmailForm(ev);
	        }
	      } else {
	        if (this.queue.serviceType === 'booking') {

	          // this._showBookingForm(ev);
	          this.searchServicesBookititQueue(ev);
	        } else if (this.asking_name === true || this.asking_phone === true || this.asking_dni === true) {

	          var _previousLimit = this.singleQueue ? this.previousNotificationLimit : this.queue.previousNotificationLimit;

	          var remainingTurns = this.singleQueue ? this.$rootScope.remainingGlobalTurns : this.$rootScope.remainingTurns[this.queue.id];

	          var validAskingPhone = this.asking_phone === true && _previousLimit != null && Number(_previousLimit) < Number(remainingTurns) ? true : false;

	          if (this.asking_name && this.asking_dni) {

	            this._showNameDniForm(ev);
	          } else if (this.asking_dni && validAskingPhone) {

	            this._showDNIPhoneForm();
	          } else if (this.asking_name && validAskingPhone) {

	            this._showNamePhoneForm(ev);
	          } else if (this.asking_dni) {

	            this._showDNIForm(ev);
	          } else if (this.asking_name) {

	            this._showNameForm(ev);
	          } else if (validAskingPhone) {

	            this.$rootScope.previousNotificationLimit = _previousLimit;
	            this._showPhoneForm(ev);
	          } else {

	            this.searchServicesBookititQueue(ev);
	          }
	        } else {

	          this.searchServicesBookititQueue(ev);
	        }
	      }
	    }
	  }]);

	  return TurnRequestButtonController;
	}();

	TurnRequestButtonController.$inject = ['$scope', 'toastr', '$translate', 'config', '$rootScope', 'Queues', '$mdDialog', '$interval', '$localStorage', 'SocketioService', 'vcRecaptchaService', 'BookititResource', 'QueueResource'];

	exports.default = TurnRequestButtonController;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TurnRequestButtonServiceComponent = undefined;

	var _turnRequestButtonService = __webpack_require__(31);

	var _turnRequestButtonService2 = _interopRequireDefault(_turnRequestButtonService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TurnRequestButtonServiceComponent = exports.TurnRequestButtonServiceComponent = {
	  bindings: {
	    queue: '=',
	    kioskId: '<'
	  },
	  controller: _turnRequestButtonService2.default,
	  templateUrl: 'app/modules/queues/common/turn-request-button-service/turn-request-button-service.html'
	};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TurnRequestButtonServiceController = function () {
	  function TurnRequestButtonServiceController($scope, toastr, $state, $translate, config, $rootScope, $stateParams, Queues, $mdDialog, $interval, $localStorage, SocketioService, vcRecaptchaService, BookititResource, QueueResource, RequestController) {
	    _classCallCheck(this, TurnRequestButtonServiceController);

	    // private
	    //  const $this = this;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$log;
	    this.SocketioService = SocketioService;
	    this.Queues = Queues;
	    this.toastr = toastr;
	    this.$translate = $translate;
	    this.establishmentId = config.ESTABLISHMENT_ID;
	    this.$mdDialog = $mdDialog;
	    this.$interval = $interval;
	    this.$localStorage = $localStorage;
	    this.determinateValue = 105;
	    var interval = '';
	    this.isAsking = true;
	    //var activePhoneQuestion = false;
	    this.remainingTurns = 0;
	    this.timerValue = 0;
	    this.name = '';
	    this.phone = '';
	    this.noTickets = false;
	    this.serviceBackground = localStorage.colorService;
	    this.showWaitingPeople = this.$localStorage.currentOrganization.waitingPeople ? this.$localStorage.currentOrganization.waitingPeople : false;
	    this.asking_name = this.$localStorage.currentLocation.askingName ? this.$localStorage.currentLocation.askingName : false;
	    this.asking_dni = this.$localStorage.currentLocation.askingDNI ? this.$localStorage.currentLocation.askingDNI : false;
	    this.asking_phone = this.$localStorage.currentLocation.asking_phone == 'true';
	    // this.$rootScope.css = this.$localStorage.currentOrganization.style_link;
	    //Captcha
	    this.vcRecaptchaService = vcRecaptchaService;

	    //Bookitit
	    this.BookititResource = BookititResource;
	    this.QueueResource = QueueResource;

	    this.RequestController = RequestController;

	    var ref = this;
	    // this.kioskId = ''
	  }

	  //////


	  _createClass(TurnRequestButtonServiceController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var $this = this;
	      if (!$this.$rootScope.remainingTurns) {
	        $this.$rootScope.remainingTurns = {};
	      }

	      $this.areaId = $this.queue.queueId;
	      $this.queue.colorService = this.serviceBackground ? '#' + this.serviceBackground : "#ff914d";
	    }
	  }, {
	    key: 'isOnline',
	    value: function isOnline() {
	      return navigator.onLine;
	    }
	  }, {
	    key: 'goToServices',
	    value: function goToServices() {
	      if (this.isOnline()) {
	        this.$state.go('queue.request-queues-subservices', {
	          kioskId: this.kioskId,
	          serviceId: this.queue.queueId
	        });
	      } else {
	        this.$scope.$parent.$parent.$ctrl.isNetworkError = true;
	      }
	    }
	  }]);

	  return TurnRequestButtonServiceController;
	}();

	TurnRequestButtonServiceController.$inject = ['$scope', 'toastr', '$state', '$translate', 'config', '$rootScope', '$stateParams', 'Queues', '$mdDialog', '$interval', '$localStorage', 'SocketioService', 'vcRecaptchaService', 'BookititResource', 'QueueResource'];

	exports.default = TurnRequestButtonServiceController;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _turnRequestSubservices = __webpack_require__(33);

	var request = angular.module('turnRequestSubservices', []).component('turnRequestSubservices', _turnRequestSubservices.TurnRequestSubservicesComponent)
	//.service('RequestService', RequestService)
	.name;

	exports.default = request;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TurnRequestSubservicesComponent = undefined;

	var _turnRequestSubservices = __webpack_require__(34);

	var _turnRequestSubservices2 = _interopRequireDefault(_turnRequestSubservices);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TurnRequestSubservicesComponent = exports.TurnRequestSubservicesComponent = {
	  controller: _turnRequestSubservices2.default,
	  templateUrl: 'app/modules/queues/turn-request-subservices/turn-request-subservices.html'
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TurnRequestSubservices = function () {
	  function TurnRequestSubservices($state, $rootScope, $localStorage, $stateParams, $interval, $location, $scope) {
	    var _this = this;

	    _classCallCheck(this, TurnRequestSubservices);

	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$localStorage = $localStorage;
	    this.$interval = $interval;
	    this.$location = $location;
	    this.timeLeft = 30;
	    this._kioskId = this.$stateParams.kioskId;
	    this.queuesByArea = this.$localStorage.queuesByArea || [];

	    this.$rootScope.remainingGlobalTurns = this.$rootScope.remainingGlobalTurns || this.queuesByArea.reduce(function (t, q) {
	      return t + _this.countAllRemainingTurns(q);
	    }, 0);

	    this.initInterval();

	    $scope.$on('$destroy', function () {
	      if (_this.interval) _this.$interval.cancel(_this.interval);
	    });
	  }

	  _createClass(TurnRequestSubservices, [{
	    key: 'initInterval',
	    value: function initInterval() {
	      var _this2 = this;

	      this.interval = this.$interval(function () {
	        if (_this2.timeLeft > 0) {
	          _this2.timeLeft--;
	        } else {
	          _this2.$interval.cancel(_this2.interval);
	          _this2.redirect();
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'redirect',
	    value: function redirect() {

	      this.$state.go('queue.request-queues', { kioskId: this._kioskId });
	    }
	  }, {
	    key: 'backToQueues',
	    value: function backToQueues() {
	      this.redirect();
	      this.$interval.cancel(this.interval);
	    }
	  }, {
	    key: 'countAllRemainingTurns',
	    value: function countAllRemainingTurns(q) {
	      var _this3 = this;

	      return (q.remainingTurns || 0) + (Array.isArray(q.children) ? q.children.reduce(function (t, c) {
	        return t + _this3.countAllRemainingTurns(c);
	      }, 0) : 0);
	    }
	  }]);

	  return TurnRequestSubservices;
	}();

	TurnRequestSubservices.$inject = ["$state", "$rootScope", "$localStorage", "$stateParams", "$interval", "$location", "$scope"];

	exports.default = TurnRequestSubservices;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RequestComponent = undefined;

	var _request = __webpack_require__(36);

	var _request2 = _interopRequireDefault(_request);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var RequestComponent = exports.RequestComponent = {
	  controller: _request2.default,
	  templateUrl: 'app/modules/queues/turn-request-index/request.template.html'
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var RequestIndexController = function () {

	  /** @ngInject */
	  RequestIndexController.$inject = ["$localStorage", "$state", "EstablishmentsResource", "$translate", "toastr", "$document", "$rootScope"];
	  function RequestIndexController($localStorage, $state, EstablishmentsResource, $translate, toastr, $document, $rootScope) {
	    var _this = this;

	    _classCallCheck(this, RequestIndexController);

	    this.EstablishmentsResource = EstablishmentsResource;
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.noKiosk = false;
	    this.$document = $document;
	    this.AsignedKiosks = [];
	    this.selectLocation = this.selectLocation;
	    //592cfffab322fa5ea50da0df

	    this.selectLocation = function (locationId) {
	      var selectedLocation = _this.allLocations.find(function (loc) {
	        return loc.id === locationId;
	      });
	      var userId = $localStorage.currentUser ? $localStorage.currentUser.id : null;
	      var authToken = localStorage.auth_token || '';

	      if (!selectedLocation) {
	        if (_this.$log) {
	          _this.$log.error("No se encontró la locación con ID:", locationId);
	        }
	        return;
	      }
	      if (!userId || !authToken) {
	        if (_this.$log) {
	          _this.$log.error("Error: Falta el usuario o el token de autenticación.");
	        }
	        return;
	      }

	      _this.selectedLocationId = locationId;
	      _this.currentLocationId = locationId;
	      _this.$localStorage.currentLocation = _this.$rootScope.currentLocation = angular.copy(selectedLocation);
	      $state.go('queue.request-index', {}, { reload: true });
	    };
	  }

	  _createClass(RequestIndexController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this2 = this;

	      var $this = this;
	      this.selectedLocationId = this.$localStorage.currentLocation && this.$localStorage.currentLocation.id || null;
	      this.allLocations = this.$localStorage.currentAllLocations || [];
	      if (this.$localStorage.current_kiosk_id) {
	        this.$state.go('queue.request-queues', { kioskId: $this.$localStorage.current_kiosk_id });
	      } else if (this.$localStorage.currentLocation && this.$localStorage.currentLocation.id) {
	        this.currentLocation = this.$localStorage.currentLocation;
	        this.currentLocationId = this.currentLocation.id;
	        // Load all kiosks by establishment
	        this.EstablishmentsResource.getDevicesByEstablishment({ id: this.currentLocationId, type: 'kiosks' }).$promise.then(function (result) {
	          if (result.length === 0) {
	            _this2.noKiosk = true;
	          } else {
	            _this2.kiosks = result;
	            _this2.kiosks.map(function (kioskTypes) {
	              if (kioskTypes.asigned === true) {
	                _this2.AsignedKiosks.push(kioskTypes);
	              }
	            });
	          }
	        }).catch(function (error) {
	          var service_error = error.statusText.toUpperCase();
	          _this2.$translate('app.API_ERROR').then(function (errorMsg) {
	            _this2.toastr.error(errorMsg + ' ' + service_error, 'Error');
	          });
	        });
	        var organization = this.$localStorage.currentOrganization;
	        if (organization.img_link) {
	          angular.element(this.$document.find('body')).css({
	            "background-image": "url(" + organization.img_link + ")",
	            "background-position": "top center",
	            "background-repeat": "no-repeat",
	            "background-size": "100% 100%"

	          });
	        }
	      } else {
	        window.location = '/login';
	        // this.$state.go('login');
	      }
	    }
	  }, {
	    key: "$onChange",
	    value: function $onChange() {

	      if (this.$log) {
	        this.$log.debug('$onChange called in RequestIndexController');
	      }
	    }
	  }]);

	  return RequestIndexController;
	}();

	RequestIndexController.$inject = ['$localStorage', '$state', 'EstablishmentsResource', '$translate', 'toastr', '$document', '$rootScope'];

	exports.default = RequestIndexController;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SocketioService = function () {

	  /** @ngInject */
	  SocketioService.$inject = ["config", "io", "$rootScope", "toastr", "$auth", "$log", "$localStorage"];
	  function SocketioService(config, io, $rootScope, toastr, $auth, $log, $localStorage) {
	    _classCallCheck(this, SocketioService);

	    this.$log = $log;
	    this.io = io;
	    this.$auth = $auth;
	    this.$rootScope = $rootScope;
	    this.toastr = toastr;
	    this.$localStorage = $localStorage;

	    this.socket = io.connect(config.api.WEBSOCKET_URL);
	    this.$rootScope.subscriptionsList = [];
	  }

	  /**
	   * Subscribe un evento cuando se agrega un turno a cada Queue asociada a la Workstation actual
	   * Agrega a la lista de subscripciones
	   */


	  _createClass(SocketioService, [{
	    key: 'subscribeNewTurnEnqueued',
	    value: function subscribeNewTurnEnqueued(queueId, cb) {
	      this._subscribe('newTurnEnqueued/' + queueId, cb);
	    }

	    /**
	     * Subscribe un evento cuando se llama a un turno a cada Queue asociada a la Workstation actual
	     * Agrega a la lista de subscripciones
	     */

	  }, {
	    key: 'subscribeNewTurnCalled',
	    value: function subscribeNewTurnCalled(queueId, cb) {
	      this._subscribe('newTurnCalled/' + queueId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza el número de turnos restantes
	     * @param queueId
	     * @param cb
	     */

	  }, {
	    key: 'subscribeRemainingTurnsCounter',
	    value: function subscribeRemainingTurnsCounter(queueId, cb) {
	      this._subscribe('remainingTurnsCounter/' + queueId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza los datos de la pantalla
	     * @param queueId
	     * @param cb
	     */

	  }, {
	    key: 'subscribeUpdateTurnsScreen',
	    value: function subscribeUpdateTurnsScreen(screenId, cb) {
	      this._subscribe('updateTurnsScreen/' + screenId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza el contador del kiosko
	     * @param kioskId
	     * @param cb
	     */

	  }, {
	    key: 'subscribeUpdateKioskCounter',
	    value: function subscribeUpdateKioskCounter(kioskId, cb) {
	      this._subscribe('updateKioskCounter/' + kioskId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza los servicios del kiosko
	     * @param kioskId
	     * @param cb
	     */

	  }, {
	    key: 'subscribeUpdateKioskServices',
	    value: function subscribeUpdateKioskServices(kioskId, cb) {
	      this._subscribe('updateKioskServices/' + kioskId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza los servicios en función de su programaión si existe
	     * @param  queueId
	     * @param  cb
	     */

	  }, {
	    key: 'subscribeStatusService',
	    value: function subscribeStatusService(queueId, cb) {
	      this._subscribe('updateKioskServiceStatus/' + queueId, cb);
	    }
	  }, {
	    key: 'subscribeNewHour',
	    value: function subscribeNewHour(cb) {
	      this._subscribe('newHour', cb);
	    }

	    /**
	     * Subscribe un evento cuando crea o actualiza un kiosk
	     * @param  kioskId
	     * @param  cb 
	     */

	  }, {
	    key: 'subscribeCreateAndUpdateKiosk',
	    value: function subscribeCreateAndUpdateKiosk(kioskId, cb) {
	      this._subscribe('createAndUpdateKiosk/' + kioskId, cb);
	    }

	    /**
	    * Subscribe un evento cuando Regenerate Token Kiosk
	    * @param  kioskId
	    * @param  cb 
	    */

	  }, {
	    key: 'subscribeNotifyRegenerateTokenKiosk',
	    value: function subscribeNotifyRegenerateTokenKiosk(kioskId, cb) {
	      this._subscribe('regenerateTokenKiosk/' + kioskId, cb);
	    }

	    /**
	     * Subscribe un evento cuando cambia una organización
	     * @param organizationId
	     * @param cb
	     */

	  }, {
	    key: 'subscribeUpdateOrganization',
	    value: function subscribeUpdateOrganization(organizationId, cb) {
	      this._subscribe('updateOrganization/' + organizationId, cb);
	    }

	    /**
	     * Subscribe un evento que actualiza el location
	     * @param {string} locationId
	     * @param {function} cb
	     */

	  }, {
	    key: 'subscribeUpdateLocation',
	    value: function subscribeUpdateLocation(locationId, cb) {
	      this._subscribe('updateLocation/' + locationId, cb);
	    }

	    /**
	     *
	     * @param name
	     * @param cb
	     * @private
	     */

	  }, {
	    key: '_subscribe',
	    value: function _subscribe(name, cb) {
	      if (!name) {
	        throw 'Error: name must be provided';
	      }

	      if (this.$rootScope.subscriptionsList.includes(name)) {
	        this.socket.removeAllListeners(name);

	        var index = this.$rootScope.subscriptionsList.indexOf(name);
	        if (index > -1) {
	          this.$rootScope.subscriptionsList.splice(index, 1);
	        }

	        if (this.$log) {
	          this.$log.debug('Socket: Cleaned duplicate listener for ' + name);
	        }
	      }

	      this.socket.on(name, cb);
	      this.$rootScope.subscriptionsList.push(name);

	      if (this.$log) {
	        this.$log.debug('Socket: Subscribed to ' + name + ' (Total: ' + this.$rootScope.subscriptionsList.length + ')');
	      }
	    }

	    //Unsubscribe all containers..

	  }, {
	    key: 'unSubscribeAll',
	    value: function unSubscribeAll() {
	      var $this = this;
	      this.$rootScope.subscriptionsList.forEach(function (socketName) {
	        return $this.socket.removeAllListeners(socketName);
	      });
	      $this.$rootScope.subscriptionsList = [];
	    }

	    //Unsubscribe one containers..

	  }, {
	    key: 'unSubscribe',
	    value: function unSubscribe(socketName) {
	      var $this = this;
	      $this.socket.removeAllListeners(socketName);

	      var index = $this.$rootScope.subscriptionsList.indexOf(socketName);
	      if (index > -1) {
	        $this.$rootScope.subscriptionsList.splice(index, 1);
	      }

	      if (this.$log) {
	        this.$log.debug('Socket: Unsubscribed from ' + socketName);
	      }
	    }
	  }, {
	    key: 'cleanServiceListeners',
	    value: function cleanServiceListeners() {
	      var _this = this;

	      var servicePrefixes = ['remainingTurnsCounter/', 'updateKioskServiceStatus/', 'newTurnEnqueued/', 'newTurnCalled/'];

	      var listenersToRemove = this.$rootScope.subscriptionsList.filter(function (name) {
	        return servicePrefixes.some(function (prefix) {
	          return name.startsWith(prefix);
	        });
	      });

	      listenersToRemove.forEach(function (name) {
	        _this.socket.removeAllListeners(name);
	        var index = _this.$rootScope.subscriptionsList.indexOf(name);
	        if (index > -1) {
	          _this.$rootScope.subscriptionsList.splice(index, 1);
	        }
	      });

	      if (this.$log) {
	        this.$log.debug('Socket: Cleaned ' + listenersToRemove.length + ' service listeners');
	      }
	    }
	  }]);

	  return SocketioService;
	}();

	SocketioService.$inject = ['config', 'io', '$rootScope', 'toastr', '$auth', '$log', '$localStorage'];

	exports.default = SocketioService;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	sentryServ.$inject = ["config"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _browser = __webpack_require__(39);

	var Sentry = _interopRequireWildcard(_browser);

	var _tracing = __webpack_require__(120);

	var _integrations = __webpack_require__(150);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function sentryServ(config) {
	    Sentry.init({
	        dsn: config.api.DSN,
	        integrations: [new _integrations.Angular(), new _tracing.BrowserTracing({
	            tracePropagationTargets: ["localhost", config.api.BASE_URL]
	        })],
	        tracesSampleRate: 1.0
	    });
	}

	exports.default = angular.module('sentry', []).config(sentryServ).name;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(41), exports);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var BrowserIntegrations = __webpack_require__(111);
	var Transports = __webpack_require__(102);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };

	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };

	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };

	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };

	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };

	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };

	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };

	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };

	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };

	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };

	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };

	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };

	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };

	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };

	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };

	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };

	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };

	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };

	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };

	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };

	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };

	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };

	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };

	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(42);
	exports.Severity = types_1.Severity;
	var core_1 = __webpack_require__(44);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.Session = core_1.Session;
	exports.startTransaction = core_1.startTransaction;
	exports.SDK_VERSION = core_1.SDK_VERSION;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(98);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(110);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(100);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(118);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(119);
	exports.SDK_NAME = version_1.SDK_NAME;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var severity_1 = __webpack_require__(43);
	exports.Severity = severity_1.Severity;
	var severity_2 = __webpack_require__(43);
	exports.SeverityLevels = severity_2.SeverityLevels;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * TODO(v7): Remove this enum and replace with SeverityLevel
	 */
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
	// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
	exports.SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(45);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(46);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	exports.Session = hub_1.Session;
	var api_1 = __webpack_require__(85);
	// eslint-disable-next-line deprecation/deprecation
	exports.API = api_1.API;
	exports.getEnvelopeEndpointWithUrlEncodedAuth = api_1.getEnvelopeEndpointWithUrlEncodedAuth;
	exports.getStoreEndpointWithUrlEncodedAuth = api_1.getStoreEndpointWithUrlEncodedAuth;
	exports.getRequestHeaders = api_1.getRequestHeaders;
	exports.initAPIDetails = api_1.initAPIDetails;
	exports.getReportDialogEndpoint = api_1.getReportDialogEndpoint;
	var baseclient_1 = __webpack_require__(86);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(89);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(90);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(92);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(91);
	exports.NoopTransport = noop_1.NoopTransport;
	var base_1 = __webpack_require__(93);
	exports.createTransport = base_1.createTransport;
	var version_1 = __webpack_require__(94);
	exports.SDK_VERSION = version_1.SDK_VERSION;
	var Integrations = __webpack_require__(95);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var hub_1 = __webpack_require__(46);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException = new Error('Sentry syntheticException');
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param Severity Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException = new Error(message);
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(47);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(81);
	exports.Session = session_1.Session;
	var sessionflusher_1 = __webpack_require__(82);
	exports.SessionFlusher = sessionflusher_1.SessionFlusher;
	var hub_1 = __webpack_require__(84);
	// eslint-disable-next-line deprecation/deprecation
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	/**
	 * Absolute maximum number of breadcrumbs added to an event.
	 * The `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	        /**
	         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
	         * sent to Sentry
	         */
	        this._sdkProcessingMetadata = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	            newScope._requestSession = scope._requestSession;
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getRequestSession = function () {
	        return this._requestSession;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setRequestSession = function (requestSession) {
	        this._requestSession = requestSession;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
	        // have a pointer to the currently-active transaction.
	        var span = this.getSpan();
	        return span && span.transaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	            if (captureContext._requestSession) {
	                this._requestSession = captureContext._requestSession;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	            if (captureContext.requestSession) {
	                this._requestSession = captureContext.requestSession;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._requestSession = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
	        // No data has been changed, so don't notify scope listeners
	        if (maxCrumbs <= 0) {
	            return this;
	        }
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs = tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional information about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relies on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = this._span.transaction && this._span.transaction.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * Add data which will be accessible during event processing but won't get sent to Sentry
	     */
	    Scope.prototype.setSDKProcessingMetadata = function (newData) {
	        this._sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, this._sdkProcessingMetadata), newData);
	        return this;
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    void result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Returns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    return utils_1.getGlobalSingleton('globalEventProcessors', function () { return []; });
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(49), exports);
	tslib_1.__exportStar(__webpack_require__(50), exports);
	tslib_1.__exportStar(__webpack_require__(57), exports);
	tslib_1.__exportStar(__webpack_require__(61), exports);
	tslib_1.__exportStar(__webpack_require__(58), exports);
	tslib_1.__exportStar(__webpack_require__(51), exports);
	tslib_1.__exportStar(__webpack_require__(62), exports);
	tslib_1.__exportStar(__webpack_require__(56), exports);
	tslib_1.__exportStar(__webpack_require__(63), exports);
	tslib_1.__exportStar(__webpack_require__(68), exports);
	tslib_1.__exportStar(__webpack_require__(69), exports);
	tslib_1.__exportStar(__webpack_require__(52), exports);
	tslib_1.__exportStar(__webpack_require__(70), exports);
	tslib_1.__exportStar(__webpack_require__(64), exports);
	tslib_1.__exportStar(__webpack_require__(71), exports);
	tslib_1.__exportStar(__webpack_require__(72), exports);
	tslib_1.__exportStar(__webpack_require__(74), exports);
	tslib_1.__exportStar(__webpack_require__(66), exports);
	tslib_1.__exportStar(__webpack_require__(75), exports);
	tslib_1.__exportStar(__webpack_require__(65), exports);
	tslib_1.__exportStar(__webpack_require__(67), exports);
	tslib_1.__exportStar(__webpack_require__(73), exports);
	tslib_1.__exportStar(__webpack_require__(76), exports);
	tslib_1.__exportStar(__webpack_require__(77), exports);
	tslib_1.__exportStar(__webpack_require__(55), exports);
	tslib_1.__exportStar(__webpack_require__(78), exports);
	tslib_1.__exportStar(__webpack_require__(79), exports);
	tslib_1.__exportStar(__webpack_require__(80), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    void promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(51);
	var is_1 = __webpack_require__(56);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem, keyAttrs) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem, keyAttrs);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el, keyAttrs) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
	    var keyAttrPairs = keyAttrs && keyAttrs.length
	        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
	        : null;
	    if (keyAttrPairs && keyAttrPairs.length) {
	        keyAttrPairs.forEach(function (keyAttrPair) {
	            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
	        });
	    }
	    else {
	        if (elem.id) {
	            out.push("#" + elem.id);
	        }
	        // eslint-disable-next-line prefer-const
	        className = elem.className;
	        if (className && is_1.isString(className)) {
	            classes = className.split(/\s+/);
	            for (i = 0; i < classes.length; i++) {
	                out.push("." + classes[i]);
	            }
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    var global = global_1.getGlobalObject();
	    try {
	        return global.document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(52);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
	            ? window // eslint-disable-line no-restricted-globals
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * Returns a global singleton contained in the global `__SENTRY__` object.
	 *
	 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
	 * function and added to the `__SENTRY__` object.
	 *
	 * @param name name of the global singleton on __SENTRY__
	 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
	 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
	 * @returns the singleton
	 */
	function getGlobalSingleton(name, creator, obj) {
	    var global = (obj || getGlobalObject());
	    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
	    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
	    return singleton;
	}
	exports.getGlobalSingleton = getGlobalSingleton;
	//# sourceMappingURL=global.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(55);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    // explicitly check for browser bundles as those can be optimized statically
	    // by terser/rollup.
	    return (!env_1.isBrowserBundle() &&
	        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/**
	 * Helper for dynamically loading module that should work with linked dependencies.
	 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
	 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
	 * build time. `require.resolve` is also not available in any other way, so we cannot create,
	 * a fake helper like we do with `dynamicRequire`.
	 *
	 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
	 * That is to mimic the behavior of `require.resolve` exactly.
	 *
	 * @param moduleName module name to require
	 * @returns possibly required module
	 */
	function loadModule(moduleName) {
	    var mod;
	    try {
	        mod = dynamicRequire(module, moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        var cwd = dynamicRequire(module, 'process').cwd;
	        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    return mod;
	}
	exports.loadModule = loadModule;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53), __webpack_require__(54)(module)))

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/*
	 * This module exists for optimizations in the build process through rollup and terser.  We define some global
	 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
	 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
	 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
	 * `logger` and preventing node-related code from appearing in browser bundles.
	 *
	 * Attention:
	 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
	 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
	 * having issues tree-shaking these constants across package boundaries.
	 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
	 * users to be able to shake away expressions that it guards.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Figures out if we're building a browser bundle.
	 *
	 * @returns true if this is a browser bundle build.
	 */
	function isBrowserBundle() {
	    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
	}
	exports.isBrowserBundle = isBrowserBundle;
	//# sourceMappingURL=env.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	// eslint-disable-next-line @typescript-eslint/unbound-method
	var objectToString = Object.prototype.toString;
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (objectToString.call(wat)) {
	        case '[object Error]':
	        case '[object Exception]':
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	function isBuiltin(wat, ty) {
	    return objectToString.call(wat) === "[object " + ty + "]";
	}
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return isBuiltin(wat, 'ErrorEvent');
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return isBuiltin(wat, 'DOMError');
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return isBuiltin(wat, 'DOMException');
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return isBuiltin(wat, 'String');
	}
	exports.isString = isString;
	/**
	 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return isBuiltin(wat, 'Object');
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return isBuiltin(wat, 'RegExp');
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value is NaN
	 * {@link isNaN}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isNaN(wat) {
	    return typeof wat === 'number' && wat !== wat;
	}
	exports.isNaN = isNaN;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var error_1 = __webpack_require__(58);
	var flags_1 = __webpack_require__(60);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	function isValidProtocol(protocol) {
	    return protocol === 'http' || protocol === 'https';
	}
	/**
	 * Renders the string representation of this Dsn.
	 *
	 * By default, this will render the public representation without the password
	 * component. To get the deprecated private representation, set `withPassword`
	 * to true.
	 *
	 * @param withPassword When set to true, the password will be included.
	 */
	function dsnToString(dsn, withPassword) {
	    if (withPassword === void 0) { withPassword = false; }
	    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
	    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
	        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	}
	exports.dsnToString = dsnToString;
	function dsnFromString(str) {
	    var match = DSN_REGEX.exec(str);
	    if (!match) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: " + str);
	    }
	    var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	    var path = '';
	    var projectId = lastPath;
	    var split = projectId.split('/');
	    if (split.length > 1) {
	        path = split.slice(0, -1).join('/');
	        projectId = split.pop();
	    }
	    if (projectId) {
	        var projectMatch = projectId.match(/^\d+/);
	        if (projectMatch) {
	            projectId = projectMatch[0];
	        }
	    }
	    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
	}
	function dsnFromComponents(components) {
	    // TODO this is for backwards compatibility, and can be removed in a future version
	    if ('user' in components && !('publicKey' in components)) {
	        components.publicKey = components.user;
	    }
	    return {
	        user: components.publicKey || '',
	        protocol: components.protocol,
	        publicKey: components.publicKey || '',
	        pass: components.pass || '',
	        host: components.host,
	        port: components.port || '',
	        path: components.path || '',
	        projectId: components.projectId,
	    };
	}
	function validateDsn(dsn) {
	    if (!flags_1.IS_DEBUG_BUILD) {
	        return;
	    }
	    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
	    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
	    requiredComponents.forEach(function (component) {
	        if (!dsn[component]) {
	            throw new error_1.SentryError("Invalid Sentry Dsn: " + component + " missing");
	        }
	    });
	    if (!projectId.match(/^\d+$/)) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
	    }
	    if (!isValidProtocol(protocol)) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
	    }
	    if (port && isNaN(parseInt(port, 10))) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid port " + port);
	    }
	    return true;
	}
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	function makeDsn(from) {
	    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
	    validateDsn(components);
	    return components;
	}
	exports.makeDsn = makeDsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var polyfill_1 = __webpack_require__(59);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
	//# sourceMappingURL=enums.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var flags_1 = __webpack_require__(60);
	var global_1 = __webpack_require__(51);
	var is_1 = __webpack_require__(56);
	var logger_1 = __webpack_require__(63);
	var object_1 = __webpack_require__(64);
	var stacktrace_1 = __webpack_require__(66);
	var supports_1 = __webpack_require__(67);
	var global = global_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            flags_1.IS_DEBUG_BUILD && logger_1.logger.warn('unknown instrumentation type:', type);
	            return;
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(type, callback) {
	    handlers[type] = handlers[type] || [];
	    handlers[type].push(callback);
	    instrument(type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                flags_1.IS_DEBUG_BUILD &&
	                    logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError:", e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    logger_1.CONSOLE_LEVELS.forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleMethod) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleMethod) {
	                    originalConsoleMethod.apply(global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            var xhrInfo = (xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            });
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        xhrInfo.status_code = xhr.status;
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.__sentry_xhr__ && args[0] !== undefined) {
	                this.__sentry_xhr__.body = args[0];
	            }
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
	            // https://github.com/getsentry/sentry-javascript/issues/3344
	            // https://github.com/bugsnag/bugsnag-js/issues/469
	            try {
	                return oldOnPopState.apply(this, args);
	            }
	            catch (_oO) {
	                // no-empty
	            }
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	var debounceDuration = 1000;
	var debounceTimerID;
	var lastCapturedEvent;
	/**
	 * Decide whether the current event should finish the debounce of previously captured one.
	 * @param previous previously captured event
	 * @param current event to be captured
	 */
	function shouldShortcircuitPreviousDebounce(previous, current) {
	    // If there was no previous event, it should always be swapped for the new one.
	    if (!previous) {
	        return true;
	    }
	    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
	    if (previous.type !== current.type) {
	        return true;
	    }
	    try {
	        // If both events have the same type, it's still possible that actions were performed on different targets.
	        // e.g. 2 clicks on different buttons.
	        if (previous.target !== current.target) {
	            return true;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
	    // to which an event listener was attached), we treat them as the same action, as we want to capture
	    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
	    return false;
	}
	/**
	 * Decide whether an event should be captured.
	 * @param event event to be captured
	 */
	function shouldSkipDOMEvent(event) {
	    // We are only interested in filtering `keypress` events for now.
	    if (event.type !== 'keypress') {
	        return false;
	    }
	    try {
	        var target = event.target;
	        if (!target || !target.tagName) {
	            return true;
	        }
	        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
	        // e.g.tabbing through elements, hotkeys, etc.
	        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	            return false;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    return true;
	}
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param handler function that will be triggered
	 * @param globalListener indicates whether event was captured by the global event listener
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function makeDOMEventHandler(handler, globalListener) {
	    if (globalListener === void 0) { globalListener = false; }
	    return function (event) {
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors).
	        // Ignore if we've already captured that event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        // We always want to skip _some_ events.
	        if (shouldSkipDOMEvent(event)) {
	            return;
	        }
	        var name = event.type === 'keypress' ? 'input' : event.type;
	        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
	        if (debounceTimerID === undefined) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
	        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
	        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
	        clearTimeout(debounceTimerID);
	        debounceTimerID = global.setTimeout(function () {
	            debounceTimerID = undefined;
	        }, debounceDuration);
	    };
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
	    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
	    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
	    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
	    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
	    global.document.addEventListener('click', globalDOMEventHandler, false);
	    global.document.addEventListener('keypress', globalDOMEventHandler, false);
	    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
	    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
	    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
	    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
	    // guaranteed to fire at least once.)
	    ['EventTarget', 'Node'].forEach(function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        object_1.fill(proto, 'addEventListener', function (originalAddEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
	                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
	                        if (!handlerForType.handler) {
	                            var handler = makeDOMEventHandler(triggerDOMHandler);
	                            handlerForType.handler = handler;
	                            originalAddEventListener.call(this, type, handler, options);
	                        }
	                        handlerForType.refCount += 1;
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalAddEventListener.call(this, type, listener, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
	                        var handlerForType = handlers_2[type];
	                        if (handlerForType) {
	                            handlerForType.refCount -= 1;
	                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
	                            if (handlerForType.refCount <= 0) {
	                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
	                                handlerForType.handler = undefined;
	                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
	                            }
	                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
	                            if (Object.keys(handlers_2).length === 0) {
	                                delete el.__sentry_instrumentation_handlers__;
	                            }
	                        }
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalRemoveEventListener.call(this, type, listener, options);
	            };
	        });
	    });
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var flags_1 = __webpack_require__(60);
	var global_1 = __webpack_require__(51);
	// TODO: Implement different loggers for different environments
	var global = global_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	exports.CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	/**
	 * Temporarily disable sentry console instrumentations.
	 *
	 * @param callback The function to run against the original `console` messages
	 * @returns The results of the callback
	 */
	function consoleSandbox(callback) {
	    var global = global_1.getGlobalObject();
	    if (!('console' in global)) {
	        return callback();
	    }
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    exports.CONSOLE_LEVELS.forEach(function (level) {
	        // TODO(v7): Remove this check as it's only needed for Node 6
	        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
	        if (level in global.console && originalWrappedFunc) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalWrappedFunc;
	        }
	    });
	    try {
	        return callback();
	    }
	    finally {
	        // Revert restoration to wrapped state
	        Object.keys(wrappedLevels).forEach(function (level) {
	            originalConsole[level] = wrappedLevels[level];
	        });
	    }
	}
	exports.consoleSandbox = consoleSandbox;
	function makeLogger() {
	    var enabled = false;
	    var logger = {
	        enable: function () {
	            enabled = true;
	        },
	        disable: function () {
	            enabled = false;
	        },
	    };
	    if (flags_1.IS_DEBUG_BUILD) {
	        exports.CONSOLE_LEVELS.forEach(function (name) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            logger[name] = function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                if (enabled) {
	                    consoleSandbox(function () {
	                        var _a;
	                        (_a = global.console)[name].apply(_a, tslib_1.__spread([PREFIX + "[" + name + "]:"], args));
	                    });
	                }
	            };
	        });
	    }
	    else {
	        exports.CONSOLE_LEVELS.forEach(function (name) {
	            logger[name] = function () { return undefined; };
	        });
	    }
	    return logger;
	}
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	var logger;
	exports.logger = logger;
	if (flags_1.IS_DEBUG_BUILD) {
	    exports.logger = logger = global_1.getGlobalSingleton('logger', makeLogger);
	}
	else {
	    exports.logger = logger = makeLogger();
	}
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var browser_1 = __webpack_require__(50);
	var is_1 = __webpack_require__(56);
	var string_1 = __webpack_require__(65);
	/**
	 * Replace a method in an object with a wrapped version of itself.
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name The name of the method to be wrapped.
	 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
	 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
	 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
	 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            markFunctionWrapped(wrapped, original);
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Defines a non-enumerable property on the given object.
	 *
	 * @param obj The object on which to set the property
	 * @param name The name of the property to be set
	 * @param value The value to which to set the property
	 */
	function addNonEnumerableProperty(obj, name, value) {
	    Object.defineProperty(obj, name, {
	        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
	        value: value,
	        writable: true,
	        configurable: true,
	    });
	}
	exports.addNonEnumerableProperty = addNonEnumerableProperty;
	/**
	 * Remembers the original function on the wrapped function and
	 * patches up the prototype.
	 *
	 * @param wrapped the wrapper function
	 * @param original the original function that gets wrapped
	 */
	function markFunctionWrapped(wrapped, original) {
	    var proto = original.prototype || {};
	    wrapped.prototype = original.prototype = proto;
	    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
	}
	exports.markFunctionWrapped = markFunctionWrapped;
	/**
	 * This extracts the original function if available.  See
	 * `markFunctionWrapped` for more information.
	 *
	 * @param func the function to unwrap
	 * @returns the unwrapped version of the function if available.
	 */
	function getOriginalFunction(func) {
	    return func.__sentry_original__;
	}
	exports.getOriginalFunction = getOriginalFunction;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function convertToPlainObject(value) {
	    var newObj = value;
	    if (is_1.isError(value)) {
	        newObj = tslib_1.__assign({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
	    }
	    else if (is_1.isEvent(value)) {
	        var event_1 = value;
	        newObj = tslib_1.__assign({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            newObj.detail = event_1.detail;
	        }
	    }
	    return newObj;
	}
	exports.convertToPlainObject = convertToPlainObject;
	/** Creates a string representation of the target of an `Event` object */
	function serializeEventTarget(target) {
	    try {
	        return is_1.isElement(target) ? browser_1.htmlTreeAsString(target) : Object.prototype.toString.call(target);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	/** Filters out all but an object's own properties */
	function getOwnProperties(obj) {
	    var extractedProps = {};
	    for (var property in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, property)) {
	            extractedProps[property] = obj[property];
	        }
	    }
	    return extractedProps;
	}
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(convertToPlainObject(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof val[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(val[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	/**
	 * Ensure that something is an object.
	 *
	 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
	 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
	 *
	 * @param wat The subject of the objectification
	 * @returns A version of `wat` which can safely be used with `Object` class methods
	 */
	function objectify(wat) {
	    var objectified;
	    switch (true) {
	        case wat === undefined || wat === null:
	            objectified = new String(wat);
	            break;
	        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
	        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
	        // an object in order to wrap it.
	        case typeof wat === 'symbol' || typeof wat === 'bigint':
	            objectified = Object(wat);
	            break;
	        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
	        case is_1.isPrimitive(wat):
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            objectified = new wat.constructor(wat);
	            break;
	        // by process of elimination, at this point we know that `wat` must already be an object
	        default:
	            objectified = wat;
	            break;
	    }
	    return objectified;
	}
	exports.objectify = objectify;
	//# sourceMappingURL=object.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(56);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var lineLength = newLine.length;
	    if (lineLength <= 150) {
	        return newLine;
	    }
	    if (colno > lineLength) {
	        // eslint-disable-next-line no-param-reassign
	        colno = lineLength;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, lineLength);
	    if (end > lineLength - 5) {
	        end = lineLength;
	    }
	    if (end === lineLength) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < lineLength) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	/**
	 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
	 * `new RegExp()`.
	 *
	 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
	 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
	 * 12+).
	 *
	 * @param regexString The string to escape
	 * @returns An version of the string with all special regex characters escaped
	 */
	function escapeStringForRegex(regexString) {
	    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
	    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
	    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
	}
	exports.escapeStringForRegex = escapeStringForRegex;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var STACKTRACE_LIMIT = 50;
	/**
	 * Creates a stack parser with the supplied line parsers
	 *
	 * StackFrames are returned in the correct order for Sentry Exception
	 * frames and with Sentry SDK internal frames removed from the top and bottom
	 *
	 */
	function createStackParser() {
	    var parsers = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        parsers[_i] = arguments[_i];
	    }
	    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
	    return function (stack, skipFirst) {
	        var e_1, _a, e_2, _b;
	        if (skipFirst === void 0) { skipFirst = 0; }
	        var frames = [];
	        try {
	            for (var _c = tslib_1.__values(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var line = _d.value;
	                try {
	                    for (var sortedParsers_1 = (e_2 = void 0, tslib_1.__values(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
	                        var parser = sortedParsers_1_1.value;
	                        var frame = parser(line);
	                        if (frame) {
	                            frames.push(frame);
	                            break;
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return stripSentryFramesAndReverse(frames);
	    };
	}
	exports.createStackParser = createStackParser;
	/**
	 * @hidden
	 */
	function stripSentryFramesAndReverse(stack) {
	    if (!stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].function || '';
	    var lastFrameFunction = localStack[localStack.length - 1].function || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return (tslib_1.__assign(tslib_1.__assign({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
	        .reverse();
	}
	exports.stripSentryFramesAndReverse = stripSentryFramesAndReverse;
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var flags_1 = __webpack_require__(60);
	var global_1 = __webpack_require__(51);
	var logger_1 = __webpack_require__(63);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in global_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	exports.isNativeFetch = isNativeFetch;
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = global_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === 'function') {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            flags_1.IS_DEBUG_BUILD &&
	                logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in global_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
	    // (see https://caniuse.com/#feat=referrer-policy),
	    // it doesn't. And it throws an exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = global_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to decycle json objects
	 */
	function memoBuilder() {
	    var hasWeakSet = typeof WeakSet === 'function';
	    var inner = hasWeakSet ? new WeakSet() : [];
	    function memoize(obj) {
	        if (hasWeakSet) {
	            if (inner.has(obj)) {
	                return true;
	            }
	            inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < inner.length; i++) {
	            var value = inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        inner.push(obj);
	        return false;
	    }
	    function unmemoize(obj) {
	        if (hasWeakSet) {
	            inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < inner.length; i++) {
	                if (inner[i] === obj) {
	                    inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    }
	    return [memoize, unmemoize];
	}
	exports.memoBuilder = memoBuilder;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var global_1 = __webpack_require__(51);
	var object_1 = __webpack_require__(64);
	var string_1 = __webpack_require__(65);
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = global_1.getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	function getFirstException(event) {
	    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
	}
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    var message = event.message, eventId = event.event_id;
	    if (message) {
	        return message;
	    }
	    var firstException = getFirstException(event);
	    if (firstException) {
	        if (firstException.type && firstException.value) {
	            return firstException.type + ": " + firstException.value;
	        }
	        return firstException.type || firstException.value || eventId || '<unknown>';
	    }
	    return eventId || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    var exception = (event.exception = event.exception || {});
	    var values = (exception.values = exception.values || []);
	    var firstException = (values[0] = values[0] || {});
	    if (!firstException.value) {
	        firstException.value = value || '';
	    }
	    if (!firstException.type) {
	        firstException.type = type || 'Error';
	    }
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
	 *
	 * @param event The event to modify.
	 * @param newMechanism Mechanism data to add to the event.
	 * @hidden
	 */
	function addExceptionMechanism(event, newMechanism) {
	    var firstException = getFirstException(event);
	    if (!firstException) {
	        return;
	    }
	    var defaultMechanism = { type: 'generic', handled: true };
	    var currentMechanism = firstException.mechanism;
	    firstException.mechanism = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaultMechanism), currentMechanism), newMechanism);
	    if (newMechanism && 'data' in newMechanism) {
	        var mergedData = tslib_1.__assign(tslib_1.__assign({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
	        firstException.mechanism.data = mergedData;
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	/**
	 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
	 * in question), and marks it captured if not.
	 *
	 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
	 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
	 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
	 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
	 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
	 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
	 * see it.
	 *
	 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
	 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
	 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
	 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
	 * must be done before the exception captured.
	 *
	 * @param A thrown exception to check or flag as having been seen
	 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
	 */
	function checkOrSetAlreadyCaught(exception) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    if (exception && exception.__sentry_captured__) {
	        return true;
	    }
	    try {
	        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
	        // `ExtraErrorData` integration
	        object_1.addNonEnumerableProperty(exception, '__sentry_captured__', true);
	    }
	    catch (err) {
	        // `exception` is a primitive, so we can't mark it seen
	    }
	    return false;
	}
	exports.checkOrSetAlreadyCaught = checkOrSetAlreadyCaught;
	//# sourceMappingURL=misc.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var is_1 = __webpack_require__(56);
	var memo_1 = __webpack_require__(68);
	var object_1 = __webpack_require__(64);
	var stacktrace_1 = __webpack_require__(66);
	/**
	 * Recursively normalizes the given object.
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skips non-enumerable properties
	 * - When stringifying, calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
	 * - Translates known global objects/classes to a string representations
	 * - Takes care of `Error` object serialization
	 * - Optionally limits depth of final output
	 * - Optionally limits number of properties/elements included in any single object/array
	 *
	 * @param input The object to be normalized.
	 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
	 * @param maxProperties The max number of elements or properties to be included in any single array or
	 * object in the normallized output..
	 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
	 */
	function normalize(input, depth, maxProperties) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (maxProperties === void 0) { maxProperties = +Infinity; }
	    try {
	        // since we're at the outermost level, there is no key
	        return visit('', input, depth, maxProperties);
	    }
	    catch (err) {
	        return { ERROR: "**non-serializable** (" + err + ")" };
	    }
	}
	exports.normalize = normalize;
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var normalized = normalize(object, depth);
	    if (jsonSize(normalized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return normalized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Visits a node to perform normalization on it
	 *
	 * @param key The key corresponding to the given node
	 * @param value The node to be visited
	 * @param depth Optional number indicating the maximum recursion depth
	 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
	 * @param memo Optional Memo class handling decycling
	 */
	function visit(key, value, depth, maxProperties, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (maxProperties === void 0) { maxProperties = +Infinity; }
	    if (memo === void 0) { memo = memo_1.memoBuilder(); }
	    var _a = tslib_1.__read(memo, 2), memoize = _a[0], unmemoize = _a[1];
	    // If the value has a `toJSON` method, see if we can bail and let it do the work
	    var valueWithToJSON = value;
	    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
	        try {
	            return valueWithToJSON.toJSON();
	        }
	        catch (err) {
	            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
	        }
	    }
	    // Get the simple cases out of the way first
	    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !is_1.isNaN(value))) {
	        return value;
	    }
	    var stringified = stringifyValue(key, value);
	    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
	    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
	    if (!stringified.startsWith('[object ')) {
	        return stringified;
	    }
	    // We're also done if we've reached the max depth
	    if (depth === 0) {
	        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
	        return stringified.replace('object ', '');
	    }
	    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
	    if (memoize(value)) {
	        return '[Circular ~]';
	    }
	    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
	    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
	    // property/entry, and keep track of the number of items we add to it.
	    var normalized = (Array.isArray(value) ? [] : {});
	    var numAdded = 0;
	    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
	    // properties are non-enumerable and otherwise would get missed.
	    var visitable = (is_1.isError(value) || is_1.isEvent(value) ? object_1.convertToPlainObject(value) : value);
	    for (var visitKey in visitable) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
	            continue;
	        }
	        if (numAdded >= maxProperties) {
	            normalized[visitKey] = '[MaxProperties ~]';
	            break;
	        }
	        // Recursively visit all the child nodes
	        var visitValue = visitable[visitKey];
	        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
	        numAdded += 1;
	    }
	    // Once we've visited all the branches, remove the parent from memo storage
	    unmemoize(value);
	    // Return accumulated values
	    return normalized;
	}
	exports.walk = visit;
	/**
	 * Stringify the given value. Handles various known special values and types.
	 *
	 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
	 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
	 *
	 * @param value The value to stringify
	 * @returns A stringified representation of the given value
	 */
	function stringifyValue(key, 
	// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
	// our internal use, it'll do
	value) {
	    try {
	        if (key === 'domain' && value && typeof value === 'object' && value._events) {
	            return '[Domain]';
	        }
	        if (key === 'domainEmitter') {
	            return '[DomainEmitter]';
	        }
	        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
	        // which won't throw if they are not present.
	        if (typeof global !== 'undefined' && value === global) {
	            return '[Global]';
	        }
	        // eslint-disable-next-line no-restricted-globals
	        if (typeof window !== 'undefined' && value === window) {
	            return '[Window]';
	        }
	        // eslint-disable-next-line no-restricted-globals
	        if (typeof document !== 'undefined' && value === document) {
	            return '[Document]';
	        }
	        // React's SyntheticEvent thingy
	        if (is_1.isSyntheticEvent(value)) {
	            return '[SyntheticEvent]';
	        }
	        if (typeof value === 'number' && value !== value) {
	            return '[NaN]';
	        }
	        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
	        if (value === void 0) {
	            return '[undefined]';
	        }
	        if (typeof value === 'function') {
	            return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	        }
	        if (typeof value === 'symbol') {
	            return "[" + String(value) + "]";
	        }
	        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
	        if (typeof value === 'bigint') {
	            return "[BigInt: " + String(value) + "]";
	        }
	        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
	        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
	        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
	        // we can make sure that only plain objects come out that way.
	        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
	    }
	    catch (err) {
	        return "**non-serializable** (" + err + ")";
	    }
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	//# sourceMappingURL=normalize.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(58);
	var syncpromise_1 = __webpack_require__(73);
	/**
	 * Creates an new PromiseBuffer object with the specified limit
	 * @param limit max number of promises that can be stored in the buffer
	 */
	function makePromiseBuffer(limit) {
	    var buffer = [];
	    function isReady() {
	        return limit === undefined || buffer.length < limit;
	    }
	    /**
	     * Remove a promise from the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    function remove(task) {
	        return buffer.splice(buffer.indexOf(task), 1)[0];
	    }
	    /**
	     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
	     *
	     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
	     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
	     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
	     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
	     *        limit check.
	     * @returns The original promise.
	     */
	    function add(taskProducer) {
	        if (!isReady()) {
	            return syncpromise_1.rejectedSyncPromise(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        // start the task and add its promise to the queue
	        var task = taskProducer();
	        if (buffer.indexOf(task) === -1) {
	            buffer.push(task);
	        }
	        void task
	            .then(function () { return remove(task); })
	            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
	            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
	            // have promises, so TS has to polyfill when down-compiling.)
	            .then(null, function () {
	            return remove(task).then(null, function () {
	                // We have to add another catch here because `remove()` starts a new promise chain.
	            });
	        });
	        return task;
	    }
	    /**
	     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
	     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
	     * `false` otherwise
	     */
	    function drain(timeout) {
	        return new syncpromise_1.SyncPromise(function (resolve, reject) {
	            var counter = buffer.length;
	            if (!counter) {
	                return resolve(true);
	            }
	            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            // if all promises resolve in time, cancel the timer and resolve to `true`
	            buffer.forEach(function (item) {
	                void syncpromise_1.resolvedSyncPromise(item).then(function () {
	                    // eslint-disable-next-line no-plusplus
	                    if (!--counter) {
	                        clearTimeout(capturedSetTimeout);
	                        resolve(true);
	                    }
	                }, reject);
	            });
	        });
	    }
	    return {
	        $: buffer,
	        add: add,
	        drain: drain,
	    };
	}
	exports.makePromiseBuffer = makePromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(56);
	/**
	 * Creates a resolved sync promise.
	 *
	 * @param value the value to resolve the promise with
	 * @returns the resolved sync promise
	 */
	function resolvedSyncPromise(value) {
	    return new SyncPromise(function (resolve) {
	        resolve(value);
	    });
	}
	exports.resolvedSyncPromise = resolvedSyncPromise;
	/**
	 * Creates a rejected sync promise.
	 *
	 * @param value the value to reject the promise with
	 * @returns the rejected sync promise
	 */
	function rejectedSyncPromise(reason) {
	    return new SyncPromise(function (_, reject) {
	        reject(reason);
	    });
	}
	exports.rejectedSyncPromise = rejectedSyncPromise;
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = 0 /* PENDING */;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(1 /* RESOLVED */, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(2 /* REJECTED */, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== 0 /* PENDING */) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                void value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === 0 /* PENDING */) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler[0]) {
	                    return;
	                }
	                if (_this._state === 1 /* RESOLVED */) {
	                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                    handler[1](_this._value);
	                }
	                if (_this._state === 2 /* REJECTED */) {
	                    handler[2](_this._value);
	                }
	                handler[0] = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._handlers.push([
	                false,
	                function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                    }
	                    else {
	                        try {
	                            resolve(onfulfilled(result));
	                        }
	                        catch (e) {
	                            reject(e);
	                        }
	                    }
	                },
	                function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                    }
	                    else {
	                        try {
	                            resolve(onrejected(reason));
	                        }
	                        catch (e) {
	                            reject(e);
	                        }
	                    }
	                },
	            ]);
	            _this._executeHandlers();
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(42);
	var enums_1 = __webpack_require__(61);
	function isSupportedSeverity(level) {
	    return enums_1.SeverityLevels.indexOf(level) !== -1;
	}
	/**
	 * Converts a string-based level into a {@link Severity}.
	 *
	 * @param level string representation of Severity
	 * @returns Severity
	 */
	function severityFromString(level) {
	    if (level === 'warn')
	        return types_1.Severity.Warning;
	    if (isSupportedSeverity(level)) {
	        return level;
	    }
	    return types_1.Severity.Log;
	}
	exports.severityFromString = severityFromString;
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Converts an HTTP status code to sentry status {@link EventStatus}.
	 *
	 * @param code number HTTP status code
	 * @returns EventStatus
	 */
	function eventStatusFromHttpCode(code) {
	    if (code >= 200 && code < 300) {
	        return 'success';
	    }
	    if (code === 429) {
	        return 'rate_limit';
	    }
	    if (code >= 400 && code < 500) {
	        return 'invalid';
	    }
	    if (code >= 500) {
	        return 'failed';
	    }
	    return 'unknown';
	}
	exports.eventStatusFromHttpCode = eventStatusFromHttpCode;
	//# sourceMappingURL=status.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(51);
	var node_1 = __webpack_require__(52);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
	    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
	    // data as reliable if they are within a reasonable threshold of the current time.
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        exports._browserPerformanceTimeOriginMode = 'none';
	        return undefined;
	    }
	    var threshold = 3600 * 1000;
	    var performanceNow = performance.now();
	    var dateNow = Date.now();
	    // if timeOrigin isn't available set delta to threshold so it isn't used
	    var timeOriginDelta = performance.timeOrigin
	        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
	        : threshold;
	    var timeOriginIsReliable = timeOriginDelta < threshold;
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    var navigationStart = performance.timing && performance.timing.navigationStart;
	    var hasNavigationStart = typeof navigationStart === 'number';
	    // if navigationStart isn't available set delta to threshold so it isn't used
	    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
	    var navigationStartIsReliable = navigationStartDelta < threshold;
	    if (timeOriginIsReliable || navigationStartIsReliable) {
	        // Use the more reliable time origin
	        if (timeOriginDelta <= navigationStartDelta) {
	            exports._browserPerformanceTimeOriginMode = 'timeOrigin';
	            return performance.timeOrigin;
	        }
	        else {
	            exports._browserPerformanceTimeOriginMode = 'navigationStart';
	            return navigationStart;
	        }
	    }
	    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
	    exports._browserPerformanceTimeOriginMode = 'dateNow';
	    return dateNow;
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)(module)))

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
	    '([0-9a-f]{32})?' + // trace_id
	    '-?([0-9a-f]{16})?' + // span_id
	    '-?([01])?' + // sampled
	    '[ \\t]*$');
	/**
	 * Extract transaction context data from a `sentry-trace` header.
	 *
	 * @param traceparent Traceparent string
	 *
	 * @returns Object containing data from the header, or undefined if traceparent string is malformed
	 */
	function extractTraceparentData(traceparent) {
	    var matches = traceparent.match(exports.TRACEPARENT_REGEXP);
	    if (matches) {
	        var parentSampled = void 0;
	        if (matches[3] === '1') {
	            parentSampled = true;
	        }
	        else if (matches[3] === '0') {
	            parentSampled = false;
	        }
	        return {
	            traceId: matches[1],
	            parentSampled: parentSampled,
	            parentSpanId: matches[2],
	        };
	    }
	    return undefined;
	}
	exports.extractTraceparentData = extractTraceparentData;
	//# sourceMappingURL=tracing.js.map

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var is_1 = __webpack_require__(56);
	/**
	 * Creates an envelope.
	 * Make sure to always explicitly provide the generic to this function
	 * so that the envelope types resolve correctly.
	 */
	function createEnvelope(headers, items) {
	    if (items === void 0) { items = []; }
	    return [headers, items];
	}
	exports.createEnvelope = createEnvelope;
	/**
	 * Add an item to an envelope.
	 * Make sure to always explicitly provide the generic to this function
	 * so that the envelope types resolve correctly.
	 */
	function addItemToEnvelope(envelope, newItem) {
	    var _a = tslib_1.__read(envelope, 2), headers = _a[0], items = _a[1];
	    return [headers, tslib_1.__spread(items, [newItem])];
	}
	exports.addItemToEnvelope = addItemToEnvelope;
	/**
	 * Get the type of the envelope. Grabs the type from the first envelope item.
	 */
	function getEnvelopeType(envelope) {
	    var _a = tslib_1.__read(envelope, 2), _b = tslib_1.__read(_a[1], 1), _c = tslib_1.__read(_b[0], 1), firstItemHeader = _c[0];
	    return firstItemHeader.type;
	}
	exports.getEnvelopeType = getEnvelopeType;
	/**
	 * Serializes an envelope into a string.
	 */
	function serializeEnvelope(envelope) {
	    var _a = tslib_1.__read(envelope, 2), headers = _a[0], items = _a[1];
	    var serializedHeaders = JSON.stringify(headers);
	    // Have to cast items to any here since Envelope is a union type
	    // Fixed in Typescript 4.2
	    // TODO: Remove any[] cast when we upgrade to TS 4.2
	    // https://github.com/microsoft/TypeScript/issues/36390
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return items.reduce(function (acc, item) {
	        var _a = tslib_1.__read(item, 2), itemHeaders = _a[0], payload = _a[1];
	        // We do not serialize payloads that are primitives
	        var serializedPayload = is_1.isPrimitive(payload) ? String(payload) : JSON.stringify(payload);
	        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
	    }, serializedHeaders);
	}
	exports.serializeEnvelope = serializeEnvelope;
	//# sourceMappingURL=envelope.js.map

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var envelope_1 = __webpack_require__(78);
	var time_1 = __webpack_require__(76);
	/**
	 * Creates client report envelope
	 * @param discarded_events An array of discard events
	 * @param dsn A DSN that can be set on the header. Optional.
	 */
	function createClientReportEnvelope(discarded_events, dsn, timestamp) {
	    var clientReportItem = [
	        { type: 'client_report' },
	        {
	            timestamp: timestamp || time_1.dateTimestampInSeconds(),
	            discarded_events: discarded_events,
	        },
	    ];
	    return envelope_1.createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
	}
	exports.createClientReportEnvelope = createClientReportEnvelope;
	//# sourceMappingURL=clientreport.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	exports.DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param header string representation of 'Retry-After' header
	 * @param now current unix timestamp
	 *
	 */
	function parseRetryAfterHeader(header, now) {
	    if (now === void 0) { now = Date.now(); }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return exports.DEFAULT_RETRY_AFTER;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * Gets the time that given category is disabled until for rate limiting
	 */
	function disabledUntil(limits, category) {
	    return limits[category] || limits.all || 0;
	}
	exports.disabledUntil = disabledUntil;
	/**
	 * Checks if a category is rate limited
	 */
	function isRateLimited(limits, category, now) {
	    if (now === void 0) { now = Date.now(); }
	    return disabledUntil(limits, category) > now;
	}
	exports.isRateLimited = isRateLimited;
	/**
	 * Update ratelimits from incoming headers.
	 * Returns true if headers contains a non-empty rate limiting header.
	 */
	function updateRateLimits(limits, headers, now) {
	    var e_1, _a, e_2, _b;
	    if (now === void 0) { now = Date.now(); }
	    var updatedRateLimits = tslib_1.__assign({}, limits);
	    // "The name is case-insensitive."
	    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	    var rateLimitHeader = headers['x-sentry-rate-limits'];
	    var retryAfterHeader = headers['retry-after'];
	    if (rateLimitHeader) {
	        try {
	            /**
	             * rate limit headers are of the form
	             *     <header>,<header>,..
	             * where each <header> is of the form
	             *     <retry_after>: <categories>: <scope>: <reason_code>
	             * where
	             *     <retry_after> is a delay in seconds
	             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	             *         <category>;<category>;...
	             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
	             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	             */
	            for (var _c = tslib_1.__values(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var limit = _d.value;
	                var parameters = limit.split(':', 2);
	                var headerDelay = parseInt(parameters[0], 10);
	                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                if (!parameters[1]) {
	                    updatedRateLimits.all = now + delay;
	                }
	                else {
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            updatedRateLimits[category] = now + delay;
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    else if (retryAfterHeader) {
	        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
	    }
	    return updatedRateLimits;
	}
	exports.updateRateLimits = updateRateLimits;
	//# sourceMappingURL=ratelimit.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.duration = 0;
	        this.status = 'ok';
	        this.init = true;
	        this.ignoreDuration = false;
	        // Both timestamp and started are in seconds since the UNIX epoch.
	        var startingTime = utils_1.timestampInSeconds();
	        this.timestamp = startingTime;
	        this.started = startingTime;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (!this.ipAddress && context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!this.did && !context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || utils_1.timestampInSeconds();
	        if (context.ignoreDuration) {
	            this.ignoreDuration = context.ignoreDuration;
	        }
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.init !== undefined) {
	            this.init = context.init;
	        }
	        if (!this.did && context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (this.ignoreDuration) {
	            this.duration = undefined;
	        }
	        else if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            var duration = this.timestamp - this.started;
	            this.duration = duration >= 0 ? duration : 0;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (!this.ipAddress && context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (!this.userAgent && context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === 'ok') {
	            this.update({ status: 'exited' });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: this.init,
	            // Make sure that sec is converted to ms for date constructor
	            started: new Date(this.started * 1000).toISOString(),
	            timestamp: new Date(this.timestamp * 1000).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: {
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            },
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(83);
	var hub_1 = __webpack_require__(84);
	/**
	 * @inheritdoc
	 */
	var SessionFlusher = /** @class */ (function () {
	    function SessionFlusher(transport, attrs) {
	        var _this = this;
	        this.flushTimeout = 60;
	        this._pendingAggregates = {};
	        this._isEnabled = true;
	        this._transport = transport;
	        // Call to setInterval, so that flush is called every 60 seconds
	        this._intervalId = setInterval(function () { return _this.flush(); }, this.flushTimeout * 1000);
	        this._sessionAttrs = attrs;
	    }
	    /** Sends session aggregates to Transport */
	    SessionFlusher.prototype.sendSessionAggregates = function (sessionAggregates) {
	        if (!this._transport.sendSession) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        void this._transport.sendSession(sessionAggregates).then(null, function (reason) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	        });
	    };
	    /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSessions` */
	    SessionFlusher.prototype.flush = function () {
	        var sessionAggregates = this.getSessionAggregates();
	        if (sessionAggregates.aggregates.length === 0) {
	            return;
	        }
	        this._pendingAggregates = {};
	        this.sendSessionAggregates(sessionAggregates);
	    };
	    /** Massages the entries in `pendingAggregates` and returns aggregated sessions */
	    SessionFlusher.prototype.getSessionAggregates = function () {
	        var _this = this;
	        var aggregates = Object.keys(this._pendingAggregates).map(function (key) {
	            return _this._pendingAggregates[parseInt(key)];
	        });
	        var sessionAggregates = {
	            attrs: this._sessionAttrs,
	            aggregates: aggregates,
	        };
	        return utils_1.dropUndefinedKeys(sessionAggregates);
	    };
	    /** JSDoc */
	    SessionFlusher.prototype.close = function () {
	        clearInterval(this._intervalId);
	        this._isEnabled = false;
	        this.flush();
	    };
	    /**
	     * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
	     * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
	     * `_incrementSessionStatusCount` along with the start date
	     */
	    SessionFlusher.prototype.incrementSessionStatusCount = function () {
	        if (!this._isEnabled) {
	            return;
	        }
	        var scope = hub_1.getCurrentHub().getScope();
	        var requestSession = scope && scope.getRequestSession();
	        if (requestSession && requestSession.status) {
	            this._incrementSessionStatusCount(requestSession.status, new Date());
	            // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
	            // case captureRequestSession is called more than once to prevent double count
	            if (scope) {
	                scope.setRequestSession(undefined);
	            }
	            /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        }
	    };
	    /**
	     * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
	     * the session received
	     */
	    SessionFlusher.prototype._incrementSessionStatusCount = function (status, date) {
	        // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
	        var sessionStartedTrunc = new Date(date).setSeconds(0, 0);
	        this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
	        // corresponds to aggregated sessions in one specific minute bucket
	        // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
	        var aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
	        if (!aggregationCounts.started) {
	            aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
	        }
	        switch (status) {
	            case 'errored':
	                aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
	                return aggregationCounts.errored;
	            case 'ok':
	                aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
	                return aggregationCounts.exited;
	            default:
	                aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
	                return aggregationCounts.crashed;
	        }
	    };
	    return SessionFlusher;
	}());
	exports.SessionFlusher = SessionFlusher;
	//# sourceMappingURL=sessionflusher.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(83);
	var scope_1 = __webpack_require__(47);
	var session_1 = __webpack_require__(81);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 4;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        if (client) {
	            this.bindClient(client);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4();
	        if (event.type !== 'transaction') {
	            this._lastEventId = eventId;
	        }
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureSession = function (endSession) {
	        if (endSession === void 0) { endSession = false; }
	        // both send the update and pull the session from the scope
	        if (endSession) {
	            return this.endSession();
	        }
	        // only send the update
	        this._sendSessionUpdate();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var layer = this.getStackTop();
	        var scope = layer && layer.scope;
	        var session = scope && scope.getSession();
	        if (session) {
	            session.close();
	        }
	        this._sendSessionUpdate();
	        // the session is over; take it off of the scope
	        if (scope) {
	            scope.setSession();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        // Will fetch userAgent if called from browser sdk
	        var global = utils_1.getGlobalObject();
	        var userAgent = (global.navigator || {}).userAgent;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
	        if (scope) {
	            // End existing session if there's one
	            var currentSession = scope.getSession && scope.getSession();
	            if (currentSession && currentSession.status === 'ok') {
	                currentSession.update({ status: 'exited' });
	            }
	            this.endSession();
	            // Afterwards we set the new session on the scope
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * Sends the current Session on the scope
	     */
	    Hub.prototype._sendSessionUpdate = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/**
	 * Returns the global shim registry.
	 *
	 * FIXME: This function is problematic, because despite always returning a valid Carrier,
	 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
	 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
	 **/
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 * @deprecated No longer used; remove in v7
	 * @returns The domain, or undefined if there is no active domain
	 */
	// eslint-disable-next-line deprecation/deprecation
	function getActiveDomain() {
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var sentry = getMainCarrier().__SENTRY__;
	        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    return utils_1.getGlobalSingleton('hub', function () { return new Hub(); }, carrier);
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 * @returns A boolean indicating success or failure
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
	    __SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var SENTRY_API_VERSION = '7';
	/**
	 * Helper class to provide urls, headers and metadata that can be used to form
	 * different types of requests to Sentry endpoints.
	 * Supports both envelopes and regular event requests.
	 *
	 * @deprecated Please use APIDetails
	 **/
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn, metadata, tunnel) {
	        if (metadata === void 0) { metadata = {}; }
	        this.dsn = dsn;
	        this._dsnObject = utils_1.makeDsn(dsn);
	        this.metadata = metadata;
	        this._tunnel = tunnel;
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Does this transport force envelopes? */
	    API.prototype.forceEnvelope = function () {
	        return !!this._tunnel;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        return getBaseApiEndpoint(this._dsnObject);
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return getStoreEndpoint(this._dsnObject);
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
	    };
	    return API;
	}());
	exports.API = API;
	/** Initializes API Details */
	function initAPIDetails(dsn, metadata, tunnel) {
	    return {
	        initDsn: dsn,
	        metadata: metadata || {},
	        dsn: utils_1.makeDsn(dsn),
	        tunnel: tunnel,
	    };
	}
	exports.initAPIDetails = initAPIDetails;
	/** Returns the prefix to construct Sentry ingestion API endpoints. */
	function getBaseApiEndpoint(dsn) {
	    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	    var port = dsn.port ? ":" + dsn.port : '';
	    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	}
	/** Returns the ingest API endpoint for target. */
	function _getIngestEndpoint(dsn, target) {
	    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
	}
	/** Returns a URL-encoded string with auth config suitable for a query string. */
	function _encodedAuth(dsn) {
	    return utils_1.urlEncode({
	        // We send only the minimum set of required information. See
	        // https://github.com/getsentry/sentry-javascript/issues/2572.
	        sentry_key: dsn.publicKey,
	        sentry_version: SENTRY_API_VERSION,
	    });
	}
	/** Returns the store endpoint URL. */
	function getStoreEndpoint(dsn) {
	    return _getIngestEndpoint(dsn, 'store');
	}
	/**
	 * Returns the store endpoint URL with auth in the query string.
	 *
	 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	 */
	function getStoreEndpointWithUrlEncodedAuth(dsn) {
	    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
	}
	exports.getStoreEndpointWithUrlEncodedAuth = getStoreEndpointWithUrlEncodedAuth;
	/** Returns the envelope endpoint URL. */
	function _getEnvelopeEndpoint(dsn) {
	    return _getIngestEndpoint(dsn, 'envelope');
	}
	/**
	 * Returns the envelope endpoint URL with auth in the query string.
	 *
	 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	 */
	function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
	    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
	}
	exports.getEnvelopeEndpointWithUrlEncodedAuth = getEnvelopeEndpointWithUrlEncodedAuth;
	/**
	 * Returns an object that can be used in request headers.
	 * This is needed for node and the old /store endpoint in sentry
	 */
	function getRequestHeaders(dsn, clientName, clientVersion) {
	    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
	    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	    header.push("sentry_client=" + clientName + "/" + clientVersion);
	    header.push("sentry_key=" + dsn.publicKey);
	    if (dsn.pass) {
	        header.push("sentry_secret=" + dsn.pass);
	    }
	    return {
	        'Content-Type': 'application/json',
	        'X-Sentry-Auth': header.join(', '),
	    };
	}
	exports.getRequestHeaders = getRequestHeaders;
	/** Returns the url to the report dialog endpoint. */
	function getReportDialogEndpoint(dsnLike, dialogOptions) {
	    var dsn = utils_1.makeDsn(dsnLike);
	    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
	    var encodedOptions = "dsn=" + utils_1.dsnToString(dsn);
	    for (var key in dialogOptions) {
	        if (key === 'dsn') {
	            continue;
	        }
	        if (key === 'user') {
	            if (!dialogOptions.user) {
	                continue;
	            }
	            if (dialogOptions.user.name) {
	                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
	            }
	            if (dialogOptions.user.email) {
	                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
	            }
	        }
	        else {
	            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
	        }
	    }
	    return endpoint + "?" + encodedOptions;
	}
	exports.getReportDialogEndpoint = getReportDialogEndpoint;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(46);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(87);
	var integration_1 = __webpack_require__(88);
	var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient._prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of calls being processed */
	        this._numProcessing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = utils_1.makeDsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        // ensure we haven't captured this very object before
	        if (utils_1.checkOrSetAlreadyCaught(exception)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        // ensure we haven't captured this very object before
	        if (hint && hint.originalException && utils_1.checkOrSetAlreadyCaught(hint.originalException)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!this._isEnabled()) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('SDK not enabled, will not capture session.');
	            return;
	        }
	        if (!(typeof session.release === 'string')) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Discarded session because of missing or non-string release');
	        }
	        else {
	            this._sendSession(session);
	            // After sending, we set init false to indicate it's not the first occurrence
	            session.update({ init: false });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getTransport = function () {
	        return this._getBackend().getTransport();
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
	            return _this.getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled() && !this._integrations.initialized) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        // A session is updated and that session update is sent in only one of the two following scenarios:
	        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
	        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
	        var sessionNonTerminal = session.status === 'ok';
	        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
	        if (shouldUpdateAndSend) {
	            session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
	            this.captureSession(session);
	        }
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /**
	     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
	     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
	     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
	     * `false` otherwise
	     */
	    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._numProcessing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.resolvedSyncPromise(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (evt) {
	                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
	                // it is only attached as extra data to the event if the event somehow skips being normalized
	                evt.sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, evt.sdkProcessingMetadata), { normalizeDepth: utils_1.normalize(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
	            }
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth, maxBreadth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth, maxBreadth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth, maxBreadth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth, maxBreadth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        normalized.sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param event The event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var integrationsArray = Object.keys(this._integrations);
	        if (integrationsArray.length > 0) {
	            event.sdk = event.sdk || {};
	            event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), integrationsArray);
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        var transport = this.getTransport();
	        function recordLostEvent(outcome, category) {
	            if (transport.recordLostEvent) {
	                transport.recordLostEvent(outcome, category);
	            }
	        }
	        if (!this._isEnabled()) {
	            return utils_1.rejectedSyncPromise(new utils_1.SentryError('SDK not enabled, will not capture event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            recordLostEvent('sample_rate', 'event');
	            return utils_1.rejectedSyncPromise(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                recordLostEvent('event_processor', event.type || 'event');
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            return _ensureBeforeSendRv(beforeSendResult);
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                recordLostEvent('before_send', event.type || 'event');
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._numProcessing += 1;
	        void promise.then(function (value) {
	            _this._numProcessing -= 1;
	            return value;
	        }, function (reason) {
	            _this._numProcessing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	/**
	 * Verifies that return value of configured `beforeSend` is of expected type.
	 */
	function _ensureBeforeSendRv(rv) {
	    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
	    if (utils_1.isThenable(rv)) {
	        return rv.then(function (event) {
	            if (!(utils_1.isPlainObject(event) || event === null)) {
	                throw new utils_1.SentryError(nullErr);
	            }
	            return event;
	        }, function (e) {
	            throw new utils_1.SentryError("beforeSend rejected with " + e);
	        });
	    }
	    else if (!(utils_1.isPlainObject(rv) || rv === null)) {
	        throw new utils_1.SentryError(nullErr);
	    }
	    return rv;
	}
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var hub_1 = __webpack_require__(46);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(87);
	exports.installedIntegrations = [];
	/**
	 * @private
	 */
	function filterDuplicates(integrations) {
	    return integrations.reduce(function (acc, integrations) {
	        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
	            acc.push(integrations);
	        }
	        return acc;
	    }, []);
	}
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = tslib_1.__spread(filterDuplicates(defaultIntegrations));
	    if (Array.isArray(userIntegrations)) {
	        // Filter out integrations that are also included in user options
	        integrations = tslib_1.__spread(integrations.filter(function (integrations) {
	            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
	        }), filterDuplicates(userIntegrations));
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(integrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
	    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
	    // considered a member of the index the way the actual integrations are
	    utils_1.addNonEnumerableProperty(integrations, 'initialized', true);
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var api_1 = __webpack_require__(85);
	var flags_1 = __webpack_require__(87);
	var request_1 = __webpack_require__(90);
	var noop_1 = __webpack_require__(91);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        // TODO(v7): Remove the if-else
	        if (this._newTransport &&
	            this._options.dsn &&
	            this._options._experiments &&
	            this._options._experiments.newTransport) {
	            var api = api_1.initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
	            var env = request_1.createEventEnvelope(event, api);
	            void this._newTransport.send(env).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending event:', reason);
	            });
	        }
	        else {
	            void this._transport.sendEvent(event).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending event:', reason);
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        // TODO(v7): Remove the if-else
	        if (this._newTransport &&
	            this._options.dsn &&
	            this._options._experiments &&
	            this._options._experiments.newTransport) {
	            var api = api_1.initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
	            var _a = tslib_1.__read(request_1.createSessionEnvelope(session, api), 1), env = _a[0];
	            void this._newTransport.send(env).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	            });
	        }
	        else {
	            void this._transport.sendSession(session).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var api_1 = __webpack_require__(85);
	/** Extract sdk info from from the API metadata */
	function getSdkMetadataForEnvelopeHeader(api) {
	    if (!api.metadata || !api.metadata.sdk) {
	        return;
	    }
	    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
	    return { name: name, version: version };
	}
	/**
	 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
	 * Merge with existing data if any.
	 **/
	function enhanceEventWithSdkInfo(event, sdkInfo) {
	    if (!sdkInfo) {
	        return event;
	    }
	    event.sdk = event.sdk || {};
	    event.sdk.name = event.sdk.name || sdkInfo.name;
	    event.sdk.version = event.sdk.version || sdkInfo.version;
	    event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), (sdkInfo.integrations || []));
	    event.sdk.packages = tslib_1.__spread((event.sdk.packages || []), (sdkInfo.packages || []));
	    return event;
	}
	/** Creates an envelope from a Session */
	function createSessionEnvelope(session, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
	    var type = 'aggregates' in session ? 'sessions' : 'session';
	    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
	    var envelopeItem = [{ type: type }, session];
	    var envelope = utils_1.createEnvelope(envelopeHeaders, [envelopeItem]);
	    return [envelope, type];
	}
	exports.createSessionEnvelope = createSessionEnvelope;
	/** Creates a SentryRequest from a Session. */
	function sessionToSentryRequest(session, api) {
	    var _a = tslib_1.__read(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
	    return {
	        body: utils_1.serializeEnvelope(envelope),
	        type: type,
	        url: api_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/**
	 * Create an Envelope from an event. Note that this is duplicated from below,
	 * but on purpose as this will be refactored in v7.
	 */
	function createEventEnvelope(event, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var eventType = event.type || 'event';
	    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
	    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
	    // TODO: Below is a temporary hack in order to debug a serialization error - see
	    // https://github.com/getsentry/sentry-javascript/issues/2809,
	    // https://github.com/getsentry/sentry-javascript/pull/4425, and
	    // https://github.com/getsentry/sentry-javascript/pull/4574.
	    //
	    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
	    // throw a circular reference error.
	    //
	    // When it's time to remove it:
	    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
	    //    `sdkProcessingMetadata`
	    // 2. Restore the original version of the request body, which is commented out
	    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
	    //    baseClient tests in this package
	    enhanceEventWithSdkInfo(event, api.metadata.sdk);
	    event.tags = event.tags || {};
	    event.extra = event.extra || {};
	    // In theory, all events should be marked as having gone through normalization and so
	    // we should never set this tag/extra data
	    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
	        event.tags.skippedNormalization = true;
	        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
	    }
	    // prevent this data from being sent to sentry
	    // TODO: This is NOT part of the hack - DO NOT DELETE
	    delete event.sdkProcessingMetadata;
	    var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	    var eventItem = [
	        {
	            type: eventType,
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        },
	        event,
	    ];
	    return utils_1.createEnvelope(envelopeHeaders, [eventItem]);
	}
	exports.createEventEnvelope = createEventEnvelope;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var eventType = event.type || 'event';
	    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
	    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
	    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
	    // TODO: Below is a temporary hack in order to debug a serialization error - see
	    // https://github.com/getsentry/sentry-javascript/issues/2809,
	    // https://github.com/getsentry/sentry-javascript/pull/4425, and
	    // https://github.com/getsentry/sentry-javascript/pull/4574.
	    //
	    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
	    // throw a circular reference error.
	    //
	    // When it's time to remove it:
	    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
	    //    `sdkProcessingMetadata`
	    // 2. Restore the original version of the request body, which is commented out
	    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
	    //    baseClient tests in this package
	    enhanceEventWithSdkInfo(event, api.metadata.sdk);
	    event.tags = event.tags || {};
	    event.extra = event.extra || {};
	    // In theory, all events should be marked as having gone through normalization and so
	    // we should never set this tag/extra data
	    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
	        event.tags.skippedNormalization = true;
	        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
	    }
	    // prevent this data from being sent to sentry
	    // TODO: This is NOT part of the hack - DO NOT DELETE
	    delete event.sdkProcessingMetadata;
	    var body;
	    try {
	        // 99.9% of events should get through just fine - no change in behavior for them
	        body = JSON.stringify(event);
	    }
	    catch (err) {
	        // Record data about the error without replacing original event data, then force renormalization
	        event.tags.JSONStringifyError = true;
	        event.extra.JSONStringifyError = err;
	        try {
	            body = JSON.stringify(utils_1.normalize(event));
	        }
	        catch (newErr) {
	            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
	            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
	            // debug with this hack, we won't ever land here.
	            var innerErr = newErr;
	            body = JSON.stringify({
	                message: 'JSON.stringify error after renormalization',
	                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
	                extra: { message: innerErr.message, stack: innerErr.stack },
	            });
	        }
	    }
	    var req = {
	        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
	        // the mystery
	        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
	        body: body,
	        type: eventType,
	        url: useEnvelope
	            ? api_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
	            : api_1.getStoreEndpointWithUrlEncodedAuth(api.dsn),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	        var eventItem = [
	            {
	                type: eventType,
	                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	            },
	            req.body,
	        ];
	        var envelope = utils_1.createEnvelope(envelopeHeaders, [eventItem]);
	        req.body = utils_1.serializeEnvelope(envelope);
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.resolvedSyncPromise({
	            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
	            status: 'skipped',
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.resolvedSyncPromise(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(46);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(87);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        if (flags_1.IS_DEBUG_BUILD) {
	            utils_1.logger.enable();
	        }
	        else {
	            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
	            // eslint-disable-next-line no-console
	            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
	        }
	    }
	    var hub = hub_1.getCurrentHub();
	    var scope = hub.getScope();
	    if (scope) {
	        scope.update(options.initialScope);
	    }
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	exports.ERROR_TRANSPORT_CATEGORY = 'error';
	exports.TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
	exports.ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
	exports.SESSION_TRANSPORT_CATEGORY = 'session';
	exports.DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
	/**
	 * Creates a `NewTransport`
	 *
	 * @param options
	 * @param makeRequest
	 */
	function createTransport(options, makeRequest, buffer) {
	    if (buffer === void 0) { buffer = utils_1.makePromiseBuffer(options.bufferSize || exports.DEFAULT_TRANSPORT_BUFFER_SIZE); }
	    var rateLimits = {};
	    var flush = function (timeout) { return buffer.drain(timeout); };
	    function send(envelope) {
	        var envCategory = utils_1.getEnvelopeType(envelope);
	        var category = envCategory === 'event' ? 'error' : envCategory;
	        var request = {
	            category: category,
	            body: utils_1.serializeEnvelope(envelope),
	        };
	        // Don't add to buffer if transport is already rate-limited
	        if (utils_1.isRateLimited(rateLimits, category)) {
	            return utils_1.rejectedSyncPromise({
	                status: 'rate_limit',
	                reason: getRateLimitReason(rateLimits, category),
	            });
	        }
	        var requestTask = function () {
	            return makeRequest(request).then(function (_a) {
	                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
	                var status = utils_1.eventStatusFromHttpCode(statusCode);
	                if (headers) {
	                    rateLimits = utils_1.updateRateLimits(rateLimits, headers);
	                }
	                if (status === 'success') {
	                    return utils_1.resolvedSyncPromise({ status: status, reason: reason });
	                }
	                return utils_1.rejectedSyncPromise({
	                    status: status,
	                    reason: reason ||
	                        body ||
	                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
	                });
	            });
	        };
	        return buffer.add(requestTask);
	    }
	    return {
	        send: send,
	        flush: flush,
	    };
	}
	exports.createTransport = createTransport;
	function getRateLimitReason(rateLimits, category) {
	    return "Too many " + category + " requests, backing off until: " + new Date(utils_1.disabledUntil(rateLimits, category)).toISOString();
	}
	//# sourceMappingURL=base.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_VERSION = '6.19.7';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(96);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(97);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = utils_1.getOriginalFunction(this) || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(87);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var hub = getCurrentHub();
	            if (hub) {
	                var self_1 = hub.getIntegration(InboundFilters);
	                if (self_1) {
	                    var client = hub.getClient();
	                    var clientOptions = client ? client.getOptions() : {};
	                    var options = _mergeOptions(self_1._options, clientOptions);
	                    return _shouldDropEvent(event, options) ? null : event;
	                }
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	/** JSDoc */
	function _mergeOptions(internalOptions, clientOptions) {
	    if (internalOptions === void 0) { internalOptions = {}; }
	    if (clientOptions === void 0) { clientOptions = {}; }
	    return {
	        allowUrls: tslib_1.__spread((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	        denyUrls: tslib_1.__spread((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	        ignoreErrors: tslib_1.__spread((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
	    };
	}
	exports._mergeOptions = _mergeOptions;
	/** JSDoc */
	function _shouldDropEvent(event, options) {
	    if (options.ignoreInternal && _isSentryError(event)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	        return true;
	    }
	    if (_isIgnoredError(event, options.ignoreErrors)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	        return true;
	    }
	    if (_isDeniedUrl(event, options.denyUrls)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
	        return true;
	    }
	    if (!_isAllowedUrl(event, options.allowUrls)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
	        return true;
	    }
	    return false;
	}
	exports._shouldDropEvent = _shouldDropEvent;
	function _isIgnoredError(event, ignoreErrors) {
	    if (!ignoreErrors || !ignoreErrors.length) {
	        return false;
	    }
	    return _getPossibleEventMessages(event).some(function (message) {
	        return ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	    });
	}
	function _isDeniedUrl(event, denyUrls) {
	    // TODO: Use Glob instead?
	    if (!denyUrls || !denyUrls.length) {
	        return false;
	    }
	    var url = _getEventFilterUrl(event);
	    return !url ? false : denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	}
	function _isAllowedUrl(event, allowUrls) {
	    // TODO: Use Glob instead?
	    if (!allowUrls || !allowUrls.length) {
	        return true;
	    }
	    var url = _getEventFilterUrl(event);
	    return !url ? true : allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	}
	function _getPossibleEventMessages(event) {
	    if (event.message) {
	        return [event.message];
	    }
	    if (event.exception) {
	        try {
	            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	            return ["" + value, type + ": " + value];
	        }
	        catch (oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	            return [];
	        }
	    }
	    return [];
	}
	function _isSentryError(event) {
	    try {
	        // @ts-ignore can't be a sentry error if undefined
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        return event.exception.values[0].type === 'SentryError';
	    }
	    catch (e) {
	        // ignore
	    }
	    return false;
	}
	function _getLastValidUrl(frames) {
	    if (frames === void 0) { frames = []; }
	    for (var i = frames.length - 1; i >= 0; i--) {
	        var frame = frames[i];
	        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
	            return frame.filename || null;
	        }
	    }
	    return null;
	}
	function _getEventFilterUrl(event) {
	    try {
	        if (event.stacktrace) {
	            return _getLastValidUrl(event.stacktrace.frames);
	        }
	        var frames_1;
	        try {
	            // @ts-ignore we only care about frames if the whole thing here is defined
	            frames_1 = event.exception.values[0].stacktrace.frames;
	        }
	        catch (e) {
	            // ignore
	        }
	        return frames_1 ? _getLastValidUrl(frames_1) : null;
	    }
	    catch (oO) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	        return null;
	    }
	}
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var backend_1 = __webpack_require__(99);
	var flags_1 = __webpack_require__(104);
	var helpers_1 = __webpack_require__(110);
	var integrations_1 = __webpack_require__(111);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        var _this = this;
	        options._metadata = options._metadata || {};
	        options._metadata.sdk = options._metadata.sdk || {
	            name: 'sentry.javascript.browser',
	            packages: [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: core_1.SDK_VERSION,
	                },
	            ],
	            version: core_1.SDK_VERSION,
	        };
	        _this = _super.call(this, backend_1.BrowserBackend, options) || this;
	        return _this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var types_1 = __webpack_require__(42);
	var utils_1 = __webpack_require__(48);
	var eventbuilder_1 = __webpack_require__(100);
	var transports_1 = __webpack_require__(102);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(exception, hint, this._options.attachStacktrace);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(message, level, hint, this._options.attachStacktrace);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
	        var api = core_1.initAPIDetails(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
	        var url = core_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel);
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            var requestOptions = tslib_1.__assign({}, transportOptions.fetchParameters);
	            this._newTransport = transports_1.makeNewFetchTransport({ requestOptions: requestOptions, url: url });
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        this._newTransport = transports_1.makeNewXHRTransport({
	            url: url,
	            headers: transportOptions.headers,
	        });
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var types_1 = __webpack_require__(42);
	var utils_1 = __webpack_require__(48);
	var stack_parsers_1 = __webpack_require__(101);
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromError(ex) {
	    // Get the frames first since Opera can lose the stack if we touch anything else first
	    var frames = parseStackFrames(ex);
	    var exception = {
	        type: ex && ex.name,
	        value: extractMessage(ex),
	    };
	    if (frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromError = exceptionFromError;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var frames_1 = parseStackFrames(syntheticException);
	        if (frames_1.length) {
	            event.stacktrace = { frames: frames_1 };
	        }
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromError(ex) {
	    return {
	        exception: {
	            values: [exceptionFromError(ex)],
	        },
	    };
	}
	exports.eventFromError = eventFromError;
	/** Parses stack frames from an error */
	function parseStackFrames(ex) {
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace || ex.stack || '';
	    var popSize = getPopSize(ex);
	    try {
	        return utils_1.createStackParser(stack_parsers_1.opera10StackParser, stack_parsers_1.opera11StackParser, stack_parsers_1.chromeStackParser, stack_parsers_1.winjsStackParser, stack_parsers_1.geckoStackParser)(stacktrace, popSize);
	    }
	    catch (e) {
	        // no-empty
	    }
	    return [];
	}
	exports.parseStackFrames = parseStackFrames;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	function getPopSize(ex) {
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            return ex.framesToPop;
	        }
	        if (reactMinifiedRegexp.test(ex.message)) {
	            return 1;
	        }
	    }
	    return 0;
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	/**
	 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
	 * @hidden
	 */
	function eventFromException(exception, hint, attachStacktrace) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
	    utils_1.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.resolvedSyncPromise(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(message, level, hint, attachStacktrace) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, attachStacktrace);
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.resolvedSyncPromise(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        return eventFromError(errorEvent.error);
	    }
	    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
	    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
	    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
	    //
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        var domException = exception;
	        if ('stack' in exception) {
	            event = eventFromError(exception);
	        }
	        else {
	            var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	            var message = domException.message ? name_1 + ": " + domException.message : name_1;
	            event = eventFromString(message, syntheticException, attachStacktrace);
	            utils_1.addExceptionTypeValue(event, message);
	        }
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        return eventFromError(exception);
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
	        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
	        // group on any key/value change.
	        var objectException = exception;
	        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, attachStacktrace);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, attachStacktrace) {
	    var event = {
	        message: input,
	    };
	    if (attachStacktrace && syntheticException) {
	        var frames_2 = parseStackFrames(syntheticException);
	        if (frames_2.length) {
	            event.stacktrace = { frames: frames_2 };
	        }
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	var OPERA10_PRIORITY = 10;
	var OPERA11_PRIORITY = 20;
	var CHROME_PRIORITY = 30;
	var WINJS_PRIORITY = 40;
	var GECKO_PRIORITY = 50;
	function createFrame(filename, func, lineno, colno) {
	    var frame = {
	        filename: filename,
	        function: func,
	        // All browser frames are considered in_app
	        in_app: true,
	    };
	    if (lineno !== undefined) {
	        frame.lineno = lineno;
	    }
	    if (colno !== undefined) {
	        frame.colno = colno;
	    }
	    return frame;
	}
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	var chrome = function (line) {
	    var parts = chromeRegex.exec(line);
	    if (parts) {
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval) {
	            var subMatch = chromeEvalRegex.exec(parts[2]);
	            if (subMatch) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = subMatch[1]; // url
	                parts[3] = subMatch[2]; // line
	                parts[4] = subMatch[3]; // column
	            }
	        }
	        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
	        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
	        var _a = tslib_1.__read(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
	        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
	    }
	    return;
	};
	exports.chromeStackParser = [CHROME_PRIORITY, chrome];
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var gecko = function (line) {
	    var _a;
	    var parts = geckoREgex.exec(line);
	    if (parts) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval) {
	            var subMatch = geckoEvalRegex.exec(parts[3]);
	            if (subMatch) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || 'eval';
	                parts[3] = subMatch[1];
	                parts[4] = subMatch[2];
	                parts[5] = ''; // no column when eval
	            }
	        }
	        var filename = parts[3];
	        var func = parts[1] || UNKNOWN_FUNCTION;
	        _a = tslib_1.__read(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
	        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
	    }
	    return;
	};
	exports.geckoStackParser = [GECKO_PRIORITY, gecko];
	var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var winjs = function (line) {
	    var parts = winjsRegex.exec(line);
	    return parts
	        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
	        : undefined;
	};
	exports.winjsStackParser = [WINJS_PRIORITY, winjs];
	var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	var opera10 = function (line) {
	    var parts = opera10Regex.exec(line);
	    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
	};
	exports.opera10StackParser = [OPERA10_PRIORITY, opera10];
	var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
	var opera11 = function (line) {
	    var parts = opera11Regex.exec(line);
	    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
	};
	exports.opera11StackParser = [OPERA11_PRIORITY, opera11];
	/**
	 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
	 * What it means, is that instead of format like:
	 *
	 * Error: wat
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *
	 * it produces something like:
	 *
	 *   function@url:row:col
	 *   function@url:row:col
	 *   function@url:row:col
	 *
	 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
	 * This function is extracted so that we can use it in both places without duplicating the logic.
	 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
	 * and fix this case seems like an impossible, or at least way too time-consuming task.
	 */
	var extractSafariExtensionDetails = function (func, filename) {
	    var isSafariExtension = func.indexOf('safari-extension') !== -1;
	    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
	    return isSafariExtension || isSafariWebExtension
	        ? [
	            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
	            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
	        ]
	        : [func, filename];
	};
	//# sourceMappingURL=stack-parsers.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(103);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(106);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(107);
	exports.XHRTransport = xhr_1.XHRTransport;
	var new_fetch_1 = __webpack_require__(108);
	exports.makeNewFetchTransport = new_fetch_1.makeNewFetchTransport;
	var new_xhr_1 = __webpack_require__(109);
	exports.makeNewXHRTransport = new_xhr_1.makeNewXHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(104);
	var utils_2 = __webpack_require__(105);
	function requestTypeToCategory(ty) {
	    var tyStr = ty;
	    return tyStr === 'event' ? 'error' : tyStr;
	}
	var global = utils_1.getGlobalObject();
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        var _this = this;
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = utils_1.makePromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._outcomes = {};
	        this._api = core_1.initAPIDetails(options.dsn, options._metadata, options.tunnel);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = core_1.getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
	        if (this.options.sendClientReports && global.document) {
	            global.document.addEventListener('visibilitychange', function () {
	                if (global.document.visibilityState === 'hidden') {
	                    _this._flushOutcomes();
	                }
	            });
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.recordLostEvent = function (reason, category) {
	        var _a;
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        // We want to track each category (event, transaction, session) separately
	        // but still keep the distinction between different type of outcomes.
	        // We could use nested maps, but it's much easier to read and type this way.
	        // A correct type for map-based implementation if we want to go that route
	        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
	        var key = requestTypeToCategory(category) + ":" + reason;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Adding outcome: " + key);
	        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
	    };
	    /**
	     * Send outcomes as an envelope
	     */
	    BaseTransport.prototype._flushOutcomes = function () {
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        var outcomes = this._outcomes;
	        this._outcomes = {};
	        // Nothing to send
	        if (!Object.keys(outcomes).length) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('No outcomes to flush');
	            return;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
	        var url = core_1.getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
	        var discardedEvents = Object.keys(outcomes).map(function (key) {
	            var _a = tslib_1.__read(key.split(':'), 2), category = _a[0], reason = _a[1];
	            return {
	                reason: reason,
	                category: category,
	                quantity: outcomes[key],
	            };
	            // TODO: Improve types on discarded_events to get rid of cast
	        });
	        var envelope = utils_1.createClientReportEnvelope(discardedEvents, this._api.tunnel && utils_1.dsnToString(this._api.dsn));
	        try {
	            utils_2.sendReport(url, utils_1.serializeEnvelope(envelope));
	        }
	        catch (e) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error(e);
	        }
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = utils_1.eventStatusFromHttpCode(response.status);
	        this._rateLimits = utils_1.updateRateLimits(this._rateLimits, headers);
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(requestType)) {
	            flags_1.IS_DEBUG_BUILD &&
	                // eslint-disable-next-line deprecation/deprecation
	                utils_1.logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
	        }
	        if (status === 'success') {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     *
	     * @deprecated Please use `disabledUntil` from @sentry/utils
	     */
	    BaseTransport.prototype._disabledUntil = function (requestType) {
	        var category = requestTypeToCategory(requestType);
	        return new Date(utils_1.disabledUntil(this._rateLimits, category));
	    };
	    /**
	     * Checks if a category is rate limited
	     *
	     * @deprecated Please use `isRateLimited` from @sentry/utils
	     */
	    BaseTransport.prototype._isRateLimited = function (requestType) {
	        var category = requestTypeToCategory(requestType);
	        return utils_1.isRateLimited(this._rateLimits, category);
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(104);
	var global = utils_1.getGlobalObject();
	var cachedFetchImpl;
	/**
	 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
	 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
	 * this chain becomes orphaned and there is no possible way to capture it's rejections
	 * other than allowing it bubble up to this very handler. eg.
	 *
	 * const f = window.fetch;
	 * window.fetch = function () {
	 *   const p = f.apply(this, arguments);
	 *
	 *   p.then(function() {
	 *     console.log('hi.');
	 *   });
	 *
	 *   return p;
	 * }
	 *
	 * `p.then(function () { ... })` is producing a completely separate promise chain,
	 * however, what's returned is `p` - the result of original `fetch` call.
	 *
	 * This mean, that whenever we use the Fetch API to send our own requests, _and_
	 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
	 * effectively causing another event to be captured.
	 * This makes a whole process become an infinite loop, which we need to somehow
	 * deal with, and break it in one way or another.
	 *
	 * To deal with this issue, we are making sure that we _always_ use the real
	 * browser Fetch API, instead of relying on what `window.fetch` exposes.
	 * The only downside to this would be missing our own requests as breadcrumbs,
	 * but because we are already not doing this, it should be just fine.
	 *
	 * Possible failed fetch error messages per-browser:
	 *
	 * Chrome:  Failed to fetch
	 * Edge:    Failed to Fetch
	 * Firefox: NetworkError when attempting to fetch resource
	 * Safari:  resource blocked by content blocker
	 */
	function getNativeFetchImplementation() {
	    if (cachedFetchImpl) {
	        return cachedFetchImpl;
	    }
	    /* eslint-disable @typescript-eslint/unbound-method */
	    // Fast path to avoid DOM I/O
	    if (utils_1.isNativeFetch(global.fetch)) {
	        return (cachedFetchImpl = global.fetch.bind(global));
	    }
	    var document = global.document;
	    var fetchImpl = global.fetch;
	    // eslint-disable-next-line deprecation/deprecation
	    if (document && typeof document.createElement === 'function') {
	        try {
	            var sandbox = document.createElement('iframe');
	            sandbox.hidden = true;
	            document.head.appendChild(sandbox);
	            var contentWindow = sandbox.contentWindow;
	            if (contentWindow && contentWindow.fetch) {
	                fetchImpl = contentWindow.fetch;
	            }
	            document.head.removeChild(sandbox);
	        }
	        catch (e) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
	        }
	    }
	    return (cachedFetchImpl = fetchImpl.bind(global));
	    /* eslint-enable @typescript-eslint/unbound-method */
	}
	exports.getNativeFetchImplementation = getNativeFetchImplementation;
	/**
	 * Sends sdk client report using sendBeacon or fetch as a fallback if available
	 *
	 * @param url report endpoint
	 * @param body report payload
	 */
	function sendReport(url, body) {
	    var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
	    var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';
	    if (hasSendBeacon) {
	        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
	        var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
	        return sendBeacon(url, body);
	    }
	    if (utils_1.supportsFetch()) {
	        var fetch_1 = getNativeFetchImplementation();
	        return utils_1.forget(fetch_1(url, {
	            body: body,
	            method: 'POST',
	            credentials: 'omit',
	            keepalive: true,
	        }));
	    }
	}
	exports.sendReport = sendReport;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var base_1 = __webpack_require__(103);
	var utils_2 = __webpack_require__(105);
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport(options, fetchImpl) {
	        if (fetchImpl === void 0) { fetchImpl = utils_2.getNativeFetchImplementation(); }
	        var _this = _super.call(this, options) || this;
	        _this._fetch = fetchImpl;
	        return _this;
	    }
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                // eslint-disable-next-line deprecation/deprecation
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
	            // (see https://caniuse.com/#feat=referrer-policy),
	            // it doesn't. And it throws an exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                void _this._fetch(sentryRequest.url, options)
	                    .then(function (response) {
	                    var headers = {
	                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                        'retry-after': response.headers.get('Retry-After'),
	                    };
	                    _this._handleResponse({
	                        requestType: sentryRequest.type,
	                        response: response,
	                        headers: headers,
	                        resolve: resolve,
	                        reject: reject,
	                    });
	                })
	                    .catch(reject);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent('queue_overflow', sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent('network_error', sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var base_1 = __webpack_require__(103);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                // eslint-disable-next-line deprecation/deprecation
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                var request = new XMLHttpRequest();
	                request.onreadystatechange = function () {
	                    if (request.readyState === 4) {
	                        var headers = {
	                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                            'retry-after': request.getResponseHeader('Retry-After'),
	                        };
	                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                    }
	                };
	                request.open('POST', sentryRequest.url);
	                for (var header in _this.options.headers) {
	                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
	                        request.setRequestHeader(header, _this.options.headers[header]);
	                    }
	                }
	                request.send(sentryRequest.body);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent('queue_overflow', sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent('network_error', sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(105);
	/**
	 * Creates a Transport that uses the Fetch API to send events to Sentry.
	 */
	function makeNewFetchTransport(options, nativeFetch) {
	    if (nativeFetch === void 0) { nativeFetch = utils_1.getNativeFetchImplementation(); }
	    function makeRequest(request) {
	        var requestOptions = tslib_1.__assign({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
	        return nativeFetch(options.url, requestOptions).then(function (response) {
	            return response.text().then(function (body) { return ({
	                body: body,
	                headers: {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                },
	                reason: response.statusText,
	                statusCode: response.status,
	            }); });
	        });
	    }
	    return core_1.createTransport({ bufferSize: options.bufferSize }, makeRequest);
	}
	exports.makeNewFetchTransport = makeNewFetchTransport;
	//# sourceMappingURL=new-fetch.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	/**
	 * The DONE ready state for XmlHttpRequest
	 *
	 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
	 * (e.g. during testing, it is `undefined`)
	 *
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
	 */
	var XHR_READYSTATE_DONE = 4;
	/**
	 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
	 */
	function makeNewXHRTransport(options) {
	    function makeRequest(request) {
	        return new utils_1.SyncPromise(function (resolve, _reject) {
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === XHR_READYSTATE_DONE) {
	                    var response = {
	                        body: xhr.response,
	                        headers: {
	                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
	                            'retry-after': xhr.getResponseHeader('Retry-After'),
	                        },
	                        reason: xhr.statusText,
	                        statusCode: xhr.status,
	                    };
	                    resolve(response);
	                }
	            };
	            xhr.open('POST', options.url);
	            for (var header in options.headers) {
	                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
	                    xhr.setRequestHeader(header, options.headers[header]);
	                }
	            }
	            xhr.send(request.body);
	        });
	    }
	    return core_1.createTransport({ bufferSize: options.bufferSize }, makeRequest);
	}
	exports.makeNewXHRTransport = makeNewXHRTransport;
	//# sourceMappingURL=new-xhr.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(104);
	var global = utils_1.getGlobalObject();
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    // for future readers what this does is wrap a function and then create
	    // a bi-directional wrapping between them.
	    //
	    // example: wrapped = wrap(original);
	    //  original.__sentry_wrapped__ -> wrapped
	    //  wrapped.__sentry_original__ -> original
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // if we're dealing with a function that was previously wrapped, return
	        // the original wrapper.
	        var wrapper = fn.__sentry_wrapped__;
	        if (wrapper) {
	            return wrapper;
	        }
	        // We don't wanna wrap it twice
	        if (utils_1.getOriginalFunction(fn)) {
	            return fn;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(event, undefined, undefined);
	                        utils_1.addExceptionMechanism(event, options.mechanism);
	                    }
	                    event.extra = tslib_1.__assign(tslib_1.__assign({}, event.extra), { arguments: args });
	                    return event;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    utils_1.markFunctionWrapped(sentryWrapped, fn);
	    utils_1.addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!global.document) {
	        return;
	    }
	    if (!options.eventId) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Missing eventId option in showReportDialog call');
	        return;
	    }
	    if (!options.dsn) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Missing dsn option in showReportDialog call');
	        return;
	    }
	    var script = global.document.createElement('script');
	    script.async = true;
	    script.src = core_1.getReportDialogEndpoint(options.dsn, options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    var injectionPoint = global.document.head || global.document.body;
	    if (injectionPoint) {
	        injectionPoint.appendChild(script);
	    }
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(112);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(113);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(114);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(115);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(116);
	exports.UserAgent = useragent_1.UserAgent;
	var dedupe_1 = __webpack_require__(117);
	exports.Dedupe = dedupe_1.Dedupe;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(44);
	var types_1 = __webpack_require__(42);
	var utils_1 = __webpack_require__(48);
	var eventbuilder_1 = __webpack_require__(100);
	var flags_1 = __webpack_require__(104);
	var helpers_1 = __webpack_require__(110);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /**
	         * Stores references functions to installing handlers. Will set to undefined
	         * after they have been run so that they are not used twice.
	         */
	        this._installFunc = {
	            onerror: _installGlobalOnErrorHandler,
	            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
	        };
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        var options = this._options;
	        // We can disable guard-for-in as we construct the options object above + do checks against
	        // `this._installFunc` for the property.
	        // eslint-disable-next-line guard-for-in
	        for (var key in options) {
	            var installFunc = this._installFunc[key];
	            if (installFunc && options[key]) {
	                globalHandlerLog(key);
	                installFunc();
	                this._installFunc[key] = undefined;
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	/** JSDoc */
	function _installGlobalOnErrorHandler() {
	    utils_1.addInstrumentationHandler('error', 
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function (data) {
	        var _a = tslib_1.__read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
	        if (!hub.getIntegration(GlobalHandlers)) {
	            return;
	        }
	        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
	        if (helpers_1.shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
	            return;
	        }
	        var event = error === undefined && utils_1.isString(msg)
	            ? _eventFromIncompleteOnError(msg, url, line, column)
	            : _enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
	        event.level = types_1.Severity.Error;
	        addMechanismAndCapture(hub, error, event, 'onerror');
	    });
	}
	/** JSDoc */
	function _installGlobalOnUnhandledRejectionHandler() {
	    utils_1.addInstrumentationHandler('unhandledrejection', 
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function (e) {
	        var _a = tslib_1.__read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
	        if (!hub.getIntegration(GlobalHandlers)) {
	            return;
	        }
	        var error = e;
	        // dig the object of the rejection out of known event types
	        try {
	            // PromiseRejectionEvents store the object of the rejection under 'reason'
	            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	            if ('reason' in e) {
	                error = e.reason;
	            }
	            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	            // https://github.com/getsentry/sentry-javascript/issues/2380
	            else if ('detail' in e && 'reason' in e.detail) {
	                error = e.detail.reason;
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        if (helpers_1.shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
	            return true;
	        }
	        var event = utils_1.isPrimitive(error)
	            ? _eventFromRejectionWithPrimitive(error)
	            : eventbuilder_1.eventFromUnknownInput(error, undefined, attachStacktrace, true);
	        event.level = types_1.Severity.Error;
	        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
	        return;
	    });
	}
	/**
	 * Create an event from a promise rejection where the `reason` is a primitive.
	 *
	 * @param reason: The `reason` property of the promise rejection
	 * @returns An Event object with an appropriate `exception` value
	 */
	function _eventFromRejectionWithPrimitive(reason) {
	    return {
	        exception: {
	            values: [
	                {
	                    type: 'UnhandledRejection',
	                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                    value: "Non-Error promise rejection captured with value: " + String(reason),
	                },
	            ],
	        },
	    };
	}
	/**
	 * This function creates a stack from an old, error-less onerror handler.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _eventFromIncompleteOnError(msg, url, line, column) {
	    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	    // If 'message' is ErrorEvent, get real message from inside
	    var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	    var name = 'Error';
	    var groups = message.match(ERROR_TYPES_RE);
	    if (groups) {
	        name = groups[1];
	        message = groups[2];
	    }
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: name,
	                    value: message,
	                },
	            ],
	        },
	    };
	    return _enhanceEventWithInitialFrame(event, url, line, column);
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _enhanceEventWithInitialFrame(event, url, line, column) {
	    // event.exception
	    var e = (event.exception = event.exception || {});
	    // event.exception.values
	    var ev = (e.values = e.values || []);
	    // event.exception.values[0]
	    var ev0 = (ev[0] = ev[0] || {});
	    // event.exception.values[0].stacktrace
	    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
	    // event.exception.values[0].stacktrace.frames
	    var ev0sf = (ev0s.frames = ev0s.frames || []);
	    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	    var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	    // event.exception.values[0].stacktrace.frames
	    if (ev0sf.length === 0) {
	        ev0sf.push({
	            colno: colno,
	            filename: filename,
	            function: '?',
	            in_app: true,
	            lineno: lineno,
	        });
	    }
	    return event;
	}
	function globalHandlerLog(type) {
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Global Handler attached: " + type);
	}
	function addMechanismAndCapture(hub, error, event, type) {
	    utils_1.addExceptionMechanism(event, {
	        handled: false,
	        type: type,
	    });
	    hub.captureEvent(event, {
	        originalException: error,
	    });
	}
	function getHubAndAttachStacktrace() {
	    var hub = core_1.getCurrentHub();
	    var client = hub.getClient();
	    var attachStacktrace = client && client.getOptions().attachStacktrace;
	    return [hub, attachStacktrace];
	}
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var helpers_1 = __webpack_require__(110);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', _wrapTimeFunction);
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', _wrapTimeFunction);
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', _wrapRAF);
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
	        }
	        var eventTargetOption = this._options.eventTarget;
	        if (eventTargetOption) {
	            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(_wrapEventTarget);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	/** JSDoc */
	function _wrapTimeFunction(original) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var originalCallback = args[0];
	        args[0] = helpers_1.wrap(originalCallback, {
	            mechanism: {
	                data: { function: utils_1.getFunctionName(original) },
	                handled: true,
	                type: 'instrument',
	            },
	        });
	        return original.apply(this, args);
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _wrapRAF(original) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function (callback) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        return original.apply(this, [
	            helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }),
	        ]);
	    };
	}
	/** JSDoc */
	function _wrapXHR(originalSend) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        // eslint-disable-next-line @typescript-eslint/no-this-alias
	        var xhr = this;
	        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	        xmlHttpRequestProps.forEach(function (prop) {
	            if (prop in xhr && typeof xhr[prop] === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                utils_1.fill(xhr, prop, function (original) {
	                    var wrapOptions = {
	                        mechanism: {
	                            data: {
	                                function: prop,
	                                handler: utils_1.getFunctionName(original),
	                            },
	                            handled: true,
	                            type: 'instrument',
	                        },
	                    };
	                    // If Instrument integration has been called before TryCatch, get the name of original function
	                    var originalFunction = utils_1.getOriginalFunction(original);
	                    if (originalFunction) {
	                        wrapOptions.mechanism.data.handler = utils_1.getFunctionName(originalFunction);
	                    }
	                    // Otherwise wrap directly
	                    return helpers_1.wrap(original, wrapOptions);
	                });
	            }
	        });
	        return originalSend.apply(this, args);
	    };
	}
	/** JSDoc */
	function _wrapEventTarget(target) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var global = utils_1.getGlobalObject();
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var proto = global[target] && global[target].prototype;
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	        return;
	    }
	    utils_1.fill(proto, 'addEventListener', function (original) {
	        return function (eventName, fn, options) {
	            try {
	                if (typeof fn.handleEvent === 'function') {
	                    fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                        mechanism: {
	                            data: {
	                                function: 'handleEvent',
	                                handler: utils_1.getFunctionName(fn),
	                                target: target,
	                            },
	                            handled: true,
	                            type: 'instrument',
	                        },
	                    });
	                }
	            }
	            catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	            }
	            return original.apply(this, [
	                eventName,
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }),
	                options,
	            ]);
	        };
	    });
	    utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	        return function (eventName, fn, options) {
	            /**
	             * There are 2 possible scenarios here:
	             *
	             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	             * as a pass-through, and call original `removeEventListener` with it.
	             *
	             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	             *
	             * When someone adds a handler prior to initialization, and then do it again, but after,
	             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	             * to get rid of the initial handler and it'd stick there forever.
	             */
	            var wrappedEventHandler = fn;
	            try {
	                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
	                if (originalEventHandler) {
	                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                }
	            }
	            catch (e) {
	                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	            }
	            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	        };
	    });
	}
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(44);
	var types_1 = __webpack_require__(42);
	var utils_1 = __webpack_require__(48);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler('console', _consoleBreadcrumb);
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler('xhr', _xhrBreadcrumb);
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler('fetch', _fetchBreadcrumb);
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler('history', _historyBreadcrumb);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	/**
	 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
	 * This is a HOC so that we get access to dom options in the closure.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _domBreadcrumb(dom) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function _innerDomBreadcrumb(handlerData) {
	        var target;
	        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
	        if (typeof keyAttrs === 'string') {
	            keyAttrs = [keyAttrs];
	        }
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target, keyAttrs)
	                : utils_1.htmlTreeAsString(handlerData.event, keyAttrs);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	            global: handlerData.global,
	        });
	    }
	    return _innerDomBreadcrumb;
	}
	/**
	 * Creates breadcrumbs from console API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _consoleBreadcrumb(handlerData) {
	    var breadcrumb = {
	        category: 'console',
	        data: {
	            arguments: handlerData.args,
	            logger: 'console',
	        },
	        level: utils_1.severityFromString(handlerData.level),
	        message: utils_1.safeJoin(handlerData.args, ' '),
	    };
	    if (handlerData.level === 'assert') {
	        if (handlerData.args[0] === false) {
	            breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	            breadcrumb.data.arguments = handlerData.args.slice(1);
	        }
	        else {
	            // Don't capture a breadcrumb for passed assertions
	            return;
	        }
	    }
	    core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	        input: handlerData.args,
	        level: handlerData.level,
	    });
	}
	/**
	 * Creates breadcrumbs from XHR API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _xhrBreadcrumb(handlerData) {
	    if (handlerData.endTimestamp) {
	        // We only capture complete, non-sentry requests
	        if (handlerData.xhr.__sentry_own_request__) {
	            return;
	        }
	        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'xhr',
	            data: {
	                method: method,
	                url: url,
	                status_code: status_code,
	            },
	            type: 'http',
	        }, {
	            xhr: handlerData.xhr,
	            input: body,
	        });
	        return;
	    }
	}
	/**
	 * Creates breadcrumbs from fetch API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _fetchBreadcrumb(handlerData) {
	    // We only capture complete fetch requests
	    if (!handlerData.endTimestamp) {
	        return;
	    }
	    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	        return;
	    }
	    if (handlerData.error) {
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'fetch',
	            data: handlerData.fetchData,
	            level: types_1.Severity.Error,
	            type: 'http',
	        }, {
	            data: handlerData.error,
	            input: handlerData.args,
	        });
	    }
	    else {
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'fetch',
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	            type: 'http',
	        }, {
	            input: handlerData.args,
	            response: handlerData.response,
	        });
	    }
	}
	/**
	 * Creates breadcrumbs from history API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _historyBreadcrumb(handlerData) {
	    var global = utils_1.getGlobalObject();
	    var from = handlerData.from;
	    var to = handlerData.to;
	    var parsedLoc = utils_1.parseUrl(global.location.href);
	    var parsedFrom = utils_1.parseUrl(from);
	    var parsedTo = utils_1.parseUrl(to);
	    // Initial pushState doesn't provide `from` information
	    if (!parsedFrom.path) {
	        parsedFrom = parsedLoc;
	    }
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	        to = parsedTo.relative;
	    }
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	        from = parsedFrom.relative;
	    }
	    core_1.getCurrentHub().addBreadcrumb({
	        category: 'navigation',
	        data: {
	            from: from,
	            to: to,
	        },
	    });
	}
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var eventbuilder_1 = __webpack_require__(100);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            return self ? _handler(self._key, self._limit, event, hint) : event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	/**
	 * @inheritDoc
	 */
	function _handler(key, limit, event, hint) {
	    if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	        return event;
	    }
	    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
	    event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	    return event;
	}
	exports._handler = _handler;
	/**
	 * JSDOC
	 */
	function _walkErrorTree(limit, error, key, stack) {
	    if (stack === void 0) { stack = []; }
	    if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
	        return stack;
	    }
	    var exception = eventbuilder_1.exceptionFromError(error[key]);
	    return _walkErrorTree(limit, error[key], key, tslib_1.__spread([exception], stack));
	}
	exports._walkErrorTree = _walkErrorTree;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = (event.request && event.request.url) || (global.location && global.location.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(104);
	/** Deduplication filter */
	var Dedupe = /** @class */ (function () {
	    function Dedupe() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Dedupe.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (currentEvent) {
	            var self = getCurrentHub().getIntegration(Dedupe);
	            if (self) {
	                // Juuust in case something goes wrong
	                try {
	                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Event dropped due to being a duplicate of previously captured event.');
	                        return null;
	                    }
	                }
	                catch (_oO) {
	                    return (self._previousEvent = currentEvent);
	                }
	                return (self._previousEvent = currentEvent);
	            }
	            return currentEvent;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Dedupe.id = 'Dedupe';
	    return Dedupe;
	}());
	exports.Dedupe = Dedupe;
	/** JSDoc */
	function _shouldDropEvent(currentEvent, previousEvent) {
	    if (!previousEvent) {
	        return false;
	    }
	    if (_isSameMessageEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    return false;
	}
	/** JSDoc */
	function _isSameMessageEvent(currentEvent, previousEvent) {
	    var currentMessage = currentEvent.message;
	    var previousMessage = previousEvent.message;
	    // If neither event has a message property, they were both exceptions, so bail out
	    if (!currentMessage && !previousMessage) {
	        return false;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
	        return false;
	    }
	    if (currentMessage !== previousMessage) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameExceptionEvent(currentEvent, previousEvent) {
	    var previousException = _getExceptionFromEvent(previousEvent);
	    var currentException = _getExceptionFromEvent(currentEvent);
	    if (!previousException || !currentException) {
	        return false;
	    }
	    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameStacktrace(currentEvent, previousEvent) {
	    var currentFrames = _getFramesFromEvent(currentEvent);
	    var previousFrames = _getFramesFromEvent(previousEvent);
	    // If neither event has a stacktrace, they are assumed to be the same
	    if (!currentFrames && !previousFrames) {
	        return true;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
	        return false;
	    }
	    currentFrames = currentFrames;
	    previousFrames = previousFrames;
	    // If number of frames differ, they are not the same
	    if (previousFrames.length !== currentFrames.length) {
	        return false;
	    }
	    // Otherwise, compare the two
	    for (var i = 0; i < previousFrames.length; i++) {
	        var frameA = previousFrames[i];
	        var frameB = currentFrames[i];
	        if (frameA.filename !== frameB.filename ||
	            frameA.lineno !== frameB.lineno ||
	            frameA.colno !== frameB.colno ||
	            frameA.function !== frameB.function) {
	            return false;
	        }
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameFingerprint(currentEvent, previousEvent) {
	    var currentFingerprint = currentEvent.fingerprint;
	    var previousFingerprint = previousEvent.fingerprint;
	    // If neither event has a fingerprint, they are assumed to be the same
	    if (!currentFingerprint && !previousFingerprint) {
	        return true;
	    }
	    // If only one event has a fingerprint, but not the other one, they are not the same
	    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
	        return false;
	    }
	    currentFingerprint = currentFingerprint;
	    previousFingerprint = previousFingerprint;
	    // Otherwise, compare the two
	    try {
	        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
	    }
	    catch (_oO) {
	        return false;
	    }
	}
	/** JSDoc */
	function _getExceptionFromEvent(event) {
	    return event.exception && event.exception.values && event.exception.values[0];
	}
	/** JSDoc */
	function _getFramesFromEvent(event) {
	    var exception = event.exception;
	    if (exception) {
	        try {
	            // @ts-ignore Object could be undefined
	            return exception.values[0].stacktrace.frames;
	        }
	        catch (_oO) {
	            return undefined;
	        }
	    }
	    else if (event.stacktrace) {
	        return event.stacktrace.frames;
	    }
	    return undefined;
	}
	//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var core_1 = __webpack_require__(44);
	var utils_1 = __webpack_require__(48);
	var client_1 = __webpack_require__(98);
	var flags_1 = __webpack_require__(104);
	var helpers_1 = __webpack_require__(110);
	var integrations_1 = __webpack_require__(111);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.Dedupe(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = true;
	    }
	    if (options.sendClientReports === undefined) {
	        options.sendClientReports = true;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    var hub = core_1.getCurrentHub();
	    var scope = hub.getScope();
	    if (scope) {
	        options.user = tslib_1.__assign(tslib_1.__assign({}, scope.getUser()), options.user);
	    }
	    if (!options.eventId) {
	        options.eventId = hub.lastEventId();
	    }
	    var client = hub.getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
	 * the client to wait until all events are sent before resolving the promise.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Cannot flush events. No client defined.');
	    return utils_1.resolvedSyncPromise(false);
	}
	exports.flush = flush;
	/**
	 * Call `close()` on the current client, if there is one. See {@link Client.close}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
	 * parameter will cause the client to wait until all events are sent before disabling itself.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Cannot flush events and disable SDK. No client defined.');
	    return utils_1.resolvedSyncPromise(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	function startSessionOnHub(hub) {
	    hub.startSession({ ignoreDuration: true });
	    hub.captureSession();
	}
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var document = window.document;
	    if (typeof document === 'undefined') {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
	        return;
	    }
	    var hub = core_1.getCurrentHub();
	    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
	    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
	    // pinned at the same version in package.json, but there are edge cases where it's possible. See
	    // https://github.com/getsentry/sentry-javascript/issues/3207 and
	    // https://github.com/getsentry/sentry-javascript/issues/3234 and
	    // https://github.com/getsentry/sentry-javascript/issues/3278.
	    if (!hub.captureSession) {
	        return;
	    }
	    // The session duration for browser sessions does not track a meaningful
	    // concept that can be used as a metric.
	    // Automatically captured sessions are akin to page views, and thus we
	    // discard their duration.
	    startSessionOnHub(hub);
	    // We want to create a session for every navigation as well
	    utils_1.addInstrumentationHandler('history', function (_a) {
	        var from = _a.from, to = _a.to;
	        // Don't create an additional session for the initial route or if the location did not change
	        if (!(from === undefined || from === to)) {
	            startSessionOnHub(core_1.getCurrentHub());
	        }
	    });
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
	exports.SDK_NAME = 'sentry.javascript.browser';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hubextensions_1 = __webpack_require__(121);
	exports.addExtensionMethods = hubextensions_1.addExtensionMethods;
	var Integrations = __webpack_require__(129);
	exports.Integrations = Integrations;
	// This is already exported as part of `Integrations` above (and for the moment will remain so for
	// backwards compatibility), but that interferes with treeshaking, so we also export it separately
	// here.
	//
	// Previously we expected users to import tracing integrations like
	//
	// import { Integrations } from '@sentry/tracing';
	// const instance = new Integrations.BrowserTracing();
	//
	// This makes the integrations unable to be treeshaken though. To address this, we now have
	// this individual export. We now expect users to consume BrowserTracing like so:
	//
	// import { BrowserTracing } from '@sentry/tracing';
	// const instance = new BrowserTracing();
	//
	// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts
	var browser_1 = __webpack_require__(134);
	exports.BrowserTracing = browser_1.BrowserTracing;
	var span_1 = __webpack_require__(127);
	exports.Span = span_1.Span;
	exports.spanStatusfromHttpCode = span_1.spanStatusfromHttpCode;
	// eslint-disable-next-line deprecation/deprecation
	var spanstatus_1 = __webpack_require__(149);
	exports.SpanStatus = spanstatus_1.SpanStatus;
	var transaction_1 = __webpack_require__(128);
	exports.Transaction = transaction_1.Transaction;
	var browser_2 = __webpack_require__(134);
	// TODO deprecate old name in v7
	exports.registerRequestInstrumentation = browser_2.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = browser_2.defaultRequestInstrumentationOptions;
	var idletransaction_1 = __webpack_require__(125);
	exports.IdleTransaction = idletransaction_1.IdleTransaction;
	var hubextensions_2 = __webpack_require__(121);
	exports.startIdleTransaction = hubextensions_2.startIdleTransaction;
	// We are patching the global object with our hub extension methods
	hubextensions_1.addExtensionMethods();
	var utils_1 = __webpack_require__(124);
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	exports.getActiveTransaction = utils_1.getActiveTransaction;
	exports.hasTracingEnabled = utils_1.hasTracingEnabled;
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var hub_1 = __webpack_require__(46);
	var utils_1 = __webpack_require__(48);
	var errors_1 = __webpack_require__(122);
	var flags_1 = __webpack_require__(123);
	var idletransaction_1 = __webpack_require__(125);
	var transaction_1 = __webpack_require__(128);
	var utils_2 = __webpack_require__(124);
	/** Returns all trace headers that are currently on the top scope. */
	function traceHeaders() {
	    var scope = this.getScope();
	    if (scope) {
	        var span = scope.getSpan();
	        if (span) {
	            return {
	                'sentry-trace': span.toTraceparent(),
	            };
	        }
	    }
	    return {};
	}
	/**
	 * Makes a sampling decision for the given transaction and stores it on the transaction.
	 *
	 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
	 * sent to Sentry.
	 *
	 * @param transaction: The transaction needing a sampling decision
	 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
	 * @param samplingContext: Default and user-provided data which may be used to help make the decision
	 *
	 * @returns The given transaction with its `sampled` value set
	 */
	function sample(transaction, options, samplingContext) {
	    // nothing to do if tracing is not enabled
	    if (!utils_2.hasTracingEnabled(options)) {
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
	    if (transaction.sampled !== undefined) {
	        transaction.setMetadata({
	            transactionSampling: { method: 'explicitly_set' },
	        });
	        return transaction;
	    }
	    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
	    // work; prefer the hook if so
	    var sampleRate;
	    if (typeof options.tracesSampler === 'function') {
	        sampleRate = options.tracesSampler(samplingContext);
	        transaction.setMetadata({
	            transactionSampling: {
	                method: 'client_sampler',
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    else if (samplingContext.parentSampled !== undefined) {
	        sampleRate = samplingContext.parentSampled;
	        transaction.setMetadata({
	            transactionSampling: { method: 'inheritance' },
	        });
	    }
	    else {
	        sampleRate = options.tracesSampleRate;
	        transaction.setMetadata({
	            transactionSampling: {
	                method: 'client_rate',
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
	    // only valid values are booleans or numbers between 0 and 1.)
	    if (!isValidSampleRate(sampleRate)) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('[Tracing] Discarding transaction because of invalid sample rate.');
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
	    if (!sampleRate) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
	                ? 'tracesSampler returned 0 or false'
	                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
	        transaction.sampled = false;
	        return transaction;
	    }
	    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
	    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
	    transaction.sampled = Math.random() < sampleRate;
	    // if we're not going to keep it, we're done
	    if (!transaction.sampled) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
	        return transaction;
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
	    return transaction;
	}
	/**
	 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
	 */
	function isValidSampleRate(rate) {
	    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (utils_1.isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
	        return false;
	    }
	    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
	    if (rate < 0 || rate > 1) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
	        return false;
	    }
	    return true;
	}
	/**
	 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
	 *
	 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
	 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
	 * "extension method."
	 *
	 * @param this: The Hub starting the transaction
	 * @param transactionContext: Data used to configure the transaction
	 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
	 *
	 * @returns The new transaction
	 *
	 * @see {@link Hub.startTransaction}
	 */
	function _startTransaction(transactionContext, customSamplingContext) {
	    var client = this.getClient();
	    var options = (client && client.getOptions()) || {};
	    var transaction = new transaction_1.Transaction(transactionContext, this);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
	    }
	    return transaction;
	}
	/**
	 * Create new idle transaction.
	 */
	function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
	    var client = hub.getClient();
	    var options = (client && client.getOptions()) || {};
	    var transaction = new idletransaction_1.IdleTransaction(transactionContext, hub, idleTimeout, onScope);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
	    }
	    return transaction;
	}
	exports.startIdleTransaction = startIdleTransaction;
	/**
	 * @private
	 */
	function _addTracingExtensions() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
	    if (!carrier.__SENTRY__.extensions.startTransaction) {
	        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
	    }
	    if (!carrier.__SENTRY__.extensions.traceHeaders) {
	        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
	    }
	}
	exports._addTracingExtensions = _addTracingExtensions;
	/**
	 * @private
	 */
	function _autoloadDatabaseIntegrations() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    var packageToIntegrationMapping = {
	        mongodb: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo();
	        },
	        mongoose: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo({ mongoose: true });
	        },
	        mysql: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mysql');
	            return new integration.Mysql();
	        },
	        pg: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/postgres');
	            return new integration.Postgres();
	        },
	    };
	    var mappedPackages = Object.keys(packageToIntegrationMapping)
	        .filter(function (moduleName) { return !!utils_1.loadModule(moduleName); })
	        .map(function (pkg) {
	        try {
	            return packageToIntegrationMapping[pkg]();
	        }
	        catch (e) {
	            return undefined;
	        }
	    })
	        .filter(function (p) { return p; });
	    if (mappedPackages.length > 0) {
	        carrier.__SENTRY__.integrations = tslib_1.__spread((carrier.__SENTRY__.integrations || []), mappedPackages);
	    }
	}
	/**
	 * This patches the global object and injects the Tracing extensions methods
	 */
	function addExtensionMethods() {
	    _addTracingExtensions();
	    // Detect and automatically load specified integrations.
	    if (utils_1.isNodeEnv()) {
	        _autoloadDatabaseIntegrations();
	    }
	    // If an error happens globally, we should make sure transaction status is set to error.
	    errors_1.registerErrorInstrumentation();
	}
	exports.addExtensionMethods = addExtensionMethods;
	//# sourceMappingURL=hubextensions.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)(module)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var utils_2 = __webpack_require__(124);
	/**
	 * Configures global error listeners
	 */
	function registerErrorInstrumentation() {
	    utils_1.addInstrumentationHandler('error', errorCallback);
	    utils_1.addInstrumentationHandler('unhandledrejection', errorCallback);
	}
	exports.registerErrorInstrumentation = registerErrorInstrumentation;
	/**
	 * If an error or unhandled promise occurs, we mark the active transaction as failed
	 */
	function errorCallback() {
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var status_1 = 'internal_error';
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
	        activeTransaction.setStatus(status_1);
	    }
	}
	//# sourceMappingURL=errors.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(46);
	/**
	 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
	 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
	 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
	 * is the only tracing function used by `@sentry/node`).
	 *
	 * These exports are kept here for backwards compatability's sake.
	 *
	 * TODO(v7): Reorganize these exports
	 *
	 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
	 */
	var utils_1 = __webpack_require__(48);
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	/**
	 * Determines if tracing is currently enabled.
	 *
	 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
	 */
	function hasTracingEnabled(maybeOptions) {
	    var client = hub_1.getCurrentHub().getClient();
	    var options = maybeOptions || (client && client.getOptions());
	    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
	}
	exports.hasTracingEnabled = hasTracingEnabled;
	/** Grabs active transaction off scope, if any */
	function getActiveTransaction(maybeHub) {
	    var hub = maybeHub || hub_1.getCurrentHub();
	    var scope = hub.getScope();
	    return scope && scope.getTransaction();
	}
	exports.getActiveTransaction = getActiveTransaction;
	/**
	 * Converts from milliseconds to seconds
	 * @param time time in ms
	 */
	function msToSec(time) {
	    return time / 1000;
	}
	exports.msToSec = msToSec;
	/**
	 * Converts from seconds to milliseconds
	 * @param time time in seconds
	 */
	function secToMs(time) {
	    return time * 1000;
	}
	exports.secToMs = secToMs;
	// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils
	var utils_2 = __webpack_require__(48);
	exports.stripUrlQueryAndFragment = utils_2.stripUrlQueryAndFragment;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var constants_1 = __webpack_require__(126);
	var flags_1 = __webpack_require__(123);
	var span_1 = __webpack_require__(127);
	var transaction_1 = __webpack_require__(128);
	exports.DEFAULT_IDLE_TIMEOUT = 1000;
	exports.HEARTBEAT_INTERVAL = 5000;
	/**
	 * @inheritDoc
	 */
	var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransactionSpanRecorder, _super);
	    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
	        if (transactionSpanId === void 0) { transactionSpanId = ''; }
	        var _this = _super.call(this, maxlen) || this;
	        _this._pushActivity = _pushActivity;
	        _this._popActivity = _popActivity;
	        _this.transactionSpanId = transactionSpanId;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    IdleTransactionSpanRecorder.prototype.add = function (span) {
	        var _this = this;
	        // We should make sure we do not push and pop activities for
	        // the transaction that this span recorder belongs to.
	        if (span.spanId !== this.transactionSpanId) {
	            // We patch span.finish() to pop an activity after setting an endTimestamp.
	            span.finish = function (endTimestamp) {
	                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	                _this._popActivity(span.spanId);
	            };
	            // We should only push new activities if the span does not have an end timestamp.
	            if (span.endTimestamp === undefined) {
	                this._pushActivity(span.spanId);
	            }
	        }
	        _super.prototype.add.call(this, span);
	    };
	    return IdleTransactionSpanRecorder;
	}(span_1.SpanRecorder));
	exports.IdleTransactionSpanRecorder = IdleTransactionSpanRecorder;
	/**
	 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
	 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
	 * put itself on the scope on creation.
	 */
	var IdleTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransaction, _super);
	    function IdleTransaction(transactionContext, _idleHub, 
	    /**
	     * The time to wait in ms until the idle transaction will be finished.
	     * @default 1000
	     */
	    _idleTimeout, 
	    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
	    _onScope) {
	        if (_idleTimeout === void 0) { _idleTimeout = exports.DEFAULT_IDLE_TIMEOUT; }
	        if (_onScope === void 0) { _onScope = false; }
	        var _this = _super.call(this, transactionContext, _idleHub) || this;
	        _this._idleHub = _idleHub;
	        _this._idleTimeout = _idleTimeout;
	        _this._onScope = _onScope;
	        // Activities store a list of active spans
	        _this.activities = {};
	        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
	        _this._heartbeatCounter = 0;
	        // We should not use heartbeat if we finished a transaction
	        _this._finished = false;
	        _this._beforeFinishCallbacks = [];
	        if (_idleHub && _onScope) {
	            // There should only be one active transaction on the scope
	            clearActiveTransaction(_idleHub);
	            // We set the transaction here on the scope so error events pick up the trace
	            // context and attach it to the error.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
	            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
	        }
	        _this._initTimeout = setTimeout(function () {
	            if (!_this._finished) {
	                _this.finish();
	            }
	        }, _this._idleTimeout);
	        return _this;
	    }
	    /** {@inheritDoc} */
	    IdleTransaction.prototype.finish = function (endTimestamp) {
	        var e_1, _a;
	        var _this = this;
	        if (endTimestamp === void 0) { endTimestamp = utils_1.timestampWithMs(); }
	        this._finished = true;
	        this.activities = {};
	        if (this.spanRecorder) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
	            try {
	                for (var _b = tslib_1.__values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var callback = _c.value;
	                    callback(this, endTimestamp);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
	                // If we are dealing with the transaction itself, we just return it
	                if (span.spanId === _this.spanId) {
	                    return true;
	                }
	                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
	                if (!span.endTimestamp) {
	                    span.endTimestamp = endTimestamp;
	                    span.setStatus('cancelled');
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
	                }
	                var keepSpan = span.startTimestamp < endTimestamp;
	                if (!keepSpan) {
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
	                }
	                return keepSpan;
	            });
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] flushing IdleTransaction');
	        }
	        else {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] No active IdleTransaction');
	        }
	        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
	        if (this._onScope) {
	            clearActiveTransaction(this._idleHub);
	        }
	        return _super.prototype.finish.call(this, endTimestamp);
	    };
	    /**
	     * Register a callback function that gets excecuted before the transaction finishes.
	     * Useful for cleanup or if you want to add any additional spans based on current context.
	     *
	     * This is exposed because users have no other way of running something before an idle transaction
	     * finishes.
	     */
	    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
	        this._beforeFinishCallbacks.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
	        var _this = this;
	        if (!this.spanRecorder) {
	            var pushActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._pushActivity(id);
	            };
	            var popActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._popActivity(id);
	            };
	            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
	            // Start heartbeat so that transactions do not run forever.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('Starting heartbeat');
	            this._pingHeartbeat();
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Start tracking a specific activity.
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._pushActivity = function (spanId) {
	        if (this._initTimeout) {
	            clearTimeout(this._initTimeout);
	            this._initTimeout = undefined;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] pushActivity: " + spanId);
	        this.activities[spanId] = true;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	    };
	    /**
	     * Remove an activity from usage
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._popActivity = function (spanId) {
	        var _this = this;
	        if (this.activities[spanId]) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] popActivity " + spanId);
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this.activities[spanId];
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	        }
	        if (Object.keys(this.activities).length === 0) {
	            var timeout = this._idleTimeout;
	            // We need to add the timeout here to have the real endtimestamp of the transaction
	            // Remember timestampWithMs is in seconds, timeout is in ms
	            var end_1 = utils_1.timestampWithMs() + timeout / 1000;
	            setTimeout(function () {
	                if (!_this._finished) {
	                    _this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[1]);
	                    _this.finish(end_1);
	                }
	            }, timeout);
	        }
	    };
	    /**
	     * Checks when entries of this.activities are not changing for 3 beats.
	     * If this occurs we finish the transaction.
	     */
	    IdleTransaction.prototype._beat = function () {
	        // We should not be running heartbeat if the idle transaction is finished.
	        if (this._finished) {
	            return;
	        }
	        var heartbeatString = Object.keys(this.activities).join('');
	        if (heartbeatString === this._prevHeartbeatString) {
	            this._heartbeatCounter += 1;
	        }
	        else {
	            this._heartbeatCounter = 1;
	        }
	        this._prevHeartbeatString = heartbeatString;
	        if (this._heartbeatCounter >= 3) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
	            this.setStatus('deadline_exceeded');
	            this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[0]);
	            this.finish();
	        }
	        else {
	            this._pingHeartbeat();
	        }
	    };
	    /**
	     * Pings the heartbeat
	     */
	    IdleTransaction.prototype._pingHeartbeat = function () {
	        var _this = this;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
	        setTimeout(function () {
	            _this._beat();
	        }, exports.HEARTBEAT_INTERVAL);
	    };
	    return IdleTransaction;
	}(transaction_1.Transaction));
	exports.IdleTransaction = IdleTransaction;
	/**
	 * Reset transaction on scope to `undefined`
	 */
	function clearActiveTransaction(hub) {
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            var transaction = scope.getTransaction();
	            if (transaction) {
	                scope.setSpan(undefined);
	            }
	        }
	    }
	}
	//# sourceMappingURL=idletransaction.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// Store finish reasons in tuple to save on bundle size
	// Readonly type should enforce that this is not mutated.
	exports.FINISH_REASON_TAG = 'finishReason';
	exports.IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	/**
	 * Keeps track of finished spans for a given transaction
	 * @internal
	 * @hideconstructor
	 * @hidden
	 */
	var SpanRecorder = /** @class */ (function () {
	    function SpanRecorder(maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        this.spans = [];
	        this._maxlen = maxlen;
	    }
	    /**
	     * This is just so that we don't run out of memory while recording a lot
	     * of spans. At some point we just stop and flush out the start of the
	     * trace tree (i.e.the first n spans with the smallest
	     * start_timestamp).
	     */
	    SpanRecorder.prototype.add = function (span) {
	        if (this.spans.length > this._maxlen) {
	            span.spanRecorder = undefined;
	        }
	        else {
	            this.spans.push(span);
	        }
	    };
	    return SpanRecorder;
	}());
	exports.SpanRecorder = SpanRecorder;
	/**
	 * Span contains all data about a span
	 */
	var Span = /** @class */ (function () {
	    /**
	     * You should never call the constructor manually, always use `Sentry.startTransaction()`
	     * or call `startChild()` on an existing span.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Span(spanContext) {
	        /**
	         * @inheritDoc
	         */
	        this.traceId = utils_1.uuid4();
	        /**
	         * @inheritDoc
	         */
	        this.spanId = utils_1.uuid4().substring(16);
	        /**
	         * Timestamp in seconds when the span was created.
	         */
	        this.startTimestamp = utils_1.timestampWithMs();
	        /**
	         * @inheritDoc
	         */
	        this.tags = {};
	        /**
	         * @inheritDoc
	         */
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.data = {};
	        if (!spanContext) {
	            return this;
	        }
	        if (spanContext.traceId) {
	            this.traceId = spanContext.traceId;
	        }
	        if (spanContext.spanId) {
	            this.spanId = spanContext.spanId;
	        }
	        if (spanContext.parentSpanId) {
	            this.parentSpanId = spanContext.parentSpanId;
	        }
	        // We want to include booleans as well here
	        if ('sampled' in spanContext) {
	            this.sampled = spanContext.sampled;
	        }
	        if (spanContext.op) {
	            this.op = spanContext.op;
	        }
	        if (spanContext.description) {
	            this.description = spanContext.description;
	        }
	        if (spanContext.data) {
	            this.data = spanContext.data;
	        }
	        if (spanContext.tags) {
	            this.tags = spanContext.tags;
	        }
	        if (spanContext.status) {
	            this.status = spanContext.status;
	        }
	        if (spanContext.startTimestamp) {
	            this.startTimestamp = spanContext.startTimestamp;
	        }
	        if (spanContext.endTimestamp) {
	            this.endTimestamp = spanContext.endTimestamp;
	        }
	    }
	    /**
	     * @inheritDoc
	     * @deprecated
	     */
	    Span.prototype.child = function (spanContext) {
	        return this.startChild(spanContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.startChild = function (spanContext) {
	        var childSpan = new Span(tslib_1.__assign(tslib_1.__assign({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
	        childSpan.spanRecorder = this.spanRecorder;
	        if (childSpan.spanRecorder) {
	            childSpan.spanRecorder.add(childSpan);
	        }
	        childSpan.transaction = this.transaction;
	        return childSpan;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setTag = function (key, value) {
	        var _a;
	        this.tags = tslib_1.__assign(tslib_1.__assign({}, this.tags), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Span.prototype.setData = function (key, value) {
	        var _a;
	        this.data = tslib_1.__assign(tslib_1.__assign({}, this.data), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setStatus = function (value) {
	        this.status = value;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setHttpStatus = function (httpStatus) {
	        this.setTag('http.status_code', String(httpStatus));
	        var spanStatus = spanStatusfromHttpCode(httpStatus);
	        if (spanStatus !== 'unknown_error') {
	            this.setStatus(spanStatus);
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.isSuccess = function () {
	        return this.status === 'ok';
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.finish = function (endTimestamp) {
	        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toTraceparent = function () {
	        var sampledString = '';
	        if (this.sampled !== undefined) {
	            sampledString = this.sampled ? '-1' : '-0';
	        }
	        return this.traceId + "-" + this.spanId + sampledString;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: this.data,
	            description: this.description,
	            endTimestamp: this.endTimestamp,
	            op: this.op,
	            parentSpanId: this.parentSpanId,
	            sampled: this.sampled,
	            spanId: this.spanId,
	            startTimestamp: this.startTimestamp,
	            status: this.status,
	            tags: this.tags,
	            traceId: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.updateWithContext = function (spanContext) {
	        var _a, _b, _c, _d, _e;
	        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
	        this.description = spanContext.description;
	        this.endTimestamp = spanContext.endTimestamp;
	        this.op = spanContext.op;
	        this.parentSpanId = spanContext.parentSpanId;
	        this.sampled = spanContext.sampled;
	        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
	        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
	        this.status = spanContext.status;
	        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
	        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.getTraceContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            trace_id: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            start_timestamp: this.startTimestamp,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            timestamp: this.endTimestamp,
	            trace_id: this.traceId,
	        });
	    };
	    return Span;
	}());
	exports.Span = Span;
	/**
	 * Converts a HTTP status code into a {@link SpanStatusType}.
	 *
	 * @param httpStatus The HTTP response status code.
	 * @returns The span status or unknown_error.
	 */
	function spanStatusfromHttpCode(httpStatus) {
	    if (httpStatus < 400 && httpStatus >= 100) {
	        return 'ok';
	    }
	    if (httpStatus >= 400 && httpStatus < 500) {
	        switch (httpStatus) {
	            case 401:
	                return 'unauthenticated';
	            case 403:
	                return 'permission_denied';
	            case 404:
	                return 'not_found';
	            case 409:
	                return 'already_exists';
	            case 413:
	                return 'failed_precondition';
	            case 429:
	                return 'resource_exhausted';
	            default:
	                return 'invalid_argument';
	        }
	    }
	    if (httpStatus >= 500 && httpStatus < 600) {
	        switch (httpStatus) {
	            case 501:
	                return 'unimplemented';
	            case 503:
	                return 'unavailable';
	            case 504:
	                return 'deadline_exceeded';
	            default:
	                return 'internal_error';
	        }
	    }
	    return 'unknown_error';
	}
	exports.spanStatusfromHttpCode = spanStatusfromHttpCode;
	//# sourceMappingURL=span.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var hub_1 = __webpack_require__(46);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var span_1 = __webpack_require__(127);
	/** JSDoc */
	var Transaction = /** @class */ (function (_super) {
	    tslib_1.__extends(Transaction, _super);
	    /**
	     * This constructor should never be called manually. Those instrumenting tracing should use
	     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Transaction(transactionContext, hub) {
	        var _this = _super.call(this, transactionContext) || this;
	        _this._measurements = {};
	        /**
	         * The reference to the current hub.
	         */
	        _this._hub = hub_1.getCurrentHub();
	        if (utils_1.isInstanceOf(hub, hub_1.Hub)) {
	            _this._hub = hub;
	        }
	        _this.name = transactionContext.name || '';
	        _this.metadata = transactionContext.metadata || {};
	        _this._trimEnd = transactionContext.trimEnd;
	        // this is because transactions are also spans, and spans have a transaction pointer
	        _this.transaction = _this;
	        return _this;
	    }
	    /**
	     * JSDoc
	     */
	    Transaction.prototype.setName = function (name) {
	        this.name = name;
	    };
	    /**
	     * Attaches SpanRecorder to the span itself
	     * @param maxlen maximum number of spans that can be recorded
	     */
	    Transaction.prototype.initSpanRecorder = function (maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        if (!this.spanRecorder) {
	            this.spanRecorder = new span_1.SpanRecorder(maxlen);
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Set observed measurements for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMeasurements = function (measurements) {
	        this._measurements = tslib_1.__assign({}, measurements);
	    };
	    /**
	     * Set metadata for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMetadata = function (newMetadata) {
	        this.metadata = tslib_1.__assign(tslib_1.__assign({}, this.metadata), newMetadata);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.finish = function (endTimestamp) {
	        var _this = this;
	        // This transaction is already finished, so we should not flush it again.
	        if (this.endTimestamp !== undefined) {
	            return undefined;
	        }
	        if (!this.name) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
	            this.name = '<unlabeled transaction>';
	        }
	        // just sets the end timestamp
	        _super.prototype.finish.call(this, endTimestamp);
	        if (this.sampled !== true) {
	            // At this point if `sampled !== true` we want to discard the transaction.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
	            var client = this._hub.getClient();
	            var transport = client && client.getTransport && client.getTransport();
	            if (transport && transport.recordLostEvent) {
	                transport.recordLostEvent('sample_rate', 'transaction');
	            }
	            return undefined;
	        }
	        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
	        if (this._trimEnd && finishedSpans.length > 0) {
	            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
	                if (prev.endTimestamp && current.endTimestamp) {
	                    return prev.endTimestamp > current.endTimestamp ? prev : current;
	                }
	                return prev;
	            }).endTimestamp;
	        }
	        var transaction = {
	            contexts: {
	                trace: this.getTraceContext(),
	            },
	            spans: finishedSpans,
	            start_timestamp: this.startTimestamp,
	            tags: this.tags,
	            timestamp: this.endTimestamp,
	            transaction: this.name,
	            type: 'transaction',
	            sdkProcessingMetadata: this.metadata,
	        };
	        var hasMeasurements = Object.keys(this._measurements).length > 0;
	        if (hasMeasurements) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
	            transaction.measurements = this._measurements;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
	        return this._hub.captureEvent(transaction);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.toContext = function () {
	        var spanContext = _super.prototype.toContext.call(this);
	        return utils_1.dropUndefinedKeys(tslib_1.__assign(tslib_1.__assign({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.updateWithContext = function (transactionContext) {
	        var _a;
	        _super.prototype.updateWithContext.call(this, transactionContext);
	        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
	        this._trimEnd = transactionContext.trimEnd;
	        return this;
	    };
	    return Transaction;
	}(span_1.Span));
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var express_1 = __webpack_require__(130);
	exports.Express = express_1.Express;
	var postgres_1 = __webpack_require__(131);
	exports.Postgres = postgres_1.Postgres;
	var mysql_1 = __webpack_require__(132);
	exports.Mysql = mysql_1.Mysql;
	var mongo_1 = __webpack_require__(133);
	exports.Mongo = mongo_1.Mongo;
	// TODO(v7): Remove this export
	// Please see `src/index.ts` for more details.
	var browser_1 = __webpack_require__(134);
	exports.BrowserTracing = browser_1.BrowserTracing;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	/**
	 * Express integration
	 *
	 * Provides an request and error handler for Express framework as well as tracing capabilities
	 */
	var Express = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Express(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Express.id;
	        this._router = options.router || options.app;
	        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
	    }
	    /**
	     * @inheritDoc
	     */
	    Express.prototype.setupOnce = function () {
	        if (!this._router) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('ExpressIntegration is missing an Express instance');
	            return;
	        }
	        instrumentMiddlewares(this._router, this._methods);
	    };
	    /**
	     * @inheritDoc
	     */
	    Express.id = 'Express';
	    return Express;
	}());
	exports.Express = Express;
	/**
	 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
	 * and finishes it once the middleware is done invoking.
	 *
	 * Express middlewares have 3 various forms, thus we have to take care of all of them:
	 * // sync
	 * app.use(function (req, res) { ... })
	 * // async
	 * app.use(function (req, res, next) { ... })
	 * // error handler
	 * app.use(function (err, req, res, next) { ... })
	 *
	 * They all internally delegate to the `router[method]` of the given application instance.
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
	function wrap(fn, method) {
	    var arity = fn.length;
	    switch (arity) {
	        case 2: {
	            return function (req, res) {
	                var transaction = res.__sentry_transaction;
	                if (transaction) {
	                    var span_1 = transaction.startChild({
	                        description: fn.name,
	                        op: "express.middleware." + method,
	                    });
	                    res.once('finish', function () {
	                        span_1.finish();
	                    });
	                }
	                return fn.call(this, req, res);
	            };
	        }
	        case 3: {
	            return function (req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        case 4: {
	            return function (err, req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, err, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        default: {
	            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
	        }
	    }
	}
	/**
	 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
	 * and wraps every function, as well as array of functions with a call to our `wrap` method.
	 * We have to take care of the arrays as well as iterate over all of the arguments,
	 * as `app.use` can accept middlewares in few various forms.
	 *
	 * app.use([<path>], <fn>)
	 * app.use([<path>], <fn>, ...<fn>)
	 * app.use([<path>], ...<fn>[])
	 */
	function wrapMiddlewareArgs(args, method) {
	    return args.map(function (arg) {
	        if (typeof arg === 'function') {
	            return wrap(arg, method);
	        }
	        if (Array.isArray(arg)) {
	            return arg.map(function (a) {
	                if (typeof a === 'function') {
	                    return wrap(a, method);
	                }
	                return a;
	            });
	        }
	        return arg;
	    });
	}
	/**
	 * Patches original router to utilize our tracing functionality
	 */
	function patchMiddleware(router, method) {
	    var originalCallback = router[method];
	    router[method] = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return originalCallback.call.apply(originalCallback, tslib_1.__spread([this], wrapMiddlewareArgs(args, method)));
	    };
	    return router;
	}
	/**
	 * Patches original router methods
	 */
	function instrumentMiddlewares(router, methods) {
	    if (methods === void 0) { methods = []; }
	    methods.forEach(function (method) { return patchMiddleware(router, method); });
	}
	//# sourceMappingURL=express.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	/** Tracing integration for node-postgres package */
	var Postgres = /** @class */ (function () {
	    function Postgres(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Postgres.id;
	        this._usePgNative = !!options.usePgNative;
	    }
	    /**
	     * @inheritDoc
	     */
	    Postgres.prototype.setupOnce = function (_, getCurrentHub) {
	        var _a;
	        var pkg = utils_1.loadModule('pg');
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Postgres Integration was unable to require `pg` package.');
	            return;
	        }
	        if (this._usePgNative && !((_a = pkg.native) === null || _a === void 0 ? void 0 : _a.Client)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Postgres Integration was unable to access 'pg-native' bindings.");
	            return;
	        }
	        var Client = (this._usePgNative ? pkg.native : pkg).Client;
	        /**
	         * function (query, callback) => void
	         * function (query, params, callback) => void
	         * function (query) => Promise
	         * function (query, params) => Promise
	         * function (pg.Cursor) => pg.Cursor
	         */
	        utils_1.fill(Client.prototype, 'query', function (orig) {
	            return function (config, values, callback) {
	                var _a, _b, _c;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof config === 'string' ? config : config.text,
	                    op: 'db',
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, config, values, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, config, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result);
	                    });
	                }
	                var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
	                if (utils_1.isThenable(rv)) {
	                    return rv.then(function (res) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        return res;
	                    });
	                }
	                (_c = span) === null || _c === void 0 ? void 0 : _c.finish();
	                return rv;
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Postgres.id = 'Postgres';
	    return Postgres;
	}());
	exports.Postgres = Postgres;
	//# sourceMappingURL=postgres.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	/** Tracing integration for node-mysql package */
	var Mysql = /** @class */ (function () {
	    function Mysql() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Mysql.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mysql.prototype.setupOnce = function (_, getCurrentHub) {
	        var pkg = utils_1.loadModule('mysql/lib/Connection.js');
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Mysql Integration was unable to require `mysql` package.');
	            return;
	        }
	        // The original function will have one of these signatures:
	        //    function (callback) => void
	        //    function (options, callback) => void
	        //    function (options, values, callback) => void
	        utils_1.fill(pkg, 'createQuery', function (orig) {
	            return function (options, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof options === 'string' ? options : options.sql,
	                    op: 'db',
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, options, values, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result, fields);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, options, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result, fields);
	                    });
	                }
	                return orig.call(this, options, values, callback);
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Mysql.id = 'Mysql';
	    return Mysql;
	}());
	exports.Mysql = Mysql;
	//# sourceMappingURL=mysql.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var OPERATIONS = [
	    'aggregate',
	    'bulkWrite',
	    'countDocuments',
	    'createIndex',
	    'createIndexes',
	    'deleteMany',
	    'deleteOne',
	    'distinct',
	    'drop',
	    'dropIndex',
	    'dropIndexes',
	    'estimatedDocumentCount',
	    'find',
	    'findOne',
	    'findOneAndDelete',
	    'findOneAndReplace',
	    'findOneAndUpdate',
	    'indexes',
	    'indexExists',
	    'indexInformation',
	    'initializeOrderedBulkOp',
	    'insertMany',
	    'insertOne',
	    'isCapped',
	    'mapReduce',
	    'options',
	    'parallelCollectionScan',
	    'rename',
	    'replaceOne',
	    'stats',
	    'updateMany',
	    'updateOne',
	];
	// All of the operations above take `options` and `callback` as their final parameters, but some of them
	// take additional parameters as well. For those operations, this is a map of
	// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
	// positional arguments when we add them to the span's `data` object later
	var OPERATION_SIGNATURES = {
	    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
	    // see https://github.com/getsentry/sentry-javascript/pull/3102
	    bulkWrite: ['operations'],
	    countDocuments: ['query'],
	    createIndex: ['fieldOrSpec'],
	    createIndexes: ['indexSpecs'],
	    deleteMany: ['filter'],
	    deleteOne: ['filter'],
	    distinct: ['key', 'query'],
	    dropIndex: ['indexName'],
	    find: ['query'],
	    findOne: ['query'],
	    findOneAndDelete: ['filter'],
	    findOneAndReplace: ['filter', 'replacement'],
	    findOneAndUpdate: ['filter', 'update'],
	    indexExists: ['indexes'],
	    insertMany: ['docs'],
	    insertOne: ['doc'],
	    mapReduce: ['map', 'reduce'],
	    rename: ['newName'],
	    replaceOne: ['filter', 'doc'],
	    updateMany: ['filter', 'update'],
	    updateOne: ['filter', 'update'],
	};
	/** Tracing integration for mongo package */
	var Mongo = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Mongo(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Mongo.id;
	        this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
	        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
	        this._useMongoose = !!options.useMongoose;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mongo.prototype.setupOnce = function (_, getCurrentHub) {
	        var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
	        var pkg = utils_1.loadModule(moduleName);
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Mongo Integration was unable to require `" + moduleName + "` package.");
	            return;
	        }
	        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
	    };
	    /**
	     * Patches original collection methods
	     */
	    Mongo.prototype._instrumentOperations = function (collection, operations, getCurrentHub) {
	        var _this = this;
	        operations.forEach(function (operation) { return _this._patchOperation(collection, operation, getCurrentHub); });
	    };
	    /**
	     * Patches original collection to utilize our tracing functionality
	     */
	    Mongo.prototype._patchOperation = function (collection, operation, getCurrentHub) {
	        if (!(operation in collection.prototype))
	            return;
	        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
	        utils_1.fill(collection.prototype, operation, function (orig) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a, _b, _c, _d;
	                var lastArg = args[args.length - 1];
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                // Check if the operation was passed a callback. (mapReduce requires a different check, as
	                // its (non-callback) arguments can also be functions.)
	                if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
	                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
	                    var maybePromise = orig.call.apply(orig, tslib_1.__spread([this], args));
	                    if (utils_1.isThenable(maybePromise)) {
	                        return maybePromise.then(function (res) {
	                            var _a;
	                            (_a = span_1) === null || _a === void 0 ? void 0 : _a.finish();
	                            return res;
	                        });
	                    }
	                    else {
	                        (_c = span_1) === null || _c === void 0 ? void 0 : _c.finish();
	                        return maybePromise;
	                    }
	                }
	                var span = (_d = parentSpan) === null || _d === void 0 ? void 0 : _d.startChild(getSpanContext(this, operation, args.slice(0, -1)));
	                return orig.call.apply(orig, tslib_1.__spread([this], args.slice(0, -1), [function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        lastArg(err, result);
	                    }]));
	            };
	        });
	    };
	    /**
	     * Form a SpanContext based on the user input to a given operation.
	     */
	    Mongo.prototype._getSpanContextFromOperationArguments = function (collection, operation, args) {
	        var data = {
	            collectionName: collection.collectionName,
	            dbName: collection.dbName,
	            namespace: collection.namespace,
	        };
	        var spanContext = {
	            op: 'db',
	            description: operation,
	            data: data,
	        };
	        // If the operation takes no arguments besides `options` and `callback`, or if argument
	        // collection is disabled for this operation, just return early.
	        var signature = OPERATION_SIGNATURES[operation];
	        var shouldDescribe = Array.isArray(this._describeOperations)
	            ? this._describeOperations.includes(operation)
	            : this._describeOperations;
	        if (!signature || !shouldDescribe) {
	            return spanContext;
	        }
	        try {
	            // Special case for `mapReduce`, as the only one accepting functions as arguments.
	            if (operation === 'mapReduce') {
	                var _a = tslib_1.__read(args, 2), map = _a[0], reduce = _a[1];
	                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
	                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
	            }
	            else {
	                for (var i = 0; i < signature.length; i++) {
	                    data[signature[i]] = JSON.stringify(args[i]);
	                }
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        return spanContext;
	    };
	    /**
	     * @inheritDoc
	     */
	    Mongo.id = 'Mongo';
	    return Mongo;
	}());
	exports.Mongo = Mongo;
	//# sourceMappingURL=mongo.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browsertracing_1 = __webpack_require__(135);
	exports.BrowserTracing = browsertracing_1.BrowserTracing;
	var request_1 = __webpack_require__(147);
	exports.instrumentOutgoingRequests = request_1.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var hubextensions_1 = __webpack_require__(121);
	var idletransaction_1 = __webpack_require__(125);
	var utils_2 = __webpack_require__(124);
	var backgroundtab_1 = __webpack_require__(136);
	var metrics_1 = __webpack_require__(137);
	var request_1 = __webpack_require__(147);
	var router_1 = __webpack_require__(148);
	exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
	var DEFAULT_BROWSER_TRACING_OPTIONS = tslib_1.__assign({ idleTimeout: idletransaction_1.DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: router_1.instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, request_1.defaultRequestInstrumentationOptions);
	/**
	 * The Browser Tracing integration automatically instruments browser pageload/navigation
	 * actions as transactions, and captures requests, metrics and errors as spans.
	 *
	 * The integration can be configured with a variety of options, and can be extended to use
	 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
	 */
	var BrowserTracing = /** @class */ (function () {
	    function BrowserTracing(_options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = BrowserTracing.id;
	        /** Store configured idle timeout so that it can be added as a tag to transactions */
	        this._configuredIdleTimeout = undefined;
	        var tracingOrigins = request_1.defaultRequestInstrumentationOptions.tracingOrigins;
	        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
	        if (_options) {
	            this._configuredIdleTimeout = _options.idleTimeout;
	            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
	                tracingOrigins = _options.tracingOrigins;
	            }
	            else {
	                flags_1.IS_DEBUG_BUILD && (this._emitOptionsWarning = true);
	            }
	        }
	        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
	        var _metricOptions = this.options._metricOptions;
	        this._metrics = new metrics_1.MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        this._getCurrentHub = getCurrentHub;
	        if (this._emitOptionsWarning) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn("[Tracing] We added a reasonable default for you: " + request_1.defaultRequestInstrumentationOptions.tracingOrigins);
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
	        if (markBackgroundTransactions) {
	            backgroundtab_1.registerBackgroundTabDetection();
	        }
	        request_1.instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
	    };
	    /** Create routing idle transaction. */
	    BrowserTracing.prototype._createRouteTransaction = function (context) {
	        var _this = this;
	        if (!this._getCurrentHub) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
	            return undefined;
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
	        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
	        var expandedContext = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, context), parentContextFromHeader), { trimEnd: true });
	        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
	        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
	        // from being sent to Sentry).
	        var finalContext = modifiedContext === undefined ? tslib_1.__assign(tslib_1.__assign({}, expandedContext), { sampled: false }) : modifiedContext;
	        if (finalContext.sampled === false) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
	        var hub = this._getCurrentHub();
	        var location = utils_1.getGlobalObject().location;
	        var idleTransaction = hubextensions_1.startIdleTransaction(hub, finalContext, idleTimeout, true, { location: location });
	        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
	            _this._metrics.addPerformanceEntries(transaction);
	            adjustTransactionDuration(utils_2.secToMs(maxTransactionDuration), transaction, endTimestamp);
	        });
	        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
	        return idleTransaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.id = 'BrowserTracing';
	    return BrowserTracing;
	}());
	exports.BrowserTracing = BrowserTracing;
	/**
	 * Gets transaction context from a sentry-trace meta.
	 *
	 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
	 */
	function getHeaderContext() {
	    var header = getMetaContent('sentry-trace');
	    if (header) {
	        return utils_2.extractTraceparentData(header);
	    }
	    return undefined;
	}
	exports.getHeaderContext = getHeaderContext;
	/** Returns the value of a meta tag */
	function getMetaContent(metaName) {
	    var el = utils_1.getGlobalObject().document.querySelector("meta[name=" + metaName + "]");
	    return el ? el.getAttribute('content') : null;
	}
	exports.getMetaContent = getMetaContent;
	/** Adjusts transaction value based on max transaction duration */
	function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
	    var diff = endTimestamp - transaction.startTimestamp;
	    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
	    if (isOutdatedTransaction) {
	        transaction.setStatus('deadline_exceeded');
	        transaction.setTag('maxTransactionDurationExceeded', 'true');
	    }
	}
	//# sourceMappingURL=browsertracing.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var constants_1 = __webpack_require__(126);
	var flags_1 = __webpack_require__(123);
	var utils_2 = __webpack_require__(124);
	var global = utils_1.getGlobalObject();
	/**
	 * Add a listener that cancels and finishes a transaction when the global
	 * document is hidden.
	 */
	function registerBackgroundTabDetection() {
	    if (global && global.document) {
	        global.document.addEventListener('visibilitychange', function () {
	            var activeTransaction = utils_2.getActiveTransaction();
	            if (global.document.hidden && activeTransaction) {
	                var statusType = 'cancelled';
	                flags_1.IS_DEBUG_BUILD &&
	                    utils_1.logger.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
	                // We should not set status if it is already set, this prevent important statuses like
	                // error or data loss from being overwritten on transaction.
	                if (!activeTransaction.status) {
	                    activeTransaction.setStatus(statusType);
	                }
	                activeTransaction.setTag('visibilitychange', 'document.hidden');
	                activeTransaction.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[2]);
	                activeTransaction.finish();
	            }
	        });
	    }
	    else {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
	    }
	}
	exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
	//# sourceMappingURL=backgroundtab.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var utils_2 = __webpack_require__(124);
	var getCLS_1 = __webpack_require__(138);
	var getFID_1 = __webpack_require__(144);
	var getLCP_1 = __webpack_require__(146);
	var getVisibilityWatcher_1 = __webpack_require__(145);
	var global = utils_1.getGlobalObject();
	/** Class tracking metrics  */
	var MetricsInstrumentation = /** @class */ (function () {
	    function MetricsInstrumentation(_reportAllChanges) {
	        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
	        this._reportAllChanges = _reportAllChanges;
	        this._measurements = {};
	        this._performanceCursor = 0;
	        if (!utils_1.isNodeEnv() && global && global.performance && global.document) {
	            if (global.performance.mark) {
	                global.performance.mark('sentry-tracing-init');
	            }
	            this._trackCLS();
	            this._trackLCP();
	            this._trackFID();
	        }
	    }
	    /** Add performance related spans to a transaction */
	    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
	        var _this = this;
	        if (!global || !global.performance || !global.performance.getEntries || !utils_1.browserPerformanceTimeOrigin) {
	            // Gatekeeper if performance API not available
	            return;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Adding & adjusting spans using Performance API');
	        var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	        var responseStartTimestamp;
	        var requestStartTimestamp;
	        global.performance
	            .getEntries()
	            .slice(this._performanceCursor)
	            .forEach(function (entry) {
	            var startTime = utils_2.msToSec(entry.startTime);
	            var duration = utils_2.msToSec(entry.duration);
	            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
	                return;
	            }
	            switch (entry.entryType) {
	                case 'navigation': {
	                    addNavigationSpans(transaction, entry, timeOrigin);
	                    responseStartTimestamp = timeOrigin + utils_2.msToSec(entry.responseStart);
	                    requestStartTimestamp = timeOrigin + utils_2.msToSec(entry.requestStart);
	                    break;
	                }
	                case 'mark':
	                case 'paint':
	                case 'measure': {
	                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
	                    // capture web vitals
	                    var firstHidden = getVisibilityWatcher_1.getVisibilityWatcher();
	                    // Only report if the page wasn't hidden prior to the web vital.
	                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
	                    if (entry.name === 'first-paint' && shouldRecord) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FP');
	                        _this._measurements['fp'] = { value: entry.startTime };
	                        _this._measurements['mark.fp'] = { value: startTimestamp };
	                    }
	                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FCP');
	                        _this._measurements['fcp'] = { value: entry.startTime };
	                        _this._measurements['mark.fcp'] = { value: startTimestamp };
	                    }
	                    break;
	                }
	                case 'resource': {
	                    var resourceName = entry.name.replace(global.location.origin, '');
	                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
	                    break;
	                }
	                default:
	                // Ignore other entry types.
	            }
	        });
	        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
	        this._trackNavigator(transaction);
	        // Measurements are only available for pageload transactions
	        if (transaction.op === 'pageload') {
	            // normalize applicable web vital values to be relative to transaction.startTimestamp
	            var timeOrigin_1 = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
	            // start of the response in milliseconds
	            if (typeof responseStartTimestamp === 'number') {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding TTFB');
	                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
	                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
	                    // Capture the time spent making the request and receiving the first byte of the response.
	                    // This is the time between the start of the request and the start of the response in milliseconds.
	                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
	                }
	            }
	            ['fcp', 'fp', 'lcp'].forEach(function (name) {
	                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
	                    return;
	                }
	                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
	                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
	                // to be adjusted to be relative to transaction.startTimestamp.
	                var oldValue = _this._measurements[name].value;
	                var measurementTimestamp = timeOrigin_1 + utils_2.msToSec(oldValue);
	                // normalizedValue should be in milliseconds
	                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
	                var delta = normalizedValue - oldValue;
	                flags_1.IS_DEBUG_BUILD &&
	                    utils_1.logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
	                _this._measurements[name].value = normalizedValue;
	            });
	            if (this._measurements['mark.fid'] && this._measurements['fid']) {
	                // create span for FID
	                _startChild(transaction, {
	                    description: 'first input delay',
	                    endTimestamp: this._measurements['mark.fid'].value + utils_2.msToSec(this._measurements['fid'].value),
	                    op: 'web.vitals',
	                    startTimestamp: this._measurements['mark.fid'].value,
	                });
	            }
	            // If FCP is not recorded we should not record the cls value
	            // according to the new definition of CLS.
	            if (!('fcp' in this._measurements)) {
	                delete this._measurements.cls;
	            }
	            transaction.setMeasurements(this._measurements);
	            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
	            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
	        }
	    };
	    /**
	     * Capture the information of the user agent.
	     */
	    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
	        var navigator = global.navigator;
	        if (!navigator) {
	            return;
	        }
	        // track network connectivity
	        var connection = navigator.connection;
	        if (connection) {
	            if (connection.effectiveType) {
	                transaction.setTag('effectiveConnectionType', connection.effectiveType);
	            }
	            if (connection.type) {
	                transaction.setTag('connectionType', connection.type);
	            }
	            if (isMeasurementValue(connection.rtt)) {
	                this._measurements['connection.rtt'] = { value: connection.rtt };
	            }
	            if (isMeasurementValue(connection.downlink)) {
	                this._measurements['connection.downlink'] = { value: connection.downlink };
	            }
	        }
	        if (isMeasurementValue(navigator.deviceMemory)) {
	            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
	        }
	        if (isMeasurementValue(navigator.hardwareConcurrency)) {
	            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
	        }
	    };
	    /** Starts tracking the Cumulative Layout Shift on the current page. */
	    MetricsInstrumentation.prototype._trackCLS = function () {
	        var _this = this;
	        // See:
	        // https://web.dev/evolving-cls/
	        // https://web.dev/cls-web-tooling/
	        getCLS_1.getCLS(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding CLS');
	            _this._measurements['cls'] = { value: metric.value };
	            _this._clsEntry = entry;
	        });
	    };
	    /** Starts tracking the Largest Contentful Paint on the current page. */
	    MetricsInstrumentation.prototype._trackLCP = function () {
	        var _this = this;
	        getLCP_1.getLCP(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding LCP');
	            _this._measurements['lcp'] = { value: metric.value };
	            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
	            _this._lcpEntry = entry;
	        }, this._reportAllChanges);
	    };
	    /** Starts tracking the First Input Delay on the current page. */
	    MetricsInstrumentation.prototype._trackFID = function () {
	        var _this = this;
	        getFID_1.getFID(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FID');
	            _this._measurements['fid'] = { value: metric.value };
	            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
	        });
	    };
	    return MetricsInstrumentation;
	}());
	exports.MetricsInstrumentation = MetricsInstrumentation;
	/** Instrument navigation entries */
	function addNavigationSpans(transaction, entry, timeOrigin) {
	    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
	        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
	    });
	    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
	    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
	    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
	    addRequest(transaction, entry, timeOrigin);
	}
	/** Create measure related spans */
	function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
	    var measureStartTimestamp = timeOrigin + startTime;
	    var measureEndTimestamp = measureStartTimestamp + duration;
	    _startChild(transaction, {
	        description: entry.name,
	        endTimestamp: measureEndTimestamp,
	        op: entry.entryType,
	        startTimestamp: measureStartTimestamp,
	    });
	    return measureStartTimestamp;
	}
	/** Create resource-related spans */
	function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
	    // we already instrument based on fetch and xhr, so we don't need to
	    // duplicate spans here.
	    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
	        return;
	    }
	    var data = {};
	    if ('transferSize' in entry) {
	        data['Transfer Size'] = entry.transferSize;
	    }
	    if ('encodedBodySize' in entry) {
	        data['Encoded Body Size'] = entry.encodedBodySize;
	    }
	    if ('decodedBodySize' in entry) {
	        data['Decoded Body Size'] = entry.decodedBodySize;
	    }
	    var startTimestamp = timeOrigin + startTime;
	    var endTimestamp = startTimestamp + duration;
	    _startChild(transaction, {
	        description: resourceName,
	        endTimestamp: endTimestamp,
	        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
	        startTimestamp: startTimestamp,
	        data: data,
	    });
	}
	exports.addResourceSpans = addResourceSpans;
	/** Create performance navigation related spans */
	function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
	    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
	    var start = entry[event + "Start"];
	    if (!start || !end) {
	        return;
	    }
	    _startChild(transaction, {
	        op: 'browser',
	        description: (description !== null && description !== void 0 ? description : event),
	        startTimestamp: timeOrigin + utils_2.msToSec(start),
	        endTimestamp: timeOrigin + utils_2.msToSec(end),
	    });
	}
	/** Create request and response related spans */
	function addRequest(transaction, entry, timeOrigin) {
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'request',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.requestStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'response',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.responseStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	}
	/**
	 * Helper function to start child on transactions. This function will make sure that the transaction will
	 * use the start timestamp of the created child span if it is earlier than the transactions actual
	 * start timestamp.
	 */
	function _startChild(transaction, _a) {
	    var startTimestamp = _a.startTimestamp, ctx = tslib_1.__rest(_a, ["startTimestamp"]);
	    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
	        transaction.startTimestamp = startTimestamp;
	    }
	    return transaction.startChild(tslib_1.__assign({ startTimestamp: startTimestamp }, ctx));
	}
	exports._startChild = _startChild;
	/**
	 * Checks if a given value is a valid measurement value.
	 */
	function isMeasurementValue(value) {
	    return typeof value === 'number' && isFinite(value);
	}
	/** Add LCP / CLS data to transaction to allow debugging */
	function tagMetricInfo(transaction, lcpEntry, clsEntry) {
	    if (lcpEntry) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding LCP Data');
	        // Capture Properties of the LCP element that contributes to the LCP.
	        if (lcpEntry.element) {
	            transaction.setTag('lcp.element', utils_1.htmlTreeAsString(lcpEntry.element));
	        }
	        if (lcpEntry.id) {
	            transaction.setTag('lcp.id', lcpEntry.id);
	        }
	        if (lcpEntry.url) {
	            // Trim URL to the first 200 characters.
	            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
	        }
	        transaction.setTag('lcp.size', lcpEntry.size);
	    }
	    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
	    if (clsEntry && clsEntry.sources) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding CLS Data');
	        clsEntry.sources.forEach(function (source, index) {
	            return transaction.setTag("cls.source." + (index + 1), utils_1.htmlTreeAsString(source.node));
	        });
	    }
	}
	//# sourceMappingURL=metrics.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(139);
	var initMetric_1 = __webpack_require__(140);
	var observe_1 = __webpack_require__(142);
	var onHidden_1 = __webpack_require__(143);
	exports.getCLS = function (onReport, reportAllChanges) {
	    var metric = initMetric_1.initMetric('CLS', 0);
	    var report;
	    var sessionValue = 0;
	    var sessionEntries = [];
	    var entryHandler = function (entry) {
	        // Only count layout shifts without recent user input.
	        // TODO: Figure out why entry can be undefined
	        if (entry && !entry.hadRecentInput) {
	            var firstSessionEntry = sessionEntries[0];
	            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
	            // If the entry occurred less than 1 second after the previous entry and
	            // less than 5 seconds after the first entry in the session, include the
	            // entry in the current session. Otherwise, start a new session.
	            if (sessionValue &&
	                sessionEntries.length !== 0 &&
	                entry.startTime - lastSessionEntry.startTime < 1000 &&
	                entry.startTime - firstSessionEntry.startTime < 5000) {
	                sessionValue += entry.value;
	                sessionEntries.push(entry);
	            }
	            else {
	                sessionValue = entry.value;
	                sessionEntries = [entry];
	            }
	            // If the current session value is larger than the current CLS value,
	            // update CLS and the entries contributing to it.
	            if (sessionValue > metric.value) {
	                metric.value = sessionValue;
	                metric.entries = sessionEntries;
	                if (report) {
	                    report();
	                }
	            }
	        }
	    };
	    var po = observe_1.observe('layout-shift', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            report(true);
	        });
	    }
	};
	//# sourceMappingURL=getCLS.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindReporter = function (callback, metric, reportAllChanges) {
	    var prevValue;
	    return function (forceReport) {
	        if (metric.value >= 0) {
	            if (forceReport || reportAllChanges) {
	                metric.delta = metric.value - (prevValue || 0);
	                // Report the metric if there's a non-zero delta or if no previous
	                // value exists (which can happen in the case of the document becoming
	                // hidden when the metric value is 0).
	                // See: https://github.com/GoogleChrome/web-vitals/issues/14
	                if (metric.delta || prevValue === undefined) {
	                    prevValue = metric.value;
	                    callback(metric);
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=bindReporter.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var generateUniqueID_1 = __webpack_require__(141);
	exports.initMetric = function (name, value) {
	    return {
	        name: name,
	        value: (value !== null && value !== void 0 ? value : -1),
	        delta: 0,
	        entries: [],
	        id: generateUniqueID_1.generateUniqueID(),
	    };
	};
	//# sourceMappingURL=initMetric.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Performantly generate a unique, 30-char string by combining a version
	 * number, the current timestamp with a 13-digit number integer.
	 * @return {string}
	 */
	exports.generateUniqueID = function () {
	    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
	};
	//# sourceMappingURL=generateUniqueID.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes a performance entry type and a callback function, and creates a
	 * `PerformanceObserver` instance that will observe the specified entry type
	 * with buffering enabled and call the callback _for each entry_.
	 *
	 * This function also feature-detects entry support and wraps the logic in a
	 * try/catch to avoid errors in unsupporting browsers.
	 */
	exports.observe = function (type, callback) {
	    try {
	        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
	            // More extensive feature detect needed for Firefox due to:
	            // https://github.com/GoogleChrome/web-vitals/issues/142
	            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
	                return;
	            }
	            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
	            po.observe({ type: type, buffered: true });
	            return po;
	        }
	    }
	    catch (e) {
	        // Do nothing.
	    }
	    return;
	};
	//# sourceMappingURL=observe.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	exports.onHidden = function (cb, once) {
	    var onHiddenOrPageHide = function (event) {
	        if (event.type === 'pagehide' || utils_1.getGlobalObject().document.visibilityState === 'hidden') {
	            cb(event);
	            if (once) {
	                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
	                removeEventListener('pagehide', onHiddenOrPageHide, true);
	            }
	        }
	    };
	    addEventListener('visibilitychange', onHiddenOrPageHide, true);
	    // Some browsers have buggy implementations of visibilitychange,
	    // so we use pagehide in addition, just to be safe.
	    addEventListener('pagehide', onHiddenOrPageHide, true);
	};
	//# sourceMappingURL=onHidden.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(139);
	var getVisibilityWatcher_1 = __webpack_require__(145);
	var initMetric_1 = __webpack_require__(140);
	var observe_1 = __webpack_require__(142);
	var onHidden_1 = __webpack_require__(143);
	exports.getFID = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('FID');
	    var report;
	    var entryHandler = function (entry) {
	        // Only report if the page wasn't hidden prior to the first input.
	        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
	            metric.value = entry.processingStart - entry.startTime;
	            metric.entries.push(entry);
	            report(true);
	        }
	    };
	    var po = observe_1.observe('first-input', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            po.disconnect();
	        }, true);
	    }
	};
	//# sourceMappingURL=getFID.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var onHidden_1 = __webpack_require__(143);
	var firstHiddenTime = -1;
	var initHiddenTime = function () {
	    return utils_1.getGlobalObject().document.visibilityState === 'hidden' ? 0 : Infinity;
	};
	var trackChanges = function () {
	    // Update the time if/when the document becomes hidden.
	    onHidden_1.onHidden(function (_a) {
	        var timeStamp = _a.timeStamp;
	        firstHiddenTime = timeStamp;
	    }, true);
	};
	exports.getVisibilityWatcher = function () {
	    if (firstHiddenTime < 0) {
	        // If the document is hidden when this code runs, assume it was hidden
	        // since navigation start. This isn't a perfect heuristic, but it's the
	        // best we can do until an API is available to support querying past
	        // visibilityState.
	        firstHiddenTime = initHiddenTime();
	        trackChanges();
	    }
	    return {
	        get firstHiddenTime() {
	            return firstHiddenTime;
	        },
	    };
	};
	//# sourceMappingURL=getVisibilityWatcher.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(139);
	var getVisibilityWatcher_1 = __webpack_require__(145);
	var initMetric_1 = __webpack_require__(140);
	var observe_1 = __webpack_require__(142);
	var onHidden_1 = __webpack_require__(143);
	var reportedMetricIDs = {};
	exports.getLCP = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('LCP');
	    var report;
	    var entryHandler = function (entry) {
	        // The startTime attribute returns the value of the renderTime if it is not 0,
	        // and the value of the loadTime otherwise.
	        var value = entry.startTime;
	        // If the page was hidden prior to paint time of the entry,
	        // ignore it and mark the metric as final, otherwise add the entry.
	        if (value < visibilityWatcher.firstHiddenTime) {
	            metric.value = value;
	            metric.entries.push(entry);
	        }
	        if (report) {
	            report();
	        }
	    };
	    var po = observe_1.observe('largest-contentful-paint', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        var stopListening_1 = function () {
	            if (!reportedMetricIDs[metric.id]) {
	                po.takeRecords().map(entryHandler);
	                po.disconnect();
	                reportedMetricIDs[metric.id] = true;
	                report(true);
	            }
	        };
	        // Stop listening after input. Note: while scrolling is an input that
	        // stop LCP observation, it's unreliable since it can be programmatically
	        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
	        ['keydown', 'click'].forEach(function (type) {
	            addEventListener(type, stopListening_1, { once: true, capture: true });
	        });
	        onHidden_1.onHidden(stopListening_1, true);
	    }
	};
	//# sourceMappingURL=getLCP.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var utils_2 = __webpack_require__(124);
	exports.DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
	exports.defaultRequestInstrumentationOptions = {
	    traceFetch: true,
	    traceXHR: true,
	    tracingOrigins: exports.DEFAULT_TRACING_ORIGINS,
	};
	/** Registers span creators for xhr and fetch requests  */
	function instrumentOutgoingRequests(_options) {
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    var _a = tslib_1.__assign(tslib_1.__assign({}, exports.defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	    // We should cache url -> decision so that we don't have to compute
	    // regexp everytime we create a request.
	    var urlMap = {};
	    var defaultShouldCreateSpan = function (url) {
	        if (urlMap[url]) {
	            return urlMap[url];
	        }
	        var origins = tracingOrigins;
	        urlMap[url] =
	            origins.some(function (origin) { return utils_1.isMatchingPattern(url, origin); }) &&
	                !utils_1.isMatchingPattern(url, 'sentry_key');
	        return urlMap[url];
	    };
	    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
	    // That's why we filter out already unwanted Spans from tracingOrigins
	    var shouldCreateSpan = defaultShouldCreateSpan;
	    if (typeof shouldCreateSpanForRequest === 'function') {
	        shouldCreateSpan = function (url) {
	            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
	        };
	    }
	    var spans = {};
	    if (traceFetch) {
	        utils_1.addInstrumentationHandler('fetch', function (handlerData) {
	            fetchCallback(handlerData, shouldCreateSpan, spans);
	        });
	    }
	    if (traceXHR) {
	        utils_1.addInstrumentationHandler('xhr', function (handlerData) {
	            xhrCallback(handlerData, shouldCreateSpan, spans);
	        });
	    }
	}
	exports.instrumentOutgoingRequests = instrumentOutgoingRequests;
	/**
	 * Create and track fetch request spans
	 */
	function fetchCallback(handlerData, shouldCreateSpan, spans) {
	    if (!utils_2.hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
	        return;
	    }
	    if (handlerData.endTimestamp) {
	        var spanId = handlerData.fetchData.__span;
	        if (!spanId)
	            return;
	        var span = spans[spanId];
	        if (span) {
	            if (handlerData.response) {
	                // TODO (kmclb) remove this once types PR goes through
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                span.setHttpStatus(handlerData.response.status);
	            }
	            else if (handlerData.error) {
	                span.setStatus('internal_error');
	            }
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[spanId];
	        }
	        return;
	    }
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { type: 'fetch' }),
	            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
	            op: 'http.client',
	        });
	        handlerData.fetchData.__span = span.spanId;
	        spans[span.spanId] = span;
	        var request = (handlerData.args[0] = handlerData.args[0]);
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var options = (handlerData.args[1] = handlerData.args[1] || {});
	        var headers = options.headers;
	        if (utils_1.isInstanceOf(request, Request)) {
	            headers = request.headers;
	        }
	        if (headers) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (typeof headers.append === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                headers.append('sentry-trace', span.toTraceparent());
	            }
	            else if (Array.isArray(headers)) {
	                headers = tslib_1.__spread(headers, [['sentry-trace', span.toTraceparent()]]);
	            }
	            else {
	                headers = tslib_1.__assign(tslib_1.__assign({}, headers), { 'sentry-trace': span.toTraceparent() });
	            }
	        }
	        else {
	            headers = { 'sentry-trace': span.toTraceparent() };
	        }
	        options.headers = headers;
	    }
	}
	exports.fetchCallback = fetchCallback;
	/**
	 * Create and track xhr request spans
	 */
	function xhrCallback(handlerData, shouldCreateSpan, spans) {
	    if (!utils_2.hasTracingEnabled() ||
	        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
	        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
	        return;
	    }
	    var xhr = handlerData.xhr.__sentry_xhr__;
	    // check first if the request has finished and is tracked by an existing span which should now end
	    if (handlerData.endTimestamp) {
	        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
	        if (!spanId)
	            return;
	        var span = spans[spanId];
	        if (span) {
	            span.setHttpStatus(xhr.status_code);
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[spanId];
	        }
	        return;
	    }
	    // if not, create a new span to track it
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
	            description: xhr.method + " " + xhr.url,
	            op: 'http.client',
	        });
	        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
	        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
	        if (handlerData.xhr.setRequestHeader) {
	            try {
	                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
	            }
	            catch (_) {
	                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
	            }
	        }
	    }
	}
	exports.xhrCallback = xhrCallback;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(123);
	var global = utils_1.getGlobalObject();
	/**
	 * Default function implementing pageload and navigation transactions
	 */
	function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	    if (!global || !global.location) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Could not initialize routing instrumentation due to invalid location');
	        return;
	    }
	    var startingUrl = global.location.href;
	    var activeTransaction;
	    if (startTransactionOnPageLoad) {
	        activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'pageload' });
	    }
	    if (startTransactionOnLocationChange) {
	        utils_1.addInstrumentationHandler('history', function (_a) {
	            var to = _a.to, from = _a.from;
	            /**
	             * This early return is there to account for some cases where a navigation transaction starts right after
	             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
	             * create an uneccessary navigation transaction.
	             *
	             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
	             * only be caused in certain development environments where the usage of a hot module reloader is causing
	             * errors.
	             */
	            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
	                startingUrl = undefined;
	                return;
	            }
	            if (from !== to) {
	                startingUrl = undefined;
	                if (activeTransaction) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
	                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
	                    activeTransaction.finish();
	                }
	                activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'navigation' });
	            }
	        });
	    }
	}
	exports.instrumentRoutingWithDefaults = instrumentRoutingWithDefaults;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an Span.
	 *
	 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
	 */
	// eslint-disable-next-line import/export
	var SpanStatus;
	(function (SpanStatus) {
	    /** The operation completed successfully. */
	    SpanStatus["Ok"] = "ok";
	    /** Deadline expired before operation could complete. */
	    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
	    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
	    SpanStatus["Unauthenticated"] = "unauthenticated";
	    /** 403 Forbidden */
	    SpanStatus["PermissionDenied"] = "permission_denied";
	    /** 404 Not Found. Some requested entity (file or directory) was not found. */
	    SpanStatus["NotFound"] = "not_found";
	    /** 429 Too Many Requests */
	    SpanStatus["ResourceExhausted"] = "resource_exhausted";
	    /** Client specified an invalid argument. 4xx. */
	    SpanStatus["InvalidArgument"] = "invalid_argument";
	    /** 501 Not Implemented */
	    SpanStatus["Unimplemented"] = "unimplemented";
	    /** 503 Service Unavailable */
	    SpanStatus["Unavailable"] = "unavailable";
	    /** Other/generic 5xx. */
	    SpanStatus["InternalError"] = "internal_error";
	    /** Unknown. Any non-standard HTTP status code. */
	    SpanStatus["UnknownError"] = "unknown_error";
	    /** The operation was cancelled (typically by the user). */
	    SpanStatus["Cancelled"] = "cancelled";
	    /** Already exists (409) */
	    SpanStatus["AlreadyExists"] = "already_exists";
	    /** Operation was rejected because the system is not in a state required for the operation's */
	    SpanStatus["FailedPrecondition"] = "failed_precondition";
	    /** The operation was aborted, typically due to a concurrency issue. */
	    SpanStatus["Aborted"] = "aborted";
	    /** Operation was attempted past the valid range. */
	    SpanStatus["OutOfRange"] = "out_of_range";
	    /** Unrecoverable data loss or corruption */
	    SpanStatus["DataLoss"] = "data_loss";
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	//# sourceMappingURL=spanstatus.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var angular_1 = __webpack_require__(151);
	exports.Angular = angular_1.Angular;
	var captureconsole_1 = __webpack_require__(153);
	exports.CaptureConsole = captureconsole_1.CaptureConsole;
	var debug_1 = __webpack_require__(154);
	exports.Debug = debug_1.Debug;
	var dedupe_1 = __webpack_require__(155);
	exports.Dedupe = dedupe_1.Dedupe;
	var ember_1 = __webpack_require__(156);
	exports.Ember = ember_1.Ember;
	var extraerrordata_1 = __webpack_require__(157);
	exports.ExtraErrorData = extraerrordata_1.ExtraErrorData;
	var offline_1 = __webpack_require__(158);
	exports.Offline = offline_1.Offline;
	var reportingobserver_1 = __webpack_require__(160);
	exports.ReportingObserver = reportingobserver_1.ReportingObserver;
	var rewriteframes_1 = __webpack_require__(161);
	exports.RewriteFrames = rewriteframes_1.RewriteFrames;
	var sessiontiming_1 = __webpack_require__(162);
	exports.SessionTiming = sessiontiming_1.SessionTiming;
	var transaction_1 = __webpack_require__(163);
	exports.Transaction = transaction_1.Transaction;
	var vue_1 = __webpack_require__(164);
	exports.Vue = vue_1.Vue;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(152);
	// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
	var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
	/**
	 * AngularJS integration
	 *
	 * Provides an $exceptionHandler for AngularJS
	 */
	var Angular = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function Angular(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Angular.id;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('You are still using the Angular integration, consider moving to @sentry/angular');
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	        this._angular = options.angular || utils_1.getGlobalObject().angular;
	        if (!this._angular) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('AngularIntegration is missing an Angular instance');
	            return;
	        }
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this._module = this._angular.module(Angular.moduleName, []);
	    }
	    /**
	     * @inheritDoc
	     */
	    Angular.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        if (!this._module) {
	            return;
	        }
	        this._getCurrentHub = getCurrentHub;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this._module.config([
	            '$provide',
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            function ($provide) {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                $provide.decorator('$exceptionHandler', ['$delegate', _this._$exceptionHandlerDecorator.bind(_this)]);
	            },
	        ]);
	    };
	    /**
	     * Angular's exceptionHandler for Sentry integration
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Angular.prototype._$exceptionHandlerDecorator = function ($delegate) {
	        var _this = this;
	        return function (exception, cause) {
	            var hub = _this._getCurrentHub && _this._getCurrentHub();
	            if (hub && hub.getIntegration(Angular)) {
	                hub.withScope(function (scope) {
	                    if (cause) {
	                        scope.setExtra('cause', cause);
	                    }
	                    scope.addEventProcessor(function (event) {
	                        var ex = event.exception && event.exception.values && event.exception.values[0];
	                        if (ex) {
	                            var matches = angularPattern.exec(ex.value || '');
	                            if (matches) {
	                                // This type now becomes something like: $rootScope:inprog
	                                ex.type = matches[1];
	                                ex.value = matches[2];
	                                event.message = ex.type + ": " + ex.value;
	                                // auto set a new tag specifically for the angular error url
	                                event.extra = tslib_1.__assign(tslib_1.__assign({}, event.extra), { angularDocs: matches[3].substr(0, 250) });
	                            }
	                        }
	                        return event;
	                    });
	                    hub.captureException(exception);
	                });
	            }
	            $delegate(exception, cause);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    Angular.id = 'AngularJS';
	    /**
	     * moduleName used in Angular's DI resolution algorithm
	     */
	    Angular.moduleName = 'ngSentry';
	    return Angular;
	}());
	exports.Angular = Angular;
	//# sourceMappingURL=angular.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var global = utils_1.getGlobalObject();
	/** Send Console API calls as Sentry Events */
	var CaptureConsole = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function CaptureConsole(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = CaptureConsole.id;
	        /**
	         * @inheritDoc
	         */
	        this._levels = utils_1.CONSOLE_LEVELS;
	        if (options.levels) {
	            this._levels = options.levels;
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    CaptureConsole.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!('console' in global)) {
	            return;
	        }
	        this._levels.forEach(function (level) {
	            if (!(level in global.console)) {
	                return;
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            utils_1.fill(global.console, level, function (originalConsoleMethod) { return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var hub = getCurrentHub();
	                if (hub.getIntegration(CaptureConsole)) {
	                    hub.withScope(function (scope) {
	                        scope.setLevel(utils_1.severityFromString(level));
	                        scope.setExtra('arguments', args);
	                        scope.addEventProcessor(function (event) {
	                            event.logger = 'console';
	                            return event;
	                        });
	                        var message = utils_1.safeJoin(args, ' ');
	                        if (level === 'assert') {
	                            if (args[0] === false) {
	                                message = "Assertion failed: " + (utils_1.safeJoin(args.slice(1), ' ') || 'console.assert');
	                                scope.setExtra('arguments', args.slice(1));
	                                hub.captureMessage(message);
	                            }
	                        }
	                        else if (level === 'error' && args[0] instanceof Error) {
	                            hub.captureException(args[0]);
	                        }
	                        else {
	                            hub.captureMessage(message);
	                        }
	                    });
	                }
	                // this fails for some browsers. :(
	                if (originalConsoleMethod) {
	                    originalConsoleMethod.apply(global.console, args);
	                }
	            }; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    CaptureConsole.id = 'CaptureConsole';
	    return CaptureConsole;
	}());
	exports.CaptureConsole = CaptureConsole;
	//# sourceMappingURL=captureconsole.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	/**
	 * Integration to debug sent Sentry events.
	 * This integration should not be used in production
	 */
	var Debug = /** @class */ (function () {
	    function Debug(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Debug.id;
	        this._options = tslib_1.__assign({ debugger: false, stringify: false }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    Debug.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event, hint) {
	            var self = getCurrentHub().getIntegration(Debug);
	            if (self) {
	                if (self._options.debugger) {
	                    // eslint-disable-next-line no-debugger
	                    debugger;
	                }
	                /* eslint-disable no-console */
	                utils_1.consoleSandbox(function () {
	                    if (self._options.stringify) {
	                        console.log(JSON.stringify(event, null, 2));
	                        if (hint) {
	                            console.log(JSON.stringify(hint, null, 2));
	                        }
	                    }
	                    else {
	                        console.log(event);
	                        if (hint) {
	                            console.log(hint);
	                        }
	                    }
	                });
	                /* eslint-enable no-console */
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Debug.id = 'Debug';
	    return Debug;
	}());
	exports.Debug = Debug;
	//# sourceMappingURL=debug.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(152);
	/** Deduplication filter */
	var Dedupe = /** @class */ (function () {
	    function Dedupe() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Dedupe.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (currentEvent) {
	            var self = getCurrentHub().getIntegration(Dedupe);
	            if (self) {
	                // Juuust in case something goes wrong
	                try {
	                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Event dropped due to being a duplicate of previously captured event.');
	                        return null;
	                    }
	                }
	                catch (_oO) {
	                    return (self._previousEvent = currentEvent);
	                }
	                return (self._previousEvent = currentEvent);
	            }
	            return currentEvent;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Dedupe.id = 'Dedupe';
	    return Dedupe;
	}());
	exports.Dedupe = Dedupe;
	/** JSDoc */
	function _shouldDropEvent(currentEvent, previousEvent) {
	    if (!previousEvent) {
	        return false;
	    }
	    if (_isSameMessageEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    return false;
	}
	exports._shouldDropEvent = _shouldDropEvent;
	/** JSDoc */
	function _isSameMessageEvent(currentEvent, previousEvent) {
	    var currentMessage = currentEvent.message;
	    var previousMessage = previousEvent.message;
	    // If neither event has a message property, they were both exceptions, so bail out
	    if (!currentMessage && !previousMessage) {
	        return false;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
	        return false;
	    }
	    if (currentMessage !== previousMessage) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameExceptionEvent(currentEvent, previousEvent) {
	    var previousException = _getExceptionFromEvent(previousEvent);
	    var currentException = _getExceptionFromEvent(currentEvent);
	    if (!previousException || !currentException) {
	        return false;
	    }
	    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameStacktrace(currentEvent, previousEvent) {
	    var currentFrames = _getFramesFromEvent(currentEvent);
	    var previousFrames = _getFramesFromEvent(previousEvent);
	    // If neither event has a stacktrace, they are assumed to be the same
	    if (!currentFrames && !previousFrames) {
	        return true;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
	        return false;
	    }
	    currentFrames = currentFrames;
	    previousFrames = previousFrames;
	    // If number of frames differ, they are not the same
	    if (previousFrames.length !== currentFrames.length) {
	        return false;
	    }
	    // Otherwise, compare the two
	    for (var i = 0; i < previousFrames.length; i++) {
	        var frameA = previousFrames[i];
	        var frameB = currentFrames[i];
	        if (frameA.filename !== frameB.filename ||
	            frameA.lineno !== frameB.lineno ||
	            frameA.colno !== frameB.colno ||
	            frameA.function !== frameB.function) {
	            return false;
	        }
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameFingerprint(currentEvent, previousEvent) {
	    var currentFingerprint = currentEvent.fingerprint;
	    var previousFingerprint = previousEvent.fingerprint;
	    // If neither event has a fingerprint, they are assumed to be the same
	    if (!currentFingerprint && !previousFingerprint) {
	        return true;
	    }
	    // If only one event has a fingerprint, but not the other one, they are not the same
	    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
	        return false;
	    }
	    currentFingerprint = currentFingerprint;
	    previousFingerprint = previousFingerprint;
	    // Otherwise, compare the two
	    try {
	        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
	    }
	    catch (_oO) {
	        return false;
	    }
	}
	/** JSDoc */
	function _getExceptionFromEvent(event) {
	    return event.exception && event.exception.values && event.exception.values[0];
	}
	/** JSDoc */
	function _getFramesFromEvent(event) {
	    var exception = event.exception;
	    if (exception) {
	        try {
	            // @ts-ignore Object could be undefined
	            return exception.values[0].stacktrace.frames;
	        }
	        catch (_oO) {
	            return undefined;
	        }
	    }
	    else if (event.stacktrace) {
	        return event.stacktrace.frames;
	    }
	    return undefined;
	}
	//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(152);
	/** JSDoc */
	var Ember = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function Ember(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Ember.id;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	        this._Ember = options.Ember || utils_1.getGlobalObject().Ember;
	    }
	    /**
	     * @inheritDoc
	     */
	    Ember.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        if (!this._Ember) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('EmberIntegration is missing an Ember instance');
	            return;
	        }
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var oldOnError = this._Ember.onerror;
	        this._Ember.onerror = function (error) {
	            if (getCurrentHub().getIntegration(Ember)) {
	                getCurrentHub().captureException(error, { originalException: error });
	            }
	            if (typeof oldOnError === 'function') {
	                oldOnError.call(_this._Ember, error);
	            }
	            else if (_this._Ember.testing) {
	                throw error;
	            }
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this._Ember.RSVP.on('error', function (reason) {
	            if (getCurrentHub().getIntegration(Ember)) {
	                getCurrentHub().withScope(function (scope) {
	                    if (utils_1.isInstanceOf(reason, Error)) {
	                        scope.setExtra('context', 'Unhandled Promise error detected');
	                        getCurrentHub().captureException(reason, { originalException: reason });
	                    }
	                    else {
	                        scope.setExtra('reason', reason);
	                        getCurrentHub().captureMessage('Unhandled Promise error detected');
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Ember.id = 'Ember';
	    return Ember;
	}());
	exports.Ember = Ember;
	//# sourceMappingURL=ember.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(152);
	/** Patch toString calls to return proper name for wrapped functions */
	var ExtraErrorData = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function ExtraErrorData(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = ExtraErrorData.id;
	        this._options = tslib_1.__assign({ depth: 3 }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    ExtraErrorData.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event, hint) {
	            var self = getCurrentHub().getIntegration(ExtraErrorData);
	            if (!self) {
	                return event;
	            }
	            return self.enhanceEventWithErrorData(event, hint);
	        });
	    };
	    /**
	     * Attaches extracted information from the Error object to extra field in the Event
	     */
	    ExtraErrorData.prototype.enhanceEventWithErrorData = function (event, hint) {
	        var _a;
	        if (!hint || !hint.originalException || !utils_1.isError(hint.originalException)) {
	            return event;
	        }
	        var name = hint.originalException.name || hint.originalException.constructor.name;
	        var errorData = this._extractErrorData(hint.originalException);
	        if (errorData) {
	            var contexts = tslib_1.__assign({}, event.contexts);
	            var normalizedErrorData = utils_1.normalize(errorData, this._options.depth);
	            if (utils_1.isPlainObject(normalizedErrorData)) {
	                contexts = tslib_1.__assign(tslib_1.__assign({}, event.contexts), (_a = {}, _a[name] = tslib_1.__assign({}, normalizedErrorData), _a));
	            }
	            return tslib_1.__assign(tslib_1.__assign({}, event), { contexts: contexts });
	        }
	        return event;
	    };
	    /**
	     * Extract extra information from the Error object
	     */
	    ExtraErrorData.prototype._extractErrorData = function (error) {
	        var e_1, _a, e_2, _b;
	        // We are trying to enhance already existing event, so no harm done if it won't succeed
	        try {
	            var nativeKeys = [
	                'name',
	                'message',
	                'stack',
	                'line',
	                'column',
	                'fileName',
	                'lineNumber',
	                'columnNumber',
	                'toJSON',
	            ];
	            var extraErrorInfo = {};
	            try {
	                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
	                for (var _c = tslib_1.__values(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var key = _d.value;
	                    if (nativeKeys.indexOf(key) !== -1) {
	                        continue;
	                    }
	                    var value = error[key];
	                    extraErrorInfo[key] = utils_1.isError(value) ? value.toString() : value;
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
	            if (typeof error.toJSON === 'function') {
	                var serializedError = error.toJSON();
	                try {
	                    for (var _e = tslib_1.__values(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var key = _f.value;
	                        var value = serializedError[key];
	                        extraErrorInfo[key] = utils_1.isError(value) ? value.toString() : value;
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	            return extraErrorInfo;
	        }
	        catch (oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Unable to extract extra data from the Error object:', oO);
	        }
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    ExtraErrorData.id = 'ExtraErrorData';
	    return ExtraErrorData;
	}());
	exports.ExtraErrorData = ExtraErrorData;
	//# sourceMappingURL=extraerrordata.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var localforage_1 = tslib_1.__importDefault(__webpack_require__(159));
	var flags_1 = __webpack_require__(152);
	/**
	 * cache offline errors and send when connected
	 */
	var Offline = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Offline(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Offline.id;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.global = utils_1.getGlobalObject();
	        this.maxStoredEvents = options.maxStoredEvents || 30; // set a reasonable default
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this.offlineEventStore = localforage_1.default.createInstance({
	            name: 'sentry/offlineEventStore',
	        });
	    }
	    /**
	     * @inheritDoc
	     */
	    Offline.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        var _this = this;
	        this.hub = getCurrentHub();
	        if ('addEventListener' in this.global) {
	            this.global.addEventListener('online', function () {
	                void _this._sendEvents().catch(function () {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not send cached events');
	                });
	            });
	        }
	        addGlobalEventProcessor(function (event) {
	            if (_this.hub && _this.hub.getIntegration(Offline)) {
	                // cache if we are positively offline
	                if ('navigator' in _this.global && 'onLine' in _this.global.navigator && !_this.global.navigator.onLine) {
	                    void _this._cacheEvent(event)
	                        .then(function (_event) { return _this._enforceMaxEvents(); })
	                        .catch(function (_error) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not cache event while offline');
	                    });
	                    // return null on success or failure, because being offline will still result in an error
	                    return null;
	                }
	            }
	            return event;
	        });
	        // if online now, send any events stored in a previous offline session
	        if ('navigator' in this.global && 'onLine' in this.global.navigator && this.global.navigator.onLine) {
	            void this._sendEvents().catch(function () {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not send cached events');
	            });
	        }
	    };
	    /**
	     * cache an event to send later
	     * @param event an event
	     */
	    Offline.prototype._cacheEvent = function (event) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.setItem(utils_1.uuid4(), utils_1.normalize(event))];
	            });
	        });
	    };
	    /**
	     * purge excess events if necessary
	     */
	    Offline.prototype._enforceMaxEvents = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var events;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                events = [];
	                return [2 /*return*/, this.offlineEventStore
	                        .iterate(function (event, cacheKey, _index) {
	                        // aggregate events
	                        events.push({ cacheKey: cacheKey, event: event });
	                    })
	                        .then(function () {
	                        // this promise resolves when the iteration is finished
	                        return _this._purgeEvents(
	                        // purge all events past maxStoredEvents in reverse chronological order
	                        events
	                            .sort(function (a, b) { return (b.event.timestamp || 0) - (a.event.timestamp || 0); })
	                            .slice(_this.maxStoredEvents < events.length ? _this.maxStoredEvents : events.length)
	                            .map(function (event) { return event.cacheKey; }));
	                    })
	                        .catch(function (_error) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not enforce max events');
	                    })];
	            });
	        });
	    };
	    /**
	     * purge event from cache
	     */
	    Offline.prototype._purgeEvent = function (cacheKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.removeItem(cacheKey)];
	            });
	        });
	    };
	    /**
	     * purge events from cache
	     */
	    Offline.prototype._purgeEvents = function (cacheKeys) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                // trail with .then to ensure the return type as void and not void|void[]
	                return [2 /*return*/, Promise.all(cacheKeys.map(function (cacheKey) { return _this._purgeEvent(cacheKey); })).then()];
	            });
	        });
	    };
	    /**
	     * send all events
	     */
	    Offline.prototype._sendEvents = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.iterate(function (event, cacheKey, _index) {
	                        if (_this.hub) {
	                            _this.hub.captureEvent(event);
	                            void _this._purgeEvent(cacheKey).catch(function (_error) {
	                                flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not purge event from cache');
	                            });
	                        }
	                        else {
	                            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('no hub found - could not send cached event');
	                        }
	                    })];
	            });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Offline.id = 'Offline';
	    return Offline;
	}());
	exports.Offline = Offline;
	//# sourceMappingURL=offline.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/*!
	    localForage -- Offline Storage, Improved
	    Version 1.10.0
	    https://localforage.github.io/localForage
	    (c) 2013-2017 Mozilla, Apache License 2.0
	*/
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;

	var scheduleDrain;

	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {

	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();

	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}

	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}

	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	var immediate = _dereq_(1);

	/* istanbul ignore next */
	function INTERNAL() {}

	var handlers = {};

	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];

	module.exports = Promise;

	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}

	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }

	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};

	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}

	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;

	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};

	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}

	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }

	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }

	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }

	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}

	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}

	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}

	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}

	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}

	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}

	},{"1":1}],3:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	if (typeof global.Promise !== 'function') {
	  global.Promise = _dereq_(2);
	}

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"2":2}],4:[function(_dereq_,module,exports){
	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function getIDB() {
	    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	    try {
	        if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	        }
	        if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	        }
	        if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	        }
	        if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	        }
	        if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	        }
	    } catch (e) {
	        return;
	    }
	}

	var idb = getIDB();

	function isIndexedDBValid() {
	    try {
	        // Initialize IndexedDB; fall back to vendor-prefixed versions
	        // if needed.
	        if (!idb || !idb.open) {
	            return false;
	        }
	        // We mimic PouchDB here;
	        //
	        // We test for openDatabase because IE Mobile identifies itself
	        // as Safari. Oh the lulz...
	        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

	        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

	        // Safari <10.1 does not meet our requirements for IDB support
	        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
	        // Safari 10.1 shipped with fetch, we can use that to detect it.
	        // Note: this creates issues with `window.fetch` polyfills and
	        // overrides; see:
	        // https://github.com/localForage/localForage/issues/856
	        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	        // some outdated implementations of IDB that appear on Samsung
	        // and HTC Android devices <4.4 are missing IDBKeyRange
	        // See: https://github.com/mozilla/localForage/issues/128
	        // See: https://github.com/mozilla/localForage/issues/272
	        typeof IDBKeyRange !== 'undefined';
	    } catch (e) {
	        return false;
	    }
	}

	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	function createBlob(parts, properties) {
	    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	    parts = parts || [];
	    properties = properties || {};
	    try {
	        return new Blob(parts, properties);
	    } catch (e) {
	        if (e.name !== 'TypeError') {
	            throw e;
	        }
	        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	        var builder = new Builder();
	        for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	        }
	        return builder.getBlob(properties.type);
	    }
	}

	// This is CommonJS because lie is an external dependency, so Rollup
	// can just ignore it.
	if (typeof Promise === 'undefined') {
	    // In the "nopromises" build this will just throw if you don't have
	    // a global promise object, but it would throw anyway later.
	    _dereq_(3);
	}
	var Promise$1 = Promise;

	function executeCallback(promise, callback) {
	    if (callback) {
	        promise.then(function (result) {
	            callback(null, result);
	        }, function (error) {
	            callback(error);
	        });
	    }
	}

	function executeTwoCallbacks(promise, callback, errorCallback) {
	    if (typeof callback === 'function') {
	        promise.then(callback);
	    }

	    if (typeof errorCallback === 'function') {
	        promise["catch"](errorCallback);
	    }
	}

	function normalizeKey(key) {
	    // Cast the key to a string, as that's all we can set as a key.
	    if (typeof key !== 'string') {
	        console.warn(key + ' used as a key, but it is not a string.');
	        key = String(key);
	    }

	    return key;
	}

	function getCallback() {
	    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	        return arguments[arguments.length - 1];
	    }
	}

	// Some code originally from async_storage.js in
	// [Gaia](https://github.com/mozilla-b2g/gaia).

	var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	var supportsBlobs = void 0;
	var dbContexts = {};
	var toString = Object.prototype.toString;

	// Transaction Modes
	var READ_ONLY = 'readonly';
	var READ_WRITE = 'readwrite';

	// Transform a binary string to an array buffer, because otherwise
	// weird stuff happens when you try to work with the binary string directly.
	// It is known.
	// From http://stackoverflow.com/questions/14967647/ (continues on next line)
	// encode-decode-image-with-base64-breaks-image (2013-04-21)
	function _binStringToArrayBuffer(bin) {
	    var length = bin.length;
	    var buf = new ArrayBuffer(length);
	    var arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = bin.charCodeAt(i);
	    }
	    return buf;
	}

	//
	// Blobs are not supported in all versions of IndexedDB, notably
	// Chrome <37 and Android <5. In those versions, storing a blob will throw.
	//
	// Various other blob bugs exist in Chrome v37-42 (inclusive).
	// Detecting them is expensive and confusing to users, and Chrome 37-42
	// is at very low usage worldwide, so we do a hacky userAgent check instead.
	//
	// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	//
	// Code borrowed from PouchDB. See:
	// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	//
	function _checkBlobSupportWithoutCaching(idb) {
	    return new Promise$1(function (resolve) {
	        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	        var blob = createBlob(['']);
	        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

	        txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	        };

	        txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	        };
	    })["catch"](function () {
	        return false; // error, so assume unsupported
	    });
	}

	function _checkBlobSupport(idb) {
	    if (typeof supportsBlobs === 'boolean') {
	        return Promise$1.resolve(supportsBlobs);
	    }
	    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	        supportsBlobs = value;
	        return supportsBlobs;
	    });
	}

	function _deferReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Create a deferred object representing the current database operation.
	    var deferredOperation = {};

	    deferredOperation.promise = new Promise$1(function (resolve, reject) {
	        deferredOperation.resolve = resolve;
	        deferredOperation.reject = reject;
	    });

	    // Enqueue the deferred operation.
	    dbContext.deferredOperations.push(deferredOperation);

	    // Chain its promise to the database readiness.
	    if (!dbContext.dbReady) {
	        dbContext.dbReady = deferredOperation.promise;
	    } else {
	        dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	        });
	    }
	}

	function _advanceReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Resolve its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.resolve();
	        return deferredOperation.promise;
	    }
	}

	function _rejectReadiness(dbInfo, err) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Reject its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.reject(err);
	        return deferredOperation.promise;
	    }
	}

	function _getConnection(dbInfo, upgradeNeeded) {
	    return new Promise$1(function (resolve, reject) {
	        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

	        if (dbInfo.db) {
	            if (upgradeNeeded) {
	                _deferReadiness(dbInfo);
	                dbInfo.db.close();
	            } else {
	                return resolve(dbInfo.db);
	            }
	        }

	        var dbArgs = [dbInfo.name];

	        if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	        }

	        var openreq = idb.open.apply(idb, dbArgs);

	        if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	                var db = openreq.result;
	                try {
	                    db.createObjectStore(dbInfo.storeName);
	                    if (e.oldVersion <= 1) {
	                        // Added when support for blob shims was added
	                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                    }
	                } catch (ex) {
	                    if (ex.name === 'ConstraintError') {
	                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                    } else {
	                        throw ex;
	                    }
	                }
	            };
	        }

	        openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	        };

	        openreq.onsuccess = function () {
	            var db = openreq.result;
	            db.onversionchange = function (e) {
	                // Triggered when the database is modified (e.g. adding an objectStore) or
	                // deleted (even when initiated by other sessions in different tabs).
	                // Closing the connection here prevents those operations from being blocked.
	                // If the database is accessed again later by this instance, the connection
	                // will be reopened or the database recreated as needed.
	                e.target.close();
	            };
	            resolve(db);
	            _advanceReadiness(dbInfo);
	        };
	    });
	}

	function _getOriginalConnection(dbInfo) {
	    return _getConnection(dbInfo, false);
	}

	function _getUpgradedConnection(dbInfo) {
	    return _getConnection(dbInfo, true);
	}

	function _isUpgradeNeeded(dbInfo, defaultVersion) {
	    if (!dbInfo.db) {
	        return true;
	    }

	    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	    var isDowngrade = dbInfo.version < dbInfo.db.version;
	    var isUpgrade = dbInfo.version > dbInfo.db.version;

	    if (isDowngrade) {
	        // If the version is not the default one
	        // then warn for impossible downgrade.
	        if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	        }
	        // Align the versions to prevent errors.
	        dbInfo.version = dbInfo.db.version;
	    }

	    if (isUpgrade || isNewStore) {
	        // If the store is new then increment the version (if needed).
	        // This will trigger an "upgradeneeded" event which is required
	        // for creating a store.
	        if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	                dbInfo.version = incVersion;
	            }
	        }

	        return true;
	    }

	    return false;
	}

	// encode a blob for indexeddb engines that don't support blobs
	function _encodeBlob(blob) {
	    return new Promise$1(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onerror = reject;
	        reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	                __local_forage_encoded_blob: true,
	                data: base64,
	                type: blob.type
	            });
	        };
	        reader.readAsBinaryString(blob);
	    });
	}

	// decode an encoded blob
	function _decodeBlob(encodedBlob) {
	    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	    return createBlob([arrayBuff], { type: encodedBlob.type });
	}

	// is this one of our fancy encoded blobs?
	function _isEncodedBlob(value) {
	    return value && value.__local_forage_encoded_blob;
	}

	// Specialize the default `ready()` function by making it dependent
	// on the current database operations. Thus, the driver will be actually
	// ready when it's been initialized (default) *and* there are no pending
	// operations on the database (initiated by some other instances).
	function _fullyReady(callback) {
	    var self = this;

	    var promise = self._initReady().then(function () {
	        var dbContext = dbContexts[self._dbInfo.name];

	        if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	        }
	    });

	    executeTwoCallbacks(promise, callback, callback);
	    return promise;
	}

	// Try to establish a new db connection to replace the
	// current one which is broken (i.e. experiencing
	// InvalidStateError while creating a transaction).
	function _tryReconnect(dbInfo) {
	    _deferReadiness(dbInfo);

	    var dbContext = dbContexts[dbInfo.name];
	    var forages = dbContext.forages;

	    for (var i = 0; i < forages.length; i++) {
	        var forage = forages[i];
	        if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	        }
	    }
	    dbInfo.db = null;

	    return _getOriginalConnection(dbInfo).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        // store the latest db reference
	        // in case the db was upgraded
	        dbInfo.db = dbContext.db = db;
	        for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	        }
	    })["catch"](function (err) {
	        _rejectReadiness(dbInfo, err);
	        throw err;
	    });
	}

	// FF doesn't like Promises (micro-tasks) and IDDB store operations,
	// so we have to do it with callbacks
	function createTransaction(dbInfo, mode, callback, retries) {
	    if (retries === undefined) {
	        retries = 1;
	    }

	    try {
	        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	        callback(null, tx);
	    } catch (err) {
	        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                    // increase the db version, to create the new ObjectStore
	                    if (dbInfo.db) {
	                        dbInfo.version = dbInfo.db.version + 1;
	                    }
	                    // Reopen the database for upgrading.
	                    return _getUpgradedConnection(dbInfo);
	                }
	            }).then(function () {
	                return _tryReconnect(dbInfo).then(function () {
	                    createTransaction(dbInfo, mode, callback, retries - 1);
	                });
	            })["catch"](callback);
	        }

	        callback(err);
	    }
	}

	function createDbContext() {
	    return {
	        // Running localForages sharing a database.
	        forages: [],
	        // Shared database.
	        db: null,
	        // Database readiness (promise).
	        dbReady: null,
	        // Deferred operations on the database.
	        deferredOperations: []
	    };
	}

	// Open the IndexedDB database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    // Get the current context of the database;
	    var dbContext = dbContexts[dbInfo.name];

	    // ...or create a new context.
	    if (!dbContext) {
	        dbContext = createDbContext();
	        // Register the new context in the global container.
	        dbContexts[dbInfo.name] = dbContext;
	    }

	    // Register itself as a running localForage in the current context.
	    dbContext.forages.push(self);

	    // Replace the default `ready()` function with the specialized one.
	    if (!self._initReady) {
	        self._initReady = self.ready;
	        self.ready = _fullyReady;
	    }

	    // Create an array of initialization states of the related localForages.
	    var initPromises = [];

	    function ignoreErrors() {
	        // Don't handle errors here,
	        // just makes sure related localForages aren't pending.
	        return Promise$1.resolve();
	    }

	    for (var j = 0; j < dbContext.forages.length; j++) {
	        var forage = dbContext.forages[j];
	        if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	        }
	    }

	    // Take a snapshot of the related localForages.
	    var forages = dbContext.forages.slice(0);

	    // Initialize the connection process only when
	    // all the related localForages aren't pending.
	    return Promise$1.all(initPromises).then(function () {
	        dbInfo.db = dbContext.db;
	        // Get the connection or open a new one without upgrade.
	        return _getOriginalConnection(dbInfo);
	    }).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        dbInfo.db = dbContext.db = db;
	        self._dbInfo = dbInfo;
	        // Share the final connection amongst related localForages.
	        for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	                // Self is already up-to-date.
	                forage._dbInfo.db = dbInfo.db;
	                forage._dbInfo.version = dbInfo.version;
	            }
	        }
	    });
	}

	function getItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.get(key);

	                    req.onsuccess = function () {
	                        var value = req.result;
	                        if (value === undefined) {
	                            value = null;
	                        }
	                        if (_isEncodedBlob(value)) {
	                            value = _decodeBlob(value);
	                        }
	                        resolve(value);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items stored in database.
	function iterate(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var iterationNumber = 1;

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (cursor) {
	                            var value = cursor.value;
	                            if (_isEncodedBlob(value)) {
	                                value = _decodeBlob(value);
	                            }
	                            var result = iterator(value, cursor.key, iterationNumber++);

	                            // when the iterator callback returns any
	                            // (non-`undefined`) value, then we stop
	                            // the iteration immediately
	                            if (result !== void 0) {
	                                resolve(result);
	                            } else {
	                                cursor["continue"]();
	                            }
	                        } else {
	                            resolve();
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);

	    return promise;
	}

	function setItem(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        var dbInfo;
	        self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                    if (blobSupport) {
	                        return value;
	                    }
	                    return _encodeBlob(value);
	                });
	            }
	            return value;
	        }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);

	                    // The reason we don't _save_ null is because IE 10 does
	                    // not support saving the `null` type in IndexedDB. How
	                    // ironic, given the bug below!
	                    // See: https://github.com/mozilla/localForage/issues/161
	                    if (value === null) {
	                        value = undefined;
	                    }

	                    var req = store.put(value, key);

	                    transaction.oncomplete = function () {
	                        // Cast to undefined so the value passed to
	                        // callback/promise is the same as what one would get out
	                        // of `getItem()` later. This leads to some weirdness
	                        // (setItem('foo', undefined) will return `null`), but
	                        // it's not my fault localStorage is our baseline and that
	                        // it's weird.
	                        if (value === undefined) {
	                            value = null;
	                        }

	                        resolve(value);
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function removeItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    // We use a Grunt task to make this safe for IE and some
	                    // versions of Android (including those used by Cordova).
	                    // Normally IE won't like `.delete()` and will insist on
	                    // using `['delete']()`, but we have a build step that
	                    // fixes this for us now.
	                    var req = store["delete"](key);
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onerror = function () {
	                        reject(req.error);
	                    };

	                    // The request will be also be aborted if we've exceeded our storage
	                    // space.
	                    transaction.onabort = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function clear(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.clear();

	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function length(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.count();

	                    req.onsuccess = function () {
	                        resolve(req.result);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function key(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        if (n < 0) {
	            resolve(null);

	            return;
	        }

	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var advanced = false;
	                    var req = store.openKeyCursor();

	                    req.onsuccess = function () {
	                        var cursor = req.result;
	                        if (!cursor) {
	                            // this means there weren't enough keys
	                            resolve(null);

	                            return;
	                        }

	                        if (n === 0) {
	                            // We have the first key, return it if that's what they
	                            // wanted.
	                            resolve(cursor.key);
	                        } else {
	                            if (!advanced) {
	                                // Otherwise, ask the cursor to skip ahead n
	                                // records.
	                                advanced = true;
	                                cursor.advance(n);
	                            } else {
	                                // When we get here, we've got the nth key.
	                                resolve(cursor.key);
	                            }
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openKeyCursor();
	                    var keys = [];

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (!cursor) {
	                            resolve(keys);
	                            return;
	                        }

	                        keys.push(cursor.key);
	                        cursor["continue"]();
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

	        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	                forages[i]._dbInfo.db = db;
	            }
	            return db;
	        });

	        if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                }

	                var dropDBPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.deleteDatabase(options.name);

	                    req.onerror = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        reject(req.error);
	                    };

	                    req.onblocked = function () {
	                        // Closing all open connections in onversionchange handler should prevent this situation, but if
	                        // we do get here, it just means the request remains pending - eventually it will succeed or error
	                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        resolve(db);
	                    };
	                });

	                return dropDBPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var i = 0; i < forages.length; i++) {
	                        var _forage = forages[i];
	                        _advanceReadiness(_forage._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        } else {
	            promise = dbPromise.then(function (db) {
	                if (!db.objectStoreNames.contains(options.storeName)) {
	                    return;
	                }

	                var newVersion = db.version + 1;

	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                    forage._dbInfo.version = newVersion;
	                }

	                var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.open(options.name, newVersion);

	                    req.onerror = function (err) {
	                        var db = req.result;
	                        db.close();
	                        reject(err);
	                    };

	                    req.onupgradeneeded = function () {
	                        var db = req.result;
	                        db.deleteObjectStore(options.storeName);
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        db.close();
	                        resolve(db);
	                    };
	                });

	                return dropObjectPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var j = 0; j < forages.length; j++) {
	                        var _forage2 = forages[j];
	                        _forage2._dbInfo.db = db;
	                        _advanceReadiness(_forage2._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        }
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var asyncStorage = {
	    _driver: 'asyncStorage',
	    _initStorage: _initStorage,
	    _support: isIndexedDBValid(),
	    iterate: iterate,
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key,
	    keys: keys,
	    dropInstance: dropInstance
	};

	function isWebSQLValid() {
	    return typeof openDatabase === 'function';
	}

	// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	// it to Base64, so this is how we store it to prevent very strange errors with less
	// verbose ways of binary <-> string data storage.
	var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

	var SERIALIZED_MARKER = '__lfsc__:';
	var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

	// OMG the serializations!
	var TYPE_ARRAYBUFFER = 'arbf';
	var TYPE_BLOB = 'blob';
	var TYPE_INT8ARRAY = 'si08';
	var TYPE_UINT8ARRAY = 'ui08';
	var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	var TYPE_INT16ARRAY = 'si16';
	var TYPE_INT32ARRAY = 'si32';
	var TYPE_UINT16ARRAY = 'ur16';
	var TYPE_UINT32ARRAY = 'ui32';
	var TYPE_FLOAT32ARRAY = 'fl32';
	var TYPE_FLOAT64ARRAY = 'fl64';
	var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

	var toString$1 = Object.prototype.toString;

	function stringToBuffer(serializedString) {
	    // Fill the string into a ArrayBuffer.
	    var bufferLength = serializedString.length * 0.75;
	    var len = serializedString.length;
	    var i;
	    var p = 0;
	    var encoded1, encoded2, encoded3, encoded4;

	    if (serializedString[serializedString.length - 1] === '=') {
	        bufferLength--;
	        if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	        }
	    }

	    var buffer = new ArrayBuffer(bufferLength);
	    var bytes = new Uint8Array(buffer);

	    for (i = 0; i < len; i += 4) {
	        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

	        /*jslint bitwise: true */
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	    return buffer;
	}

	// Converts a buffer to a string to store, serialized, in the backend
	// storage library.
	function bufferToString(buffer) {
	    // base64-arraybuffer
	    var bytes = new Uint8Array(buffer);
	    var base64String = '';
	    var i;

	    for (i = 0; i < bytes.length; i += 3) {
	        /*jslint bitwise: true */
	        base64String += BASE_CHARS[bytes[i] >> 2];
	        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	        base64String += BASE_CHARS[bytes[i + 2] & 63];
	    }

	    if (bytes.length % 3 === 2) {
	        base64String = base64String.substring(0, base64String.length - 1) + '=';
	    } else if (bytes.length % 3 === 1) {
	        base64String = base64String.substring(0, base64String.length - 2) + '==';
	    }

	    return base64String;
	}

	// Serialize a value, afterwards executing a callback (which usually
	// instructs the `setItem()` callback/promise to be executed). This is how
	// we store binary data with localStorage.
	function serialize(value, callback) {
	    var valueType = '';
	    if (value) {
	        valueType = toString$1.call(value);
	    }

	    // Cannot use `value instanceof ArrayBuffer` or such here, as these
	    // checks fail when running the tests using casper.js...
	    //
	    // TODO: See why those tests fail and use a better solution.
	    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	        // Convert binary arrays to a string and prefix the string with
	        // a special marker.
	        var buffer;
	        var marker = SERIALIZED_MARKER;

	        if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	        } else {
	            buffer = value.buffer;

	            if (valueType === '[object Int8Array]') {
	                marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	                marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	                marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	                marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	                marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	                marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	                marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	                marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	                marker += TYPE_FLOAT64ARRAY;
	            } else {
	                callback(new Error('Failed to get type for BinaryArray'));
	            }
	        }

	        callback(marker + bufferToString(buffer));
	    } else if (valueType === '[object Blob]') {
	        // Conver the blob to a binaryArray and then to a string.
	        var fileReader = new FileReader();

	        fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	        };

	        fileReader.readAsArrayBuffer(value);
	    } else {
	        try {
	            callback(JSON.stringify(value));
	        } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);

	            callback(null, e);
	        }
	    }
	}

	// Deserialize data we've inserted into a value column/field. We place
	// special markers into our strings to mark them as encoded; this isn't
	// as nice as a meta field, but it's the only sane thing we can do whilst
	// keeping localStorage support intact.
	//
	// Oftentimes this will just deserialize JSON content, but if we have a
	// special marker (SERIALIZED_MARKER, defined above), we will extract
	// some kind of arraybuffer/binary data/typed array out of the string.
	function deserialize(value) {
	    // If we haven't marked this string as being specially serialized (i.e.
	    // something other than serialized JSON), we can just return it and be
	    // done with it.
	    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	        return JSON.parse(value);
	    }

	    // The following code deals with deserializing some kind of Blob or
	    // TypedArray. First we separate out the type of data we're dealing
	    // with from the data itself.
	    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

	    var blobType;
	    // Backwards-compatible blob type serialization strategy.
	    // DBs created with older versions of localForage will simply not have the blob type.
	    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	        blobType = matcher[1];
	        serializedString = serializedString.substring(matcher[0].length);
	    }
	    var buffer = stringToBuffer(serializedString);

	    // Return the right type based on the code/type set during
	    // serialization.
	    switch (type) {
	        case TYPE_ARRAYBUFFER:
	            return buffer;
	        case TYPE_BLOB:
	            return createBlob([buffer], { type: blobType });
	        case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	        case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	        case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	        case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	        case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	        case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	        case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	        case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	        case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	        default:
	            throw new Error('Unkown type: ' + type);
	    }
	}

	var localforageSerializer = {
	    serialize: serialize,
	    deserialize: deserialize,
	    stringToBuffer: stringToBuffer,
	    bufferToString: bufferToString
	};

	/*
	 * Includes code from:
	 *
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */

	function createDbTable(t, dbInfo, callback, errorCallback) {
	    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	}

	// Open the WebSQL database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage$1(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	        }
	    }

	    var dbInfoPromise = new Promise$1(function (resolve, reject) {
	        // Open the database; the openDatabase API will automatically
	        // create it for us if it doesn't exist.
	        try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	        } catch (e) {
	            return reject(e);
	        }

	        // Create our key/value table if it doesn't exist.
	        dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	                self._dbInfo = dbInfo;
	                resolve();
	            }, function (t, error) {
	                reject(error);
	            });
	        }, reject);
	    });

	    dbInfo.serializer = localforageSerializer;
	    return dbInfoPromise;
	}

	function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	    t.executeSql(sqlStatement, args, callback, function (t, error) {
	        if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	                if (!results.rows.length) {
	                    // if the table is missing (was deleted)
	                    // re-create it table and retry
	                    createDbTable(t, dbInfo, function () {
	                        t.executeSql(sqlStatement, args, callback, errorCallback);
	                    }, errorCallback);
	                } else {
	                    errorCallback(t, error);
	                }
	            }, errorCallback);
	        } else {
	            errorCallback(t, error);
	        }
	    }, errorCallback);
	}

	function getItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).value : null;

	                    // Check to see if this is serialized content we need to
	                    // unpack.
	                    if (result) {
	                        result = dbInfo.serializer.deserialize(result);
	                    }

	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function iterate$1(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;

	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var rows = results.rows;
	                    var length = rows.length;

	                    for (var i = 0; i < length; i++) {
	                        var item = rows.item(i);
	                        var result = item.value;

	                        // Check to see if this is serialized content
	                        // we need to unpack.
	                        if (result) {
	                            result = dbInfo.serializer.deserialize(result);
	                        }

	                        result = iterator(result, item.key, i + 1);

	                        // void(0) prevents problems with redefinition
	                        // of `undefined`.
	                        if (result !== void 0) {
	                            resolve(result);
	                            return;
	                        }
	                    }

	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function _setItem(key, value, callback, retriesLeft) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	                value = null;
	            }

	            // Save the original value to pass to the callback.
	            var originalValue = value;

	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    dbInfo.db.transaction(function (t) {
	                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                            resolve(originalValue);
	                        }, function (t, error) {
	                            reject(error);
	                        });
	                    }, function (sqlError) {
	                        // The transaction failed; check
	                        // to see if it's a quota error.
	                        if (sqlError.code === sqlError.QUOTA_ERR) {
	                            // We reject the callback outright for now, but
	                            // it's worth trying to re-run the transaction.
	                            // Even if the user accepts the prompt to use
	                            // more storage on Safari, this error will
	                            // be called.
	                            //
	                            // Try to re-run the transaction.
	                            if (retriesLeft > 0) {
	                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                                return;
	                            }
	                            reject(sqlError);
	                        }
	                    });
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function setItem$1(key, value, callback) {
	    return _setItem.apply(this, [key, value, callback, 1]);
	}

	function removeItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Deletes every item in the table.
	// TODO: Find out if this resets the AUTO_INCREMENT number.
	function clear$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Does a simple `COUNT(key)` to get the number of items stored in
	// localForage.
	function length$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                // Ahhh, SQL makes this one soooooo easy.
	                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var result = results.rows.item(0).c;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Return the key located at key index X; essentially gets the key from a
	// `WHERE id = ?`. This is the most efficient way I can think to implement
	// this rarely-used (in my experience) part of the API, but it can seem
	// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	// the ID of each key will change every time it's updated. Perhaps a stored
	// procedure for the `setItem()` SQL would solve this problem?
	// TODO: Don't change ID on `setItem()`.
	function key$1(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).key : null;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var keys = [];

	                    for (var i = 0; i < results.rows.length; i++) {
	                        keys.push(results.rows.item(i).key);
	                    }

	                    resolve(keys);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// https://www.w3.org/TR/webdatabase/#databases
	// > There is no way to enumerate or delete the databases available for an origin from this API.
	function getAllStoreNames(db) {
	    return new Promise$1(function (resolve, reject) {
	        db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	                var storeNames = [];

	                for (var i = 0; i < results.rows.length; i++) {
	                    storeNames.push(results.rows.item(i).name);
	                }

	                resolve({
	                    db: db,
	                    storeNames: storeNames
	                });
	            }, function (t, error) {
	                reject(error);
	            });
	        }, function (sqlError) {
	            reject(sqlError);
	        });
	    });
	}

	function dropInstance$1(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	                // use the db reference of the current instance
	                db = self._dbInfo.db;
	            } else {
	                db = openDatabase(options.name, '', '', 0);
	            }

	            if (!options.storeName) {
	                // drop all database tables
	                resolve(getAllStoreNames(db));
	            } else {
	                resolve({
	                    db: db,
	                    storeNames: [options.storeName]
	                });
	            }
	        }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	                operationInfo.db.transaction(function (t) {
	                    function dropTable(storeName) {
	                        return new Promise$1(function (resolve, reject) {
	                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                                resolve();
	                            }, function (t, error) {
	                                reject(error);
	                            });
	                        });
	                    }

	                    var operations = [];
	                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                        operations.push(dropTable(operationInfo.storeNames[i]));
	                    }

	                    Promise$1.all(operations).then(function () {
	                        resolve();
	                    })["catch"](function (e) {
	                        reject(e);
	                    });
	                }, function (sqlError) {
	                    reject(sqlError);
	                });
	            });
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var webSQLStorage = {
	    _driver: 'webSQLStorage',
	    _initStorage: _initStorage$1,
	    _support: isWebSQLValid(),
	    iterate: iterate$1,
	    getItem: getItem$1,
	    setItem: setItem$1,
	    removeItem: removeItem$1,
	    clear: clear$1,
	    length: length$1,
	    key: key$1,
	    keys: keys$1,
	    dropInstance: dropInstance$1
	};

	function isLocalStorageValid() {
	    try {
	        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	        // in IE8 typeof localStorage.setItem === 'object'
	        !!localStorage.setItem;
	    } catch (e) {
	        return false;
	    }
	}

	function _getKeyPrefix(options, defaultConfig) {
	    var keyPrefix = options.name + '/';

	    if (options.storeName !== defaultConfig.storeName) {
	        keyPrefix += options.storeName + '/';
	    }
	    return keyPrefix;
	}

	// Check if localStorage throws when saving an item
	function checkIfLocalStorageThrows() {
	    var localStorageTestKey = '_localforage_support_test';

	    try {
	        localStorage.setItem(localStorageTestKey, true);
	        localStorage.removeItem(localStorageTestKey);

	        return false;
	    } catch (e) {
	        return true;
	    }
	}

	// Check if localStorage is usable and allows to save an item
	// This method checks if localStorage is usable in Safari Private Browsing
	// mode, or in any other case where the available quota for localStorage
	// is 0 and there wasn't any saved items yet.
	function _isLocalStorageUsable() {
	    return !checkIfLocalStorageThrows() || localStorage.length > 0;
	}

	// Config the localStorage backend, using options set in the config.
	function _initStorage$2(options) {
	    var self = this;
	    var dbInfo = {};
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

	    if (!_isLocalStorageUsable()) {
	        return Promise$1.reject();
	    }

	    self._dbInfo = dbInfo;
	    dbInfo.serializer = localforageSerializer;

	    return Promise$1.resolve();
	}

	// Remove all keys from the datastore, effectively destroying all data in
	// the app's key/value store!
	function clear$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var keyPrefix = self._dbInfo.keyPrefix;

	        for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);

	            if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Retrieve an item from the store. Unlike the original async_storage
	// library in Gaia, we don't modify return values at all. If a key's value
	// is `undefined`, we pass that value to the callback function.
	function getItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result = localStorage.getItem(dbInfo.keyPrefix + key);

	        // If a result was found, parse it from the serialized
	        // string into a JS object. If result isn't truthy, the key
	        // is likely undefined and we'll pass it straight to the
	        // callback.
	        if (result) {
	            result = dbInfo.serializer.deserialize(result);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items in the store.
	function iterate$2(iterator, callback) {
	    var self = this;

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var keyPrefix = dbInfo.keyPrefix;
	        var keyPrefixLength = keyPrefix.length;
	        var length = localStorage.length;

	        // We use a dedicated iterator instead of the `i` variable below
	        // so other keys we fetch in localStorage aren't counted in
	        // the `iterationNumber` argument passed to the `iterate()`
	        // callback.
	        //
	        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	        var iterationNumber = 1;

	        for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	                continue;
	            }
	            var value = localStorage.getItem(key);

	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	                value = dbInfo.serializer.deserialize(value);
	            }

	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

	            if (value !== void 0) {
	                return value;
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Same as localStorage's key() method, except takes a callback.
	function key$2(n, callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result;
	        try {
	            result = localStorage.key(n);
	        } catch (error) {
	            result = null;
	        }

	        // Remove the prefix from the key, if a key is found.
	        if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var length = localStorage.length;
	        var keys = [];

	        for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	        }

	        return keys;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Supply the number of keys in the datastore to the callback function.
	function length$2(callback) {
	    var self = this;
	    var promise = self.keys().then(function (keys) {
	        return keys.length;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Remove an item from the store, nice and simple.
	function removeItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        localStorage.removeItem(dbInfo.keyPrefix + key);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Set a key's value and run an optional callback once the value is set.
	// Unlike Gaia's implementation, the callback function is passed the value,
	// in case you want to operate on that value only after you're sure it
	// saved, or something like that.
	function setItem$2(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        // Convert undefined values to null.
	        // https://github.com/mozilla/localForage/pull/42
	        if (value === undefined) {
	            value = null;
	        }

	        // Save the original value to pass to the callback.
	        var originalValue = value;

	        return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    try {
	                        localStorage.setItem(dbInfo.keyPrefix + key, value);
	                        resolve(originalValue);
	                    } catch (e) {
	                        // localStorage capacity exceeded.
	                        // TODO: Make this a specific error/event.
	                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                            reject(e);
	                        }
	                        reject(e);
	                    }
	                }
	            });
	        });
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance$2(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        var currentConfig = this.config();
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	                resolve(options.name + '/');
	            } else {
	                resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	        }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	                var key = localStorage.key(i);

	                if (key.indexOf(keyPrefix) === 0) {
	                    localStorage.removeItem(key);
	                }
	            }
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var localStorageWrapper = {
	    _driver: 'localStorageWrapper',
	    _initStorage: _initStorage$2,
	    _support: isLocalStorageValid(),
	    iterate: iterate$2,
	    getItem: getItem$2,
	    setItem: setItem$2,
	    removeItem: removeItem$2,
	    clear: clear$2,
	    length: length$2,
	    key: key$2,
	    keys: keys$2,
	    dropInstance: dropInstance$2
	};

	var sameValue = function sameValue(x, y) {
	    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	};

	var includes = function includes(array, searchElement) {
	    var len = array.length;
	    var i = 0;
	    while (i < len) {
	        if (sameValue(array[i], searchElement)) {
	            return true;
	        }
	        i++;
	    }

	    return false;
	};

	var isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	};

	// Drivers are stored here when `defineDriver()` is called.
	// They are shared across all instances of localForage.
	var DefinedDrivers = {};

	var DriverSupport = {};

	var DefaultDrivers = {
	    INDEXEDDB: asyncStorage,
	    WEBSQL: webSQLStorage,
	    LOCALSTORAGE: localStorageWrapper
	};

	var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

	var OptionalDriverMethods = ['dropInstance'];

	var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

	var DefaultConfig = {
	    description: '',
	    driver: DefaultDriverOrder.slice(),
	    name: 'localforage',
	    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	    // we can use without a prompt.
	    size: 4980736,
	    storeName: 'keyvaluepairs',
	    version: 1.0
	};

	function callWhenReady(localForageInstance, libraryMethod) {
	    localForageInstance[libraryMethod] = function () {
	        var _args = arguments;
	        return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	        });
	    };
	}

	function extend() {
	    for (var i = 1; i < arguments.length; i++) {
	        var arg = arguments[i];

	        if (arg) {
	            for (var _key in arg) {
	                if (arg.hasOwnProperty(_key)) {
	                    if (isArray(arg[_key])) {
	                        arguments[0][_key] = arg[_key].slice();
	                    } else {
	                        arguments[0][_key] = arg[_key];
	                    }
	                }
	            }
	        }
	    }

	    return arguments[0];
	}

	var LocalForage = function () {
	    function LocalForage(options) {
	        _classCallCheck(this, LocalForage);

	        for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	                var driver = DefaultDrivers[driverTypeKey];
	                var driverName = driver._driver;
	                this[driverTypeKey] = driverName;

	                if (!DefinedDrivers[driverName]) {
	                    // we don't need to wait for the promise,
	                    // since the default drivers can be defined
	                    // in a blocking manner
	                    this.defineDriver(driver);
	                }
	            }
	        }

	        this._defaultConfig = extend({}, DefaultConfig);
	        this._config = extend({}, this._defaultConfig, options);
	        this._driverSet = null;
	        this._initDriver = null;
	        this._ready = false;
	        this._dbInfo = null;

	        this._wrapLibraryMethodsWithReady();
	        this.setDriver(this._config.driver)["catch"](function () {});
	    }

	    // Set any config values for localForage; can be called anytime before
	    // the first API call (e.g. `getItem`, `setItem`).
	    // We loop through options so we don't overwrite existing config
	    // values.


	    LocalForage.prototype.config = function config(options) {
	        // If the options argument is an object, we use it to set values.
	        // Otherwise, we return either a specified config value or all
	        // config values.
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	                return new Error("Can't call config() after localforage " + 'has been used.');
	            }

	            for (var i in options) {
	                if (i === 'storeName') {
	                    options[i] = options[i].replace(/\W/g, '_');
	                }

	                if (i === 'version' && typeof options[i] !== 'number') {
	                    return new Error('Database version must be a number.');
	                }

	                this._config[i] = options[i];
	            }

	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	                return this.setDriver(this._config.driver);
	            }

	            return true;
	        } else if (typeof options === 'string') {
	            return this._config[options];
	        } else {
	            return this._config;
	        }
	    };

	    // Used to define a custom driver, shared across all instances of
	    // localForage.


	    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	        var promise = new Promise$1(function (resolve, reject) {
	            try {
	                var driverName = driverObject._driver;
	                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

	                // A driver name should be defined and not overlap with the
	                // library-defined, default drivers.
	                if (!driverObject._driver) {
	                    reject(complianceError);
	                    return;
	                }

	                var driverMethods = LibraryMethods.concat('_initStorage');
	                for (var i = 0, len = driverMethods.length; i < len; i++) {
	                    var driverMethodName = driverMethods[i];

	                    // when the property is there,
	                    // it should be a method even when optional
	                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                        reject(complianceError);
	                        return;
	                    }
	                }

	                var configureMissingMethods = function configureMissingMethods() {
	                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                        return function () {
	                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                            var promise = Promise$1.reject(error);
	                            executeCallback(promise, arguments[arguments.length - 1]);
	                            return promise;
	                        };
	                    };

	                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                        var optionalDriverMethod = OptionalDriverMethods[_i];
	                        if (!driverObject[optionalDriverMethod]) {
	                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                        }
	                    }
	                };

	                configureMissingMethods();

	                var setDriverSupport = function setDriverSupport(support) {
	                    if (DefinedDrivers[driverName]) {
	                        console.info('Redefining LocalForage driver: ' + driverName);
	                    }
	                    DefinedDrivers[driverName] = driverObject;
	                    DriverSupport[driverName] = support;
	                    // don't use a then, so that we can define
	                    // drivers that have simple _support methods
	                    // in a blocking manner
	                    resolve();
	                };

	                if ('_support' in driverObject) {
	                    if (driverObject._support && typeof driverObject._support === 'function') {
	                        driverObject._support().then(setDriverSupport, reject);
	                    } else {
	                        setDriverSupport(!!driverObject._support);
	                    }
	                } else {
	                    setDriverSupport(true);
	                }
	            } catch (e) {
	                reject(e);
	            }
	        });

	        executeTwoCallbacks(promise, callback, errorCallback);
	        return promise;
	    };

	    LocalForage.prototype.driver = function driver() {
	        return this._driver || null;
	    };

	    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

	        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	        return getDriverPromise;
	    };

	    LocalForage.prototype.getSerializer = function getSerializer(callback) {
	        var serializerPromise = Promise$1.resolve(localforageSerializer);
	        executeTwoCallbacks(serializerPromise, callback);
	        return serializerPromise;
	    };

	    LocalForage.prototype.ready = function ready(callback) {
	        var self = this;

	        var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	                self._ready = self._initDriver();
	            }

	            return self._ready;
	        });

	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	    };

	    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	        var self = this;

	        if (!isArray(drivers)) {
	            drivers = [drivers];
	        }

	        var supportedDrivers = this._getSupportedDrivers(drivers);

	        function setDriverToConfig() {
	            self._config.driver = self.driver();
	        }

	        function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();

	            self._ready = self._initStorage(self._config);
	            return self._ready;
	        }

	        function initDriver(supportedDrivers) {
	            return function () {
	                var currentDriverIndex = 0;

	                function driverPromiseLoop() {
	                    while (currentDriverIndex < supportedDrivers.length) {
	                        var driverName = supportedDrivers[currentDriverIndex];
	                        currentDriverIndex++;

	                        self._dbInfo = null;
	                        self._ready = null;

	                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                    }

	                    setDriverToConfig();
	                    var error = new Error('No available storage method found.');
	                    self._driverSet = Promise$1.reject(error);
	                    return self._driverSet;
	                }

	                return driverPromiseLoop();
	            };
	        }

	        // There might be a driver initialization in progress
	        // so wait for it to finish in order to avoid a possible
	        // race condition to set _dbInfo
	        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	        }) : Promise$1.resolve();

	        this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;

	            return self.getDriver(driverName).then(function (driver) {
	                self._driver = driver._driver;
	                setDriverToConfig();
	                self._wrapLibraryMethodsWithReady();
	                self._initDriver = initDriver(supportedDrivers);
	            });
	        })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	        });

	        executeTwoCallbacks(this._driverSet, callback, errorCallback);
	        return this._driverSet;
	    };

	    LocalForage.prototype.supports = function supports(driverName) {
	        return !!DriverSupport[driverName];
	    };

	    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	        extend(this, libraryMethodsAndProperties);
	    };

	    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	        var supportedDrivers = [];
	        for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this.supports(driverName)) {
	                supportedDrivers.push(driverName);
	            }
	        }
	        return supportedDrivers;
	    };

	    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	        // Add a stub for each driver API method that delays the call to the
	        // corresponding driver method until localForage is ready. These stubs
	        // will be replaced by the driver methods as soon as the driver is
	        // loaded, so there is no performance impact.
	        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this, LibraryMethods[i]);
	        }
	    };

	    LocalForage.prototype.createInstance = function createInstance(options) {
	        return new LocalForage(options);
	    };

	    return LocalForage;
	}();

	// The actual localForage object that we expose as a module or via a
	// global. It's extended by pulling in one of our other libraries.


	var localforage_js = new LocalForage();

	module.exports = localforage_js;

	},{"3":3}]},{},[4])(4)
	});

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	/** Reporting API integration - https://w3c.github.io/reporting/ */
	var ReportingObserver = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function ReportingObserver(_options) {
	        if (_options === void 0) { _options = {
	            types: ['crash', 'deprecation', 'intervention'],
	        }; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = ReportingObserver.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!utils_1.supportsReportingObserver()) {
	            return;
	        }
	        this._getCurrentHub = getCurrentHub;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	        var observer = new (utils_1.getGlobalObject().ReportingObserver)(this.handler.bind(this), {
	            buffered: true,
	            types: this._options.types,
	        });
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        observer.observe();
	    };
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.prototype.handler = function (reports) {
	        var e_1, _a;
	        var hub = this._getCurrentHub && this._getCurrentHub();
	        if (!hub || !hub.getIntegration(ReportingObserver)) {
	            return;
	        }
	        var _loop_1 = function (report) {
	            hub.withScope(function (scope) {
	                scope.setExtra('url', report.url);
	                var label = "ReportingObserver [" + report.type + "]";
	                var details = 'No details available';
	                if (report.body) {
	                    // Object.keys doesn't work on ReportBody, as all properties are inheirted
	                    var plainBody = {};
	                    // eslint-disable-next-line guard-for-in
	                    for (var prop in report.body) {
	                        plainBody[prop] = report.body[prop];
	                    }
	                    scope.setExtra('body', plainBody);
	                    if (report.type === 'crash') {
	                        var body = report.body;
	                        // A fancy way to create a message out of crashId OR reason OR both OR fallback
	                        details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
	                    }
	                    else {
	                        var body = report.body;
	                        details = body.message || details;
	                    }
	                }
	                hub.captureMessage(label + ": " + details);
	            });
	        };
	        try {
	            for (var reports_1 = tslib_1.__values(reports), reports_1_1 = reports_1.next(); !reports_1_1.done; reports_1_1 = reports_1.next()) {
	                var report = reports_1_1.value;
	                _loop_1(report);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (reports_1_1 && !reports_1_1.done && (_a = reports_1.return)) _a.call(reports_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.id = 'ReportingObserver';
	    return ReportingObserver;
	}());
	exports.ReportingObserver = ReportingObserver;
	//# sourceMappingURL=reportingobserver.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	/** Rewrite event frames paths */
	var RewriteFrames = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function RewriteFrames(options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = RewriteFrames.id;
	        /**
	         * @inheritDoc
	         */
	        this._prefix = 'app:///';
	        /**
	         * @inheritDoc
	         */
	        this._iteratee = function (frame) {
	            if (!frame.filename) {
	                return frame;
	            }
	            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
	            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
	            var startsWithSlash = /^\//.test(frame.filename);
	            if (isWindowsFrame || startsWithSlash) {
	                var filename = isWindowsFrame
	                    ? frame.filename
	                        .replace(/^[A-Z]:/, '') // remove Windows-style prefix
	                        .replace(/\\/g, '/') // replace all `\\` instances with `/`
	                    : frame.filename;
	                var base = _this._root ? utils_1.relative(_this._root, filename) : utils_1.basename(filename);
	                frame.filename = "" + _this._prefix + base;
	            }
	            return frame;
	        };
	        if (options.root) {
	            this._root = options.root;
	        }
	        if (options.prefix) {
	            this._prefix = options.prefix;
	        }
	        if (options.iteratee) {
	            this._iteratee = options.iteratee;
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    RewriteFrames.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(RewriteFrames);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    RewriteFrames.prototype.process = function (originalEvent) {
	        var processedEvent = originalEvent;
	        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
	            processedEvent = this._processExceptionsEvent(processedEvent);
	        }
	        if (originalEvent.stacktrace) {
	            processedEvent = this._processStacktraceEvent(processedEvent);
	        }
	        return processedEvent;
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processExceptionsEvent = function (event) {
	        var _this = this;
	        try {
	            return tslib_1.__assign(tslib_1.__assign({}, event), { exception: tslib_1.__assign(tslib_1.__assign({}, event.exception), { 
	                    // The check for this is performed inside `process` call itself, safe to skip here
	                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                    values: event.exception.values.map(function (value) { return (tslib_1.__assign(tslib_1.__assign({}, value), { stacktrace: _this._processStacktrace(value.stacktrace) })); }) }) });
	        }
	        catch (_oO) {
	            return event;
	        }
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processStacktraceEvent = function (event) {
	        try {
	            return tslib_1.__assign(tslib_1.__assign({}, event), { stacktrace: this._processStacktrace(event.stacktrace) });
	        }
	        catch (_oO) {
	            return event;
	        }
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processStacktrace = function (stacktrace) {
	        var _this = this;
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function (f) { return _this._iteratee(f); }) });
	    };
	    /**
	     * @inheritDoc
	     */
	    RewriteFrames.id = 'RewriteFrames';
	    return RewriteFrames;
	}());
	exports.RewriteFrames = RewriteFrames;
	//# sourceMappingURL=rewriteframes.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	/** This function adds duration since Sentry was initialized till the time event was sent */
	var SessionTiming = /** @class */ (function () {
	    function SessionTiming() {
	        /**
	         * @inheritDoc
	         */
	        this.name = SessionTiming.id;
	        /** Exact time Client was initialized expressed in milliseconds since Unix Epoch. */
	        this._startTime = Date.now();
	    }
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(SessionTiming);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.prototype.process = function (event) {
	        var _a;
	        var now = Date.now();
	        return tslib_1.__assign(tslib_1.__assign({}, event), { extra: tslib_1.__assign(tslib_1.__assign({}, event.extra), (_a = {}, _a['session:start'] = this._startTime, _a['session:duration'] = now - this._startTime, _a['session:end'] = now, _a)) });
	    };
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.id = 'SessionTiming';
	    return SessionTiming;
	}());
	exports.SessionTiming = SessionTiming;
	//# sourceMappingURL=sessiontiming.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Add node transaction to the event */
	var Transaction = /** @class */ (function () {
	    function Transaction() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Transaction.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(Transaction);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.process = function (event) {
	        var frames = this._getFramesFromEvent(event);
	        // use for loop so we don't have to reverse whole frames array
	        for (var i = frames.length - 1; i >= 0; i--) {
	            var frame = frames[i];
	            if (frame.in_app === true) {
	                event.transaction = this._getTransaction(frame);
	                break;
	            }
	        }
	        return event;
	    };
	    /** JSDoc */
	    Transaction.prototype._getFramesFromEvent = function (event) {
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        return (exception && exception.stacktrace && exception.stacktrace.frames) || [];
	    };
	    /** JSDoc */
	    Transaction.prototype._getTransaction = function (frame) {
	        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.id = 'Transaction';
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	var utils_1 = __webpack_require__(48);
	var flags_1 = __webpack_require__(152);
	/**
	 * Used to extract Tracing integration from the current client,
	 * without the need to import `Tracing` itself from the @sentry/apm package.
	 * @deprecated as @sentry/tracing should be used over @sentry/apm.
	 */
	var TRACING_GETTER = {
	    id: 'Tracing',
	};
	/**
	 * Used to extract BrowserTracing integration from @sentry/tracing
	 */
	var BROWSER_TRACING_GETTER = {
	    id: 'BrowserTracing',
	};
	var VUE_OP = 'ui.vue';
	// Mappings from operation to corresponding lifecycle hook.
	var HOOKS = {
	    activate: ['activated', 'deactivated'],
	    create: ['beforeCreate', 'created'],
	    destroy: ['beforeDestroy', 'destroyed'],
	    mount: ['beforeMount', 'mounted'],
	    update: ['beforeUpdate', 'updated'],
	};
	var COMPONENT_NAME_REGEXP = /(?:^|[-_/])(\w)/g;
	var ROOT_COMPONENT_NAME = 'root';
	var ANONYMOUS_COMPONENT_NAME = 'anonymous component';
	/** JSDoc */
	var Vue = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Vue(options) {
	        var _this = this;
	        /**
	         * @inheritDoc
	         */
	        this.name = Vue.id;
	        /**
	         * Cache holding already processed component names
	         */
	        this._componentsCache = {};
	        /** Keep it as attribute function, to keep correct `this` binding inside the hooks callbacks  */
	        // eslint-disable-next-line @typescript-eslint/typedef
	        this._applyTracingHooks = function (vm, getCurrentHub) {
	            // Don't attach twice, just in case
	            if (vm.$options.$_sentryPerfHook) {
	                return;
	            }
	            vm.$options.$_sentryPerfHook = true;
	            var name = _this._getComponentName(vm);
	            var rootMount = name === ROOT_COMPONENT_NAME;
	            var spans = {};
	            // Render hook starts after once event is emitted,
	            // but it ends before the second event of the same type.
	            //
	            // Because of this, we start measuring inside the first event,
	            // but finish it before it triggers, to skip the event emitter timing itself.
	            var rootHandler = function (hook) {
	                var now = utils_1.timestampWithMs();
	                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
	                // However, on the second call (after), it'll be already in place.
	                if (_this._rootSpan) {
	                    _this._finishRootSpan(now, getCurrentHub);
	                }
	                else {
	                    vm.$once("hook:" + hook, function () {
	                        // Create an activity on the first event call. There'll be no second call, as rootSpan will be in place,
	                        // thus new event handler won't be attached.
	                        // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
	                        // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
	                        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	                        // eslint-disable-next-line deprecation/deprecation
	                        var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
	                        if (tracingIntegration) {
	                            _this._tracingActivity = tracingIntegration.constructor.pushActivity('Vue Application Render');
	                            var transaction = tracingIntegration.constructor.getTransaction();
	                            if (transaction) {
	                                _this._rootSpan = transaction.startChild({
	                                    description: 'Application Render',
	                                    op: VUE_OP,
	                                });
	                            }
	                            // Use functionality from @sentry/tracing
	                        }
	                        else {
	                            var activeTransaction = getActiveTransaction(getCurrentHub());
	                            if (activeTransaction) {
	                                _this._rootSpan = activeTransaction.startChild({
	                                    description: 'Application Render',
	                                    op: VUE_OP,
	                                });
	                            }
	                        }
	                        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	                    });
	                }
	            };
	            var childHandler = function (hook, operation) {
	                // Skip components that we don't want to track to minimize the noise and give a more granular control to the user
	                var shouldTrack = Array.isArray(_this._options.tracingOptions.trackComponents)
	                    ? _this._options.tracingOptions.trackComponents.indexOf(name) > -1
	                    : _this._options.tracingOptions.trackComponents;
	                if (!_this._rootSpan || !shouldTrack) {
	                    return;
	                }
	                var now = utils_1.timestampWithMs();
	                var span = spans[operation];
	                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
	                // However, on the second call (after), it'll be already in place.
	                if (span) {
	                    span.finish();
	                    _this._finishRootSpan(now, getCurrentHub);
	                }
	                else {
	                    vm.$once("hook:" + hook, function () {
	                        if (_this._rootSpan) {
	                            spans[operation] = _this._rootSpan.startChild({
	                                description: "Vue <" + name + ">",
	                                op: VUE_OP + "." + operation,
	                            });
	                        }
	                    });
	                }
	            };
	            // Each component has it's own scope, so all activities are only related to one of them
	            _this._options.tracingOptions.hooks.forEach(function (operation) {
	                // Retrieve corresponding hooks from Vue lifecycle.
	                // eg. mount => ['beforeMount', 'mounted']
	                var internalHooks = HOOKS[operation];
	                if (!internalHooks) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Unknown hook: " + operation);
	                    return;
	                }
	                internalHooks.forEach(function (internalHook) {
	                    var handler = rootMount
	                        ? rootHandler.bind(_this, internalHook)
	                        : childHandler.bind(_this, internalHook, operation);
	                    var currentValue = vm.$options[internalHook];
	                    if (Array.isArray(currentValue)) {
	                        vm.$options[internalHook] = tslib_1.__spread([handler], currentValue);
	                    }
	                    else if (typeof currentValue === 'function') {
	                        vm.$options[internalHook] = [handler, currentValue];
	                    }
	                    else {
	                        vm.$options[internalHook] = [handler];
	                    }
	                });
	            });
	        };
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('You are still using the Vue.js integration, consider moving to @sentry/vue');
	        this._options = tslib_1.__assign(tslib_1.__assign({ 
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            Vue: utils_1.getGlobalObject().Vue, attachProps: true, logErrors: false, tracing: false }, options), { tracingOptions: tslib_1.__assign({ hooks: ['mount', 'update'], timeout: 2000, trackComponents: false }, options.tracingOptions) });
	    }
	    /**
	     * @inheritDoc
	     */
	    Vue.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!this._options.Vue) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Vue integration is missing a Vue instance');
	            return;
	        }
	        this._attachErrorHandler(getCurrentHub);
	        if (this._options.tracing) {
	            this._startTracing(getCurrentHub);
	        }
	    };
	    /**
	     * Extract component name from the ViewModel
	     */
	    Vue.prototype._getComponentName = function (vm) {
	        // Such level of granularity is most likely not necessary, but better safe than sorry. — Kamil
	        if (!vm) {
	            return ANONYMOUS_COMPONENT_NAME;
	        }
	        if (vm.$root === vm) {
	            return ROOT_COMPONENT_NAME;
	        }
	        if (!vm.$options) {
	            return ANONYMOUS_COMPONENT_NAME;
	        }
	        if (vm.$options.name) {
	            return vm.$options.name;
	        }
	        if (vm.$options._componentTag) {
	            return vm.$options._componentTag;
	        }
	        // injected by vue-loader
	        if (vm.$options.__file) {
	            var unifiedFile = vm.$options.__file.replace(/^[a-zA-Z]:/, '').replace(/\\/g, '/');
	            var filename = utils_1.basename(unifiedFile, '.vue');
	            return (this._componentsCache[filename] ||
	                (this._componentsCache[filename] = filename.replace(COMPONENT_NAME_REGEXP, function (_, c) {
	                    return c ? c.toUpperCase() : '';
	                })));
	        }
	        return ANONYMOUS_COMPONENT_NAME;
	    };
	    /** Finish top-level span and activity with a debounce configured using `timeout` option */
	    Vue.prototype._finishRootSpan = function (timestamp, getCurrentHub) {
	        var _this = this;
	        if (this._rootSpanTimer) {
	            clearTimeout(this._rootSpanTimer);
	        }
	        this._rootSpanTimer = setTimeout(function () {
	            if (_this._tracingActivity) {
	                // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
	                // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
	                // eslint-disable-next-line deprecation/deprecation
	                var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
	                if (tracingIntegration) {
	                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                    tracingIntegration.constructor.popActivity(_this._tracingActivity);
	                }
	            }
	            // We should always finish the span, only should pop activity if using @sentry/apm
	            if (_this._rootSpan) {
	                _this._rootSpan.finish(timestamp);
	            }
	        }, this._options.tracingOptions.timeout);
	    };
	    /** Inject configured tracing hooks into Vue's component lifecycles */
	    Vue.prototype._startTracing = function (getCurrentHub) {
	        var applyTracingHooks = this._applyTracingHooks;
	        this._options.Vue.mixin({
	            beforeCreate: function () {
	                // eslint-disable-next-line deprecation/deprecation
	                if (getCurrentHub().getIntegration(TRACING_GETTER) || getCurrentHub().getIntegration(BROWSER_TRACING_GETTER)) {
	                    // `this` points to currently rendered component
	                    applyTracingHooks(this, getCurrentHub);
	                }
	                else {
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.error('Vue integration has tracing enabled, but Tracing integration is not configured');
	                }
	            },
	        });
	    };
	    /** Inject Sentry's handler into owns Vue's error handler  */
	    Vue.prototype._attachErrorHandler = function (getCurrentHub) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var currentErrorHandler = this._options.Vue.config.errorHandler;
	        this._options.Vue.config.errorHandler = function (error, vm, info) {
	            var metadata = {};
	            if (vm) {
	                try {
	                    metadata.componentName = _this._getComponentName(vm);
	                    if (_this._options.attachProps) {
	                        metadata.propsData = vm.$options.propsData;
	                    }
	                }
	                catch (_oO) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Unable to extract metadata from Vue component.');
	                }
	            }
	            if (info) {
	                metadata.lifecycleHook = info;
	            }
	            if (getCurrentHub().getIntegration(Vue)) {
	                // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
	                setTimeout(function () {
	                    getCurrentHub().withScope(function (scope) {
	                        scope.setContext('vue', metadata);
	                        getCurrentHub().captureException(error);
	                    });
	                });
	            }
	            if (typeof currentErrorHandler === 'function') {
	                currentErrorHandler.call(_this._options.Vue, error, vm, info);
	            }
	            if (_this._options.logErrors) {
	                if (_this._options.Vue.util) {
	                    _this._options.Vue.util.warn("Error in " + info + ": \"" + (error && error.toString()) + "\"", vm);
	                }
	                // eslint-disable-next-line no-console
	                console.error(error);
	            }
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    Vue.id = 'Vue';
	    return Vue;
	}());
	exports.Vue = Vue;
	/** Grabs active transaction off scope */
	function getActiveTransaction(hub) {
	    if (hub && hub.getScope) {
	        var scope = hub.getScope();
	        if (scope) {
	            return scope.getTransaction();
	        }
	    }
	    return undefined;
	}
	exports.getActiveTransaction = getActiveTransaction;
	//# sourceMappingURL=vue.js.map

/***/ })
/******/ ]);
angular.module('queue-manager').run(['$templateCache', function($templateCache) {$templateCache.put('app/modules/auth/pages/login.html','<div class=back-login><div class=full-height id=login-container layout=column ng-class="{\'layout-align-center-center\' : !vm.isDesk}" layout-fill ng-hide=vm.isWidget><div class=loginBox ng-class="{\'\' : !vm.isDesk, \'desk\' : vm.isDesk}"><img class=md-card-image ng-src=/assets/images/logo_book_the_city.png alt="Logo Book The City"><div class=contents><p>Iniciar sesi\xF3n</p></div><md-content ng-class="{\'md-padding\' : !vm.isDesk, \'md-padding-left\' : vm.isDesk}"><form ng-class="{\'layout-column\' : !vm.isDesk, \'layout-row isDesk\' : vm.isDesk}" name=loginForm ng-submit=vm.login(loginForm) role=form novalidate><md-input-container><label>{{ \'app.login.USERNAME\'|translate }}</label><input class=username ng-model=vm.credentials.username name=userName type=text ng-required=true placeholder="{{ \'app.login.USERNAME\'|translate }}"><div ng-messages=loginForm.userName.$error><div ng-message=required>{{ \'app.login.USERNAME_REQUIRED\'|translate }}</div><div ng-message=email>Your full name is</div></div></md-input-container><md-input-container class=pass><label>{{ \'app.login.PASSWORD\'|translate }}</label><input class=password ng-model=vm.credentials.password type="{{ vm.show ? \'text\' : \'password\' }}" ng-required=true name=userPassword placeholder="{{ \'app.login.PASSWORD\'|translate }}"><md-button ng-click=vm._showPass() style="position: absolute; right: -6px!important; top: -12px"><md-icon>remove_red_eye</md-icon></md-button><div ng-messages=loginForm.userPassword.$error><div ng-message=required>{{ \'app.login.PASSWORD_REQUIRED\'|translate }}</div></div></md-input-container><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid style="background-color:#ff914d; color:#ffffff">{{ \'app.login.LOGIN\'|translate }}</md-button><!--div(flex)--><!--  a.md-body-2(href="", md-no-ink) {{ \'app.login.PASSWORD_FORGOT\'|translate }}--></div><div class=deskBoxButton ng-class="{\'content-hidden\' : !vm.isDesk}" layout=row layout-align="center center" ng-show=vm.isDesk><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid><md-icon>send</md-icon></md-button></div></form></md-content></div></div></div>');
$templateCache.put('app/modules/queues/turn-request/turn-request.html','<!--md-icon(style="margin: 1rem 1rem 0rem 0rem; font-size: 28px; cursor:pointer" ng-click="$ctrl.back()") keyboard_backspacemd-tooltip(md-direction="left") Volver\n--><div id=turn-request-container><!--md-fab-speed-dial.lock-size(md-open="$ctrl.isOpen" md-direction="down" ng-class="$ctrl.selectedMode")\n  md-fab-trigger\n    md-button.language(aria-label="menu" class="md-fab")\n      //img(src="assets/flags/bandera-multiidioma.png" alt="Spanish" width="40px" height="40px")\n      md-icon language\n  md-fab-actions\n    md-button.language-btn(aria-label="Spanish" class="md-fab md-raised md-mini" ng-click="$ctrl.selectLanguage(\'es\')" )\n      img(src="assets/flags/bandera-espana.png" alt="Spanish" width="40px" height="40px")\n    md-button.language-btn(aria-label="English" class="md-fab md-raised md-mini" ng-click="$ctrl.selectLanguage(\'en\')" )\n      img(src="assets/flags/bandera-uk.png" alt="Spanish" width="40px" height="40px")\n    md-button.language-btn(aria-label="Catalan" class="md-fab md-raised md-mini" ng-click="$ctrl.selectLanguage(\'ca\')" )\n      img(src="assets/flags/bandera-catalan.png" alt="Spanish" width="40px" height="40px")\n  \n  --><!-- Title--><!--h1.md-display-3(style="padding:28px;")span {{\'app.request.SELECT_TURN\'|translate}}\n  --><!-- Selects container--><!----><!--img.logo(src="{{$ctrl.ticketLogo}}" style="height: 200px;margin: 0 auto; position: absolute;left: 0; right: 0;top: 24px")--><!--granite-qrcode-generator.qr(data="https://github.com/lostinbrittany/granite-elements" mode="alphanumeric" style="width:100px;height: 150px;position: absolute; right: 50px;top: 50px")--><!--qrcode(version=\'8\', error-correction-level=\'L\', size=\'150\', data=\'https://github.com/lostinbrittany/granite-elements\' style="position: absolute; right: 50px;top: 50px") download)--><div id=media-container layout=row layout-gt-sm=row style="justify-content:space-evenly; margin:300px 130px 50px 180px" layout-align="space-around center" layout-wrap><div class=component-responsive layout=column layout-gt-sm=row layout-align="center center" style=height:100px><img class=logo src={{$ctrl.ticketLogo}} style="left:30px; margin: 0 auto;top: 0 !important"></div><div class=componet-responsive layout=row layout-gt-sm=row layout-align=center style="gap: 30px 200px" ng-if="((!$ctrl.isOnlineKiosk &amp;&amp; $ctrl.kiosk.activeQR) || ($ctrl.kiosk.open &amp;&amp; $ctrl.kiosk.close))"><div class=component-responsive layout=column layout-gt-sm=row layout-align="center center" ng-if="(!$ctrl.isOnlineKiosk) &amp;&amp; ($ctrl.kiosk.activeQR)"><qrcode version=8 error-correction-level=L size=150 data={{$ctrl.dataQR}} download></qrcode></div><div class="component-responsive operation-hours" ng-if="($ctrl.queuesLoaded) &amp;&amp; $ctrl.kiosk.open &amp;&amp; $ctrl.kiosk.close" layout=column layout-gt-sm=column layout-align=center style="margin-top:15px ;margin-bottom:30px;box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1), 0px 2px 24px rgba(0, 0, 0, 0.1)"><h2 style=font-size:16px>{{\'app.request.OPENING_HOURS\'|translate}}</h2><p style=font-size:24px>{{$ctrl.kiosk.open | date : \'HH:mm\' }} a {{$ctrl.kiosk.close | date : \'HH:mm\' }}</p></div></div></div><div class=component-responsive style=margin-bottom:40px layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if=($ctrl.isNetworkError)><h2 class=turns-not-available>{{\'app.request.TURN_ERROR_NETWORK\'|translate}}</h2></div><div class=component-responsive style=margin-bottom:40px layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if="(!$ctrl.isOnlineKiosk) &amp;&amp; ($ctrl.isKioskClosed)"><h2 class=turns-not-available>{{\'app.request.TURN_NOT_AVAILABLE\'|translate}}</h2></div><div class=component-responsive style=margin-bottom:40px layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if="(!$ctrl.isOnlineKiosk) &amp;&amp; ($ctrl.isKioskClosed)"><p class=kiosk-closed style="font-size: xx-large;font-weight: bold;color: grey;text-decoration: underline;text-transform: uppercase">{{\'app.KIOSK_CLOSED\'|translate}}</p></div><div class=component-responsive style=margin-bottom:40px layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if="(!$ctrl.isOnlineKiosk) &amp;&amp; ($ctrl.kiosk.activeQR) &amp;&amp; ($ctrl.queuesLoaded) &amp;&amp; (!$ctrl.isKioskClosed)"><h2 class=kiosk-text>{{\'app.request.SCAN_QR\'|translate}}</h2></div><div class=component-responsive style=margin-bottom:40px layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if="(!$ctrl.isOnlineKiosk) &amp;&amp; (!$ctrl.kiosk.activeQR) &amp;&amp; ($ctrl.queuesLoaded) &amp;&amp; (!$ctrl.isKioskClosed)"><h2 class=kiosk-text>{{\'app.request.SELECT_THE_TURN\'|translate}}</h2></div><div class=remaining-global ng-if="$ctrl.singleQueue &amp;&amp; $ctrl.queuesLoaded &amp;&amp; !$ctrl.isKioskClosed"><p><span class=remaining-number>{{$root.remainingGlobalTurns}}</span><span class=remaining-people>{{\'app.request.REMAINING_PEOPLE\'|translate}}</span></p></div><div id=selects-container layout=row layout-gt-sm=row layout-align="center center" layout-wrap style="gap: 20px"><div class=component-responsive ng-if="$ctrl.queuesLoaded &amp;&amp; !$ctrl.isKioskClosed" ng-repeat="queue in $ctrl.queuesByArea" layout=column layout-gt-sm=row layout-align="center center"><turn-request-button-service queue=queue kiosk-id=$ctrl._kioskId ng-if="queue.children.length &gt; 0 &amp;&amp; !queue.outOfService"></turn-request-button-service><turn-request-button queue=queue on-select=$ctrl.onSelect(turn) ng-if="$ctrl.validateServiceToNotShow(queue) &amp;&amp; !queue.outOfService"></turn-request-button><turn-request-button queue=queue on-select=$ctrl.onSelect(turn) ng-if="$ctrl.validateServiceToShowInQueue(queue) &amp;&amp; $ctrl.areServiceId &amp;&amp; !queue.outOfService"></turn-request-button></div><p ng-if="!$ctrl.queuesLoaded &amp;&amp; !$ctrl.isKioskClosed">{{\'app.request.NO_QUEUES\'|translate}}</p></div><div class=component-responsive style="margin-bottom: 40px; padding-top: 40px; margin-top: 100px" layout=row layout-gt-sm=row layout-align="center center" layout-wrap><h2 class=kiosk-text style="margin-bottom: 250px; font-size: 18px; font-weight: bold; text-align: center; width: 100%;color: #5e5e5e">{{$ctrl.location}}</h2></div><div id=captcha-container layout=row layout-gt-sm=row layout-align="center center" layout-wrap ng-if="$ctrl.isOnlineKiosk &amp;&amp; $ctrl.queuesLoaded"><div theme=light vc-recaptcha key=$ctrl.publicKeyCaptcha on-create=$ctrl.setWidgetId() on-success=$ctrl.setResponse(response) on-expire=$ctrl.cbExpiration()></div></div><!-- Dialog Dni Bookitit - ORGANIZATIONS--><div style="visibility: hidden"><div class="md-dialog-container md-dialog-container" id=myDniBookititDialog style=cursor:none><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.NAME_ADVICE\'|translate}}</h2><span flex=flex><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"></md-button><md-icon>close</md-icon></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex=flex style="padding:0px 45px 0px 45px"><h3 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.bookitit_modal.CONTENT_TITLE\'|translate}}</h3><form name=dniBookititForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text autocomplete=off id=field_bookitit name=field_bookitit use-keyboard=field_bookitit placeholder="{{\'app.bookitit_modal.PLACEHOLDER\'|translate}}" ng-model=$ctrl.field_bookitit ng-virtual-keyboard="{relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() minlength=9><small ng-if="!$ctrl.field_bookitit_is_valid &amp;&amp; $ctrl.field_bookitit" id=mssgError style=color:#d62f2f>{{\'app.bookitit_modal.FIELD_FORMAT\'|translate}}</small><small ng-if="!$ctrl.field_bookitit &amp;&amp; dniBookititForm.field_bookitit.$dirty" style=color:#d62f2f>{{\'app.bookitit_modal.FIELD_BLANK\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex=flex layout=row style="padding:0px 45px 40px 45px"><md-button class="md-diny md-button-cancel" aria-label=button ng-click="$ctrl._cancelDniBokitit(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.bookitit_modal.NOT\'|translate}}</md-button><md-button class="button-raised md-raised" aria-label=button ng-click="$ctrl._sendCustomField(\'field_bookitit\', $ctrl.field_bookitit); $ctrl.resetControl()" ng-disabled="!$ctrl.field_bookitit || !$ctrl.field_bookitit_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.bookitit_modal.YES\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG BOOKING CODE--><div style="visibility: hidden"><div class=md-dialog-container id=myBookingDialog><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{\'app.request.BOOKING_SERVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><!-- Typing booking code dialog--><md-dialog-content><div class=md-dialog-content flex><h2>{{\'app.request.BOOKING_REQUEST\'|translate}}</h2><form name=bookingForm novalidate><md-input-container md-no-float style=width:100%><span style="color:red; text-align: center" ng-show="bookingForm.$invalid &amp;&amp; bookingForm.booking_number.$dirty">{{ \'app.request.PHONE_ERROR\'|translate}}</span> <input class="md-input no-spin" type=text id=booking_number name=booking_number ng-model=$ctrl.code use-keyboard=Numbers ng-virtual-keyboard="{kt: \'All\', relative: false, keyCenter: 1, customClass: \'myCustomizedVkt allTextPad\'}" placeholder="{{\'app.request.PHONE_TYPING\'|translate}}" ng-change=$ctrl._reStartTimer($ctrl.determinatePhoneValue) ng-required=true></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-primary" aria-label=button ng-click="$ctrl._sendCode(); $ctrl.resetControl()" ng-disabled=bookingForm.$invalid>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button><md-button class="md-raised md-warn" aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()">{{\'app.request.PHONE_EXIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW NAME DIALOG--><div style="visibility: hidden"><div class="md-dialog-container md-dialog-container" id=myNameDialog style=cursor:none><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.NAME_ADVICE\'|translate}}</h2><span flex=flex><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"></md-button><md-icon>close</md-icon></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex=flex style="padding:0px 45px 0px 45px"><h3 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.NAME_REQUEST\'|translate}}</h3><form name=nameForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text autocomplete=off id=name name=name use-keyboard=name placeholder="{{\'app.request.PHONE_TYPING\'|translate}}" ng-model=$ctrl.name ng-virtual-keyboard="{relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() ng-change="$ctrl._validField(\'name\', $ctrl.name)"><small ng-if="!$ctrl.name &amp;&amp; nameForm.name.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.name_is_valid &amp;&amp; $ctrl.name" style=color:#d62f2f>{{\'Digite solo letras\'|translate}}</small><br><small ng-if="$ctrl.name_is_valid_spaces &amp;&amp; $ctrl.name" style=color:#d62f2f>{{\'Digite solo letras.\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex=flex layout=row style="padding:0px 45px 40px 45px"><md-button class="md-diny md-button-cancel" aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised md-raised md-button-accept" aria-label=button ng-click="$ctrl._sendCustomField(\'name\', $ctrl.name); $ctrl.resetControl()" ng-disabled="!$ctrl.name || !$ctrl.name_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW DNI DIALOG myDNIDialog--><div style="visibility: hidden"><div class="md-dialog-container md-dialog-container" id=myDNIDialog style="cursor:none !important"><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 0px"><h2 style="font-size:22px;margin-left: 45px;">{{\'app.request.DNI_ADVICE\'|translate}}</h2><span flex=flex><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style="margin-left: 45px; margin-right: 5px; margin-bottom: 30px"><md-icon>close</md-icon></md-button></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex=flex style="padding:0px 45px 0px 45px"><h3 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.DNI_REQUEST\'|translate}}</h3><form name=dniForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><span style="color:red; text-align: center" ng-show="dniForm.$invalid &amp;&amp; dniForm.phone_number.$dirty">{{ \'app.request.DNI_ERROR\'|translate}}</span> <input class="md-input no-spin" type=text autocomplete=off id=dni name=dni value=textDni use-keyboard=Numbers placeholder="{{\'app.request.PHONE_TYPING\'|translate}}" ng-model=$ctrl.dni ng-virtual-keyboard="{relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() minlength=9><small ng-if="!$ctrl.dni_is_valid &amp;&amp; $ctrl.dni" id=mssgError style=color:#d62f2f>{{\'Ingrese DNI v\xE1lido.\'|translate}}</small><small ng-if="!$ctrl.dni &amp;&amp; dniForm.dni.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex=flex layout=row style="padding:0px 45px 40px 45px"><md-button class=md-diny aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised md-raised" aria-label=button ng-click="$ctrl._sendCustomField(\'dni\', $ctrl.dni); $ctrl.resetControl()" ng-disabled="!$ctrl.dni || !$ctrl.dni_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW PHONE AND DNI DIALOG--><div style="visibility: hidden"><div class=md-dialog-container id=myDNIPhoneDialog><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.DNI_PHONE_ADVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><!-- Asking receive phone advice dialog--><md-dialog-content ng-show=$ctrl.isAsking><div class=md-dialog-content><h2 style="opacity:0.8;font-weight:400;font-size:20px;margin:10px 0px 8px 0px">{{\'app.request.PHONE_ADVICE_TEXT_FIRST\'|translate}} {{$root.previousNotificationLimit}} {{\'app.request.PHONE_ADVICE_TEXT_SECOND\'|translate}}</h2></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=$ctrl.isAsking><md-button class=md-diny aria-label=button ng-click="$ctrl._sendPhone(\'btnCancel\'); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_CANCEL\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._receiveAdvice(); $ctrl.resetControl()" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_OK\'|translate}}</md-button></md-dialog-actions><!-- Typing phone number dialog--><md-dialog-content ng-show=!$ctrl.isAsking><div class=md-dialog-content flex><h4 style="opacity:0.8;font-weight:400;font-size:20px;margin:10px 0px 8px 0px">{{\'app.request.DNI_PHONE_REQUEST\'|translate}}</h4><form name=dniPhoneForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text id=numbers name=numbers ng-model=$ctrl.numbers use-keyboard=Numbers ng-virtual-keyboard="{kt: \'Numerico\', relative: false, keyCenter: 5, customClass: \'myCustomizedVkt\'}" placeholder="{{\'app.request.DNI_PHONE_PHONE_TYPING\'|translate}}" ng-change="$ctrl._validField(\'numbers\', $ctrl.numbers)" style="font-family:Roboto Slab;serif:undefined" maxlength=9><small ng-if="!$ctrl.numbers &amp;&amp; dniPhoneForm.numbers.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.numbers_is_valid &amp;&amp; $ctrl.numbers" style=color:#d62f2f>{{\'Digite solo numeros\'|translate}}</small></md-input-container><div class=alert_number style="max-width: 35vw;text-align: center"><small style="color:#FFA500; margin-top: 10px">Su n\xFAmero de tel\xE9fono se usar\xE1 \xFAnicamente para notificarle la proximidad de su turno. Una vez enviado el aviso, ser\xE1 eliminado de nuestro sistema para garantizar su privacidad y seguridad.</small><small>Para mas informaci\xF3n escanee el siguiente QR</small><qrcode version=8 error-correction-level=L size=100 data="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679"></qrcode></div><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input type=text id=dni name=dni use-keyboard=Numbers placeholder="{{\'app.request.DNI_PHONE_DNI_TYPING\'|translate}}" ng-model=$ctrl.dni ng-virtual-keyboard="{kt: \'Numerico\', relative: false, keyCenter: 5, customClass: \'myCustomizedVkt\'}" ng-change="$ctrl._validField(\'dni\', $ctrl.dni)" style="font-family:Roboto Slab;serif:undefined" maxlength=8><small ng-if="!$ctrl.dni_is_valid &amp;&amp; $ctrl.dni" style=color:#d62f2f>{{\'Digite solo letras\'|translate}}</small><small ng-if="!$ctrl.dni &amp;&amp; dniPhoneForm.dni.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class=md-diny aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._sendCustomField(\'dni_phone\', $ctrl.dni); $ctrl.resetControl()" ng-disabled="!$ctrl.numbers || !$ctrl.numbers_is_valid || !$ctrl.dni || !$ctrl.dni_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW NAME AND DNI DIALOG--><div style="visibility: hidden"><div class=md-dialog-container id=myDNINameDialog><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.DNI_NAME_ADVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h4 style="opacity:0.8;font-weight:400;font-size:20px;margin:10px 0px 8px 0px">{{\'app.request.DNI_NAME_REQUEST\'|translate}}</h4><form name=dniNameForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text autocomplete=off id=dni name=dni value=textDni use-keyboard=Numbers placeholder="{{\'app.request.DNI_TYPING\'|translate}}" ng-model=$ctrl.dni ng-virtual-keyboard="{relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() maxlength=9 ng-change="$ctrl._validField(\'dni\', $ctrl.dni)"><small ng-if="!$ctrl.dni_is_valid &amp;&amp; $ctrl.dni" id=mssgError style=color:#d62f2f>{{\'Ingrese DNI v\xE1lido.\'|translate}}</small><small ng-if="!$ctrl.dni &amp;&amp; dniForm.dni.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small></md-input-container><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text autocomplete=off id=name name=name use-keyboard=name placeholder="{{\'app.request.NAME_TYPING\'|translate}}" ng-model=$ctrl.name ng-virtual-keyboard="{relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() ng-change="$ctrl._validField(\'name\', $ctrl.name)"><small ng-if="!$ctrl.name &amp;&amp; nameForm.name.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.name_is_valid &amp;&amp; $ctrl.name" style=color:#d62f2f>{{\'Digite solo letras\'|translate}}</small><br><small ng-if="$ctrl.name_is_valid_spaces &amp;&amp; $ctrl.name" style=color:#d62f2f>{{\'Digite solo letras.\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class=md-diny aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._sendCustomField(\'dni_name\', $ctrl.dni); $ctrl.resetControl()" ng-disabled="!$ctrl.name || !$ctrl.name_is_valid || !$ctrl.dni || !$ctrl.dni_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW EMAIL DIALOG--><div style="visibility: hidden"><div class="md-dialog-container md-dialog-container" id=myEmailDialog style="cursor:none !important"><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.EMAIL_ADVICE\'|translate}}</h2><span flex=flex><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"></md-button><md-icon>close</md-icon></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex=flex><h3 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.EMAIL_REQUEST\'|translate}}</h3><form name=mailForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><span style="color:red; text-align: center" ng-show="mailForm.$invalid &amp;&amp; mailForm.phone_number.$dirty">{{ \'app.request.email_ERROR\'|translate}}</span> <input class="md-input no-spin" type=text placeholder="{{\'app.request.PHONE_TYPING\'|translate}}" use-keyboard=Name id=user_email name=user_email ng-model=$ctrl.email ng-keyup=$ctrl._stopTimer() ng-minlength=5 ng-required style="font-family:Roboto Slab;serif:undefined"></md-input-container></form></div></md-dialog-content><md-dialog-actions flex=flex layout=row><md-button class="md-raised button-raised md-raised md-primary" aria-label=button ng-click="$ctrl._sendCustomField(\'email\', $ctrl.email)" ng-disabled="mailForm.$invalid || !$ctrl._validateEmail($ctrl.email)" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button><md-button class="md-diny md-raised md-warn" aria-label=button ng-click=$ctrl._cancel() style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW PHONE AND NAME DIALOG--><div style="visibility: hidden"><div class=md-dialog-container id=myNamePhoneDialog><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2>{{\'app.request.NAME_PHONE_ADVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><!-- Asking receive phone advice dialog--><md-dialog-content ng-show=$ctrl.isAsking><div class=md-dialog-content><h2 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.PHONE_ADVICE_TEXT_FIRST\'|translate}} {{$root.previousNotificationLimit}} {{\'app.request.PHONE_ADVICE_TEXT_SECOND\'|translate}}</h2></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=$ctrl.isAsking><md-button class=md-diny aria-label=button ng-click="$ctrl._sendPhone(\'btnCancel\'); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_CANCEL\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._receiveAdvice(); $ctrl.resetControl()" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_OK\'|translate}}</md-button></md-dialog-actions><!-- Typing phone number dialog--><md-dialog-content ng-show=!$ctrl.isAsking><div class=md-dialog-content flex><h4 style="opacity:0.8;font-weight:400;font-size:20px;margin:10px 0px 8px 0px">{{\'app.request.NAME_PHONE_REQUEST\'|translate}}</h4><form name=namePhoneForm><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text id=numbers name=numbers ng-model=$ctrl.numbers use-keyboard=Numbers ng-virtual-keyboard="{kt: \'Numerico\', relative: false, keyCenter: 5, customClass: \'myCustomizedVkt\'}" placeholder="{{\'app.request.NAME_PHONE_PHONE_TYPING\'|translate}}" ng-change="$ctrl._validField(\'numbers\', $ctrl.numbers)" style="font-family:Roboto Slab;serif:undefined" maxlength=9><small ng-if="!$ctrl.numbers &amp;&amp; namePhoneForm.numbers.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.numbers_is_valid &amp;&amp; $ctrl.numbers" style=color:#d62f2f>{{\'Digite solo numeros\'|translate}}</small></md-input-container><div class=alert_number style="max-width: 35vw;text-align: center"><small style="color:#FFA500; margin-top: 10px">Su n\xFAmero de tel\xE9fono se usar\xE1 \xFAnicamente para notificarle la proximidad de su turno. Una vez enviado el aviso, ser\xE1 eliminado de nuestro sistema para garantizar su privacidad y seguridad.</small><small>Para mas informaci\xF3n escanee el siguiente QR</small><qrcode version=8 error-correction-level=L size=100 data="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679"></qrcode></div><md-input-container md-no-float=md-no-float style="margin:8px 0px 0px 0px;width:100%"><input class="md-input no-spin" type=text autocomplete=off id=name name=name use-keyboard=Name placeholder="{{\'app.request.NAME_PHONE_NAME_TYPING\'|translate}}" ng-model=$ctrl.name ng-virtual-keyboard="{kt: \'Name\', relative: false, keyCenter: 1, customClass: \'myCustomizedVkt textPad\'}" ng-keyup=$ctrl._stopTimer() ng-change="$ctrl._validField(\'name\', $ctrl.name)" style="font-family:Roboto Slab;serif:undefined"><small ng-if="!$ctrl.name &amp;&amp; namePhoneForm.name.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.name_is_valid &amp;&amp; $ctrl.name" style=color:#d62f2f>{{\'Digite solo letras\'|translate}}</small></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class=md-diny aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._sendCustomField(\'name_phone\', $ctrl.name); $ctrl.resetControl()" ng-disabled="!$ctrl.numbers || !$ctrl.numbers_is_valid || !$ctrl.name || !$ctrl.name_is_valid" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW PHONE AND EMAIL DIALOG--><div style="visibility: hidden"><div class=md-dialog-container id=myPhoneEmailDialog><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{\'app.request.PHONE_EMAIL_ADVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><!-- Typing phone number dialog--><md-dialog-content><div class=md-dialog-content flex><h4>{{\'app.request.PHONE_EMAIL_REQUEST\'|translate}}</h4><form name=namePhoneForm2><md-input-container md-no-float style=width:100%><span style="color:red; text-align: center" ng-show="namePhoneForm2.$invalid &amp;&amp; namePhoneForm2.phone_number.$dirty">{{ \'app.request.PHONE_ERROR\'|translate}}</span> <input class="md-input no-spin" type=text id=phone_email_phone_number name=phone_email_phone_number ng-model=$ctrl.numbers use-keyboard=Numbers placeholder="{{\'app.request.PHONE_EMAIL_PHONE_TYPING\'|translate}}" ng-change=$ctrl._reStartTimer($ctrl.determinatePhoneValue) ng-minlength=9></md-input-container><md-input-container md-no-float=md-no-float style=width:100%><span style="color:red; text-align: center" ng-show="namePhoneForm2.$invalid &amp;&amp; namePhoneForm2.user_name.$dirty">{{ \'app.request.email_ERROR\'|translate}}</span> <input class="md-input no-spin" type=text autocomplete=off id=phone_email_email placeholder="{{\'app.request.PHONE_EMAIL_EMAIL_TYPING\'|translate}}" name=phone_email_email use-keyboard=Email ng-model=$ctrl.email ng-keyup=$ctrl._stopTimer() ng-minlength=5></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-primary" aria-label=button ng-click="$ctrl._sendCustomField(\'email_phone\', $ctrl.email); $ctrl.resetControl()" ng-disabled=namePhoneForm2.$invalid>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button><md-button class="md-raised md-warn" aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()">{{\'app.request.PHONE_EXIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- NEW PHONE DIALOG--><div style="visibility: hidden"><div class=md-dialog-container id=myPhoneDialog><md-dialog style=border-radius:15px><md-toolbar style="padding:5px 0px 5px 0px"><div class=md-toolbar-tools style="padding:0px 45px 0px 45px"><h2 style=font-size:22px>{{\'app.request.PHONE_ADVICE\'|translate}}</h2><span flex></span><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"><md-icon>close</md-icon></md-button></div></md-toolbar><!-- Asking receive phone advice dialog--><md-dialog-content ng-show=$ctrl.isAsking><div class=md-dialog-content><h2 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.PHONE_ADVICE_TEXT_FIRST\'|translate}} {{$root.previousNotificationLimit}} {{\'app.request.PHONE_ADVICE_TEXT_SECOND\'|translate}}</h2></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=$ctrl.isAsking style="padding:0px 45px 40px 45px"><md-button class=md-diny aria-label=button ng-click="$ctrl._sendPhone(\'btnCancel\'); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_CANCEL\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._receiveAdvice(); $ctrl.resetControl()" style=color:#fff;font-size:14px;text-transform:none;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_OK\'|translate}}</md-button></md-dialog-actions><!-- Typing phone number dialog--><md-dialog-content ng-show=!$ctrl.isAsking><div class=md-dialog-content flex><h2 style="opacity:0.8;font-weight:400;font-size:20px;margin:18px 0px 8px 0px">{{\'app.request.PHONE_REQUEST\'|translate}}</h2><form name=userForm><md-input-container md-no-float style="margin:8px 0px 0px 0px;width:100%"><!--span(style="color:red; text-align: center" ng-show="userForm.$invalid && userForm.phone_number.$dirty") {{ \'app.request.PHONE_ERROR\'|translate}}--> <input class="md-input no-spin" type=text id=numbers name=numbers ng-model=$ctrl.numbers use-keyboard=Numbers ng-virtual-keyboard="{kt: \'Numerico\', relative: false, keyCenter: 5, customClass: \'myCustomizedVkt\'}" ng-change="$ctrl._validField(\'numbers\', $ctrl.numbers)" placeholder="{{\'app.request.PHONE_TYPING\'|translate}}" maxlength=9 style="font-family:Roboto Slab;serif:undefined"><small ng-if="!$ctrl.numbers &amp;&amp; userForm.numbers.$dirty" style=color:#d62f2f>{{\'app.request.USERNAME_ERROR\'|translate}}</small><small ng-if="!$ctrl.numbers_is_valid &amp;&amp; $ctrl.numbers" style=color:#d62f2f>{{\'Digite solo numeros\'|translate}}</small></md-input-container><div class=alert_number style="max-width: 35vw;text-align: center"><small style="color:#FFA500; margin-top: 10px">Su n\xFAmero de tel\xE9fono se usar\xE1 \xFAnicamente para notificarle la proximidad de su turno. Una vez enviado el aviso, ser\xE1 eliminado de nuestro sistema para garantizar su privacidad y seguridad. Para mas informaci\xF3n escanee el siguiente QR</small><br><qrcode style="color:#FFA500; margin-top: 10px" version=8 error-correction-level=L size=100 data="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32016R0679"></qrcode></div></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking style="padding:0px 45px 40px 45px"><md-button class=md-diny aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl(); $ctrl.resetControl()" style=font-size:14px;text-transform:none;border-radius:8px;min-width:100px;min-height:40px>{{\'app.request.PHONE_EXIT\'|translate}}</md-button><md-button class="md-raised button-raised" aria-label=button ng-click="$ctrl._sendPhone(); $ctrl.resetControl()" ng-disabled="!$ctrl.numbers || !$ctrl.numbers_is_valid" style=color:#fff;font-size:14px;text-transform:none;background-color:#FF914D;border-radius:8px;min-width:130px;min-height:40px>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- TOOLATE/TOSOON DIALOG--><div style="visibility: hidden"><div class="md-dialog-container md-dialog-container" id=myBookingMessage style="cursor:none !important"><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{\'app.request.BOOKING_SERVICE\'|translate}}</h2><span flex=flex><md-button class=md-icon-button aria-label=button ng-click="$ctrl._cancel(); $ctrl.resetControl()"></md-button><md-icon>close</md-icon></span></div></md-toolbar><md-dialog-content><div class="md-dialog-content booking-message" flex=flex><h3>{{ $ctrl.time_error_msg }}</h3></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-primary" aria-label=button ng-click=$ctrl._cancel()>{{\'app.request.PHONE_ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG YOU TICKET--><div style="visibility: hidden"><div class=md-dialog-container id=myTicket style="text-align: center; overflow: hidden; cursor:none !important"><md-dialog id=dialog_ticket style="text-align: center; border-radius:15px"><md-toolbar style="padding:10px 0px 10px 0px"><div class=md-toolbar-tools style="padding:0px 10px 0px 10px"><h2 id=no-print style="font-size: 22px; margin: 0">{{\'app.request.SCAN_QR_TITLE\'|translate}}</h2><span flex></span><md-button class=md-icon-button id=no-print2 aria-label=button ng-click=$ctrl._cancel()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content style="padding: 10px"><div class="md-dialog-content booking-message" style="width: 100%; padding: 0"><div flex layout=row style="padding: 0px 10px 0px 10px; justify-content: space-between; align-items: center"><img class=tiket_logo src={{$ctrl.ticketLogo}}></div><div class=turn_content flex layout=row style="margin: 0; margin-bottom: 20px; align-items: center"><div flex layout=column style="text-align: center; min-width: 140px"><p class=ticket_queue ng-if=!$ctrl.currentLocation.ticketText style="padding: 0; margin: 0;font-weight: 400; font-size: 20px; line-height: 16px; color: rgba(0, 0, 0, 1)">{{\'app.request.YOUR_TURN\'|translate}}</p><p class=ticket_queue ng-if=$ctrl.currentLocation.ticketText style="padding: 0; margin: 0;font-weight: 400; font-size: 20px; line-height: 16px; color: rgba(0, 0, 0, 1)" ng-bind-html=$ctrl.currentLocation.ticketText></p><p class=ticket_number style="font-weight: 600; font-size: 55px; margin: 0">{{ $ctrl.your_turn }}</p></div><p class=ticket_queue style=padding:0;margin:0;font-weight:400;font-size:14px;line-height:16px;color:black>{{\'app.request.REMAINING_PEOPLE\'|translate}}: {{$ctrl.singleQueue ? $root.remainingGlobalTurns : $ctrl.enqueued_people}}</p></div><img ng-if="$ctrl.ticketPromo != \'\'" style=max-height:330px src={{$ctrl.ticketPromo}}><p class=current_time style="font-size: 18px; text-align: center; color: rgba(0, 0, 0, 1); margin-top: 0px">{{ $ctrl.readable_time }} - {{ $ctrl.readable_date }}</p><p class=current_time style="font-size: 18px; text-align: center; color: rgba(0, 0, 0, 1); margin-top: 0px" ng-if=$ctrl.showInstructions>{{ $ctrl.instructions }}</p><div style="text-align: center; margin-top: 10px" ng-if="$ctrl.showManualPrint || !$root.isPrinting"><a id=no-print3 ng-click=$ctrl._printDirective() style="font-size: 14px; color:rgba(162, 162, 162, 1); text-decoration: underline">Imprimir</a></div></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/queues/turn-request-index/request.template.html','<div layout=row layout-align="end center" style="padding: 10px 20px"><md-input-container><md-select ng-model=$ctrl.selectedLocationId ng-change=$ctrl.selectLocation($ctrl.selectedLocationId)><md-option ng-repeat="location in $ctrl.allLocations" ng-value=location.id>{{ location.name }}</md-option></md-select></md-input-container></div><div class=queues-container layout=column layout-align="center center"><div ng-if=$ctrl.currentLocation style="padding-top: 150px"><h2>{{\'app.request.KIOSKS_ENABLED\'|translate}} {{$ctrl.currentLocation.name}}</h2><md-button class="md-primary md-raised" ng-repeat="kiosk in $ctrl.AsignedKiosks" ng-href=/request/kiosk/{{kiosk.id}} style="background-color:#ff914d; color:#ffffff">{{kiosk.name}} ({{kiosk.description}})</md-button><p ng-if="!$ctrl.AsignedKiosks || !$ctrl.AsignedKiosks.length" style="margin-top: 20px; color: #999; font-size: 16px">{{\'app.request.NO_KIOSK\'|translate}}</p></div></div>');
$templateCache.put('app/modules/queues/turn-request-subservices/turn-request-subservices.html','<div style="align-self: left;position:absolute;left:5%;top:5%;display: flex;width: 90%;justify-content: space-between;z-index:1"><div style=text-align:right></div><div><md-button class=button-raised style="align-self: left;color: #fff; font-size: 14px; text-transform: none;border-radius:8px; min-width: 130px; min-height: 40px" aria-label=button ng-click=$ctrl.backToQueues()>Regresar</md-button><p style="color:rgba(0,0,0,0.5); font-size:17px">Redirigiendo en {{ $ctrl.timeLeft }}</p></div></div><turn-request></turn-request>');
$templateCache.put('app/modules/queues/common/turn-request-button/turn-request-button.html','<div class=turn-request-button-container><md-button class="md-raised btn btn-danger btn-service" id={{$ctrl.queue.id}} aria-label=button style=background-color:{{$ctrl.queue.colorService}} ng-if="!$ctrl.queue.btn_image &amp;&amp; !$ctrl.queue.outOfService" ng-click=$ctrl.onSelectClick($ctrl.queue) ng-class="{\'noAvailable\': $ctrl.queue.noTickets == true || $ctrl.queue.outOfService == true}" ng-disabled="$root.isClicked || $ctrl.queue.outOfService || $root.isPrinting" queue-name={{$ctrl.queue.name}}><!--h2.md-title {{$ctrl.queue.name}}--><h2 class=md-title ng-if="!$ctrl.queue.noTickets &amp;&amp; !$ctrl.queue.outOfService" ng-bind-html=$ctrl.queue.display></h2><h2 class=md-title ng-if=$ctrl.queue.noTickets ng-bind-html=$ctrl.queue.display></h2><h2 class="md-title strikeout" ng-if=$ctrl.queue.outOfService ng-bind-html=$ctrl.queue.display></h2><p class=description-text ng-if="($ctrl.queue.serviceType != \'booking\' &amp;&amp; $ctrl.showWaitingPeople &amp;&amp; !$ctrl.singleQueue) || ($ctrl.queue.outOfService || $ctrl.queue.noTickets)"><span class=remaining-number ng-if="!$ctrl.queue.noTickets &amp;&amp; !$ctrl.queue.outOfService &amp;&amp; !$ctrl.singleQueue" style=color:{{$ctrl.queue.colorService}}>{{ $root.remainingTurns[$ctrl.queue.id] }}</span><span class=button-span ng-if="!$ctrl.queue.noTickets &amp;&amp; !$ctrl.queue.outOfService &amp;&amp; !$ctrl.singleQueue"> {{\'app.request.REMAINING_PEOPLE\'|translate}}</span><span ng-if=$ctrl.queue.noTickets style="color: red">{{\'app.request.SOLD_OUT\'|translate}}</span><span class=outOfService ng-if=$ctrl.queue.outOfService style="color: red">{{\'app.request.OUT_OF_SERVICE\'|translate}}</span></p><div class="component-responsive service-operation-hours" ng-if="$ctrl.queue.open &amp;&amp; $ctrl.queue.close &amp;&amp; $ctrl.queue.outOfService" layout=column layout-gt-sm=column layout-align=center><h2>{{\'app.request.OPENING_HOURS\'|translate}}</h2><p>{{$ctrl.queue.open | date : \'HH:mm\' }} a {{$ctrl.queue.close | date : \'HH:mm\' }}</p></div></md-button><md-button class="btn btn-danger btn-service" aria-label=button style=background-color:{{$ctrl.queue.colorService}} ng-if="$ctrl.queue.btn_image &amp;&amp; !$ctrl.queue.outOfService" ng-click=$ctrl.onSelectClick() ng-class="{\'noAvailable\': $ctrl.queue.noTickets == true || $ctrl.queue.outOfService == true}" ng-disabled="$root.isClicked || $ctrl.queue.outOfService || $root.isPrinting" queue-name={{$ctrl.queue.name}}><img class=png-icon ng-src={{$ctrl.queue.btn_image}} style="width: 330px"></md-button></div>');
$templateCache.put('app/modules/queues/common/turn-request-button-service/turn-request-button-service.html','<div class=turn-request-button-container><md-button class="md-raised btn btn-danger btn-service" id={{$ctrl.queue.id}} aria-label=button style=background-color:#ff914d queue-name={{$ctrl.queue.name}} ng-click=$ctrl.goToServices() ng-if=!$ctrl.queue.outOfService><h2 class=md-title>{{$ctrl.queue.display}}</h2><p class=selectSubservices style=color:#fff;font-size:40px>Seleccionar servicios</p></md-button></div>');}]);